// RestaFlex — Çoklu Dil Çeviri Dosyası
// Desteklenen diller: tr (Türkçe), en (English), ar (العربية)

const translations = {
  tr: {
    // Genel
    save: 'Kaydet',
    saving: 'Kaydediliyor...',
    cancel: 'İptal',
    delete: 'Sil',
    add: 'Ekle',
    edit: 'Düzenle',
    close: 'Kapat',
    openMenu: 'Menüyü aç',
    hideSidebar: 'Menüyü gizle',
    showSidebar: 'Menüyü göster',
    back: 'Geri',
    search: 'Ara',
    loading: 'Yükleniyor...',
    update: 'Güncelle',
    all: 'Tümü',
    noData: 'Veri bulunamadı',
    actions: 'İşlemler',
    status: 'Durum',
    date: 'Tarih',
    total: 'Toplam',
    name: 'Ad',
    description: 'Açıklama',
    price: 'Fiyat',
    quantity: 'Miktar',
    active: 'Aktif',
    passive: 'Pasif',
    // Login
    loginTitle: 'Hesabınıza giriş yapın',
    email: 'E-posta',
    password: 'Şifre',
    loginBtn: 'Giriş Yap',
    loggingIn: 'Giriş yapılıyor...',
    forgotPassword: 'Şifremi Unuttum',
    loginError: 'Giriş başarısız.',
    emailRequired: 'E-posta ve şifre gereklidir.',

    // Navigasyon
    nav_dashboard: 'Dashboard',
    nav_tables: 'Masalar',
    nav_reservations: 'Rezervasyonlar',
    nav_shifts: 'Vardiya',
    nav_hr: 'Personel',
    nav_orders: 'Siparişler',
    nav_menu: 'Menü',
    nav_kitchen: 'Mutfak',
    nav_stock: 'Stok',
    nav_recipes: 'Reçeteler',
    nav_suppliers: 'Tedarikçiler',
    nav_purchase_orders: 'Satın Alma',
    nav_cash_transactions: 'Kasa Hareketleri',
    nav_refunds: 'İadeler',
    nav_stock_history: 'Stok Hareketleri',
    nav_payments: 'Kasa',
    nav_delivery: 'Teslimat',
    nav_couriers: 'Kuryeler',
    nav_platforms: 'Platform Yönetimi',
    nav_pos: 'Yazarkasa',
    nav_printers: 'Yazıcılar',
    nav_customers: 'Müşteriler',
    nav_promo: 'Kampanyalar',
    nav_gifts: 'Hediye Çekleri',
    nav_users: 'Kullanıcılar',
    nav_waiterStats: 'Garson Takibi',
    nav_reports: 'Raporlar',
    nav_settings: 'Ayarlar',
    nav_gdpr: 'KVKK / Gizlilik',
    nav_webhooks: 'Webhook Entegrasyonları',
    nav_whitelabel: 'White-label',
    nav_subscription: 'Aboneliğim',
    nav_audit_logs: 'Denetim Kayıtları',
    nav_trash: 'Çöp Kutusu',
    nav_security: 'Güvenlik & 2FA',
    nav_tax_groups: 'Vergi Grupları',
    nav_feature_flags: 'Feature Flags',
    logout: 'Çıkış Yap',

    // Roller
    role_admin: 'Admin',
    role_waiter: 'Garson',
    role_kitchen: 'Mutfak',
    role_cashier: 'Kasiyer',
    chainStaffTitle: 'Personel Yönetimi',
    chainStaffSubtitle: 'Zincirdeki tüm şubelerin personelini görüntüleyin ve yönetin.',
    chainStaffAdd: 'Personel Ekle',
    chainStaffTotal: 'Toplam Personel',
    chainStaffBranchFilter: 'Şube Filtrele:',
    chainStaffAllBranches: 'Tüm Şubeler',
    chainStaffClearFilter: 'Filtreyi Temizle',
    chainStaffShowing: 'personel gösteriliyor',
    chainStaffNameCol: 'İsim',
    chainStaffBranch: 'Şube',
    chainStaffRegDate: 'Kayıt Tarihi',
    chainStaffDeleting: 'Siliniyor...',
    chainStaffNotFound: 'Personel bulunamadı',
    chainStaffNoInBranch: 'Bu şubeye ait personel yok.',
    chainStaffBranchSelect: 'Şube Seçiniz',
    chainStaffFullName: 'Ad Soyad',
    chainStaffEmailPlaceholder: 'personel@ornek.com',
    chainStaffPwHint: 'Min 6 karakter',
    chainStaffLoadError: 'Personel bilgileri yüklenirken bir hata oluştu.',
    chainStaffBranchRequired: 'Şube seçiniz.',
    chainStaffPwTooShort: 'Şifre en az 6 karakter olmalıdır.',
    chainStaffEmailReq: 'E-posta zorunludur.',
    chainStaffNoResultsTitle: 'Sonuç bulunamadı',
    chainStaffNoResultsDesc: 'Şube, arama veya tarih filtresini değiştir.',
    chainStaffEmptyTitle: 'Henüz personel yok',
    chainStaffEmptyDesc: 'Şubelere personel ekleyerek izleme başlayabilirsin.',
    chainReportsEmptyDesc: 'Şubelerden veri toplandıkça raporlar burada görünecek.',
    chainReportsNoRangeDesc: 'Tarih aralığını değiştirin.',
    chainDashTitleSuffix: 'Zincir Yönetim Paneli',
    chainDashSubtitle: 'Tüm şubelerinizin performansını tek ekrandan takip edin.',
    chainDashChain: 'Zincir',
    chainDashToday: 'Bugün',
    chainDashLast7Days: 'Son 7 Gün',
    chainDashLast30Days: 'Son 30 Gün',
    chainDashThisMonth: 'Bu Ay',
    chainDashStart: 'Başlangıç',
    chainDashEnd: 'Bitiş',
    chainDashFilter: 'Filtrele',
    chainDashTotalRevenue: 'Toplam Ciro',
    chainDashBranchCount: 'Şube Sayısı',
    chainDashTotalTables: 'Toplam Masa',
    chainDashPerformance: 'Şube Performansı',
    chainDashNoBranchData: 'Seçili tarih aralığında şube verisi bulunamadı.',
    chainDashDetails: 'Şube Detayları',
    chainDashRevenue: 'Ciro',
    chainDashOrder: 'Sipariş',
    chainDashTable: 'Masa',
    chainDashOrderUnit: 'sipariş',
    chainDashLoadError: 'Veriler yüklenirken bir hata oluştu.',
    chainBranchesTitle: 'Şube Yönetimi',
    chainBranchesSubtitle: 'Zincire bağlı tüm şubeleri görüntüleyin ve yönetin.',
    chainBranchesAdd: 'Yeni Şube Ekle',
    chainBranchStatTotal: 'Toplam Şube',
    chainBranchStatActive: 'Aktif',
    chainBranchStatInactive: 'Pasif',
    chainBranchStatTables: 'Toplam Masa',
    chainBranchesEmpty: 'Henüz şube eklenmemiş.',
    chainBranchesTableUnit: 'masa',
    chainBranchesUserUnit: 'kullanıcı',
    chainBranchesEntering: 'Giriş yapılıyor...',
    chainBranchesEnter: 'Şubeye Gir',
    chainBranchesMakeActive: 'Aktif Et',
    chainBranchesMakePassive: 'Pasif Et',
    chainBranchesInfo: 'Şube Bilgileri',
    chainBranchesNameLabel: 'Şube Adı',
    chainBranchesAdminInfo: 'Yönetici Bilgileri',
    chainBranchesAdminName: 'Yönetici Adı',
    chainBranchesAdminEmail: 'Yönetici E-posta',
    chainBranchesCreateBtn: 'Şube Oluştur',
    chainBranchesEditTitle: 'Şube Düzenle',
    chainBranchesNameRequired: 'Şube adı zorunludur.',
    chainBranchesEmailRequired: 'E-posta zorunludur.',
    chainBranchesLoadError: 'Şubeler yüklenirken bir hata oluştu.',
    chainBranchesCreateError: 'Şube oluşturulamadı.',
    chainBranchesUpdateError: 'Şube güncellenemedi.',
    chainBranchesStatusError: 'Şube durumu güncellenemedi.',
    chainBranchesEnterError: 'Şubeye giriş yapılamadı.',
    chainBranchesNamePh: 'Örn: Kadıköy Şubesi',
    chainBranchesAddressPh: 'Şube adresi',
    chainBranchesPwPh: 'Şifre',
    chainReportsTitle: 'Zincir Raporları & Analitik',
    chainReportsSubtitle: 'Tüm şubelerinizin detaylı performans analizini görüntüleyin.',
    chainReportsQuickSelect: 'Hızlı Seçim',
    chainReportsAllBranches: 'Tüm Şubeler',
    chainReportsFetch: 'Raporu Getir',
    chainReportsLoadError: 'Rapor verileri yüklenirken bir hata oluştu.',
    chainReportsTotalOrders: 'Toplam Sipariş',
    chainReportsAvgOrder: 'Ort. Sipariş Tutarı',
    chainReportsBestBranch: 'En İyi Şube',
    chainReportsBranchCompare: 'Şube Karşılaştırması',
    chainReportsAvgAmount: 'Ort. Tutar',
    chainReportsStaffCol: 'Personel',
    chainReportsRevenueShare: 'Ciro Payı',
    chainReportsDailyTrend: 'Günlük Trend',
    chainReportsHourlyDist: 'Saatlik Dağılım (Ortalama)',
    chainReportsAvgRevenue: 'Ort. Ciro',
    chainReportsAvgOrders: 'Ort. Sipariş',
    chainReportsTopItems: 'En Çok Satan Ürünler (Zincir Geneli)',
    chainReportsBranchesSuffix: 'şube',
    chainReportsWeekdayAvg: 'Haftanın Günlerine Göre Ortalama Ciro',
    chainReportsPaymentMethods: 'Ödeme Yöntemleri (Şube Bazlı)',
    chainReportsSplit: 'Karma',
    chainReportsEmpty: 'Rapor görüntülemek için filtreleyin.',
    chainReportsDay0: 'Pazar',
    chainReportsDay1: 'Pazartesi',
    chainReportsDay2: 'Salı',
    chainReportsDay3: 'Çarşamba',
    chainReportsDay4: 'Perşembe',
    chainReportsDay5: 'Cuma',
    chainReportsDay6: 'Cumartesi',
    chainMenuTitle: 'Menü Yönetimi',
    chainMenuStatTotal: 'Toplam Ürün',
    chainMenuStatActive: 'Aktif',
    chainMenuStatInactive: 'Pasif',
    chainMenuStatCategories: 'Kategori',
    chainMenuSubtitle: 'Şube menülerini görüntüle veya zincir genelinde ortak menü yönet.',
    chainMenuBranchMenus: 'Şube Menüleri',
    chainMenuChainMenu: 'Zincir Menüsü',
    chainMenuNoBranches: 'Henüz şube yok',
    chainMenuNoPlan: 'Plan yok',
    chainMenuViewMenu: 'Menüyü Gör',
    chainMenuInfoText: 'Ürünler eklendiğinde/güncellendiğinde tüm şubelere otomatik uygulanır. Kilitli 🔒 ürünler fiyatı da günceller; kilitsiz ürünlerde şube kendi fiyatını korur. "Şubelere Uygula" butonu yeni eklenen şubeler için kullanılabilir.',
    chainMenuApplying: 'Uygulanıyor...',
    chainMenuApplyToBranches: '🔄 Şubelere Uygula',
    chainMenuAddItem: '+ Ürün Ekle',
    chainMenuNoItems: 'Henüz ürün eklenmemiş',
    chainMenuNoItemsHint: 'Zincir menüsüne ürün ekleyerek tüm şubelere uygulayabilirsiniz.',
    chainMenuItemsUnit: 'ürün',
    chainMenuLocked: '🔒 Kilitli',
    chainMenuFree: 'Serbest',
    chainMenuBranchMenuSubtitle: 'Şube Menüsü',
    chainMenuEmptyBranchMenu: 'Bu şubede henüz menü yok',
    chainMenuEmptyBranchHint: 'Zincir menüsünden şubeye ürün uygulayabilirsiniz.',
    chainMenuPriceLocked: '🔒 Fiyat Kilitli',
    chainMenuUnlockPrice: 'Fiyat kilidini kaldır',
    chainMenuLockPrice: 'Fiyatı kilitle',
    chainMenuManageChainMenu: 'Zincir Menüsünü Yönet',
    chainMenuEditItem: 'Ürün Düzenle',
    chainMenuNewItem: 'Yeni Ürün Ekle',
    chainMenuItemName: 'Ürün Adı',
    chainMenuItemNamePh: 'Ürün adı',
    chainMenuPriceLabel: 'Fiyat (₺)',
    chainMenuDescriptionPlaceholder: 'Ürün açıklaması (isteğe bağlı)',
    chainMenuPriceLockLabel: '🔒 Fiyatı Kilitle',
    chainMenuPriceLockHint: 'Şube admini bu ürünün fiyatını değiştiremez.',
    chainMenuBranchAvailableHint: 'Ürün şube menüsünde görünür ve sipariş alınabilir.',
    chainMenuUpdate: 'Güncelle',
    chainMenuCategoryPlaceholder: 'Örn: Ana Yemekler',
    chainMenuLockedItem: '🔒 Kilitli Ürün',
    chainMenuLockedItemHint: 'Senkronizasyonda şubelerdeki fiyatı günceller.',
    chainMenuAvailableHint: 'Ürün menüde görünür ve sipariş alınabilir.',
    chainMenuApplyQuestion: 'Hangi şubelere uygulamak istiyorsunuz? Seçmezseniz tüm şubelere uygulanır.',
    chainMenuBranchesSelectedSuffix: 'şube seçildi.',
    chainMenuAllBranchesApply: 'Tüm şubelere uygulanacak.',
    chainMenuApply: 'Uygula',
    chainMenuLoadFailed: 'Menü yüklenemedi.',
    chainMenuNameRequired: 'Ürün adı zorunludur.',
    chainMenuInvalidPrice: 'Geçerli bir fiyat giriniz.',
    chainMenuPriceLockFailed: 'Fiyat kilidi güncellenemedi.',
    chainMenuStatusUpdateFailed: 'Durum güncellenemedi.',
    chainMenuSyncDone: 'Senkronizasyon tamamlandı.',
    chainMenuSyncFailed: 'Başarısız.',
    lockScreenTitle: 'Ekran Kilitli',
    lockScreenNoPin: 'Henüz PIN ayarlanmamış.',
    lockScreenNoPinHint: 'Devam etmek için butona dokunun.',
    lockScreenUnlock: 'Kilidi Aç',
    lockScreenPinFromSettings: "⚙️ Ayarlar'dan PIN belirleyebilirsiniz",
    lockScreenResetTitle: "PIN'i Sıfırla",
    lockScreenResetDesc: "Tüm kayıtlı PIN'ler silinecek ve oturumunuz kapatılacak. Tekrar giriş yaparak yeni PIN belirleyebilirsiniz.",
    lockScreenResetConfirm: 'Evet, Çıkış Yap ve Sıfırla',
    lockScreenResetBack: 'Geri Dön',
    lockScreenEnterPin: 'PIN kodunuzu girin',
    lockScreenWrongPin: 'Yanlış PIN kodu',
    lockScreenForgotPin: "PIN'imi unuttum",
    subBannerNoActive: 'Aktif aboneliğiniz bulunmuyor',
    subBannerNoActiveDesc: 'Sistemi kullanmak için bir plan seçin.',
    subBannerChoosePlan: 'Plan Seç',
    subBannerTrialEnding: 'Deneme süreniz bitiyor!',
    subBannerSubEnding: 'Aboneliğiniz bitiyor!',
    subBannerTodayEnd: 'Bugün sona eriyor!',
    subBannerDaysLeft: 'gün kaldı.',
    subBannerRenewSoon: 'Hemen yenileyin.',
    subBannerRenew: 'Aboneliği Yenile',
    subBannerRenewNow: 'Hemen Yenile',
    subBannerTrialHeader: '14 günlük ücretsiz deneme',
    subBannerTrialHint: 'Tüm özellikleri ücretsiz keşfedin!',
    subBannerTrialDaysLeft: 'gün kaldı.',
    subBannerExpired: 'Aboneliğiniz sona erdi',
    subBannerExpiredDesc: 'Hizmetlere erişmek için aboneliğinizi yenileyin.',
    cookieBannerTitle: 'Çerezler ve Gizlilik:',
    cookieBannerDesc: 'Size daha iyi hizmet sunmak için zorunlu çerezler kullanıyoruz. İsterseniz analitik ve pazarlama çerezlerine de izin verebilirsiniz.',
    cookieBannerManage: 'Seçenekleri yönet',
    cookieBannerOnlyRequired: 'Yalnızca Zorunlu',
    cookieBannerAcceptAll: 'Tümünü Kabul Et',
    cookieBannerSaveChoices: 'Seçimlerimi Kaydet',
    cookieBannerDetailsTitle: 'Çerez Tercihleri',
    cookieCategoryRequired: 'Zorunlu Çerezler',
    cookieCategoryRequiredDesc: 'Sitenin çalışması için gerekli.',
    cookieCategoryAnalytics: 'Analitik Çerezler',
    cookieCategoryAnalyticsDesc: 'Kullanım istatistikleri için.',
    cookieCategoryMarketing: 'Pazarlama Çerezleri',
    cookieCategoryMarketingDesc: 'Kişiselleştirilmiş içerik için.',
    chainAdminTitle: 'Zincir Admin',
    chainAdminSubtitle: 'RestaFlex Zincir Yönetimi',
    chainAdminRoleLabel: 'Zincir Yöneticisi',
    caNavBranches: 'Şubeler',
    caNavReports: 'Raporlar',
    caNavAnalytics: 'Analitik',
    caNavChainMenu: 'Zincir Menü',
    caNavStaff: 'Personel',
    superAdminTitle: 'SuperAdmin',
    superAdminSubtitle: 'RestaFlex Yönetim Merkezi',
    saNavRestaurants: 'Restoranlar',
    saNavPlans: 'Planlar',
    saNavSubscriptions: 'Abonelikler',
    receiptTitle: 'Adisyon',
    receiptSubtitle: 'Restoran Yönetim Sistemi',
    receiptSplit: 'Karma (Nakit + Kart)',
    receiptProduct: 'Ürün',
    receiptUnit: 'Birim',
    receiptGrandTotal: 'TOPLAM',
    receiptPaymentLabel: 'Ödeme:',
    receiptThanks: 'Teşekkürler!',
    receiptThanksLong: 'Bizi tercih ettiğiniz için teşekkür ederiz.',
    activityRecentOrders: 'Hazırlanan Siparişler',
    activityTodayReservations: 'Bugünkü Rezervasyonlar',
    activityLowStock: 'Kritik Stok',
    activitySeeAll: 'Tümü',
    activityNoOrders: 'Hazırlanan sipariş yok.',
    activityNoReservations: 'Bugün için rezervasyon yok.',
    activityNoLowStock: 'Kritik seviyede malzeme yok.',
    activityItemsUnit: 'ürün',
    activityGuestsUnit: 'kişi',
    activityCriticalLevel: 'Kritik',
    role_superadmin: 'Süper Admin',

    // Settings
    settingsTitle: 'Ayarlar',
    tab_notifications: 'Bildirimler',
    restaurantName: 'Restoran Adı',
    ownerName: 'Yetkili Adı',
    phone: 'Telefon',
    address: 'Adres',
    theme: 'Tema',
    theme_light: 'Açık',
    theme_dark: 'Koyu',
    theme_system: 'Sistem',
    languageSelect: 'Dil Seçin',
    kitchenSound: 'Mutfak Ses Bildirimi',
    kitchenSoundDesc: 'Yeni sipariş geldiğinde ses çal',
    autoPrint: 'Otomatik Yazdırma',
    autoPrintDesc: 'Sipariş onayında otomatik fiş yazdır',
    webPush: 'Web Push Bildirimleri',
    menuTitle: 'Menü Başlığı',
    settingsSaved: 'Ayarlar kaydedildi.',
    // Dashboard
    totalOrders: 'Toplam Sipariş',
    trendBadgeTooltip: 'Dün aynı saate göre',
    partialLoadError: 'Bazı veriler yüklenemedi.',
    kpiTotalTables: 'Toplam Masa',
    kpiOccupiedTables: 'Dolu Masa',
    kpiOccupancy: 'Doluluk',
    kpiActiveOrders: 'Aktif Sipariş',
    kpiAvgTicket: 'Ort. Sepet',
    kpiTodayRevenue: 'Bugünkü Ciro',
    kpiTodaySales: 'Bugünün Satışı',
    kpiOpenOrders: 'Açık Sipariş',
    kpiLowStock: 'Düşük Stok',
    kpiPendingReservations: 'Bekleyen Rezervasyon',
    kpiMonthlyNetProfit: 'Bu Ay Net Kâr',
    kpiActiveCouriers: 'Aktif Kurye',
    kpiActiveShifts: 'Aktif Vardiya',
    actionItemsTitle: 'Bugün Yapılacaklar',
    actionReadyOrders: 'hazır sipariş',
    actionReadyOrdersDesc: 'Servis bekliyor',
    actionPendingReservations: 'rezervasyon onayı',
    actionPendingReservationsDesc: 'Bekliyor',
    actionCriticalStock: 'kritik stok',
    actionUnassignedDeliveries: 'teslimat',
    actionUnassignedDeliveriesDesc: 'Kuryeye atanmadı',
    kpiThisMonth: 'bu ay',
    kpiToday: 'bugün',
    kpiLive: 'canlı',
    chartHourly: 'Saatlik Ciro',
    chartDaily: 'Günlük Ciro',
    chartWeekly: 'Haftalık Ciro',
    chartHourlyHint: 'Bugün · 24 saat',
    chartDailyHint: 'Son 7 gün',
    chartWeeklyHint: 'Son 8 hafta',
    periodHourly: 'Saatlik',
    periodDaily: 'Günlük',
    periodWeekly: 'Haftalık',
    chartPeriodLabel: 'Zaman aralığı',
    chartNoData: 'Bu dönem için veri yok',
    sectionActiveOrders: 'Aktif Siparişler',
    viewAll: 'Tümünü Gör',
    noActiveOrders: 'Aktif sipariş yok',
    dailySummary: 'Günlük Özet',
    totalTransactions: 'Toplam İşlem',
    totalRevenueLabel: 'Toplam Ciro',
    noPaymentsToday: 'Bugün henüz ödeme alınmadı',
    quickActions: 'Hızlı İşlemler',
    criticalStockAlert: '⚠️ Kritik Stok Uyarısı',
    topItemsTitle: '⭐ En Çok Satanlar (Bugün)',
    unitPieces: 'adet',

    // Bildirim Merkezi (Notifications + Header NotificationBell)
    severityCritical: 'Kritik',
    severityWarning: 'Uyarı',
    severityInfo: 'Bilgi',
    notifSeverityLabel: 'Önem:',
    notifSearchPlaceholder: 'Bildirimde ara...',
    viewModeList: 'Liste',
    viewModeKanban: 'Kanban',
    newCustomerBadge: 'Yeni misafir (son 30 gün)',
    notifStatusLabel: 'Durum:',
    notifUnread: 'Okunmamış',
    notifRead: 'Okunmuş',
    notifShowDismissed: 'Silinenleri göster',
    notifCountSuffix: 'bildirim',
    notifMarkVisibleRead: 'Görünenleri okundu işaretle',
    notifRestoreAll: 'Silinenleri geri al',
    notifNoMatch: 'Filtrelere uyan bildirim yok.',
    notifNewLabel: 'Yeni',
    notifDismissedLabel: 'Silindi',
    notifGoToPage: '→ İlgili sayfaya git',
    notifMarkRead: 'Okundu işaretle',
    notifRestore: 'Geri al',
    notifMarkAllReadTitle: 'Tümünü okundu işaretle',
    notifMarkAllReadShort: 'Okundu ✓',
    notifDismissAllTitle: 'Tüm bildirimleri sil',
    notifDismissAllShort: 'Tümünü sil',
    notifEmpty: 'Yeni bildirim yok.',
    notifViewAll: 'Tüm bildirimleri görüntüle →',
    notifUnreadCountSuffix: 'okunmamış',
    notifDismissOne: 'Bildirimi sil',
    notifAllCaughtUp: 'Tüm bildirimler okundu',
    notifNoReadYet: 'Henüz okunmuş bildirim yok',
    notifFilterAll: 'Tümü',
    notifFilterUnread: 'Okunmamış',
    notifFilterRead: 'Okundu',
    notifBadgeUnread: 'okunmamış',
    notifBadgeTotal: 'toplam',
    reportsExportCSV: 'CSV İndir',
    reportsCSVNotAvailable: 'Bu rapor için CSV mevcut değil.',
    timeAgoSuffix: 'önce',
    themeLightMode: 'Açık Mod',
    themeDarkMode: 'Koyu Mod',

    // Müşteriler (Customers + CustomerDetail)
    customersTitle: 'Müşteriler',
    customersSubtitle: 'Müşteri yönetimi ve sadakat programı',
    newCustomer: 'Yeni Müşteri',
    editCustomer: 'Müşteriyi Düzenle',
    customerSearchPlaceholder: 'İsim, telefon veya e-posta ara...',
    noCustomersYet: 'Henüz müşteri yok',
    addFirstCustomer: 'İlk müşterinizi ekleyin',
    customerLoadError: 'Müşteri yüklenemedi',
    customerNotFound: 'Müşteri bulunamadı',
    deleteConfirm: 'Bu öğeyi silmek istediğinizden emin misiniz?',
    deleteCustomerConfirm: 'Bu müşteriyi silmek istediğinizden emin misiniz?',
    genericError: 'Hata oluştu',
    deleteFailed: 'Silinemedi',
    birthdaySoon: 'Doğum günü yaklaşıyor',
    colCustomer: 'Müşteri',
    colContact: 'İletişim',
    colSpend: 'Harcama',
    colVisits: 'Ziyaret',
    points: 'Puan',
    loyaltyAction: 'Puan İşlemi',
    addPointsBtn: '+ Puan Ekle',
    redeemPointsBtn: '- Puan Kullan',
    loyaltyHistoryTitle: 'Puan Geçmişi',
    notes: 'Notlar',
    fullName: 'Ad Soyad',
    phoneLabel: 'Telefon',
    emailLabel: 'E-posta',
    birthdayLabel: 'Doğum Tarihi',
    customerNotesPlaceholder: 'Özel tercihler, alerjiler...',
    pointsEarned: 'Puan kazanıldı',
    pointsRedeemed: 'Puan kullanıldı',

    // CustomerDetail
    backToCustomers: '← Müşterilere dön',
    loyaltyLabel: 'Sadakat',
    pointsUnit: 'puan',
    totalSpentLabel: 'Toplam Harcama',
    lastOrderLabel: 'Son Sipariş',
    descriptionOptional: 'Açıklama (opsiyonel)',
    useAction: 'Kullan',
    orderHistoryTitle: '📋 Sipariş Geçmişi',
    recordsSuffix: 'kayıt',
    noPhoneMatchSuffix: '· (telefon yok — eşleşme mümkün değil)',
    noOrdersForPhone: 'Bu telefon numarası ile eşleşen sipariş yok.',
    addPhoneForOrders: 'Sipariş eşleştirmek için müşteriye telefon numarası ekleyin.',
    paymentPaid: '✓ Ödendi',
    paymentPending: '○ Beklemede',
    loyaltyActivityTitle: '⭐ Sadakat Hareketleri',
    noLoyaltyActivity: 'Henüz sadakat hareketi yok.',
    successPointsAdded: '✓ Puan eklendi',
    successPointsRedeemed: '✓ Puan kullanıldı',
    pointsAddError: 'Puan eklenemedi',
    pointsRedeemError: 'Puan kullanılamadı',
    orderServedShort: 'Servis',

    // Orders sayfası + Header pageTitles
    ordersLoadError: 'Siparişler yüklenemedi.',
    orderDetailLoadError: 'Sipariş detayı yüklenemedi.',
    itemRemoveError: 'Ürün kaldırılamadı.',
    statusUpdateError: 'Durum güncellenemedi.',
    orderDeleteError: 'Sipariş silinemedi.',
    menuLoadError: 'Menü yüklenemedi.',
    itemAddError: 'Ürün eklenemedi.',
    refresh: 'Yenile',
    addItem: 'Ürün Ekle',
    colTableTime: 'Masa / Saat',
    colItems: 'Kalem',
    colAmount: 'Tutar',
    colAction: 'İşlem',
    detail: 'Detay',
    itemsSuffix: 'kalem',
    orderNotFound: 'Sipariş bulunamadı',
    ordersSuffix: 'sipariş',
    totalLabel: 'Toplam',
    orderPrefix: 'Sipariş',
    cancelOrderConfirm: 'Siparişi iptal etmek istediğinize emin misiniz?',
    markReady: '✓ Hazır İşaretle',
    markServed: '🚀 Servis Edildi',
    cancelOrderBtn: '🗑️ Siparişi İptal Et',
    addItemBtn: '➕ Ürün Ekle',

    // Header pageTitles (route → title)
    pageTableManagement: 'Masa Yönetimi',
    pageOrderManagement: 'Sipariş Yönetimi',
    pageMenuManagement: 'Menü Yönetimi',
    pageKitchenScreen: 'Mutfak Ekranı',
    pageStockManagement: 'Stok Yönetimi',
    pageRecipeSystem: 'Reçete Sistemi',
    pagePaymentsCash: 'Ödeme & Kasa',
    pageUserManagement: 'Kullanıcı Yönetimi',
    roleAdmin: 'Admin',
    roleWaiter: 'Garson',
    roleKitchen: 'Mutfak',

    // Reservations
    resStatusPending: 'Bekliyor',
    resStatusConfirmed: 'Onaylandı',
    resStatusConfirmedShort: 'Onaylı',
    resStatusArrived: 'Geldi',
    resStatusCompleted: 'Tamamlandı',
    resStatusNoShow: 'Gelmedi',
    totalGuests: 'Toplam Misafir',
    editReservation: 'Rezervasyonu Düzenle',
    newReservation: 'Yeni Rezervasyon',
    create: 'Oluştur',
    reservationsTitle: 'Rezervasyonlar',
    reservationsSubtitle: 'Masa rezervasyon yönetimi',
    customerName: 'Müşteri Adı',
    partySize: 'Kişi Sayısı',
    durationMin: 'Süre (dk)',
    tableOptional: 'Masa (opsiyonel)',
    noTableSelected: '-- Masa seçilmedi --',
    capacityPersons: 'kişilik',
    persons: 'kişi',
    minShort: 'dk',
    dateLabel: 'Tarih:',
    statusFilterLabel: 'Durum:',
    clear: 'Temizle',
    reservationStatTotal: 'Toplam',
    reservationStatConfirmed: 'Onaylı',
    reservationStatPending: 'Bekleyen',
    reservationStatCancelled: 'İptal',
    reservationNotFound: 'Rezervasyon bulunamadı',
    reservationEmptyHint: 'Yeni rezervasyon eklemek için + butonunu kullanın',
    deleteReservationConfirm: 'Rezervasyonu silmek istediğinizden emin misiniz?',
    timeLabel: 'Saat',
    notesPlaceholder: 'Özel istek, alerji, doğum günü vb.',
    // Stock
    stockLoadError: 'Stok verileri yüklenemedi.',
    allFieldsRequired: 'Tüm alanlar zorunludur.',
    invalidQuantity: 'Miktar geçerli ve negatif olmayan bir sayı olmalıdır.',
    invalidCriticalLevel: 'Kritik seviye geçerli ve negatif olmayan bir sayı olmalıdır.',
    saveFailed: 'Kaydedilemedi.',
    updateStock: 'Stok Güncelle',
    newIngredient: 'Yeni Malzeme Ekle',
    supplierName: 'Tedarikçi adı',
    reorderQuantity: 'Sipariş miktarı',
    ingredient: 'Malzeme',
    ingredientName: 'Malzeme Adı',
    totalIngredients: 'Toplam Malzeme',
    criticalStock: 'Kritik Stok',
    normalStock: 'Normal Stok',
    addIngredient: '+ Malzeme Ekle',
    unit: 'Birim',
    criticalLevel: 'Kritik Seviye',
    supplierOptional: '📦 Tedarikçi (Opsiyonel)',
    phoneWhatsapp: 'Telefon (WhatsApp)',
    supplierEmailHint: 'Stok kritik seviyeye düşünce admin email\'inde WhatsApp ve E-posta sipariş linkleri otomatik oluşturulur.',
    ingredientNotFound: 'Malzeme bulunamadı',
    statusCritical: '⚠️ Kritik',
    statusNormal: '✓ Normal',
    deleteIngredientConfirm: 'Bu malzemeyi silmek istediğinize emin misiniz?',
    criticalCount: 'Kritik',
    // MenuManagement
    dataLoadError: 'Veri yüklenemedi.',
    variantAddError: 'Varyant eklenemedi.',
    variantDeleteError: 'Varyant silinemedi.',
    enterValidValue: 'Lütfen geçerli bir değer girin.',
    bulkPriceUpdateError: 'Toplu fiyat güncellenemedi.',
    categoryNameRequired: 'Kategori adı gerekli.',
    categorySaveError: 'Kategori kaydedilemedi.',
    categoryDeleteError: 'Kategori silinemedi.',
    nameAndPriceRequired: 'Ad ve fiyat gerekli.',
    menuItemSaveError: 'Menü öğesi kaydedilemedi.',
    menuItemDeleteError: 'Menü öğesi silinemedi.',
    aiScanFailed: 'AI tarama başarısız. Lütfen daha net bir fotoğraf deneyin.',
    excelDownloadError: 'Excel indirilemedi.',
    importFailed: 'İçe aktarma başarısız.',
    editCategory: 'Kategori Düzenle',
    newCategory: 'Yeni Kategori',
    categoryName: 'Kategori adı',
    optional: 'İsteğe bağlı',
    editProduct: 'Ürün Düzenle',
    newProduct: 'Yeni Ürün',
    productName: 'Ürün adı',
    variantsExample: 'Küçük / Orta / Büyük',
    bulkPriceUpdate: 'Toplu Fiyat Güncelleme',
    updating: 'Güncelleniyor...',
    apply: 'Uygula',
    adding: 'Ekleniyor...',
    qrMenuCode: 'QR Menü Kodu',
    // Kitchen
    justNow: 'Az önce',
    actionFailed: 'İşlem başarısız.',

    // Tables sayfası
    tablesLoadError: 'Masalar yüklenemedi.',
    orderCreateError: 'Sipariş oluşturulamadı.',
    tableNameRequired: 'Masa adı gerekli.',
    tableAddError: 'Masa eklenemedi.',
    tablesAddError: 'Masalar eklenemedi.',
    tableDeleteError: 'Masa silinemedi.',
    tableCloseError: 'Masa kapatılamadı.',
    paymentFailed: 'Ödeme alınamadı.',
    invalidPromoCode: 'Geçersiz kampanya kodu',
    invalidGiftVoucher: 'Geçersiz hediye çeki',
    addOrder: '➕ Sipariş Ekle',
    closeTable: '✕ Masayı Kapat',
    deleteTableAction: '🗑️ Masayı Sil',
    tableNotSpecified: 'Masa belirtilmedi',
    searchTableHint: 'Masa ara...',
    noTablesYet: 'Henüz masa eklenmedi',
    noTableMatching: 'masa bulunamadı',
    statusEmpty: 'Boş',
    statusOccupied: 'Dolu',
    statusReserved: 'Rezerve',
    allFloors: 'Tüm Katlar',
    categoriesNav: '⚙️ Kategoriler',
    addFloorCategory: '+ Kat / Bölge kategorisi ekle',
    addTableShort: '+ Masa',
    seenLabel: '• Görüldü',
    markSeen: 'Gördüm',
    resolvedLabel: 'Çözüldü',
    hide: '▲ Gizle',
    show: '▼ Göster',
    ordersSheetTitle: 'Siparişler',
    checkoutTitle: 'Hesap',
    noPendingOrders: 'Ödeme bekleyen sipariş yok',
    markReadyShort: '✓ Hazır',
    orderSubtotal: 'sipariş toplamı',
    closeCheck: '💰 Hesabı Kapat',
    addNewOrder: '➕ Yeni Sipariş Ekle',
    createOrderTitle: 'Sipariş Oluştur',
    orderNotePlaceholder: 'Sipariş notu...',
    addNewTable: 'Yeni Masa Ekle',
    paymentMixed: 'Karma',
    categoryNameLabel: 'Kategori Adı',

    // Onboarding wizard
    onbTitle: 'Hoş geldiniz! 🎊',
    onbSubtitle: 'Restoranınızı birkaç adımda kurmaya başlayalım',
    onbStepRestaurant: 'Restoran',
    onbStepTables: 'Masalar',
    onbStepMenu: 'Menü',
    onbStepDone: 'Tamamla',
    onbStep1Hint: 'Restoranınız hakkında temel bilgileri girin. Sonradan Ayarlar\'dan değiştirebilirsiniz.',
    onbRestaurantName: 'Restoran Adı',
    onbOwnerName: 'Sahibi',
    onbAddress: 'Adres',
    onbNameRequired: 'Restoran adı zorunludur',
    onbContinue: 'Devam Et →',
    onbSkip: 'Bu Adımı Geç',
    onbDoneTitle: 'Kurulum Tamamlandı!',
    onbDoneHint: 'Artık restoranınızı yönetmeye başlayabilirsiniz.',
    onbGoDashboard: 'Panele Git',
    onbStep2Hint: 'İsteğe bağlı: kat/bölge kategorisi ekleyin, sonra hızlıca masa oluşturun.',
    onbCategoriesLabel: 'Kategoriler',
    onbCategoryNamePh: 'Yeni kategori (örn. Bahçe, Salon)',
    onbBulkTablesTitle: 'Masaları toplu oluştur',
    onbPrefix: 'Önek',
    onbCount: 'Adet',
    onbCapacity: 'Kapasite',
    onbStep3Hint: 'Menü kategorileri ekleyin, sonra ilk birkaç ürünü hızlıca tanımlayın. Detaylı menü Menü Yönetimi sayfasından düzenlenir.',
    onbMenuCategoriesLabel: 'Menü Kategorileri',
    onbMenuCategoryPh: 'Yeni kategori (örn. Çorbalar, İçecekler)',
    onbQuickItemTitle: 'Hızlı ürün ekle',
    onbNeedCategoryFirst: 'Önce en az bir kategori ekleyin.',
    onbReopenTitle: 'Kurulum Sihirbazı',
    onbReopenDesc: 'Restoran bilgileri, masalar ve menü için adım adım kurulum sihirbazını yeniden açın.',
    onbReopenBtn: 'Sihirbazı Aç',

    // Sound preferences (Madde 15)
    soundPresetTitle: 'Bildirim Sesi',
    soundPresetDesc: 'Mutfak ekranında yeni sipariş geldiğinde çalınacak ses.',
    soundPreset_beep: 'Bip',
    soundPreset_chime: 'Çan Sesi',
    soundPreset_bell: 'Zil',
    soundVolumeLabel: 'Ses Seviyesi',
    soundTestBtn: 'Sesi Dene',

    // DeliveryOrders i18n tail (Madde 13)
    deliveryOrdersTitle: 'Teslimat Siparişleri',
    deliveryOrdersSubtitle: 'Tüm platformlardan gelen siparişler',
    deliveryEmptyTitle: 'Teslimat siparişi bulunamadı',
    deliveryEmptyFiltered: 'Filtreleri değiştirerek tekrar deneyin',
    deliveryEmptyDefault: 'Platform entegrasyonları aktif edildiğinde siparişler burada görünür',
    activeOrders: 'Aktif Siparişler',
    completedCancelled: 'Tamamlanan / İptal',
    paidOnline: 'Online Ödendi',
    payOnDelivery: 'Kapıda Ödeme',
    cancelledByRestaurant: 'Restoran tarafından iptal edildi',
    statusUpdateFailed: 'Durum güncellenemedi.',
    loadFailed: 'Veriler yüklenemedi.',
    filterAll: 'Tümü',
    prevPage: 'Önceki',
    nextPage: 'Sonraki',

    // Users i18n tail (Madde 13)
    role: 'Rol',
    registrationDate: 'Kayıt Tarihi',
    totalUsers: 'Toplam kullanıcı',
    addUser: 'Kullanıcı Ekle',
    editUserTitle: 'Kullanıcı Düzenle',
    newUserTitle: 'Yeni Kullanıcı',
    newPasswordOptional: 'Yeni Şifre (boş bırakılırsa değişmez)',
    userNameEmailRequired: 'Ad ve e-posta zorunludur.',
    invalidEmailAddress: 'Geçerli bir e-posta adresi girin.',
    passwordRequired: 'Şifre zorunludur.',
    passwordMinChars: 'Şifre en az 6 karakter olmalıdır.',
    deleteUserConfirm: 'Bu kullanıcıyı silmek istediğinize emin misiniz?',

    // Tables.js checkout sheet i18n tail (Madde 13)
    discountAndTreat: 'İskonto / İkram',
    amountMode: 'Tutar',
    percentMode: 'Oran',
    treatLabel: 'İkram',
    promoCodeAndVoucher: 'Kampanya Kodu / Hediye Çeki',
    promoCodeShort: 'Kampanya',
    giftVoucher: 'Hediye Çeki',
    removeAction: 'Kaldır',
    balanceLabel: 'Bakiye',
    amountToPay: 'Ödenecek Tutar',
    amountsMatch: 'Tutarlar eşleşiyor',
    remainingLabel: 'Kalan',
    processing: 'İşleniyor...',
    treatCloseBill: 'İkram — Hesabı Kapat',
    takePayment: 'Ödemeyi Al',

    // Payments + Reports i18n tail (Madde 13)
    dailyCashReport: 'Günlük Kasa Raporu',
    transactionCount: 'İşlem Sayısı',
    paymentList: 'Ödeme Listesi',
    paymentTypeCol: 'Ödeme Türü',
    timeCol: 'Saat',
    noPaymentsForDate: 'Bu tarih için ödeme kaydı bulunamadı',
    dateRangeSalesReport: 'Tarih Aralığı Satış Raporu',
    startDate: 'Başlangıç',
    endDate: 'Bitiş',
    runReport: 'Raporla',
    periodTotalRevenue: 'Dönem Toplam Ciro',
    selectDateRange: 'Lütfen başlangıç ve bitiş tarihlerini seçin.',
    reportLoadFailed: 'Rapor verileri yüklenemedi.',
    salesReportLoadFailed: 'Satış raporu yüklenemedi.',
    advancedReports: 'Gelişmiş Raporlar',
    advancedReportsSubtitle: 'Satış analitikleri ve detaylı ciro raporları',
    reportsTabReports: 'Raporlar',
    reportsTabBI: 'BI Dashboard',
    reportsTabDetail: 'Detay Raporlar',
    periodToday: 'Bugün',
    periodThisWeek: 'Bu Hafta',
    periodThisMonth: 'Bu Ay',
    periodCustomDate: 'Özel Tarih',
    reportLoadingMsg: 'Rapor yükleniyor...',
    noDataYet: 'Henüz veri yok',
    selectDateRangeAndRun: 'Tarih aralığı seçip Raporla butonuna tıklayın',
    noDataForPeriod: 'Bu dönem için veri bulunamadı',

    // Tables.js create-order/add-table sheet i18n tail (Madde 13)
    noProductInCategory: 'Bu kategoride ürün yok',
    noteOptionalLabel: 'Not (isteğe bağlı)',
    itemSuffix: 'ürün',
    creating: 'Oluşturuluyor...',
    createOrderBtn: 'Sipariş Oluştur',
    singleTableMode: 'Tek Masa',
    bulkAddMode: 'Toplu Ekle',
    tableNameLabel: 'Masa Adı',
    capacityPeople: 'Kapasite (kişi)',
    categoryFloorZone: 'Kategori (Kat / Bölge)',
    uncategorized: 'Kategorisiz',
    addTableBtn: 'Masa Ekle',
    prefixLabel: 'Ön Ek',
    countLabel: 'Adet',
    maxLabel: 'maks.',
    startNumber: 'Başlangıç Numarası',
    tablesToCreate: 'Oluşturulacak masalar',
    countSuffix: 'adet',
    categoryLabel: 'Kategori',
    invalidPrefixCount: 'Geçerli bir ön ek ve adet (1-50) girin.',

    // Reports.js BI tab + Reports tab tail (Madde 13)
    showBtn: 'Göster',
    biLoadFailed: 'BI dashboard verisi yüklenemedi.',
    dashboardLoadingMsg: 'Dashboard yükleniyor...',
    hourlyOrderDensity: 'Saatlik Sipariş Yoğunluğu',
    noDataForDate: 'Bu tarihte veri yok',
    topSellingItems: 'En Çok Satan Ürünler',
    waiterPerformance: 'Garson Performansı',
    deliveryPlatformSummary: 'Teslimat Platform Özeti',
    platformCol: 'Platform',
    orderShortCol: 'Sipariş',
    revenueCol: 'Ciro',
    cancelledCol: 'İptal',
    orderCountSuffix: 'sipariş',
    orderCountCol: 'Sipariş Sayısı',
    cashCollected: 'Nakit Tahsilat',
    cardCollected: 'Kart Tahsilat',
    totalCollected: 'Toplam Tahsilat',
    paymentTypeBreakdown: 'Ödeme Türü Dağılımı',
    hourlyBreakdown: 'Saatlik Dağılım',
    unknown: 'Bilinmiyor',

    // Reports.js Detail tab i18n tail (Madde 13)
    detailLoadFailed: 'Detay rapor verileri yüklenemedi.',
    categoryBasedSales: 'Kategori Bazlı Satış',
    noDataInRange: 'Bu aralıkta veri yok',
    paymentChannelsTrend: 'Ödeme Kanalları Trendi',
    vatReportTitle: 'KDV Raporu (Vergi Beyanı)',
    vatRate: 'KDV Oranı',
    grossAmount: 'Brüt Tutar',
    vatLabel: 'KDV',
    netAmount: 'Net Tutar',
    stockStatusTitle: 'Stok Durumu',
    criticalStockShort: 'kritik stok',
    noStockRecord: 'Stok kaydı bulunamadı',
    unitCol: 'Birim',
    criticalThreshold: 'Kritik Eşik',
    criticalBadge: 'Kritik',
    normalBadge: 'Normal',

    // Settings.js i18n tail (Madde 13)
    tabGeneral: 'Genel',
    tabInterface: 'Arayüz',
    tabNotifications: 'Bildirimler',
    tabQRMenu: 'QR Menü',
    tabCurrency: 'Para Birimi',
    criticalStockAlertLabel: 'Kritik Stok Uyarısı',
    criticalStockAlertDesc: 'Stok kritik seviyeye düştüğünde bildir',
    recipeStockDeduction: 'Reçete Stok Düşme',
    recipeStockDeductionDesc: 'Sipariş servis edilince reçetedeki malzemeler stoktan düşülür',
    settingsLoadFailed: 'Ayarlar yüklenemedi.',
    currencyUpdated: 'Para birimi güncellendi.',
    updateFailedShort: 'Güncellenemedi.',
    notifsDisabledMsg: 'Bildirimler devre dışı bırakıldı.',
    notifsEnabledMsg: 'Bildirimler etkinleştirildi!',
    vapidNotConfigured: 'VAPID yapılandırılmamış.',
    operationFailed: 'İşlem başarısız.',
    pushTestBody: 'Push bildirim çalışıyor!',
    testNotifSent: 'Test bildirimi gönderildi.',
    testNotifFailed: 'Test gönderilemedi.',
    saveFailedShort: 'Kayıt başarısız.',
    updateCurrencyBtn: 'Para Birimini Güncelle',
    saveSettingsBtn: 'Ayarları Kaydet',
    pushNotSupported: 'Bu tarayıcı push bildirimleri desteklemiyor.',
    pushEnabledDevice: 'Bu cihazda push bildirimleri etkin. Yeni siparişlerde bildirim alırsınız.',
    pushEnableHint: 'Yeni siparişlerde anlık tarayıcı bildirimi almak için etkinleştirin.',

    // Recipes.js i18n tail (Madde 13)
    selectMenuItem: 'Menü Öğesi Seçin',
    selectPlaceholder: 'Seçiniz',
    recipeLabel: 'Reçete',
    addIngredientBtn: 'Malzeme Ekle',
    recipeLoadFailed: 'Reçete yüklenemedi.',
    recipeAddFailed: 'Reçete eklenemedi.',
    portionCalculator: 'Porsiyon Hesabı',
    maxPortions: 'maksimum porsiyon',
    limitingIngredient: 'Kısıtlayan Malzeme',
    portionAfterRecipe: 'Reçete tanımlandıktan sonra hesaplanır',
    addIngredientToRecipe: 'Reçeteye Malzeme Ekle',
    quantityPerPortion: 'Miktar (porsiyon başına)',

    // GiftVouchers.js i18n tail (Madde 13)
    giftVouchersTitle: 'Hediye Çekleri',
    giftVouchersSubtitle: 'Hediye çeki oluşturun ve yönetin',
    newVoucherBtn: 'Yeni Hediye Çeki',
    queryCode: 'Kod Sorgula',
    queryBtn: 'Sorgula',
    validVoucher: 'Geçerli Hediye Çeki',
    remainingBalance: 'Kalan Bakiye',
    invalidCode: 'Geçersiz kod',
    errorOccurred: 'Hata oluştu',
    deleteVoucherConfirm: 'Bu hediye çekini silmek istediğinizden emin misiniz?',
    noVouchersYet: 'Henüz hediye çeki yok',
    createFirstVoucher: 'İlk hediye çekinizi oluşturun',
    printAction: 'Yazdır',
    usedLabel: 'kullanıldı',
    expiredLabel: 'Süresi doldu',
    endsLabel: 'Bitiş',
    customCodeOptional: 'Özel Kod (isteğe bağlı)',
    autoGeneratedPh: 'Otomatik oluşturulur',
    endDateLabel: 'Bitiş Tarihi',
    notesLabel: 'Notlar',
    customMessagePh: 'Özel mesaj...',
    createBtn: 'Oluştur',
    dearLabel: 'Sayın',
    expiresLabel: 'Son Kullanım',

    // PromoCodes.js i18n tail (Madde 13)
    promoCodesTitle: 'Kampanya Kodları',
    promoCodesSubtitle: 'İndirim ve promosyon kodlarını yönetin',
    newCodeBtn: 'Yeni Kod',
    noPromoCodesYet: 'Henüz kampanya kodu yok',
    createFirstPromoCode: 'İlk kampanya kodunuzu oluşturun',
    deletePromoConfirm: 'Bu kampanya kodunu silmek istediğinizden emin misiniz?',
    namelessCampaign: 'İsimsiz kampanya',
    discountSuffix: 'indirim',
    minShortLabel: 'Min',
    usageLabel: 'Kullanım',
    activeStatus: 'Aktif',
    inactiveStatus: 'Pasif',
    setActive: 'Aktif yap',
    setInactive: 'Pasif yap',
    editCodeTitle: 'Kodu Düzenle',
    newPromoCodeTitle: 'Yeni Kampanya Kodu',
    codeLabel: 'Kod',
    campaignName: 'Kampanya Adı',
    summerSalePh: 'Yaz indirimi',
    discountTypeLabel: 'İndirim Tipi',
    percentOption: 'Yüzde (%)',
    fixedAmountOption: 'Sabit Tutar (₺)',
    amountOption: 'Tutar (₺)',
    minOrderLabel: 'Min. Sipariş',
    maxUsageLabel: 'Maks. Kullanım',
    unlimitedPh: 'Sınırsız',
    updateBtn: 'Güncelle',

    // WaiterStats.js i18n tail (Madde 13)
    waiterStatsSubtitle: 'Personel bazında sipariş ve ciro istatistikleri',
    waiterDataLoadFailed: 'Garson verileri yüklenemedi.',
    sortLabel: 'Sırala',
    averageOrder: 'Ortalama Sipariş',
    topPerformance: 'En Yüksek Performans',
    staffList: 'Personel Listesi',
    staffCountSuffix: 'personel',
    dataLoadingMsg: 'Veriler yükleniyor...',
    tryDifferentPeriod: 'Farklı bir dönem seçmeyi deneyin',
    waiterNameCol: 'Garson Adı',
    avgOrderCol: 'Ort. Sipariş',
    lastActivityCol: 'Son Aktivite',

    // Checkout.js i18n tail (Madde 13)
    planInfoMissing: 'Plan bilgisi eksik.',
    planInfoLoadFailed: 'Plan bilgisi yüklenemedi.',
    firstNameRequired: 'Ad zorunludur',
    lastNameRequired: 'Soyad zorunludur',
    phoneRequired: 'Telefon zorunludur',
    phoneInvalid: 'Geçerli bir telefon giriniz',
    cityRequired: 'Şehir zorunludur',
    addressRequired: 'Adres zorunludur',
    paymentFormLoadFailed: 'Ödeme formu yüklenemedi. Lütfen tekrar deneyin.',
    paymentStartFailed: 'Ödeme başlatılamadı. Lütfen tekrar deneyin.',
    securePayment: 'Güvenli Ödeme',
    iyzicoProtected: 'iyzico güvencesiyle korunan ödeme',
    paymentHeader: 'Ödeme',
    enterBillingInfo: 'Faturalama bilgilerinizi girin',
    billingInfoTitle: 'Faturalama Bilgileri',
    firstNameLabel: 'Ad',
    lastNameLabel: 'Soyad',
    cityLabel: 'Şehir',
    addressPh: 'Mahalle, Sokak, Bina No...',
    paymentFormPreparing: 'Ödeme formu hazırlanıyor...',
    proceedToPayment: 'Ödemeye Geç',
    sslEncrypted: 'SSL Şifreli',
    iyzicoSecured: 'iyzico Güvenceli',
    orderSummary: 'Sipariş Özeti',
    yearlyBilling: 'Yıllık faturalama',
    monthlyBilling: 'Aylık faturalama',
    yearShort: 'yıl',
    monthShort: 'ay',
    yearlyBonusHint: 'Yıllık ödeme ile 2 ay ücretsiz kazanıyorsunuz!',
    userSuffix: 'kullanıcı',
    freeTrialDays: '14 gün ücretsiz deneme',
    cancelAnytime: 'İstediğiniz zaman iptal',
    planLabel: 'Plan',

    // Siparişler
    orderPreparing: 'Hazırlanıyor',
    orderReady: 'Hazır',
    orderCancelled: 'İptal',
    tableNo: 'Masa',

    // Kasa
    cash: 'Nakit',
    card: 'Kart',
    online: 'Online',
    discount: 'İndirim',
    tax: 'KDV',
    subtotal: 'Ara Toplam',
    // Teslimat
    delivery_new: 'Yeni',
    delivery_accepted: 'Kabul Edildi',
    delivery_preparing: 'Hazırlanıyor',
    delivery_ready: 'Hazır',
    delivery_delivered: 'Teslim Edildi',
    delivery_cancelled: 'İptal',

    // Şifre Sıfırlama
    newPassword: 'Yeni Şifre',
    // Genel durumlar
    // === Batch i18n merge (agent outputs) ===
    posDisplayThanks: 'Teşekkürler!',
    posDisplayPaymentReceived: 'Ödemeniz alındı, iyi günler dileriz.',
    posDisplayPaymentPending: 'Ödeme Bekleniyor',
    posDisplayWaitForCashier: 'Lütfen kasiyeri bekleyiniz...',
    posDisplayTellCashier: 'Siparişinizi kasiyere bildirin',
    posDisplayCustomerScreen: 'Müşteri Ekranı',
    posDisplayAdAlt: 'Promosyon',
    posDisplayAdHint: 'Yöneticiniz Settings → Fiş Ayarları sayfasından promosyon görsellerini ekleyebilir.',
    posDisplayPerUnit: 'adet',
    posDisplayDiscount: 'İndirim',
    posDisplayVatIncluded: 'KDV (dahil)',
    paymentResultTokenMissing: 'Ödeme token bilgisi bulunamadı.',
    paymentResultFailedGeneric: 'Ödeme işlemi başarısız oldu.',
    paymentResultFetchError: 'Ödeme sonucu alınamadı. Lütfen destek ile iletişime geçin.',
    paymentResultChecking: 'Ödeme Kontrol Ediliyor',
    paymentResultVerifying: 'Lütfen bekleyin, ödemeniz doğrulanıyor...',
    paymentResultSuccess: 'Ödemeniz Başarılı!',
    paymentResultSuccessDesc: 'Aboneliğiniz başarıyla oluşturuldu. Tüm özelliklere erişiminiz açıldı.',
    paymentResultPlan: 'Plan',
    paymentResultBillingCycle: 'Dönem',
    paymentResultYearly: 'Yıllık',
    paymentResultMonthly: 'Aylık',
    paymentResultAmountPaid: 'Ödenen Tutar',
    paymentResultValidUntil: 'Geçerlilik',
    paymentResultTransactionId: 'İşlem No',
    paymentResultGoToDashboard: 'Dashboard\'a Git',
    paymentResultViewSubscription: 'Aboneliğimi Görüntüle',
    paymentResultReceiptSent: 'Ödeme makbuzu e-posta adresinize gönderildi.',
    paymentResultFailed: 'Ödeme Başarısız',
    paymentResultFailedDesc: 'Ödeme işlemi tamamlanamadı.',
    paymentResultRetry: 'Tekrar Dene',
    paymentResultBackToPlans: 'Planlara Dön',
    paymentResultGoHome: 'Ana Sayfaya Git',
    paymentResultSupportPrefix: 'Sorun devam ederse',
    paymentResultSupportSuffix: 'ile iletişime geçin.',
    securityTitle: 'Güvenlik',
    securityProtectAccount: 'hesabınızı koruyun',
    security2FATitle: 'İki Adımlı Doğrulama (TOTP)',
    security2FADescription: 'Authenticator (Google/Authy/1Password) ile ek koruma',
    securityActive: 'Aktif',
    securityInactive: 'Kapalı',
    securityBackupCodes: 'Yedek Kodlar',
    securityShownOnce: 'Bir kez gösterilir',
    securityBackupCodesHint: 'Authenticator\'a erişiminizi kaybederseniz bu kodları kullanın. Güvenli yere kaydedin.',
    securitySavedClose: 'Kaydettim, kapat',
    securityScanQRStep: '1. Authenticator uygulamanızla aşağıdaki QR kodu okutun.',
    securityManualCode: 'Manuel kod',
    securityEnterCodeStep: '2. Uygulamadaki 6 haneli kodu girin:',
    securityVerifying: 'Doğrulanıyor...',
    security2FAEnable: 'Etkinleştir',
    security2FADisable: '2FA Devre Dışı Bırak',
    security2FASetup: '2FA Kur',
    securityPreparing: 'Hazırlanıyor...',
    securityEnterPasswordTOTP: 'Şifrenizi ve TOTP kodunuzu girin.',
    securityTOTPCode: '6 haneli TOTP kodu',
    securitySetupFailed: 'Kurulum başlatılamadı.',
    securityCodeInvalid: 'Kod hatalı.',
    securityDisableFailed: 'Devre dışı bırakılamadı.',
    gdprTitle: 'KVKK / GDPR',
    gdprSubtitle: 'Kişisel veri hakları ve gizlilik yönetimi',
    gdprTabRights: 'KVKK Haklarım',
    gdprTabRequest: 'Talep Gönder',
    gdprTabMyRequests: 'Taleplerim',
    gdprTabAdmin: 'Admin Panel',
    gdprTypeExport: 'Veri Dışa Aktarma',
    gdprTypeDelete: 'Veri Silme (Unutulma Hakkı)',
    gdprTypeRectify: 'Veri Düzeltme',
    gdprTypeRestrict: 'İşlemeyi Kısıtlama',
    gdprTypeObject: 'İşlemeye İtiraz',
    gdprStatusPending: 'Bekliyor',
    gdprStatusProcessing: 'İşleniyor',
    gdprStatusCompleted: 'Tamamlandı',
    gdprStatusRejected: 'Reddedildi',
    gdprStatTotal: 'Toplam İstek',
    gdprStatPending: 'Bekleyen',
    gdprStatCompleted: 'Tamamlanan',
    gdprStatRejected: 'Reddedilen',
    gdprRightsHeading: '6698 Sayılı KVKK Kapsamındaki Haklarınız',
    gdprRightsIntro: 'Kişisel Verilerin Korunması Kanunu (KVKK) ve Avrupa Genel Veri Koruma Tüzüğü (GDPR) kapsamında aşağıdaki haklara sahipsiniz:',
    gdprRightInfoTitle: 'Bilgi Edinme Hakkı',
    gdprRightInfoDesc: 'Kişisel verilerinizin işlenip işlenmediğini öğrenme hakkına sahipsiniz.',
    gdprRightPortabilityTitle: 'Veri Portabilitesi',
    gdprRightPortabilityDesc: 'İşlenen kişisel verilerinizin yapılandırılmış ve makine okunabilir formatta tarafınıza verilmesini talep edebilirsiniz.',
    gdprRightRectifyTitle: 'Düzeltme Hakkı',
    gdprRightRectifyDesc: 'Yanlış veya eksik kişisel verilerinizin düzeltilmesini talep edebilirsiniz.',
    gdprRightDeleteTitle: 'Silinme / Unutulma Hakkı',
    gdprRightDeleteDesc: 'Kişisel verilerinizin silinmesini veya yok edilmesini talep edebilirsiniz.',
    gdprRightObjectTitle: 'İşlemeye İtiraz',
    gdprRightObjectDesc: 'Kişisel verilerinizin işlenmesine itiraz edebilirsiniz.',
    gdprRightRestrictTitle: 'İşlemeyi Kısıtlama',
    gdprRightRestrictDesc: 'Belirli koşullarda kişisel verilerinizin işlenmesinin kısıtlanmasını talep edebilirsiniz.',
    gdprDataController: 'Veri Sorumlusu',
    gdprControllerInfo: 'RestaFlex — Talepleriniz en geç 30 gün içinde yanıtlanır. Sorularınız için:',
    gdprCreateRequest: 'Talep Oluştur',
    gdprNewRequest: 'Yeni KVKK Talebi',
    gdprRequestType: 'Talep Türü',
    gdprDescriptionOptional: 'Açıklama (opsiyonel)',
    gdprDescriptionPlaceholder: 'Talebinizle ilgili ek bilgi...',
    gdprSubmitting: 'Gönderiliyor...',
    gdprSubmitRequest: 'Talep Gönder',
    gdprDownloadNow: 'Verilerinizi hemen indirmek ister misiniz?',
    gdprDownloadPackage: 'Veri paketimi indir (JSON)',
    gdprNoRequests: 'Henüz gönderdiğiniz bir talep yok.',
    gdprResponse: 'Yanıt',
    gdprTotalConsent: 'Toplam Rıza',
    gdprAnalyticsAccepted: 'Analitik Kabul',
    gdprAnalyticsRejected: 'Analitik Red',
    gdprMarketingAccepted: 'Pazarlama Kabul',
    gdprAllStatuses: 'Tüm Durumlar',
    gdprAllTypes: 'Tüm Türler',
    gdprFilter: 'Filtrele',
    gdprNoRequestsFound: 'Talep bulunamadı.',
    gdprProcess: 'İşle',
    gdprProcessRequest: 'Talebi İşle',
    gdprStatus: 'Durum',
    gdprResponseNote: 'Yanıt Notu',
    gdprResponsePlaceholder: 'Kullanıcıya iletilecek yanıt...',
    gdprExportFailed: 'Veri dışa aktarılamadı.',
    pricingTrialBadge: '14 Gün Ücretsiz Dene — Kredi Kartı Gerekmez',
    pricingTitleLine1: 'Restoranınız İçin',
    pricingTitleHighlight: 'Doğru Planı',
    pricingTitleLine2: 'Seçin',
    pricingSubtitle: 'RestaFlex ile masalarınızı, siparişlerinizi ve mutfağınızı tek platformdan kolayca yönetin.',
    pricingMonthly: 'Aylık',
    pricingYearly: 'Yıllık',
    pricingTwoMonthsFree: '2 AY ÜCRETSİZ',
    pricingPlansLoadError: 'Planlar yüklenemedi.',
    pricingNoPlansFound: 'Plan bulunamadı. Lütfen daha sonra tekrar deneyin.',
    pricingMostPopular: 'EN POPÜLER',
    pricingYearlySavingsPrefix: 'Yıllık',
    pricingYearlySavingsSuffix: 'tasarruf!',
    pricingTablesSuffix: 'masa',
    pricingStartFreeTrial: '14 Gün Ücretsiz Dene',
    pricingComparisonTitle: 'Özellik Karşılaştırması',
    pricingComparisonSubtitle: 'Hangi plan size uygun? Karşılaştırın ve karar verin.',
    pricingFeatureColumn: 'Özellik',
    pricingPriceMonthly: 'Fiyat (Aylık)',
    pricingMaxTables: 'Maks. Masa',
    pricingMaxUsers: 'Maks. Kullanıcı',
    pricingFeatureQrMenu: 'QR Menü',
    pricingFeatureTableManagement: 'Masa Yönetimi',
    pricingFeatureOrderManagement: 'Sipariş Yönetimi',
    pricingFeatureKitchenDisplay: 'Mutfak Ekranı',
    pricingFeaturePaymentSystem: 'Ödeme Sistemi',
    pricingFeatureStockManagement: 'Stok Yönetimi',
    pricingFeatureRecipeSystem: 'Reçete Sistemi',
    pricingFeatureWaiterManagement: 'Garson Yönetimi',
    pricingFeatureAdvancedAnalytics: 'Gelişmiş Analitik',
    pricingFeatureApiAccess: 'API Erişimi',
    pricingFaqTitle: 'Sıkça Sorulan Sorular',
    pricingFaqSubtitle: 'Aklınızdaki soruların cevapları burada.',
    pricingFaq1Q: 'Deneme süresi bitince ne olur?',
    pricingFaq1A: '14 günlük ücretsiz deneme süreniz bittiğinde hesabınız askıya alınır. Verileriniz silinmez, bir plan seçerek kaldığınız yerden devam edebilirsiniz.',
    pricingFaq2Q: 'İstediğim zaman iptal edebilir miyim?',
    pricingFaq2A: 'Evet, aboneliğinizi istediğiniz zaman iptal edebilirsiniz. İptal ettiğinizde mevcut dönem sonuna kadar hizmet almaya devam edersiniz, bir sonraki dönem için ücret alınmaz.',
    pricingFaq3Q: 'Plan değişikliği yapabilir miyim?',
    pricingFaq3A: 'Evet, istediğiniz zaman planınızı yükseltebilir veya düşürebilirsiniz. Yükseltme anında geçerli olur, düşürme ise mevcut dönem sonunda uygulanır.',
    pricingFaq4Q: 'Ödeme güvenli mi?',
    pricingFaq4A: 'Tüm ödemeler iyzico altyapısı üzerinden 256-bit SSL şifrelemesiyle güvenli şekilde işlenir. Kart bilgileriniz sistemimizde saklanmaz.',
    pricingCtaTitle: 'Hemen Başlayın',
    pricingCtaSubtitle: '14 gün boyunca tüm özellikleri ücretsiz kullanın. Kredi kartı gerekmez.',
    pricingCtaTryFree: 'Ücretsiz Deneyin',
    pricingCtaChoosePlan: 'Planımı Seç',
    webhooksTitle: 'Webhook Entegrasyonları',
    webhooksSubtitle: 'Zapier, Make.com veya özel sistemlerinizi gerçek zamanlı olaylarla entegre edin.',
    webhookNewButton: '+ Yeni Webhook',
    webhookNewTitle: 'Yeni Webhook Ekle',
    webhookEditTitle: 'Webhook Düzenle',
    webhookHintZapier: 'Trigger URL\'yi buraya yapıştırın',
    webhookHintMake: 'Custom Webhook modülü URL\'si',
    webhookHintN8n: 'Webhook node trigger URL\'si',
    webhookHintCustomLabel: 'Özel sistem',
    webhookHintCustomDesc: 'Herhangi bir HTTPS endpoint',
    webhookStatTotal: 'Toplam Webhook',
    webhookStatFailing: 'Hatalı',
    webhookEmptyTitle: 'Henüz webhook yok',
    webhookEmptyDesc: 'Zapier veya Make.com ile entegrasyon için bir webhook ekleyin.',
    webhookErrorsLabel: 'hata',
    webhookErrorLabel: 'Hata',
    webhookLastTriggered: 'Son tetiklenme',
    webhookTestSend: 'Test',
    webhookTestSent: 'Test webhook gönderildi.',
    webhookTestFailed: 'Test gönderilemedi.',
    webhookDeliveryHistory: 'Teslim Geçmişi',
    webhookNoDeliveries: 'Henüz teslimat kaydı yok.',
    webhookDeleteConfirm: 'Bu webhook silinsin mi?',
    webhookUpdateFailed: 'Güncellenemedi.',
    webhookNameRequired: 'İsim zorunludur.',
    webhookUrlRequired: 'URL zorunludur.',
    webhookEventRequired: 'En az bir event seçin.',
    webhookUrlInvalid: 'Geçerli bir URL girin.',
    webhookNameLabel: 'İsim',
    webhookNamePlaceholder: 'Örn: Zapier Sipariş Bildirimi',
    webhookEndpointLabel: 'Webhook URL',
    webhookHttpsRecommended: '(HTTPS önerilir)',
    webhookEventsLabel: 'Olaylar (Events)',
    webhookSecretLabel: 'İmza Sırrı (Secret)',
    webhookSecretHint: '— opsiyonel, boş bırakılırsa otomatik üretilir',
    webhookSecretPlaceholder: 'Kendi belirlediğiniz secret veya boş bırakın',
    webhookSecurityLabel: 'Güvenlik',
    webhookSecurityPart1: 'Her istek imzalanır ve',
    webhookSecurityPart2: 'başlığı ile gönderilir.',
    webhookSecurityPart3: 'Zapier\'de Custom Request içinde bu başlığı doğrulayabilirsiniz.',
    webhookSaving: 'Kaydediliyor…',
    webhookEventOrderCreated: 'Sipariş Oluşturuldu',
    webhookEventOrderStatusChanged: 'Sipariş Durumu Değişti',
    webhookEventPaymentCompleted: 'Ödeme Tamamlandı',
    webhookEventReservationCreated: 'Rezervasyon Oluşturuldu',
    webhookEventReservationStatusChanged: 'Rezervasyon Durumu Değişti',
    webhookEventCustomerCreated: 'Yeni Müşteri Kaydı',
    webhookEventDeliveryOrderCreated: 'Teslimat Siparişi Geldi',
    webhookEventDeliveryOrderStatusChanged: 'Teslimat Durumu Değişti',
    subscriptionStatusTrial: 'Deneme',
    subscriptionStatusCancelled: 'İptal Edildi',
    subscriptionStatusExpired: 'Süresi Doldu',
    subscriptionStatusPastDue: 'Gecikmiş',
    subscriptionLoadError: 'Veriler yüklenemedi.',
    subscriptionCancelSuccess: 'Aboneliğiniz iptal edildi. Mevcut dönem sonuna kadar hizmet almaya devam edeceksiniz.',
    subscriptionCancelError: 'İptal işlemi başarısız oldu.',
    subscriptionTitle: 'Aboneliğim',
    subscriptionSubtitle: 'Abonelik durumunuzu yönetin ve planınızı güncelleyin.',
    subscriptionWord: 'abonelik',
    subscriptionTrialPeriod: 'Deneme Süresi',
    subscriptionTrialEnd: 'Deneme Bitiş',
    subscriptionNextPayment: 'Sonraki Ödeme',
    subscriptionDaysRemaining: 'Kalan Gün',
    subscriptionDaysUnit: 'gün',
    subscriptionEnded: 'Sona erdi',
    subscriptionTimeUsage: 'Süre kullanımı',
    subscriptionDaysLeft: 'gün kaldı',
    subscriptionNoActive: 'Aktif aboneliğiniz yok',
    subscriptionNeedPlan: 'Sistemi kullanmak için bir plan seçmeniz gerekiyor.',
    subscriptionChoosePlan: 'Plan Seç',
    subscriptionChangePlan: 'Planı Değiştir',
    subscriptionCurrentPlan: 'Mevcut Plan',
    subscriptionMaxTables: 'Maks.',
    subscriptionTablesUnit: 'masa',
    subscriptionMaxUsers: 'Maks.',
    subscriptionUsersUnit: 'kullanıcı',
    subscriptionUpgradeBtn: 'Yükselt',
    subscriptionDowngradeBtn: 'Düşür',
    subscriptionStartBtn: 'Başla',
    subscriptionActivePlan: 'Aktif Plan',
    subscriptionPaymentHistory: 'Ödeme Geçmişi',
    subscriptionDateCol: 'Tarih',
    subscriptionPeriodCol: 'Dönem',
    subscriptionPaymentSuccess: 'Başarılı',
    subscriptionPaymentFailed: 'Başarısız',
    subscriptionCancelTitle: 'Aboneliği İptal Et',
    subscriptionCancelInfo: 'Aboneliğinizi iptal ederseniz, mevcut dönem sonuna kadar hizmet almaya devam edersiniz. İptal işlemi geri alınamaz.',
    subscriptionCancelInfoTrial: 'Deneme aboneliğiniz hemen sona erecek ve tüm özelliklere erişiminiz kesilecektir.',
    subscriptionCancelConfirm: 'Aboneliğiniz dönem sonunda iptal edilecek.',
    subscriptionCancelConfirmTrial: 'Deneme aboneliğiniz hemen iptal edilecektir. Emin misiniz?',
    subscriptionCancelAccessUntil: 'Erişiminiz {date} tarihine kadar aktif.',
    subscriptionCancelScheduled: 'Aboneliğiniz dönem sonunda iptal edilecek',
    subscriptionAccessUntil: 'Erişiminiz şu tarihe kadar aktif:',
    subscriptionCancelling: 'İptal ediliyor...',
    subscriptionCancelYes: 'Evet, İptal Et',
    printersTitle: 'Yazıcılar',
    printersSubtitle: 'Fiş, mutfak ve barkod yazıcılarını yönetin',
    printerAddBtn: 'Yazıcı Ekle',
    printerAddFirstBtn: 'İlk Yazıcıyı Ekle',
    printerAddTitle: 'Yazıcı Ekle',
    printerEditTitle: 'Yazıcıyı Düzenle',
    printerEmptyTitle: 'Henüz yazıcı eklenmemiş',
    printerEmptySubtitle: 'Yazıcı ekleyerek fişlerinizi yönetin',
    printerJobsTab: 'Print Kuyruğu',
    printerJobQueueTitle: 'Print Job Kuyruğu',
    printerNoJobs: 'Kuyrukta iş yok',
    printerDefault: 'Varsayılan',
    printerTypeReceipt: 'Kasa Fişi',
    printerTypeKitchen: 'Mutfak',
    printerTypeBar: 'Bar',
    printerConnectionNetwork: 'Ağ (IP)',
    printerConnectionUsb: 'USB',
    printerConnectionSerial: 'Seri Port',
    printerConnectionLabel: 'Bağlantı',
    printerAddressLabel: 'Adres',
    printerPortLabel: 'Port',
    printerComPortLabel: 'COM Port',
    printerPaperWidthLabel: 'Kağıt Genişliği',
    printerNameLabel: 'Yazıcı Adı',
    printerNamePlaceholder: 'örn. Kasa Yazıcısı',
    printerTypeLabel: 'Tür',
    printerIpLabel: 'IP Adresi',
    printerNameRequired: 'Yazıcı adı zorunlu.',
    printerIpRequired: 'IP adresi zorunlu.',
    printerComPortRequired: 'COM port zorunlu.',
    printerDeleteConfirm: 'Bu yazıcıyı silmek istediğinize emin misiniz?',
    printerRetryFailed: 'Yeniden denenemedi.',
    printerOnline: 'Çevrimiçi',
    printerOffline: 'Çevrimdışı',
    printerTestSent: 'Test sayfası gönderildi',
    printerTestFailed: 'Test başarısız',
    printerStatusBtn: 'Durum',
    printerTestBtn: 'Test Et',
    printerRetryBtn: 'Tekrar Dene',
    printerLabel: 'Yazıcı',
    printerAttempt: 'deneme',
    printerJobStatusPending: 'Bekliyor',
    printerJobStatusPrinting: 'Yazdırılıyor',
    printerJobStatusDone: 'Tamamlandı',
    printerJobStatusFailed: 'Hata',
    printerStatTotal: 'Toplam Yazıcı',
    printerStatActive: 'Aktif',
    printerStatInactive: 'Pasif',
    printerStatPending: 'Bekleyen İş',
    printerIsDefaultTitle: 'Varsayılan Yazıcı',
    printerIsDefaultHint: 'Bu türdeki işlemlerde otomatik seçilir',
    printerIsActiveHint: 'Pasif yazıcılara iş gönderilmez',
    whiteLabelTitle: 'White-label Yönetimi',
    whiteLabelSubtitle: 'İş ortakları için özel marka konfigürasyonları',
    whiteLabelNewConfig: 'Yeni Config',
    whiteLabelNewConfigTitle: 'Yeni White-label Config',
    whiteLabelEditConfig: 'Config Düzenle',
    whiteLabelStatTotal: 'Toplam Config',
    whiteLabelStatActive: 'Aktif',
    whiteLabelStatPassive: 'Pasif',
    whiteLabelStatusActive: 'Aktif',
    whiteLabelStatusPassive: 'Pasif',
    whiteLabelEmptyTitle: 'Henüz white-label config yok',
    whiteLabelEmptyDesc: 'İş ortakları için özel markalar oluşturun',
    whiteLabelRestaurantsSuffix: 'restoran',
    whiteLabelDetailTitle: 'Detay',
    whiteLabelSlug: 'Slug',
    whiteLabelDomain: 'Domain',
    whiteLabelSupportEmail: 'Destek E-posta',
    whiteLabelSupportPhone: 'Destek Telefon',
    whiteLabelBrandingUrl: 'Branding URL',
    whiteLabelLinkedRestaurants: 'Bağlı Restoranlar',
    whiteLabelNoRestaurants: 'Henüz restoran atanmadı.',
    whiteLabelUnassignTitle: 'Atamayı kaldır',
    whiteLabelPartnerName: 'Partner Adı',
    whiteLabelPartnerNamePlaceholder: 'Örn: Acme Restaurant Solutions',
    whiteLabelAppName: 'Uygulama Adı',
    whiteLabelLogoUrl: 'Logo URL',
    whiteLabelPrimaryColor: 'Ana Renk',
    whiteLabelSecondaryColor: 'İkincil Renk',
    whiteLabelTextColor: 'Metin Rengi',
    whiteLabelBgColor: 'Arkaplan Rengi',
    whiteLabelCustomDomain: 'Özel Domain',
    whiteLabelFooterText: 'Alt Bilgi Metni',
    whiteLabelFooterPlaceholder: '© 2026 Partner Adı. Tüm hakları saklıdır.',
    whiteLabelCustomCss: 'Özel CSS',
    whiteLabelHidePoweredBy: '"Powered by RestaFlex" gizle',
    whiteLabelPreview: 'Önizleme',
    whiteLabelSaving: 'Kaydediliyor...',
    whiteLabelNameSlugRequired: 'Ad ve slug zorunludur.',
    whiteLabelSlugPattern: 'Slug yalnızca küçük harf, rakam ve tire içerebilir.',
    whiteLabelDeleteConfirm: 'Bu white-label config silinecek. Bağlı restoranların ataması kaldırılacak. Devam?',
    whiteLabelLoadError: 'Veriler yüklenemedi.',
    whiteLabelDetailError: 'Detay yüklenemedi.',
    whiteLabelDeleteError: 'Silme hatası.',
    whiteLabelUpdateError: 'Güncelleme hatası.',
    whiteLabelUnassignError: 'Atama kaldırma hatası.',
    qrmenuWaiterCalled: 'Garson çağrıldı! Kısa süre içinde masanıza gelinecektir.',
    qrmenuWaiterCallFailed: 'Çağrı gönderilemedi. Tekrar deneyin.',
    qrmenuLoadFailed: 'Menü yüklenemedi.',
    qrmenuPaymentVerifyFailed: 'Ödeme doğrulanamadı. Lütfen restoranla iletişime geçin.',
    qrmenuDefaultTitle: 'Restoran Menüsü',
    qrmenuEnterName: 'Lütfen adınızı girin.',
    qrmenuRestaurantNotFound: 'Restoran bilgisi bulunamadı. QR kodu tekrar okutun.',
    qrmenuOrderFailed: 'Sipariş gönderilemedi. Tekrar deneyin.',
    // QR Menü tema sistemi (Faz B+E1)
    qrThemeTitle: 'Tema',
    qrThemeDesc: '44 hazır tema arasından seçin. Her tema font, renk ve düzen içerir.',
    qrThemeAllCats: 'Tümü',
    qrThemeSearchPh: 'Tema ara (isim, font, layout...)',
    qrThemeNoMatch: 'Eşleşen tema bulunamadı.',
    qrThemeDarkOnly: 'Sadece Dark',
    qrThemeRandom: 'Rastgele',
    qrThemeFav: 'Favoriye ekle',
    qrThemeUnfav: 'Favoriden çıkar',
    qrThemeFavoritesOnly: 'Favoriler',
    qrThemeClearFilters: 'Filtreleri Temizle',
    qrThemeRecent: 'Son Kullanılan',
    qrThemeCategoryFilter: 'Tema kategorisi filtresi',
    qrThemeLivePreview: 'Canlı Önizle',
    qrThemeCatClassic: 'Klasik',
    qrThemeCatCafe: 'Kafe',
    qrThemeCatFastFood: 'Fast Food',
    qrThemeCatModern: 'Modern',
    qrThemeCatTropical: 'Tropikal',
    qrThemeCatBakery: 'Pastane',
    qrThemeCatPub: 'Pub/Bar',
    qrThemeCatEthnic: 'Etnik / Mutfak',
    qrThemeCatCorporate: 'Kurumsal',
    qrCustomOverrideTitle: 'Tema Renk Override (Opsiyonel)',
    qrCustomOverrideDesc: 'Seçili temanın renklerini override eder. Boş bırakırsanız temadan gelen renkler kullanılır.',
    qrCustomPrimary: 'Birincil Renk',
    qrCustomSecondary: 'İkincil Renk',
    qrCustomFont: 'Yazı Tipi Override',
    qrCustomFontTheme: 'Temadan',
    qrThemeSampleItem: 'Örnek Ürün',
    qrThemePreviewItem: 'Latte',
    qrThemeSampleDesc: 'kısa açıklama',
    qrThemeDarkLabel: 'Karanlık tema',
    qrThemeDarkShort: 'Karanlık',
    qrVariantPreviewLabel: 'stili önizleme',
    qrLayoutPrefix: 'Layout',
    qrPublicUrlTitle: 'Public Menü Adresi',
    qrPublicUrlDesc: 'Müşterilerin tarayarak ulaşacağı public menü URL\'si',
    qrScanForMenu: 'Menüyü görmek için QR kodu tarayın',
    printQr: 'QR Kodu Yazdır',
    popupBlocked: 'Popup engellendi. Lütfen popup\'lara izin verin.',
    downloadFailed: 'İndirme başarısız.',
    downloadSvg: 'SVG indir',
    linkCopied: 'Bağlantı kopyalandı',
    copyFailed: 'Kopyalanamadı',
    copy: 'Kopyala',
    qrLogoTitle: 'Restoran Logosu',
    qrLogoDesc: 'QR menü üst kısmında görünecek logo (PNG/JPG/WEBP, max 2MB)',
    qrLogoUploadBtn: 'Logo Yükle',
    qrLogoUpload: 'Logo Yükle',
    qrLogoUploaded: 'Logo yüklendi.',
    qrLogoRemove: 'Logoyu Kaldır',
    qrLogoSize: 'Logo Boyutu',
    qrLogoMaxSize: 'Maks. dosya boyutu: 2MB',
    qrThemeCategory: 'Tema Kategorisi',
    qrThemeSearch: 'Tema Ara',
    qrThemeNotFound: 'Tema bulunamadı',
    qrThemeReset: 'Temayı Sıfırla',
    qrDisplayTitle: 'Görünüm & Davranış',
    qrDisplayDesc: 'Müşterinin QR menüde göreceği detayları yönetin',
    qrLayoutLabel: 'Düzen',
    qrLayoutGrid: 'Izgara',
    qrLayoutList: 'Liste',
    qrLayoutMagazine: 'Dergi',
    qrShowImages: 'Ürün görsellerini göster',
    qrShowDescriptions: 'Ürün açıklamalarını göster',
    qrShowPrices: 'Fiyatları göster',
    qrShowAllergens: 'Alerjen bilgilerini göster',
    qrShowCalories: 'Kalori bilgilerini göster',
    qrActiveTheme: 'Aktif Tema',
    qrCartDisabledHint: 'QR sepet özelliği kapalı — müşteri sadece menüyü görüntüleyebilecek, sipariş veremeyecek.',
    qrCartDisabledInfo: 'Bu restoran QR sipariş kabul etmiyor, lütfen garson çağırın.',
    qrCartEmpty: 'Sepetiniz boş — menüden ürün ekleyin',
    qrEnableCart: 'Sepet & sipariş (QR) özelliği',
    qrEnableWaiterCall: 'Garson çağırma butonu',
    qrWelcomeMsg: 'Karşılama Mesajı',
    qrWelcomeMsgPh: 'Hoş geldiniz, lezzetli bir tercih yapmanızı dileriz!',
    qrCartSendToWaiter: 'QR ile Garsona Gönder',
    qrCartTitle: 'Siparişiniz Hazır',
    qrCartSubtitle: 'Garsona bu QR\'ı gösterin',
    qrCartGenerating: 'QR kodu oluşturuluyor...',
    qrCartGenFail: 'QR oluşturulamadı.',
    qrCartTotal: 'Toplam',
    qrCartInstruction: 'Garsonu çağırın ve bu QR kodunu okutmasını isteyin. Sipariş otomatik olarak sisteme düşecek.',
    qrCartRegenerate: 'Süre Doldu — Yeni QR Üret',
    qrCartClaimed: 'Siparişiniz Alındı!',
    qrCartClaimedSub: 'Hazırlanıyor, kısa süre içinde size ulaşacak.',
    qrCartOrderNo: 'Sipariş No',
    qrCartRejectedTitle: 'Sepet Reddedildi',
    qrCartRejectedSub: 'Garson sepetinizi onaylayamadı. Lütfen sepetinizi gözden geçirip tekrar deneyin veya garsonla iletişime geçin.',
    qrCartTryAgain: 'Tekrar Dene',
    qrCartZoom: 'QR\'ı büyüt',
    zoomImage: 'Görseli büyüt',
    qrCartZoomHint: 'Kapatmak için dokunun',
    qrCartShare: 'QR\'ı Paylaş',
    qrCartShareTitle: 'Sipariş QR Kodu',
    qrCartShareText: 'Garsona göstereceğim sipariş kodu',
    qrCartAutoClose: 'Otomatik kapanıyor…',
    qrCartCloseNow: 'Şimdi Kapat',
    qrCartRetrying: 'Tekrar deniyor',
    confirmRemoveImage: 'Bu ürünün görselini silmek istediğinize emin misiniz?',
    qrPending: 'bekleyen QR',
    qrPendingCartsTitle: 'Bekleyen QR Sepetler',
    qrPendingCartsSub: 'müşteri sipariş bekliyor — incelemek için tıkla',
    qrPendingCartsSub2: 'sepet onayınızı bekliyor',
    qrNoPendingCarts: 'Bekleyen sepet yok',
    qrCartClaimFail: 'Sepet alınamadı.',
    qrAcceptToOrder: 'Siparişe Çevir',
    qrCartPickTable: 'Masa Seç',
    qrCartPickTableHint: 'Bu sepeti hangi masaya işliyorsunuz?',
    qrCartNoTables: 'Masa bulunamadı.',
    tableOccupied: 'Dolu',
    qrCartReject: 'Reddet',
    qrCartCallCustomer: 'Müşteriyi Ara',
    qrCartRejectConfirm: 'Bu QR sepeti reddetmek istediğinize emin misiniz?',
    qrCartRejectReason: 'Garson reddetti',
    qrCartRejectFail: 'Sepet reddedilemedi.',
    qrCartRejected: 'Sepet reddedildi',
    qrCartBulkClaim: 'Hepsini Onayla',
    qrCartBulkClaimConfirm: 'Tüm bekleyen sepetleri onaylayıp siparişe çevirmek istiyor musunuz?',
    qrCartBulkOk: 'sepet siparişe çevrildi',
    qrCartBulkFail: 'başarısız',
    qrCartBulkReject: 'Hepsini Reddet',
    qrCartBulkRejectConfirm: 'Tüm bekleyen sepetleri reddetmek istiyor musunuz? Bu işlem geri alınamaz.',
    qrCartBulkRejectOk: 'sepet reddedildi',
    sortBy: 'Sırala',
    sortNewestFirst: 'En yeni',
    sortOldestFirst: 'En eski',
    sortTotalDesc: 'Yüksek tutar',
    qrPendingSearchPh: 'Müşteri, telefon, masa veya token ara…',
    qrPendingNoMatch: 'Eşleşen sepet yok',
    qrPendingEmptyHint: 'Müşteriler QR menüden sipariş gönderince burada görünecek',
    orderSourceQrOnline: 'QR Sipariş',
    orderStatQrToday: 'QR Bugün',
    soundMute: 'Sesi Kapat',
    soundUnmute: 'Sesi Aç',
    retry: 'Tekrar Dene',
    qrMinOrder: 'Minimum Sipariş Tutarı',
    qrMinOrderHint: '0 ise minimum yok. QR sepet üzerinden bu tutarın altındaki siparişler kabul edilmez.',
    qrMinOrderWarn: 'Minimum sipariş',
    qrMinOrderMissing: 'Kalan',
    qrMinOrderMet: 'Minimum sipariş karşılandı',
    clearCartBtn: 'Sepeti Temizle',
    clearCartConfirm: 'Sepeti boşaltmak istediğinize emin misiniz?',
    qrResetSettings: 'QR Menü Ayarlarını Sıfırla',
    qrResetConfirm: 'QR menü ayarlarını varsayılana sıfırlamak istiyor musunuz? Bu işlem yapılan tüm tema/logo/layout/kart ayarlarını siler.',
    qrResetDone: 'Varsayılana sıfırlandı. Kaydet butonuna basın.',
    qrExportConfig: 'Tema Ayarlarını JSON Olarak İndir',
    qrExportConfigError: 'Dışa aktarma başarısız',
    qrImportConfig: 'Tema Ayarlarını JSON\'dan Yükle',
    qrImportConfigOk: 'Ayarlar yüklendi. Kaydet butonuna basın.',
    qrImportConfigError: 'JSON okunamadı veya geçersiz.',
    viewDetails: 'Detayı göster',
    hideDetails: 'Detayı gizle',
    tap: 'dokun',
    torchOn: 'Fener Aç',
    torchOff: 'Fener Kapat',
    flipCamera: 'Kamerayı Çevir',
    pickImageSourcePrompt: 'Görseli nereden seçmek istersiniz?',
    camera: 'Kamera',
    gallery: 'Galeri',
    cameraPermDenied: 'Kamera izni reddedildi',
    viewPendingCarts: 'Bekleyenleri Gör',
    scan: 'Tara',
    // Mobile scan ekranı
    scanQrTitle: 'QR Sipariş Tara',
    scanQrHint: 'Müşterinin telefonundaki QR kodu çerçeve içine alın',
    scanQrFetching: 'Sepet alınıyor...',
    scanQrInvalidPayload: 'Geçersiz QR kodu.',
    scanQrExpired: 'Sepetin süresi dolmuş.',
    scanQrAlreadyClaimed: 'Sepet zaten alınmış.',
    scanQrNotFound: 'Sepet bulunamadı.',
    scanQrFetchFail: 'Sepet alınamadı.',
    scanQrCartReady: 'Sepet Hazır',
    scanQrCustomer: 'Müşteri',
    scanQrNote: 'Müşteri Notu',
    scanQrTotal: 'Toplam',
    scanQrReject: 'Vazgeç',
    scanQrAccept: 'Siparişi Aç',
    scanQrSuccess: 'Sipariş alındı!',
    scanQrOrderNo: 'Sipariş No',
    scanQrViewOrder: 'Siparişi Gör',
    scanQrScanMore: 'Yeni Tarama',
    cameraPermNeeded: 'Kamera izni gerekli',
    cameraPermDesc: 'QR kod taramak için kameraya erişim izni vermelisiniz.',
    grantPermission: 'İzin Ver',
    // Görsel yükleme
    menuMgmtUploadImage: 'Görsel Yükle',
    menuMgmtChangeImage: 'Görseli Değiştir',
    menuMgmtRemoveImage: 'Görseli Kaldır',
    menuSearchPh: 'Ürün veya açıklama ara…',
    menuNoMatch: 'Eşleşen ürün yok',
    menuMgmtImageHint: 'JPEG/PNG/WEBP/GIF, max 2MB',
    menuMgmtDropHere: 'Buraya bırakın',
    menuMgmtDragOrClick: 'Sürükleyin veya tıklayın',
    uploading: 'Yükleniyor…',
    invalidFileType: 'Sadece görsel dosyaları kabul edilir.',
    fileTooLarge: 'Dosya 2MB üstünde olamaz.',
    uploadFailed: 'Yükleme başarısız.',
    productImage: 'Ürün Görseli',
    pickImage: 'Görsel Seç',
    changeImage: 'Görseli Değiştir',
    imageUploaded: 'Görsel yüklendi',
    imageRemoved: 'Görsel kaldırıldı',
    removeFailed: 'Kaldırma başarısız',
    cameraRollPermDenied: 'Galeri izni reddedildi',
    qrmenuOrderReceived: 'Sipariş Alındı!',
    qrmenuOrderSentToKitchen: 'Siparişiniz mutfağa iletildi. Kısa süre içinde hazırlanacak.',
    qrmenuApproxReadyIn: 'Yaklaşık',
    qrmenuMinutes: 'dk içinde hazır',
    qrmenuOrderNo: 'Sipariş No',
    qrmenuBackToMenu: 'Menüye Dön',
    qrmenuSecurePayment: 'Güvenli Ödeme',
    qrmenuPlaceOrder: 'Sipariş Ver',
    qrmenuYourCart: 'Sepetiniz',
    qrmenuYourInfo: 'Bilgileriniz',
    qrmenuFullNameLabel: 'Ad Soyad *',
    qrmenuFullNamePlaceholder: 'Adınız Soyadınız',
    qrmenuPhoneLabel: 'Telefon (opsiyonel)',
    qrmenuEmailLabel: 'E-posta (adisyon için)',
    qrmenuNoteLabel: 'Not (opsiyonel)',
    qrmenuNotePlaceholder: 'Allerji, özel istek...',
    qrmenuPaymentMethod: 'Ödeme Yöntemi',
    qrmenuPayCash: 'Nakit (Masada Öde)',
    qrmenuPayCardTable: 'Kart (Masada Öde)',
    qrmenuPayOnline: 'Online Ödeme (Şimdi Öde)',
    qrmenuSelected: 'Seçildi',
    qrmenuSending: 'Gönderiliyor...',
    qrmenuGoToPayment: 'Ödemeye Geç',
    qrmenuDigitalMenu: 'Dijital Menü',
    qrmenuAll: 'Tümü',
    qrmenuAllergenFilter: 'Alerjen Filtresi',
    qrmenuAllergenFilterHint: 'İçermesini istemediğiniz alerjenleri seçin:',
    // ── 14 Zorunlu Alerjen (label + desc) — TR ──
    allergenGlutenLabel: 'Gluten',
    allergenGlutenDesc: 'Buğday, arpa, yulaf ve türevleri',
    allergenCrustaceansLabel: 'Kabuklular',
    allergenCrustaceansDesc: 'Karides, yengeç, ıstakoz ve türevleri',
    allergenEggsLabel: 'Yumurta',
    allergenEggsDesc: 'Yumurta ve yumurta ürünleri',
    allergenFishLabel: 'Balık',
    allergenFishDesc: 'Balık ve balık ürünleri',
    allergenPeanutsLabel: 'Yer Fıstığı',
    allergenPeanutsDesc: 'Yer fıstığı ve türevleri',
    allergenSoyLabel: 'Soya',
    allergenSoyDesc: 'Soya fasulyesi ve türevleri',
    allergenMilkLabel: 'Süt / Laktoz',
    allergenMilkDesc: 'Süt ve süt ürünleri (laktoz dahil)',
    allergenNutsLabel: 'Kabuklu Yemişler',
    allergenNutsDesc: 'Badem, fındık, ceviz, antep fıstığı, kaju vb.',
    allergenCeleryLabel: 'Kereviz',
    allergenCeleryDesc: 'Kereviz sapı, tohumu ve türevleri',
    allergenMustardLabel: 'Hardal',
    allergenMustardDesc: 'Hardal tohumu, yaprağı ve türevleri',
    allergenSesameLabel: 'Susam',
    allergenSesameDesc: 'Susam tohumu ve türevleri',
    allergenSulphitesLabel: 'Sülfitler',
    allergenSulphitesDesc: 'Kükürt dioksit (SO₂) ve sülfitler',
    allergenLupinLabel: 'Acı Bakla',
    allergenLupinDesc: 'Acı bakla unu, tohumu ve türevleri',
    allergenMolluscsLabel: 'Yumuşakçalar',
    allergenMolluscsDesc: 'Midye, istiridye, kalamar, ahtapot vb.',
    qrmenuClearFilter: 'Filtreyi temizle',
    qrmenuItemsCount: 'ürün',
    qrmenuNoItemsInCategory: 'Bu kategoride ürün bulunamadı',
    qrmenuCheckoutBtn: 'Sepeti Onayla',
    qrmenuFooterHint: 'Ürünleri sepete ekleyerek sipariş verebilirsiniz',
    qrmenuCallingWaiter: 'Çağrı gönderiliyor...',
    qrmenuCallWaiter: 'Garson Çağır',
    qrmenuAllergens: 'Alerjenler',
    qrmenuOption: 'Seçenek',
    qrmenuSpecialRequestPlaceholder: 'Özel istek, allerji...',
    qrmenuClose: 'Kapat',
    qrmenuAddToCart: 'Sepete Ekle',
    shiftsTitle: 'Vardiya & Mesai',
    shiftAutoGenerate: 'Otomatik Oluştur',
    shiftCopyWeek: 'Haftayı Kopyala',
    shiftPrintBtn: 'Yazdır',
    shiftAddAssignment: 'Atama Ekle',
    shiftStatTotal: 'Toplam Atama',
    shiftStatActive: 'Çalışıyor',
    shiftStatStaff: 'Bekleyen',
    shiftStatClosed: 'Tamamlanan',
    shiftStatusScheduled: 'Planlandı',
    shiftStatusCheckedIn: 'İşte',
    shiftStatusCheckedOut: 'Çıktı',
    shiftStatusAbsent: 'Devamsız',
    shiftStatusLate: 'Geç Geldi',
    shiftTabWeekly: 'Haftalık Plan',
    shiftTabTemplates: 'Vardiya Şablonları',
    shiftTabSummary: 'Mesai Özeti',
    shiftTabBordro: 'Bordro',
    shiftTodayBtn: 'Bugün',
    shiftPrintTitle: 'Haftalık Vardiya Planı',
    shiftCheckInBtn: 'Giriş',
    shiftCheckOutBtn: 'Çıkış',
    shiftAbsentBtn: 'Yok',
    shiftStaffHeader: 'Personel',
    shiftNoAssignmentsThisWeek: 'Bu haftada atama bulunamadı',
    shiftPrintedAt: 'Yazdırma tarihi',
    shiftNewTemplate: 'Yeni Şablon',
    shiftNoTemplatesYet: 'Henüz vardiya şablonu yok',
    shiftNoSummaryData: 'Bu hafta için mesai verisi yok',
    shiftColShift: 'Vardiya',
    shiftColLate: 'Geç',
    shiftColTotalHours: 'Toplam Saat',
    shiftColOvertime: 'Fazla Mesai',
    shiftHourShort: 'sa',
    shiftMinShort: 'dk',
    shiftEditAssignment: 'Atama Düzenle',
    shiftNewAssignment: 'Yeni Atama',
    shiftSelectPlaceholder: 'Seçin...',
    shiftTemplateLabelOptional: 'Vardiya Şablonu (isteğe bağlı)',
    shiftManualEntry: 'Manuel girin',
    shiftNoteLabel: 'Not',
    shiftNotePlaceholder: 'İsteğe bağlı not...',
    shiftEditTemplate: 'Şablon Düzenle',
    shiftNameLabel: 'Vardiya Adı',
    shiftNamePlaceholder: 'örn. Sabah Vardiyası',
    shiftColorLabel: 'Renk',
    shiftCopyDescription: 'haftasındaki tüm atamalar seçilen haftaya kopyalanır.',
    shiftTargetWeek: 'Hedef Hafta (Pazartesi)',
    shiftWeekLabel: 'Hafta',
    shiftCopying: 'Kopyalanıyor...',
    shiftCopyBtn: 'Kopyala',
    shiftAutoModalTitle: 'Otomatik Vardiya Oluştur',
    shiftAutoDescription: 'Restoran çalışma saatlerine göre seçilen personele haftalık vardiya ataması yapılır.',
    shiftWeekMondayLabel: 'Hafta (Pazartesi)',
    shiftUseRestaurantHours: 'Restoran saatlerini kullan',
    shiftIncludeWeekend: 'Hafta sonu dahil (7 gün)',
    shiftSelectStaff: 'Personel Seç',
    shiftSelectAll: 'Tümünü Seç',
    shiftClearSelection: 'Temizle',
    shiftNoStaffFound: 'Personel bulunamadı',
    shiftStaffSelected: 'personel seçildi',
    shiftAutoGenerating: 'Oluşturuluyor...',
    shiftAutoCreateForStaff: 'Personel İçin Oluştur',
    shiftSelectStaffError: 'Personel seçin',
    shiftSummaryLoadFailed: 'Özet yüklenemedi',
    shiftMarkAbsentConfirm: 'Devamsız olarak işaretle?',
    shiftDeleteAssignConfirm: 'Atama silinsin mi?',
    shiftDeleteTemplateConfirm: 'Vardiya şablonu silinsin mi?',
    shiftTemplateNameRequired: 'Vardiya adı zorunlu',
    shiftCopyInserted: 'atama kopyalandı',
    shiftCopySkipped: 'çakışma atlandı',
    shiftCopyFailed: 'Kopyalama başarısız',
    shiftAutoSelectAtLeastOne: 'En az bir personel seçin',
    shiftAutoCreated: 'atama oluşturuldu',
    shiftAutoFailed: 'Otomatik oluşturma başarısız',
    dayMon: 'Pzt',
    dayTue: 'Sal',
    dayWed: 'Çar',
    dayThu: 'Per',
    dayFri: 'Cum',
    daySat: 'Cmt',
    daySun: 'Paz',
    menuStatTotal: 'Toplam Ürün',
    menuStatActive: 'Aktif',
    menuStatInactive: 'Pasif',
    menuStatCategories: 'Kategori',
    menuMgmtTitle: 'Menü Yönetimi',
    menuMgmtProductSuffix: 'ürün',
    menuMgmtCategorySuffix: 'kategori',
    menuMgmtAiScan: 'AI Tara',
    menuMgmtExcelDownload: 'Excel İndir',
    menuMgmtExcelUpload: 'Excel Yükle',
    menuMgmtBulkPrice: 'Toplu Fiyat',
    menuMgmtQrCode: 'QR Kod',
    menuMgmtProductsTab: 'Ürünler',
    menuMgmtCategoriesTab: 'Kategoriler',
    menuMgmtAddProduct: 'Ürün Ekle',
    menuMgmtAddCategory: 'Kategori Ekle',
    menuMgmtNoCategoriesYet: 'Henüz kategori yok',
    menuMgmtNoMenuItems: 'Menü öğesi bulunamadı',
    menuMgmtProduct: 'Ürün',
    menuMgmtCategoryDeleteConfirm: 'Kategoriyi silmek istediğinize emin misiniz?',
    menuMgmtItemDeleteConfirm: 'Bu menü öğesini silmek istediğinize emin misiniz?',
    menuMgmtImageGallery: 'Görsel Galerisi',
    menuMgmtItemsWithoutImage: 'Görselsiz Ürünler',
    menuMgmtPrinter: 'Yazıcı',
    menuMgmtDefaultKitchenPrinter: 'Varsayılan mutfak yazıcısı',
    menuMgmtPrinterRouteHint: 'Bu kategorinin siparişleri seçilen yazıcıya yönlendirilir.',
    menuMgmtDetailsTab: 'Detaylar',
    menuMgmtVariantsTab: 'Varyantlar',
    menuMgmtPriceTry: 'Fiyat (₺)',
    menuMgmtSelectCategory: 'Kategori Seçin',
    menuMgmtImageUrl: 'Ürün Görseli',
    menuMgmtTaxGroup: 'KDV Grubu',
    menuMgmtTaxGroupNone: '— Yok / Manuel KDV —',
    menuMgmtTaxGroupHint: 'Grup seçilirse KDV oranı otomatik gruptan alınır.',
    menuMgmtAllergens: 'Alerjenler',
    menuMgmtSelectedSuffix: 'seçili',
    menuMgmtVisibleOnMenu: 'Aktif (menüde görünsün)',
    menuMgmtVariantsHint: 'Örn: Küçük (-5₺), Orta (0₺), Büyük (+5₺). Temel fiyat:',
    menuMgmtNoVariantsYet: 'Henüz varyant yok',
    menuMgmtAddNewVariant: 'Yeni Varyant Ekle',
    menuMgmtVariantPriceDiffHint: 'Fiyat farkı: pozitif (+) veya negatif (-) değer girin, sıfır girmek de mümkündür.',
    menuMgmtBulkWarning: '⚠️ Bu işlem seçilen kategorideki tüm ürün fiyatlarını kalıcı olarak günceller.',
    menuMgmtAllCategories: 'Tüm Kategoriler',
    menuMgmtUpdateType: 'Güncelleme Tipi',
    menuMgmtIncreasePercent: 'Yüzde Artır (%)',
    menuMgmtDecreasePercent: 'Yüzde Azalt (%)',
    menuMgmtIncreaseFixed: 'Sabit Artır (₺)',
    menuMgmtDecreaseFixed: 'Sabit Azalt (₺)',
    menuMgmtSetFixed: 'Sabit Fiyat Belirle (₺)',
    menuMgmtValueLabel: 'Değer',
    menuMgmtPreview: 'Önizleme:',
    menuMgmtItemsAffected: 'ürün etkilenecek',
    menuMgmtAiScanTitle: 'AI ile Menü Fotoğrafı Tara',
    menuMgmtAiScanDesc: 'Menü fotoğrafı yükleyin. Gemini AI yemek/içecek adlarını ve fiyatlarını otomatik okur.',
    menuMgmtClickToChoosePhoto: 'Fotoğraf seçmek için tıklayın',
    menuMgmtPhotoFormats: 'JPG, PNG, WEBP desteklenir',
    menuMgmtAiAnalyzing: 'Gemini AI analiz ediyor...',
    menuMgmtItemsFound: 'ürün bulundu',
    menuMgmtSelectAll: 'Tümünü Seç',
    menuMgmtImportTitle: 'Excel ile Menü İçe Aktar',
    menuMgmtImportFormatLabel: 'Şablon formatı:',
    menuMgmtImportFormatDesc: 'Ad, Kategori, Fiyat, KDV Oranı, Açıklama, Aktif sütunları gereklidir. Şablonu indirmek için Excel İndir butonunu kullanın (Import Şablonu sayfası dahildir).',
    menuMgmtFileProcessing: 'Dosya işleniyor...',
    menuMgmtClickToChooseExcel: 'Excel dosyası seçmek için tıklayın',
    menuMgmtXlsxSupported: '.xlsx formatı desteklenir',
    menuMgmtImportComplete: 'İçe Aktarma Tamamlandı',
    menuMgmtInserted: 'Eklendi',
    menuMgmtSkipped: 'Atlandı',
    menuMgmtQrDesc: 'Müşteriler bu kodu okutarak dijital menüyü görüntüleyebilir',
    menuMgmtPreviewMenu: 'Menüyü önizle',
    menuMgmtQrPastingHint: 'Bu QR kodu masalara veya menü kartlarına yapıştırabilirsiniz',
    posSessionOpenTitle: 'Kasa Açılışı',
    posSessionOpenSub: 'Kasadaki başlangıç nakdini girin',
    posOpeningCashLabel: 'Başlangıç Nakdi (₺)',
    posOpening: 'Açılıyor...',
    posOpenSession: 'Kasayı Aç',
    posPayment: 'Ödeme',
    posTotalAmount: 'Toplam Tutar',
    posSplitPayment: 'Karma',
    posAmountReceived: 'Alınan tutar',
    posChange: 'Para Üstü',
    posCardChargePrefix: 'Kart ile',
    posCardChargeSuffix: 'tahsil edilecek',
    posAmountsMatch: 'Tutar eşleşiyor',
    posRemaining: 'Kalan',
    posProcessing: 'İşleniyor...',
    posCompleteSale: 'Satışı Tamamla',
    posZReport: 'Z Raporu',
    posNewProductBtn: '+ Yeni Ürün',
    posNewProductTitle: 'Yeni Ürün Ekle',
    posImportFromMenuBtn: '📋 Menüden Aktar',
    posImportFromMenuTitle: 'Menüden POS\'a Aktar',
    posImportSelectAll: 'Tümünü seç',
    posImportAlreadyAdded: 'Eklendi',
    posImportConfirmBtn: 'Aktar',
    posImportNoSelection: 'Önce ürün seçin',
    posImportResult: '{n} ürün aktarıldı',
    posImportSkipped: '{n} atlandı',
    posPrintBtn: '🖨️ Yazdır',
    posPrintingBtn: 'Yazdırılıyor...',
    posReportPrintQueued: 'Rapor yazıcı kuyruğuna alındı',
    posReportPrintFailed: 'Yazdırma başarısız',
    posSaleCount: 'Satış Adedi',
    posGrossTotal: 'Brüt Toplam',
    posOpeningCash: 'Açılış Nakdi',
    posClosingCash: 'Kapanış Nakdi',
    posCashDifference: 'Kasa Farkı',
    posTopSellers: 'En Çok Satanlar',
    posUnits: 'adet',
    posOk: 'Tamam',
    posXReport: 'X Raporu',
    posStock: 'Stok',
    posAddedSuffix: 'eklendi',
    posBarcodeNotFound: 'Barkod bulunamadı',
    posKeyboardToggle: 'Ekran Klavyesi',
    posKeyboardEnabled: 'Klavye aktif',
    posKeyboardDisabled: 'Klavye kapalı',
    posKeyboardClose: 'Klavyeyi kapat',
    posKeyboardModeNumeric: 'Sayısal',
    posKeyboardModeFull: 'Harfler',
    posKeyboardEnter: 'Tamam',
    posKeyboardSpace: 'Boşluk',
    posKeyboardBackspace: 'Sil',
    posProductsLoadFailed: 'Ürünler yüklenemedi',
    posSessionOpened: 'Kasa açıldı',
    posSessionOpenFailed: 'Kasa açılamadı',
    posReceiptNotFound: 'Fiş bulunamadı',
    posRefundedSuffix: 'iade edildi',
    posRefundFailed: 'İade başarısız',
    posSaleCompleted: 'Satış tamamlandı',
    posSaleFailed: 'Satış tamamlanamadı',
    posSessionClosed: 'Kasa kapatıldı',
    posSessionCloseFailed: 'Kasa kapatılamadı',
    posXReportFailed: 'X raporu alınamadı',
    posExcelDownloadFailed: 'Excel indirilemedi',
    posImportedSuffix: 'eklendi',
    posUpdatedSuffix: 'güncellendi',
    posImportFailed: 'İçe aktarma başarısız',
    posRefundProcess: 'İade İşlemi',
    posRefundSearchHint: 'Fiş numarasını girerek satışı bulun',
    posReceiptNo: 'Fiş No',
    posCashier: 'Kasiyer',
    posStatusCompleted: 'Tamamlandı',
    posStatusRefunded: 'İade Edildi',
    posStatusCancelled: 'İptal',
    posNoteLabel: 'Not',
    posAlreadyRefunded: 'Bu satış zaten iade/iptal edilmiş — tekrar iade yapılamaz.',
    posRefunding: 'İade Ediliyor...',
    posRefundAction: 'İade Et',
    posCustomerSearch: 'Müşteri ara... (opsiyonel)',
    posUseLoyaltyPoints: 'puan kullan',
    posPromoPlaceholder: 'Promo / Voucher kodu',
    posPromoApply: 'Uygula',
    posPromoApplied: 'uygulandı',
    posPromoInvalid: 'Geçersiz kod',
    posPromoDiscount: 'Promo indirimi',
    posHoldOrder: 'Siparişi Beklet',
    posHeldOrders: 'Bekletilen Siparişler',
    posHeldOrdersHint: 'Geri yüklemek için bir sipariş seçin',
    posNoHeldOrders: 'Bekletilen sipariş yok',
    posRecallOrder: 'Geri Yükle',
    posOrderHeld: 'Sipariş bekletildi',
    posOrderRecalled: 'Sipariş geri yüklendi',
    posTip: 'Bahşiş',
    posTipNone: 'Yok',
    posBeforeTip: 'Bahşiş öncesi',
    posTitle: 'Yazarkasa',
    posOpen: 'Açık',
    posRevenue: 'ciro',
    posSales: 'satış',
    posSalesHistory: 'Geçmiş Satışlar',
    posSalesHistoryEmpty: 'Bu tarihte satış bulunamadı',
    posReprintReceipt: 'Yeniden Yazdır',
    posPrintReceiptBtn: 'Fiş Yazdır',
    posHistoryTitle: 'Satış Geçmişi',
    posHistoryCashier: 'Kasiyer',
    posHistoryPayment: 'Ödeme',
    posHistoryRefundBtn: 'İade Et',
    posTerminalSend: 'Terminale Gönder',
    posTerminalSent: 'Terminale gönderildi',
    posTerminalNoConfig: 'Terminal IP adresi ayarlanmamış',
    posEInvoiceBtn: 'E-Fatura',
    posEInvoiceTitle: 'E-Fatura / E-Arşiv Fatura',
    posEInvoiceVkn: 'VKN / TC Kimlik No',
    posEInvoiceCreate: 'Fatura Oluştur',
    posEInvoiceNote: 'GİB entegrasyonu aktif değil. Muhasebe entegrasyon ayarlarından etkinleştirin.',
    posHistoryToday: 'Bugün',
    posHistoryYesterday: 'Dün',
    posHistorySaleCount: 'satış',
    posHistoryTip: 'Bahşiş',
    posCustomerScreenTitle: 'Müşteri ekranını aç',
    posXReportBtn: 'X Rapor',
    posCloseSession: 'Kasayı Kapat',
    posSearchPlaceholder: 'Ürün ara veya barkod...',
    posExportTitle: 'Ürünleri Excel\'e aktar',
    posImportTitle: 'Excel\'den ürün içe aktar',
    posOpenSessionFirst: 'Önce kasayı açın',
    posProductsLoading: 'Ürünler yükleniyor...',
    posProductNotFound: 'Ürün bulunamadı',
    posCart: 'Sepet',
    posRefund: 'İade',
    posNoTableTakeaway: 'Masasız / Paket',
    posPricesVatInclusive: 'Fiyatlar KDV Dahil',
    posPricesVatExclusive: 'Fiyatlar KDV Hariç',
    posCartEmpty: 'Sepet boş',
    posDecreaseQty: 'Adeti azalt',
    posIncreaseQty: 'Adeti artır',
    posRemove: 'Kaldır',
    posAddNote: 'Not ekle...',
    posTakePayment: 'Ödeme Al',
    posSessionCloseTitle: 'Kasa Kapanışı',
    posSessionCloseSub: 'Kasadaki mevcut nakit miktarını girin',
    posClosingCashLabel: 'Kapanış Nakdi (₺)',
    posClosing: 'Kapatılıyor...',

    // === Tur 39 batch ===
    resetPwdInvalidLinkTitle: 'Geçersiz Bağlantı',
    resetPwdInvalidLinkDesc: 'Şifre sıfırlama bağlantısı geçersiz veya eksik.',
    resetPwdRequestNewLink: 'Yeni Bağlantı İste',
    resetPwdMinLength: 'Şifre en az 6 karakter olmalıdır.',
    resetPwdMismatch: 'Şifreler eşleşmiyor.',
    resetPwdGenericError: 'Bir hata oluştu. Bağlantı süresi dolmuş olabilir.',
    resetPwdTitle: 'Yeni Şifre Belirle',
    resetPwdSubtitle: 'Hesabınız için yeni bir şifre girin.',
    resetPwdSuccess: 'Şifreniz başarıyla güncellendi!',
    resetPwdRedirecting: 'Birkaç saniye içinde giriş sayfasına yönlendirileceksiniz...',
    resetPwdSignIn: 'Giriş Yap',
    resetPwdMinLengthPlaceholder: 'En az 6 karakter',
    resetPwdConfirm: 'Şifre Tekrar',
    resetPwdSaving: 'Kaydediliyor...',
    resetPwdUpdateBtn: 'Şifreyi Güncelle',
    resetPwdBackToLogin: 'Giriş sayfasına dön',
    forgotPwdEmailRequired: 'E-posta adresi gereklidir.',
    forgotPwdGenericError: 'Bir hata oluştu. Lütfen tekrar deneyin.',
    forgotPwdTitle: 'Şifremi Unuttum',
    forgotPwdSubtitle: 'E-posta adresinizi girin, şifre sıfırlama bağlantısı gönderelim.',
    forgotPwdSentTitle: 'Şifre sıfırlama bağlantısı gönderildi!',
    forgotPwdSentDesc: 'adresine gönderilen bağlantıya tıklayarak şifrenizi sıfırlayabilirsiniz.',
    forgotPwdBackToLogin: 'Giriş sayfasına dön',
    forgotPwdSending: 'Gönderiliyor...',
    forgotPwdSendLink: 'Sıfırlama Bağlantısı Gönder',
    auditLoadFailed: 'Audit log yüklenemedi.',
    auditStatTotal: 'Toplam Log',
    auditStatToday: 'Bugünkü',
    auditStatPerUser: 'Kullanıcı Başına',
    auditStatTopAction: 'En Sık İşlem',
    auditTitle: 'Denetim Kayıtları',
    auditSubtitle: 'Kim, ne zaman, hangi kayda ne yaptı? Kritik işlemler burada tutulur.',
    auditActionLabel: 'Eylem',
    auditEntityLabel: 'Varlık',
    auditApply: 'Uygula',
    auditClear: 'Temizle',
    auditNoRecords: 'Kayıt bulunamadı.',
    auditDate: 'Tarih',
    auditUser: 'Kullanıcı',
    auditIp: 'IP',
    auditBefore: 'Öncesi',
    auditAfter: 'Sonrası',
    auditTotal: 'Toplam',
    auditRecords: 'kayıt',
    flagKeyFormatError: 'flag_key küçük harf+rakam+_ olmalı (ör: new_dashboard).',
    flagRolloutRangeError: 'Rollout 0-100 arası olmalı.',
    flagDeleteConfirm: 'Bu feature flag\'i silmek istediğinizden emin misiniz?',
    flagGlobal: 'GENEL',
    flagTitle: 'Özellik Bayrakları',
    flagSubtitle: 'Özellikleri kademeli rollout ile aç/kapa. Restoran-spesifik kayıt global\'i ezer. Rollout %, restoran ID hash\'ine göre stable seçer.',
    flagNewBtn: 'Yeni Bayrak',
    flagKey: 'Anahtar',
    flagScope: 'Kapsam',
    flagRollout: 'Rollout %',
    flagThisRestaurant: 'Bu Restoran',
    flagOptional: 'Opsiyonel',
    flagEmpty: 'Henüz özellik bayrağı yok.',
    taxGroupNameRequired: 'Ad zorunlu.',
    taxGroupRateRangeError: 'Oran 0-100 arası olmalı.',
    taxGroupDeleteConfirm: 'Bu vergi grubunu silmek istediğinizden emin misiniz?',
    taxGroupTitle: 'Vergi Grupları',
    taxGroupSubtitle: 'KDV oranlarınızı tanımlayın ve menü öğelerine atayın. Varsayılan grup, oran belirtilmemiş yeni ürünler için kullanılır.',
    taxGroupNewBtn: 'Yeni Grup',
    taxGroupName: 'Ad',
    taxGroupRate: 'Oran',
    taxGroupDefault: 'Varsayılan',
    taxGroupEmpty: 'Vergi grubu yok.',
    taxGroupNamePlaceholder: 'KDV %10',

    // === Tur 40 batch ===
    settingsHeaderDesc: 'Restoran ve uygulama tercihlerinizi yönetin',
    restaurantInfoTitle: 'Restoran Bilgileri',
    restaurantNamePh: 'Restoran adınız',
    restaurantAddressPh: 'Restoran adresi',
    workingHoursLabel: 'Çalışma Saatleri',
    workingHoursDesc: 'Vardiya otomatik oluşturma ve diğer özellikler bu saatleri kullanır.',
    openingHourLabel: 'Açılış Saati',
    closingHourLabel: 'Kapanış Saati',
    loginAfterPageTitle: 'Giriş Sonrası Sayfa',
    loginAfterPageDesc: 'Giriş yaptıktan sonra hangi sayfaya yönlendirilmek istersiniz?',
    adisyonBadge: 'Adisyon',
    coverImageTitle: 'Kapak Görseli',
    coverImageDesc: 'Menünün üst kısmında görünecek kapak fotoğrafı URL\'si',
    coverImagePreviewAlt: 'Kapak önizleme',
    restaurantMenuFallback: 'Restoran Menüsü',
    imageUrlLabel: 'Görsel URL',
    menuTitleDesc: 'Boş bırakılırsa restoran adı kullanılır',
    accentColorTitle: 'Vurgu Rengi',
    accentColorDesc: 'Fiyat, kategori seçimi ve butonlarda kullanılır',
    customColorLabel: 'Özel renk:',
    footerTextTitle: 'Alt Yazı',
    footerTextDesc: 'Menünün en altında görünecek metin',
    footerTextPh: 'Garsonumuza sipariş vermek için çağırınız',
    previewMenuBtn: 'Menüyü Önizle',
    defaultCurrencyTitle: 'Varsayılan Para Birimi',
    defaultCurrencyDesc: 'Restoranınızın menü ve fatura para birimi. Çoklu para birimi destekleniyor (turistik bölge için EUR/USD vb.).',
    currencyChangeWarning: 'Bu değişiklik mevcut menü fiyatlarını dönüştürmez. Sadece görüntü ve yeni siparişlerin etiketi etkilenir. Döviz kuru tablosu için ayrı yönetim ekranı planlanmıştır.',
    currencyTRYName: 'Türk Lirası',
    currencyUSDName: 'ABD Doları',
    currencyEURName: 'Euro',
    currencyGBPName: 'İngiliz Sterlini',
    currencyCHFName: 'İsviçre Frangı',
    currencyJPYName: 'Japon Yeni',
    currencyAEDName: 'BAE Dirhemi',
    currencySARName: 'Suudi Riyali',
    pageOptDashboardLabel: 'Dashboard',
    pageOptDashboardDesc: 'Ana istatistik ekranı',
    pageOptTablesLabel: 'Masalar',
    pageOptTablesDesc: 'Direkt adisyon ekranına git',
    pageOptOrdersLabel: 'Siparişler',
    pageOptOrdersDesc: 'Sipariş listesi ekranı',
    pageOptKitchenLabel: 'Mutfak Ekranı',
    pageOptKitchenDesc: 'Mutfak takip ekranı',
    colorOrange: 'Turuncu',
    colorRed: 'Kırmızı',
    colorPurple: 'Mor',
    colorBlue: 'Mavi',
    colorGreen: 'Yeşil',
    colorYellow: 'Sarı',
    colorPink: 'Pembe',
    colorDark: 'Koyu',
    platformMgmtTitle: 'Platform Yönetimi',
    platformStatTotal: 'Toplam Platform',
    platformStatConfigured: 'Yapılandırılmış',
    platformStatActive: 'Aktif',
    platformStatTested: 'Test Başarılı',
    platformMgmtSubtitle: 'Teslimat platformu entegrasyonlarını yönetin.',
    platformMgmtLoadFailed: 'Platformlar yüklenemedi.',
    platformMgmtToggleFailed: 'Toggle başarısız.',
    platformMgmtConnectionOk: 'Bağlantı başarılı.',
    platformMgmtConnectionError: 'Bağlantı hatası.',
    platformMgmtNotConfigured: 'Yapılandırılmamış',
    platformMgmtTesting: 'Test ediliyor...',
    platformMgmtTestBtn: '🔌 Test',
    platformMgmtConfigure: 'Yapılandır',
    platformMgmtDeactivate: '⏸ Devre Dışı',
    platformMgmtActivate: '▶ Aktifleştir',
    platformMgmtSettingsSuffix: 'Ayarları',
    platformMgmtChangePlaceholder: '(değiştirmek için girin)',
    platformMgmtSaving: 'Kaydediliyor...',
    trashStatTotal: 'Toplam Silinen',
    trashStatOrders: 'Sipariş',
    trashStatCustomers: 'Müşteri',
    trashStatMenuItems: 'Menü Öğesi',
    trashTitle: 'Çöp Kutusu',
    trashSubtitle: 'Silinen kayıtlar burada arşivlenir. Geri yüklemek için sağdaki butonu kullanın.',
    trashOrdersTab: 'Siparişler',
    trashMenuItemsTab: 'Menü Öğeleri',
    trashCustomersTab: 'Müşteriler',
    trashRestaurantsTab: 'Restoranlar',
    trashLoadFailed: 'Yüklenemedi.',
    trashRestoreConfirm: 'Bu kaydı geri yüklemek istediğinizden emin misiniz?',
    trashRestoreFailed: 'Geri yüklenemedi.',
    trashEmpty: 'Bu kategoride silinmiş kayıt yok. 🎉',
    trashActionCol: 'Aksiyon',
    trashRestoreBtn: '↩️ Geri Yükle',
    tablesDeleteConfirmSuffix: 'masasını silmek istediğinize emin misiniz?',
    tablesCloseConfirmSuffix: 'masasını kapatmak istediğinize emin misiniz?',
    tablesCategoryDeleteConfirmSuffix: 'kategorisini silmek istediğinize emin misiniz? Masalar kategorisiz kalır.',
    tablesTablePrefix: 'Masa',
    tablesWaiterCallTitle: 'Garson Çağrısı',
    tablesWaitingSuffix: 'bekliyor',
    tablesManageAriaSuffix: 'masasını yönet',
    tablesManageCategoriesTitle: 'Kat & Bölge Kategorileri',
    tablesTableLower: 'masa',
    tablesAddNewCategory: 'Yeni Kategori Ekle',
    tablesCategoryPlaceholder: 'Örn: 1. Kat, Teras, Bahçe...',
    tablesChooseColor: 'Renk seç',
    tablesPreviewLabel: 'Önizleme',
    tablesAddCategoryBtn: 'Kategori Ekle',
    tablesTableNamePlaceholder: 'Masa 11',
    tableSeatingDuration: 'Oturma süresi',
    kitchenMinShort: 'dk',
    kitchenHourShort: 'sa',
    kitchenLate: 'gecikti',
    kitchenRemaining: 'kalan',
    kitchenConnectionError: 'Bağlantı hatası — yenilemeyi deneyin.',
    kitchenScreenTitle: 'Mutfak Ekranı',
    kitchenWaitingLabel: 'Bekliyor',
    kitchenServedLabel: 'Servis',
    kitchenStatServed: 'Teslim Edildi',
    kitchenStatPrepTime: 'Tahmini Süre (dk)',
    kitchenPanelBtn: 'Panel',
    kitchenWaitingOrders: 'Bekleyen Siparişler',
    kitchenEmptyQueue: 'Bekleyen sipariş yok',
    kitchenServeBtn: 'Servis Et',
    loginTotpRequired: 'TOTP kodu gerekli.',
    loginCodeVerifyFailed: 'Kod doğrulanamadı.',
    loginTwoFactorTitle: 'İki Adımlı Doğrulama',
    loginTwoFactorHint: 'Authenticator uygulamanızdaki 6 haneli kodu girin (veya 8 haneli yedek kodu).',
    loginVerifying: 'Doğrulanıyor...',
    loginVerifyAndEnter: 'Doğrula ve Gir',
    loginDifferentAccount: 'Farklı hesapla giriş yap',
    loginTestAccounts: 'Test Hesapları:',
    loginTestSuperAdmin: 'SuperAdmin',
    loginTestAdmin: 'Admin',
    loginTestWaiter: 'Garson',
    loginTestKitchen: 'Mutfak',
    loginTestChainAdmin: 'Zincir Admin',
    loginTestDemoChain: 'Demo Zincir',
    reportsChartSR: 'Grafik',

    // === Tur 44 Quick Start ===
    quickStartTitle: 'Hızlı Başlangıç',
    quickStartSubtitle: 'Restoranınızı çalışır hale getirmek için birkaç adım kaldı.',
    qsRestaurantInfo: 'Restoran bilgilerini gir',
    qsAddFirstTable: 'İlk masanı ekle',
    qsAddMenuItem: 'Menüye ürün ekle',
    qsAddStaff: 'Personel ekle',
    quickStartOrWizard: 'Veya sihirbazla adım adım kur:',

    // === Tur 50 shortcuts ===
    shortcutsTitle: 'Klavye Kısayolları',
    shortcutHelp: 'Kısayol yardımını aç/kapat',
    shortcutHome: 'Ana sayfa',
    shortcutTables: 'Masalar',
    shortcutOrders: 'Siparişler',
    shortcutKitchen: 'Mutfak ekranı',
    shortcutReports: 'Raporlar',
    shortcutSettings: 'Ayarlar',
    shortcutMenu: 'Menü yönetimi',
    shortcutCustomers: 'Müşteriler',
    shortcutPOS: 'Yazarkasa',
    shortcutClose: 'Modali kapat',
    shortcutHint: 'İpucu: bir tuşu basılı tutmadan kısa aralıklarla basın.',

    // === FAZ K3.1 Müşteri sipariş takibi ===
    orderTrackTitle: 'Sipariş Takibi',
    orderTrackStatusTitle: 'Sipariş Durumu',
    orderTrackAccepted: 'Siparişiniz alındı',
    orderTrackPreparing: 'Restoran hazırlıyor',
    orderTrackOnTheWay: 'Kurye yola çıktı',
    orderTrackDelivered: 'Teslim edildi',
    orderTrackInProgress: 'Devam ediyor...',
    orderTrackEta: 'Tahmini varış',
    orderTrackEtaPrefix: 'Yaklaşık',
    orderTrackEtaMinutes: 'dakika',
    orderTrackCourier: 'Kuryeniz',
    orderTrackRestaurant: 'Restoran',
    orderTrackYou: 'Adresiniz',
    orderTrackMap: 'Harita',
    orderTrackLocationUpdating: 'Konum güncelleniyor...',
    orderTrackLocationWaiting: 'Kurye konumu bekleniyor...',
    orderTrackInvalidToken: 'Geçersiz takip linki',
    orderTrackInvalidTokenDesc: 'Bu sipariş takip linki geçerli değil veya süresi dolmuş olabilir.',
    orderTrackNetworkError: 'Bağlantı hatası',
    orderTrackAutoRefresh: 'Sayfa her 30 saniyede bir otomatik yenilenir',
    orderTrackEtaWaiting: 'ETA hesaplanıyor — kurye konum gönderince güncellenir',
    orderTrackCancelled: 'Sipariş iptal edildi',

    // === Tur 51 a11y ===
    skipToMain: 'Ana içeriğe atla',

    // === Tur 55 confirm ===
    confirmBtn: 'Onayla',
    confirmDefaultTitle: 'Onay',

    // === Onboarding Tour ===
    tourSkip: 'Atla',
    tourNext: 'İleri',
    tourPrev: 'Geri',
    tourFinish: 'Bitir',
    tourGetStarted: 'Hadi Başlayalım',
    tourGoTo: 'Sayfaya Git',
    tourStep1Title: 'RestaFlex\'e Hoş Geldin!',
    tourStep1Body: 'Yaklaşık 2 dakikalık kısa bir turla sana ana özelliklerin nerede olduğunu göstereceğiz. İstediğin an atlayabilirsin.',
    tourStep2Title: 'Dashboard & KPI',
    tourStep2Body: 'Günlük cironu, sipariş sayısını ve en çok satan ürünleri tek bakışta Dashboard\'da görürsün. Performansını anlık takip edebilirsin.',
    tourStep3Title: 'Menü Yönetimi',
    tourStep3Body: 'Kategorileri, ürünleri, varyantları ve fiyatları buradan yönetirsin. QR menüne de otomatik yansır.',
    tourStep4Title: 'Masalar & Siparişler',
    tourStep4Body: 'Masa düzeni, sipariş akışı, mutfağa iletim ve ödeme — hepsi tek ekranda. Tüm operasyonu buradan yürütürsün.',
    tourStep5Title: 'Ayarlar',
    tourStep5Body: 'Restoran bilgisi, yazıcılar, webhook\'lar, kullanıcılar ve diğer yapılandırma seçenekleri Ayarlar\'da.',
    // UI-01: Settings içinde "Yönetim ve Entegrasyonlar" bölümü
    settingsIntegrationsTitle: 'Yönetim ve Entegrasyonlar',
    settingsIntegrationsSub: 'Yazıcılar, webhook entegrasyonları, GDPR ve özel marka ayarlarına buradan hızlıca erişin.',
    // Tur 137: Settings yeniden tasarım — vertical nav + Yönetim tab'ı
    tabAdmin: 'Yönetim',
    settingsAdminSub: 'Vergi grupları, denetim, güvenlik ve tüm sistem yönetim sayfalarına buradan eriş.',
    settingsSectionDataSafety: 'Veri & Güvenlik',
    settingsSectionIntegrations: 'Entegrasyonlar',
    settingsSectionConfig: 'Yapılandırma',
    // Tur 138 — ERP-08 Parça 2 multi-tag filter
    customerTagFilterLabel: 'Etiket filtresi',
    customerTagToggleHint: 'Bu etikete göre filtrele',
    // Tur 139 — i18n tail (Madde 13)
    whatsappBtnTitle: 'WhatsApp',
    whatsappOrderRef: 'Sipariş hk.',
    payrollDescPrefix: 'Maaş ödemesi',
    payrollHoursHeader: 'Çalışılan',
    payrollRateHeader: 'Ücret',
    payrollScheduledHeader: 'Saatler',
    payrollOvertimeHeader: 'Mesai dk',
    csvAvgOrder: 'Ort. Sipariş',
    csvRevenuePerCustomer: 'Müşteri Başı',
    // Tur 140 — Dashboard recent audit widget
    recentAuditTitle: 'Son Yönetim İşlemleri',
    // Tur 141 — Kitchen kanban view
    statusPreparing: 'Hazırlanıyor',
    statusReady: 'Hazır',
    kitchenReadyBtn: 'Hazır',
    // Tur 142 — Reports detail/P&L date preset chips
    datePresetLast7: 'Son 7 gün',
    datePresetLast30: 'Son 30 gün',
    datePresetLast90: 'Son 90 gün',
    datePresetThisMonth: 'Bu Ay',
    datePresetLastMonth: 'Geçen Ay',
    // Tur 143 — Customers segment quick-filter chips
    segmentQuickLabel: 'Hızlı',
    segmentBirthday: 'Doğum günü yakın',
    segmentNewCustomer: 'Yeni müşteri',
    segmentVIP: 'VIP',
    // Tur 145 — Reservations date quick chips
    dateChipToday: '📅 Bugün',
    dateChipTomorrow: '➡️ Yarın',
    dateChipAll: '🗓️ Tümü',
    dateChipYesterday: '⬅️ Dün',
    // Tur 164 — PromoCodes status chip
    promoStatusActive: 'Aktif',
    promoStatusExpired: 'Süresi Doldu',
    // Tur 165 — GiftVouchers status chip
    voucherStatusUsed: 'Tükendi',
    // Tur 169 — Printer search
    printerSearchPlaceholder: 'Yazıcı adı / IP ara...',
    // Tur 170 — Webhooks search
    webhookSearchPlaceholder: 'Webhook ara (URL/etiket)...',
    // Tur 171 — Tax / Flag search
    taxGroupSearchPlaceholder: 'Vergi grubu ara (ad/oran)...',
    flagSearchPlaceholder: 'Bayrak ara (anahtar/açıklama)...',
    // Tur 148 — MySubscription plan card feature listesi
    plnProfitLoss: 'Kâr/Zarar Raporu',
    nav_chain: 'Zincir Yönetimi',
    // Tur 149 — Stock search
    stockSearchPlaceholder: 'Malzeme ara...',
    // Tur 150 — Promo / Voucher / Refund search
    promoSearchPlaceholder: 'Kod veya açıklama ara...',
    voucherSearchPlaceholder: 'Kod ara...',
    refundSearchPlaceholder: 'Masa, sebep, sipariş # ara...',
    // Tur 156 — Notifications bulk dismiss read
    notifDismissRead: 'Okunmuşları temizle',
    notifDismissReadHint: 'Okunmuş bildirimleri gizle',
    notifDismissVisible: 'Görüneni gizle',
    notifDismissVisibleHint: 'Filtrelenen bildirimleri gizle',
    // Tur 173-176 — Paralel agent batch (Dashboard peak hour + Recipes searchable + Customers bulk tag)
    peakHourTitle: 'En Yoğun Saat',
    recipeItemSearchPlaceholder: 'Ürün adı yazın veya seçin...',
    recipeItemSearchHint: '{N} ürün arasında arayın',
    items: 'ürün',
    foodCostPctLabel: 'Maliyet',
    foodCostPctTooltip: 'Reçete maliyeti / Satış fiyatı',
    bulkTagBtn: '🏷️➕ Toplu Etiket Ekle',
    bulkTagModalTitle: 'Toplu Etiket Ekleme',
    bulkTagModalDesc: '{count} müşteriye aşağıdaki etiketler eklenecek',
    bulkTagApplyBtn: 'Uygula',
    bulkTagSuccess: 'Etiketler eklendi',
    bulkTagFailed: 'Bazı müşteriler güncellenemedi',
    // Tur 177 — CustomerDetail
    avgOrderValue: 'Ort. Sipariş',
    // Tur 179 — Security backup codes
    copyAllBtn: 'Tümünü Kopyala',
    downloadTxtBtn: 'TXT İndir',
    // Tur 184 — Customers stats overview
    customersStatTotal: 'Toplam',
    // Tur 185 — Stock total value
    stockTotalValue: 'Stok Değeri',
    // Tur 186 — stat overview keys
    deliveryStatPending: 'Bekleyen',
    deliveryStatDelivered: 'Teslim',
    deliveryStatCancelled: 'İptal',
    deliveryStatRevenue: 'Toplam Ciro',
    supplierStatTotal: 'Toplam Tedarikçi',
    supplierStatActive: 'Aktif',
    supplierStatInactive: 'Pasif',
    supplierStatProducts: 'Toplam Ürün',
    cashStatIncome: 'Gelir',
    cashStatExpense: 'Gider',
    cashStatNet: 'Net Bakiye',
    cashStatCount: 'İşlem Sayısı',
    paymentStatTotal: 'Toplam Ciro',
    paymentStatCompleted: 'Tamamlanan',
    paymentStatPending: 'Bekleyen',
    paymentStatAvg: 'Ortalama Ödeme',
    // Tur 187 — stat overview + filter keys
    tableStatTotal: 'Toplam Masa',
    tableStatOccupied: 'Dolu',
    tableStatReserved: 'Rezerve',
    tableStatFree: 'Boş',
    promoStatActive: 'Aktif',
    promoStatExpired: 'Süresi Dolmuş',
    promoStatUsage: 'Toplam Kullanım',
    promoStatTotal: 'Toplam İndirim',
    voucherStatActive: 'Aktif',
    voucherStatTotalValue: 'Toplam Değer',
    voucherStatUsed: 'Kullanılan',
    voucherStatCount: 'Toplam Voucher',
    // Tur 157 — Users search
    userSearchPlaceholder: 'İsim veya email ara...',
    // Tur 158 — MenuManagement search
    menuItemSearchPlaceholder: 'Ürün ara...',
    // Empty-state metinleri (liste sayfaları)
    emptyUsersTitle: 'Henüz kullanıcı yok',
    emptyUsersHint: 'Ekibine ilk kullanıcıyı ekleyerek başla.',
    emptyRecipeTitle: 'Reçete tanımlı değil',
    emptyRecipeHint: 'Bu ürün için ilk malzemeyi ekleyerek reçete oluştur.',
    // Suppliers (Tedarikçiler)
    supplierTitle: 'Tedarikçiler',
    supplierSubtitle: 'Stok ve hammadde tedarikçilerinizi yönetin.',
    supplierAdd: 'Tedarikçi Ekle',
    supplierEditTitle: 'Tedarikçi Düzenle',
    supplierNewTitle: 'Yeni Tedarikçi',
    supplierContactPerson: 'Yetkili Kişi',
    supplierTaxNumber: 'Vergi No',
    supplierNotes: 'Notlar',
    supplierTotal: 'Toplam',
    supplierActive: 'Aktif',
    supplierInactive: 'Pasif',
    supplierLedger: 'Cari',
    supplierLedgerTitle: 'Cari Hesap',
    supplierLedgerDebit: 'Borç',
    supplierLedgerCredit: 'Ödeme',
    supplierLedgerBalance: 'Bakiye',
    supplierLedgerEmpty: 'Hareket yok',
    supplierLedgerEmptyHint: 'Bu tedarikçi için henüz teslim alınmış sipariş veya ödeme bulunmuyor.',
    supplierShowInactive: 'Pasifleri göster',
    supplierEmptyTitle: 'Henüz tedarikçi yok',
    supplierEmptyHint: 'İlk tedarikçinizi ekleyerek başlayın.',
    supplierNameRequired: 'Firma adı zorunludur.',
    supplierLoadError: 'Tedarikçiler yüklenemedi.',
    supplierSearchPlaceholder: 'Tedarikçi ara...',
    supplierSelect: 'Tedarikçi seç',
    // Purchase Orders (ERP-02 Parça 4)
    poTitle: 'Satın Alma Siparişleri',
    poSubtitle: 'Tedarikçilerden malzeme satın alma siparişleri.',
    poNew: 'Yeni Sipariş',
    poEdit: 'Sipariş Düzenle',
    poNumber: 'Sipariş No',
    poSupplier: 'Tedarikçi',
    poDate: 'Tarih',
    poExpectedDate: 'Beklenen Tarih',
    poReceivedDate: 'Teslim Tarihi',
    poStatus_draft: 'Taslak',
    poStatus_sent: 'Gönderildi',
    poStatus_received: 'Teslim Alındı',
    poStatus_cancelled: 'İptal',
    poItems: 'Kalemler',
    poAddRow: '+ Satır Ekle',
    poIngredient: 'Malzeme',
    poQuantity: 'Miktar',
    poUnitPrice: 'Birim ₺',
    poLineTotal: 'Tutar',
    poGrandTotal: 'GENEL TOPLAM',
    poNotes: 'Notlar',
    poMarkReceived: 'Teslim Aldı',
    poReceiveConfirm: 'Bu siparişi teslim alındı olarak işaretle? Stok otomatik güncellenecek.',
    poStatTotal: 'Toplam Sipariş',
    poStatPending: 'Bekleyen',
    poStatCompleted: 'Tamamlanan',
    poStatTotalAmount: 'Toplam Tutar',
    poStatThisMonth: 'Bu Ay',
    paymentStatCount: 'Ödeme Adedi',
    paymentStatFailed: 'Başarısız',
    datePresetGroupLabel: 'Tarih ön ayarları',
    datePresetLast7Days: 'Son 7 Gün',
    datePresetLast30Days: 'Son 30 Gün',
    tableStatCapacity: 'Toplam Kapasite',
    promoStatDiscount: 'Toplam İndirim',
    voucherStatRedeemed: 'Kullanılmış',
    voucherStatRedeemedValue: 'Kullanılan Değer',
    notifReadFilterLabel: 'Okundu durumu filtresi',
    loginDemoGroupAria: 'Demo hesap kısayolları',
    loginDemoTitle: 'Demo Hesaplar',
    loginDemoDevOnly: 'Sadece geliştirme ortamında görünür',
    loginDemoSuperadmin: 'Süperadmin',
    loginDemoAdmin: 'Admin (demo restoran)',
    loginDemoWaiter: 'Garson',
    loginDemoKitchen: 'Mutfak',
    onbStepperAriaLabel: 'Onboarding adımları',
    onbProgressBarLabel: 'Onboarding ilerleme',
    onbCompletedSuffix: 'tamamlandı',
    peakHourChartAria: 'Saat bazında sipariş yoğunluğu',
    peakHourSourceLive: 'Canlı veri',
    peakHourSourceOrders: 'Sipariş geçmişinden',
    peakHourSourceDemo: 'Demo veri',
    peakHourLegendHigh: 'Yoğun (>%75)',
    peakHourLegendMid: 'Orta (%40–75)',
    peakHourLegendLow: 'Sakin (<%40)',
    reportsDownloadCSV: 'CSV İndir',
    a11yDownloadCsvLabel: 'CSV İndir',
    metricCol: 'Metrik',
    valueCol: 'Değer',
    amountCol: 'Tutar (₺)',
    amountExtraCol: 'Ek (₺)',
    settingsDirtyBadge: 'Kaydedilmemiş değişiklikler',
    hrTotalPayrolls: 'Toplam Bordro',
    hrTotalNetSalary: 'Toplam Net Maaş',
    hrRemainingLeave: 'Kalan İzin',
    hrDocumentCount: 'Belge Sayısı',
    hrYears: 'yıl',
    hrWeeks: 'hafta',
    hrLast6Payrolls: 'Son 6 Bordro',
    hrPeriod: 'Dönem',
    hrNetShort: 'Net',
    hrSGKShort: 'SGK',
    hrNoPayrollRecord: 'Bordro kaydı yok.',
    hrLast30DaysShifts: 'Son 30 Gün Vardiyalar',
    hrShowAllShifts: 'tüm vardiyaları göster →',
    hrNoLinkedAccountShifts: 'Bu personele login hesabı eşleştirilmemiş — vardiya görüntülenemiyor.',
    hrNoShiftsLast30Days: 'Son 30 gün vardiya kaydı yok.',
    hrMoreShifts: 'vardiya daha…',
    hrSeveranceNoticeTitle: 'Kıdem & İhbar Tazminatı',
    hrSeveranceNoticeDesc: 'Mevcut çalışma süresine göre tahmini hesap.',
    hrCalculateSeveranceNotice: 'Kıdem & İhbar Hesapla',
    hrCSVImportEmployeesTitle: 'CSV ile toplu personel ekle',
    hrImport: 'İçe Aktar',
    hrImporting: 'Aktarılıyor…',
    hrRowsImport: 'satırı içe aktar',
    hrColAccount: 'Hesap',
    hrAccountLinked: 'Hesap Bağlı',
    hrNoAccount: 'Hesap Yok',
    hrDetail: 'Detay',
    hrAnnualPayrollSummary: 'Yıllık Bordro Özeti',
    hrColEmployerCostShort: 'İşveren Mal.',
    hrPeople: 'kişi',
    hrNoDataFound: 'Veri bulunamadı.',
    hrPreviousMonth: 'Önceki ay',
    hrMuhtasarSummaryTitle: 'Muhtasar Beyanname Özeti',
    hrMuhtasarSummaryAria: 'Muhtasar Beyanname Özeti PDF indir',
    hrMuhtasarPDFBtn: 'Muhtasar PDF',
    hrBankTransferCSVTitle: 'Banka transfer CSV indir',
    hrBankFileBtn: 'Banka Dosyası',
    hrCSVExport: 'CSV Export',
    hrCustomDeduction: 'Özel Kesinti',
    hrDownloadPDF: 'PDF indir',
    hrToday: 'Bugün',
    hrDayMon: 'Pzt',
    hrDayTue: 'Sal',
    hrDayWed: 'Çar',
    hrDayThu: 'Per',
    hrDayFri: 'Cum',
    hrDaySat: 'Cmt',
    hrDaySun: 'Paz',
    hrMore: 'daha',
    hrViewList: 'Liste',
    hrViewCalendar: 'Takvim',
    hrClearDate: 'Tarihi Temizle',
    hrLast30Days: 'Son 30 Gün',
    hrExpiringDocuments: 'Süresi Dolan/Dolacak',
    channel: 'Kanal',
    customersMessageBodyPlaceholder: 'Merhaba {ad}, sizi tekrar görmekten mutluluk duyarız. Bu ay özel %20 indirim...',
    settingsPushTestBtn: 'Test',
    tablesCustomerOptionalLabel: 'Müşteri (opsiyonel — sadakat için)',
    orderStatTodayRevenue: 'Bugünkü Ciro',
    reservationStatWeekTotal: 'Bu Hafta Toplam',
    refundStatCount: 'Toplam İade Adedi',
    refundStatAmount: 'Toplam İade Tutarı',
    refundStatPending: 'Bekleyen',
    refundStatCompleted: 'Tamamlanan',
    auditStatTotalFiltered: 'Toplam Kayıt',
    auditStatLast24h: 'Son 24 Saat',
    auditStatCritical: 'Kritik İşlem',
    auditStatUniqueUsers: 'Benzersiz Kullanıcı',
    stockStatTotalItems: 'Toplam Ürün',
    stockStatLowStock: 'Düşük Stok',
    stockStatValue: 'Stok Değeri',
    stockStatCategoryCount: 'Kategori Sayısı',
    courierStatActiveCouriers: 'Aktif Kurye',
    courierStatAssignedDeliveries: 'Atanmış Teslimat',
    courierStatDeliveredToday: 'Bugün Teslim Edilen',
    shiftStatTodayActive: 'Bugün Aktif',
    shiftStatOpenShifts: 'Açık Vardiya',
    shiftStatWeekHours: 'Bu Hafta Toplam Saat',
    shiftStatTotalStaff: 'Toplam Personel',
    wsPodiumLabel: 'En iyi 3 garson',
    wsPodiumFirst: 'Birinci',
    wsPodiumSecond: 'İkinci',
    wsPodiumThird: 'Üçüncü',
    kitchenOldestOrder: 'En Eski Sipariş',
    kitchenAvgWait: 'Ortalama Bekleme',
    posDisplayQueueOverview: 'Sipariş Durumu',
    posDisplayQueuePreparing: 'Hazırlanan Sipariş',
    posDisplayQueueReady: 'Hazır',
    posDisplayQueueAvgWait: 'Ortalama Bekleme',
    posSummaryTodayCount: 'Bugün Satış',
    posSummaryUnitsSuffix: 'adet',
    posSummaryTodayRevenue: 'Bugünkü Ciro',
    posSummaryRevenueSub: 'toplam',
    posSummaryAvgBasket: 'Ortalama Sepet',
    posSummaryAvgBasketSub: 'satış başına',
    posSummaryOpenSession: 'Açık Session',
    posSummarySessionActive: 'Aktif',
    posSummarySessionClosed: 'Kapalı',
    posSummarySessionNone: 'Oturum yok',
    trashStatOthers: 'Diğer',
    recipeOverviewRegionAria: 'Tarif özeti',
    recipeOverviewTotal: 'Toplam Tarif',
    recipeOverviewAvgCost: 'Ort. Maliyet',
    recipeOverviewMargin: 'Ort. Kar Marjı',
    recipeOverviewLinked: 'Bağlı Menü Öğesi',
    flagStatPartial: 'Kademeli Rollout',
    featureFlagSearchPlaceholder: 'Flag ara...',
    webhookOverviewTotal: 'Toplam Abonelik',
    webhookOverviewActive: 'Aktif',
    webhookOverviewDeliveries24h: 'Son 24s Teslimat',
    webhookOverviewFailed: 'Başarısız',
    printerStatTodayJobs: 'Bugün Print Job',
    printerStatPendingJobs: 'Bekleyen Job',
    taxStatTotalGroups: 'Toplam Grup',
    taxStatDefaultCount: 'Varsayılan',
    taxStatMaxRate: 'En Yüksek Oran',
    taxStatMinRate: 'En Düşük Oran',
    chainStaffSearchPlaceholder: 'Ad veya email ara...',
    chainStaffActive: 'Aktif',
    chainStaffBranchCount: 'Şube Sayısı',
    chainStaffTopRole: 'Roller',
    supplierStatOutstanding: 'Açık Bakiye',
    supplierStatPoThisMonth: 'Bu Ay PO',
    supplierStatRecent30d: 'Son 30g Eklenen',
    supplierActiveFilterAria: 'Aktiflik filtresi',
    clearDates: 'Tarihi Temizle',
    role_chain_admin: 'Zincir Yöneticisi',
    poEmptyTitle: 'Henüz satın alma siparişi yok',
    poEmptyHint: 'İlk satın alma siparişinizi oluşturun.',
    poNoItemsError: 'En az bir kalem ekleyin.',
    poSupplierRequired: 'Tedarikçi seçin.',
    courierTitle: 'Kuryeler',
    courierSubtitle: 'Teslimat kuryelerinizi yönetin.',
    courierAdd: 'Kurye Ekle',
    courierEditTitle: 'Kurye Düzenle',
    courierNewTitle: 'Yeni Kurye',
    courierName: 'Ad Soyad',
    courierVehicle: 'Araç',
    courierVehicle_motorbike: 'Motosiklet',
    courierVehicle_bicycle: 'Bisiklet',
    courierVehicle_car: 'Araba',
    courierVehicle_walking: 'Yaya',
    courierLicensePlate: 'Plaka',
    courierNotes: 'Notlar',
    courierActive: 'Aktif',
    courierInactive: 'Pasif',
    courierLocation: 'Konum',
    courierLocationTitle: 'Konum Güncelle',
    courierLat: 'Enlem',
    courierLng: 'Boylam',
    courierStatTotal: 'Toplam Kurye',
    courierStatActive: 'Aktif',
    courierStatOnDelivery: 'Teslimatta',
    courierStatIdle: 'Boşta',
    courierStatus: 'Durum',
    courierStatusPlaceholder: 'Yolda / Müşteride / Restoran',
    courierLastSeen: 'Son görülme',
    courierUseMyLocation: 'Mevcut konumumu kullan',
    courierShowInactive: 'Pasifleri göster',
    courierEmptyTitle: 'Henüz kurye yok',
    courierEmptyHint: 'İlk kuryenizi ekleyerek teslimat akışını başlatın.',
    courierNameRequired: 'Ad Soyad zorunludur.',
    courierPhoneRequired: 'Telefon zorunludur.',
    courierLoadError: 'Kuryeler yüklenemedi.',
    courierSearchPlaceholder: 'Kurye ara...',
    courierAssignNone: 'Atanmamış',
    courierRating: 'Kurye Değerlendirmesi',
    courierRatingPrompt: 'Bu teslimatı nasıl değerlendirirsiniz?',
    courierAvgRating: 'Ort. Puan',
    courierRatingError: 'Değerlendirme kaydedilemedi',
    courierRatingDone: 'Değerlendirmeniz kaydedildi',
    qrClaimedToday: 'talep alındı',
    qrConversionRate: 'dönüşüm',
    stockCostPerUnit: 'Birim Maliyet (₺)',
    stockCostHint: '— food cost hesabı için',
    foodCostTitle: 'Maliyet Analizi',
    foodCostUnitCost: 'Birim Maliyet',
    foodCostSellPrice: 'Satış Fiyatı',
    foodCostMargin: 'Marj',
    foodCostMissing: 'Bazı malzemelerin birim maliyeti girilmemiş — Stok sayfasından ekleyebilirsiniz.',
    foodCostAnalysisTitle: 'Maliyet ve Marj Analizi',
    foodCostAvgMargin: 'Ortalama marj',
    foodCostMissingShort: 'eksik maliyet',
    foodCostNoData: 'Reçeteli ürün yok. Recipes sayfasından reçete oluşturun.',
    foodCostTargetMargin: 'Hedef Marj',
    foodCostSuggested: 'Önerilen ₺',
    cogsTitle: 'Günlük COGS (Satılan Ürün Maliyeti)',
    cogsTotal: 'COGS',
    cogsTotalRevenue: 'Gelir',
    cogsGrossProfit: 'Brüt Kar',
    customerTags: 'Etiketler',
    customerTagsHint: 'segmentasyon (vip, vegan, no-spice...)',
    customerTagAddPlaceholder: 'Etiket yaz, Enter veya virgül ile ekle',
    customerAllTags: 'Tüm etiketler',
    customerClearTag: 'Etiketi temizle',
    segmentTitle: 'Müşteri Segmentasyonu',
    segmentTagsCount: 'segment',
    segmentNoData: 'Henüz segment verisi yok. Müşterilere etiket ekleyin.',
    // ERP-07 Part 1 — Cash transactions (kasa/banka hareketleri)
    cashTxTitle: 'Kasa Hareketleri',
    cashTxSubtitle: 'Restoranınızın gelir ve giderlerini takip edin.',
    cashTxNew: 'Yeni Hareket',
    cashTxEdit: 'Hareket Düzenle',
    cashTxTypeIn: 'Gelir',
    cashTxTypeOut: 'Gider',
    cashTxAmount: 'Tutar (₺)',
    cashTxCategory: 'Kategori',
    cashTxDate: 'Tarih',
    cashTxMethod: 'Yöntem',
    cashTxMethod_cash: 'Nakit',
    cashTxMethod_bank: 'Banka',
    cashTxMethod_card: 'Kart',
    cashTxMethod_other: 'Diğer',
    cashTxDescription: 'Açıklama',
    cashTxStatTotalIn: 'Toplam Gelir',
    cashTxStatTotalOut: 'Toplam Gider',
    cashTxStatBalance: 'Bakiye',
    cashTxFilterType: 'Tip',
    cashTxFilterAll: 'Tümü',
    cashTxClearFilters: 'Filtreleri temizle',
    cashTxEmptyTitle: 'Henüz hareket yok',
    cashTxEmptyHint: 'İlk gelir/gider kaydınızı ekleyerek başlayın.',
    cashTxAmountRequired: 'Tutar zorunludur ve sıfırdan büyük olmalı.',
    cashTxCategory_sale: 'Satış',
    cashTxCategory_supplier: 'Tedarikçi',
    cashTxCategory_rent: 'Kira',
    cashTxCategory_salary: 'Maaş',
    cashTxCategory_tax: 'Vergi',
    cashTxCategory_utilities: 'Faturalar',
    cashTxCategory_other: 'Diğer',
    cashTxAuto: 'Otomatik',
    cashTxAutoHint: 'Bu hareket bağlı bir kayıttan (satın alma siparişi/ödeme) otomatik oluşturuldu.',
    cashTxSyncPayments: 'Ödemelerden Senkronize Et',
    cashTxSyncConfirm: 'Onaylanmış ödemelerden henüz aktarılmamış olanları kasaya gelir olarak ekleyelim mi?',
    cashTxSyncResult: '{n} hareket eklendi.',
    pnlTabTitle: 'Kâr / Zarar',
    pnlSubtitle: 'Seçili dönem için gelir, COGS ve gider bazlı net kâr/zarar.',
    pnlIncome: 'Toplam Gelir',
    pnlCogs: 'COGS',
    pnlGrossProfit: 'Brüt Kâr',
    pnlExpense: 'Toplam Gider',
    pnlNetProfit: 'Net Kâr',
    pnlIncomeBreakdown: 'Gelir Kategorileri',
    pnlExpenseBreakdown: 'Gider Kategorileri',
    pnlEmptyTitle: 'Veri yok',
    pnlEmptyHint: 'Bu dönem için kasa hareketi bulunamadı.',
    customerLedger: 'Cari',
    customerLedgerTitle: 'Cari Hesap',
    customerLedgerDebit: 'Borç',
    customerLedgerCredit: 'Ödeme',
    customerLedgerBalance: 'Bakiye',
    customerLedgerOrder: 'Sipariş',
    customerLedgerPayment: 'Ödeme',
    customerLedgerEmpty: 'Hareket yok',
    customerLedgerEmptyHint: 'Bu müşteri için henüz sipariş veya ödeme bulunmuyor.',
    supplierMakePayment: 'Ödeme Yap',
    supplierPaymentAmount: 'Tutar (₺)',
    supplierPaymentMethod: 'Yöntem',
    supplierPaymentDate: 'Tarih',
    supplierPaymentNote: 'Açıklama',
    supplierPaymentSave: 'Kaydet',
    userHourlyRate: 'Saatlik Ücret (₺)',
    userPayroll: 'Maaş',
    payrollTitle: 'Maaş Hesabı',
    payrollPeriodStart: 'Başlangıç',
    payrollPeriodEnd: 'Bitiş',
    payrollCalculate: 'Hesapla',
    payrollShifts: 'Vardiya',
    payrollHours: 'Saat',
    payrollOvertimeHours: 'Mesai Saat',
    payrollRegularPay: 'Normal Ücret',
    payrollOvertimePay: 'Mesai Ücreti',
    payrollTotal: 'Toplam',
    payrollPay: 'Maaşı Öde',
    payrollPaid: 'Maaş ödemesi kasa hareketine kaydedildi.',
    payrollEmpty: 'Vardiya yok',
    payrollEmptyHint: 'Bu dönemde personelin vardiyası bulunmuyor.',
    payrollNoRate: 'Saatlik ücret tanımlı değil — ücretler 0 hesaplanıyor.',
    payrollReportTabTitle: 'Maaş Raporu',
    payrollReportTitle: 'Personel Maaş Raporu',
    payrollReportSubtitle: 'Seçili dönem için tüm personelin vardiya × saatlik ücret hesabı.',
    payrollReportStaff: 'Personel',
    payrollReportEmployee: 'Personel',
    payrollReportEmpty: 'Bu dönem için vardiya kaydı bulunamadı.',
    exportCsv: 'CSV İndir',
    msgWhatsApp: 'WhatsApp\'ta aç',
    stockOrderWhatsapp: 'Sipariş Ver',
    stockAdjustBtn: 'Ayarla',
    stockAdjustQuick: 'Hızlı Stok Ayarı',
    stockAdjustCurrent: 'Mevcut stok',
    stockAdjustAdd: 'Ekle (giriş)',
    stockAdjustRemove: 'Çıkar (ziyan/kullanım)',
    stockAdjustAmount: 'Miktar',
    stockAdjustNewQty: 'Yeni stok',
    stockAdjustNegative: 'Yeni stok negatif olamaz',
    stockAdjustReasonOptional: 'Sebep (opsiyonel)',
    stockAdjustReasonPlaceholder: 'Örn: tedarikçi teslimat, ziyan, sayım düzeltme',
    stockAdjustHistory: 'Geçmiş',
    stockAdjustNoHistory: 'Henüz hareket kaydı yok.',
    wasteWidgetTitle: 'Stok Hareketi',
    wasteWidgetGoStock: 'Stoğa git',
    wasteTotal: 'Ziyan',
    wasteIncoming: 'Giriş',
    wasteIncomingDesc: 'Tedarikçiden',
    wasteItemsCount: 'malzeme',
    wasteTopList: 'En çok ziyan',
    refundsTitle: 'İadeler',
    refundsSubtitle: 'Tüm iade kayıtları',
    refundStatTotal: 'Toplam İade',
    refundsTotalAmount: 'Toplam İade Tutarı',
    refundsCount: 'İade Sayısı',
    refundsAvg: 'Ortalama İade',
    refundsFilterFrom: 'Başlangıç',
    refundsFilterTo: 'Bitiş',
    refundsFilterApply: 'Filtrele',
    refundsFilterClear: 'Temizle',
    refundsFilterMonth: 'Bu Ay',
    refundsColPayment: 'Ödeme #',
    refundsColOrderTable: 'Sipariş / Masa',
    refundsColMethod: 'Yöntem',
    refundsColReason: 'Sebep',
    refundsEmptyTitle: 'İade kaydı yok',
    refundsEmptyHint: 'Henüz iade yapılmamış.',
    stockHistoryTitle: 'Stok Hareketleri',
    stockHistorySubtitle: 'Tüm stok giriş/çıkış kayıtları',
    stockHistoryTotal: 'Toplam Kayıt',
    stockHistoryIn: 'Giriş',
    stockHistoryOut: 'Çıkış',
    stockHistoryNetValue: 'Net Değer',
    stockHistoryFilterType: 'Tip',
    stockHistoryFilterIngredient: 'Malzeme',
    stockHistoryFilterAll: 'Tümü',
    stockHistoryColMovement: 'Hareket',
    stockHistoryColBefore: 'Önce → Sonra',
    stockHistoryColValue: 'Değer (₺)',
    stockHistoryColUser: 'Kullanıcı',
    stockHistoryEmpty: 'Hareket kaydı yok',
    stockHistoryEmptyHint: 'Bu filtre için stok hareketi bulunamadı.',
    msgSms: 'SMS gönder',
    msgEmail: 'E-posta gönder',

    // Tur 197 — Orders/Recipes/Webhooks/FeatureFlags/TaxGroups stat + date preset
    orderStatTotal: 'Toplam',
    orderStatPreparing: 'Hazırlanıyor',
    orderStatReady: 'Hazır',
    orderStatServed: 'Teslim Edildi',
    datePresetToday: 'Bugün',
    datePreset7Days: 'Son 7 Gün',
    datePreset30Days: 'Son 30 Gün',
    datePresetClear: '✕ Tarihi Temizle',
    recipeStatSteps: 'Tarif Adımı',
    recipeStatCost: 'Toplam Maliyet',
    recipeStatPrice: 'Satış Fiyatı',
    recipeStatMargin: 'Brüt Marjin',
    webhookStatSuccess: 'Son Başarılı',
    flagStatTotal: 'Toplam',
    flagStatEnabled: 'Aktif',
    flagStatDisabled: 'Pasif',
    taxStatTotal: 'Toplam',
    taxStatDefault: 'Varsayılan',
    taxStatRange: 'Aralık',
    // HR (Tur 210)
    hrPageTitle: 'Personel Yönetimi',
    hrPageSubtitle: 'Bordro, İzin ve İK işlemleri',
    hrTabEmployees: 'Personeller',
    hrTabPayroll: 'Bordro',
    hrTabLeaves: 'İzinler',
    hrTabDocuments: 'Belgeler',
    hrNewEmployee: 'Yeni Personel',
    hrEditEmployee: 'Personel Düzenle',
    hrFirstName: 'Ad',
    hrLastName: 'Soyad',
    hrTcKimlik: 'TC Kimlik No',
    hrElevenDigit: '11 haneli',
    hrBirthDate: 'Doğum Tarihi',
    hrHireDate: 'İşe Giriş Tarihi',
    hrDepartment: 'Departman',
    hrPosition: 'Pozisyon',
    hrEmploymentType: 'Çalışma Türü',
    hrGrossSalaryRequired: 'Brüt Maaş (₺) *',
    hrGrossSalaryPlaceholder: 'örn: 25000',
    hrHourlyRateOptional: 'Saatlik Ücret (₺, opsiyonel)',
    hrIban: 'IBAN',
    hrPhone: 'Telefon',
    hrEmail: 'E-posta',
    hrAddress: 'Adres',
    hrNotes: 'Notlar',
    hrActiveEmployee: 'Aktif Personel',
    hrCancel: 'İptal',
    hrSave: 'Kaydet',
    hrSaving: 'Kaydediliyor…',
    hrEmployeesRegistered: 'personel kayıtlı',
    hrTotalEmployees: 'Toplam Personel',
    hrActive: 'Aktif',
    hrPassive: 'Pasif',
    hrMonthlyTotalGross: 'Aylık Toplam Brüt',
    hrColFullName: 'Ad Soyad',
    hrColDepartment: 'Departman',
    hrColPosition: 'Pozisyon',
    hrColHireDate: 'İşe Giriş',
    hrColEmploymentType: 'Çalışma',
    hrColGrossSalary: 'Brüt Maaş',
    hrColStatus: 'Durum',
    hrColActions: 'İşlemler',
    hrNoEmployeesYet: 'Henüz personel eklenmemiş.',
    hrDelete: 'Sil',
    hrCalculatePayroll: 'Bordro Hesapla',
    hrEmployee: 'Personel',
    hrSelectPlaceholder: '-- Seçiniz --',
    hrYear: 'Yıl',
    hrMonth: 'Ay',
    hrWorkingDaysTotal: 'Çalışma Günü (toplam)',
    hrWorkedDays: 'Çalışılan Gün',
    hrOvertimeHours: 'Fazla Mesai (saat)',
    hrBonus: 'Prim / Bonus (₺)',
    hrAdvance: 'Avans (₺)',
    hrCalculate: 'Hesapla',
    hrCalculating: 'Hesaplanıyor…',
    hrCalculationSummary: 'Hesaplama Özeti',
    hrGrossSalary: 'Brüt Maaş',
    hrOvertimePay: 'Fazla Mesai Ücreti',
    hrBonusPremium: 'Prim / Bonus',
    hrSgkEmployee: 'SGK İşçi (%14)',
    hrUnemploymentEmployee: 'İşsizlik İşçi (%1)',
    hrIncomeTax: 'Gelir Vergisi',
    hrStampTax: 'Damga Vergisi',
    hrAdvanceDeduction: 'Avans Kesintisi',
    hrNetSalary: 'NET MAAŞ',
    hrSgkEmployerShare: 'SGK İşveren Payı',
    hrTotalCost: 'Toplam Maliyet',
    hrThisMonthTotalCost: 'Bu Ay Toplam Maliyet',
    hrTotalNetPayment: 'Toplam Net Ödeme',
    hrPendingApproval: 'Onay Bekleyen',
    hrBulkCalculate: 'Toplu Hesapla',
    hrColGross: 'Brüt',
    hrColSgkEmployee: 'SGK İşçi',
    hrColUnemployment: 'İşsizlik',
    hrColIncomeTaxShort: 'Gelir V.',
    hrColStampTax: 'Damga',
    hrColDeductions: 'Kesintiler',
    hrColNetSalary: 'Net Maaş',
    hrColSgkEmployer: 'SGK İşveren',
    hrColTotalCost: 'Toplam Maliyet',
    hrNoPayrollForPeriod: 'Bu dönem için bordro bulunamadı.',
    hrApprove: 'Onayla',
    hrPaid: 'Ödendi',
    hrPrint: 'Çıktı',
    hrCreateLeaveRequest: 'İzin Talebi Oluştur',
    hrLeaveType: 'İzin Türü',
    hrStartDate: 'Başlangıç Tarihi',
    hrEndDate: 'Bitiş Tarihi',
    hrDescriptionReason: 'Açıklama / Neden',
    hrSubmitRequest: 'Talep Oluştur',
    hrAllEmployees: 'Tüm Personeller',
    hrAllStatuses: 'Tüm Durumlar',
    hrPending: 'Bekleyen',
    hrApproved: 'Onaylı',
    hrRejected: 'Reddedilen',
    hrLeaveRequest: 'İzin Talebi',
    hrTotalLeaves: 'Toplam İzin',
    hrEntitlement: 'Hak',
    hrUsed: 'Kullanılan',
    hrRemaining: 'Kalan',
    hrDays: 'gün',
    hrStart: 'Başlangıç',
    hrEnd: 'Bitiş',
    hrDay: 'Gün',
    hrNoLeavesFound: 'İzin kaydı bulunamadı.',
    hrReject: 'Reddet',
    hrAddDocument: 'Belge Ekle',
    hrDocumentType: 'Belge Türü',
    hrTitle: 'Başlık',
    hrDocumentTitlePlaceholder: 'Belge başlığı',
    hrFileUrl: "Dosya URL'si",
    hrAdd: 'Ekle',
    hrTotalDocuments: 'Toplam Belge',
    hrThisMonth: 'Bu Ay',
    hrEmployeeCount: 'Personel Sayısı',
    hrNoDocumentsFound: 'Belge bulunamadı.',
    hrView: 'Görüntüle',
    hrSearchEmployee: 'Personel ara...',
    hrBulkLeaveTitle: 'Toplu İzin Ekle',
    hrBulkLeaveBtn: 'Toplu İzin',
    hrBulkLeaveHint: 'Yılbaşı, dini bayram veya resmi tatil için tüm personele tek seferde izin atayın.',
    hrBulkScope: 'Kapsam',
    hrBulkAllActive: 'Tüm aktif personel',
    hrBulkSelected: 'Seçili personeller',
    hrBulkCreate: 'Toplu Ata',
    hrStatus: 'Durum',
    hrSelectDateRange: 'Tarih aralığı giriniz.',
    hrEndBeforeStart: 'Bitiş tarihi başlangıçtan önce olamaz.',
    hrSelectAtLeastOne: 'En az 1 personel seçin.',
    hrNoActiveEmployees: 'Aktif personel yok.',
    hrCalcModeGross: '📥 Brüt → Net',
    hrCalcModeNet: '📤 Net → Brüt',
    hrNetTarget: 'Net Hedef (₺)',
    hrEstimatedGross: 'Tahmini Brüt',
    hrIterations: 'iterasyon',
    // HR mevzuat genişletme (Tur 229)
    hrOptionalAllowancesDeductions: 'Aylık Yardımlar & Kesintiler (Opsiyonel)',
    hrMaritalStatus: 'Medeni Durum',
    hrMaritalSingle: 'Bekar',
    hrMaritalMarried: 'Evli',
    hrMaritalWidowed: 'Dul',
    hrMaritalDivorced: 'Boşanmış',
    hrChildrenCount: 'Çocuk Sayısı',
    hrMonthlyAllowancesTaxFree: 'Aylık Yardımlar (vergisiz, nete dahil)',
    hrMealAllowance: 'Yemek Kartı',
    hrTransportAllowance: 'Yol Parası',
    hrFamilyAllowance: 'Aile Yardımı',
    hrChildAllowance: 'Çocuk Yardımı',
    hrMonthlyDeductions: 'Aylık Kesintiler',
    hrUnionDues: 'Sendika Aidatı',
    hrBesPayment: 'BES Kesintisi',
    hrWeeklyHolidayHours: 'Hafta Tatili Mesai (saat)',
    hrWeeklyHolidayHint: '1.5x katsayı',
    hrPublicHolidayHours: 'Resmi Tatil Mesai (saat)',
    hrPublicHolidayHint: '2x katsayı',
    hrAllowancesAndSpecialDeductions: 'Yardımlar & Özel Kesintiler',
    hrSpecialDeductions: 'Özel Kesintiler',
    hrAlimony: 'Nafaka',
    hrGarnishment: 'İcra',
    hrWeeklyHolidayPay: 'Hafta Tatili Ücreti',
    hrPublicHolidayPay: 'Resmi Tatil Ücreti',
    stockLowAlert: '⚠️ {count} malzeme kritik seviyede',
    settingsSavedAt: 'Kaydedildi',
    // Tur 248 i18n tail sweep
    custCorporateLabel: 'Kurumsal',
    custTypeLabel: 'Müşteri Türü',
    custIndividual: 'Bireysel',
    custCorporateInfo: 'Kurumsal Bilgiler',
    custCompanyName: 'Şirket Adı',
    custTaxNumber: 'Vergi No',
    custTaxOffice: 'Vergi Dairesi',
    custCreditLimit: 'Cari Borç Limiti (₺)',
    custAddressLabel: 'Adres',
    custLedgerAddDebt: 'Borç Ekle',
    custLedgerTakePayment: 'Ödeme Al',
    setTaxSgkSection: 'Vergi & SGK Bilgileri (e-Bildirge / Muhtasar için)',
    setTaxNumberLabel: 'Vergi Numarası',
    setTaxOfficeLabel: 'Vergi Dairesi',
    setSgkSicilNo: 'SGK İşyeri Sicil No',
    setTaxSgkHint: "Bu bilgiler SGK Bildirge ve Muhtasar Beyanname PDF'lerinde otomatik kullanılır.",
    dashDocExpiryTitle: 'Belge Süreleri',
    dashViewAll: 'tümü →',
    dashDocExpiryEmpty: 'Süresi yaklaşan/dolan belge yok',
    rptTopSpendersTitle: 'En Çok Harcayan Top 10',
    rptViewAll: 'tümü →',
    rptNoDataShort: 'Henüz veri yok',
    hrSgkSicilNoLabel: 'SGK Sicil No (opsiyonel)',
    hrSgkSicilNoPlaceholder: 'SGK aylık prim hizmet bildirimi için',
    hrSgkBildirgeBtn: 'SGK Bildirge',
    hrSearchLeave: 'İzin ara...',
    hrSearchDocument: 'Belge ara...',
    // Couriers (Tur 216)
    crGeoNotSupported: 'Tarayıcı konum erişimi desteklemiyor',
    crGeoFailed: 'Konum alınamadı',
    crFillAtLeastOne: 'En az bir alan doldurun',
    crAgoNow: 'şimdi',
    crAgoMin: 'dk önce',
    crAgoHour: 'sa önce',
    crAgoDay: 'g önce',
    crLast7Days: 'Son 7 Gün',
    crLast30Days: 'Son 30 Gün',
    crThisMonth: 'Bu Ay',
    crLastMonth: 'Geçen Ay',
    crClearDate: 'Tarihi Temizle',
    loginEmailPlaceholder: 'ornek@restoran.com',
    // Empty states (Tur 218)
    stockNoItemsTitle: 'Henüz malzeme yok',
    stockNoItemsDesc: 'İlk malzemeni ekleyerek envanterini takip etmeye başla.',
    stockAddItem: '+ Yeni Malzeme',
    stockNoSearchResultsTitle: 'Sonuç bulunamadı',
    stockNoSearchResultsDesc: 'Arama veya filtre kriterlerini değiştirerek tekrar deneyin.',
    rcpNoItemsTitle: 'Henüz tarif yok',
    rcpNoItemsDesc: 'Menü ürünleri için tarif ekleyerek maliyetlerini takip et.',
    rcpNoSearchResultsTitle: 'Sonuç bulunamadı',
    rcpNoSearchResultsDesc: 'Arama kriterlerini değiştirerek tekrar deneyin.',
    whkNoItemsTitle: 'Henüz webhook aboneliği yok',
    whkNoItemsDesc: 'Zapier, Make veya kendi sunucuna olay yayını yapmak için bir abonelik ekle.',
    whkAddBtn: '+ Yeni Abonelik',
    whkNoSearchResultsTitle: 'Sonuç bulunamadı',
    whkNoSearchResultsDesc: 'URL veya etkinlik aramasını değiştir.',
    auditNoItemsTitle: 'Henüz log kaydı yok',
    auditNoItemsDesc: 'Sistem üzerinde yapılan işlemler burada izlenir.',
    auditNoSearchResultsTitle: 'Sonuç bulunamadı',
    auditNoSearchResultsDesc: 'Arama veya tarih filtresini değiştir.',
    // Empty states 2 (Tur 219)
    taxNoItemsTitle: 'Henüz vergi grubu yok',
    taxNoItemsDesc: 'KDV oranlarını gruplandırarak menü ürünlerini hızlıca etiketleyebilirsin.',
    taxAddBtn: '+ Yeni Vergi Grubu',
    taxNoSearchResultsTitle: 'Sonuç bulunamadı',
    taxNoSearchResultsDesc: 'Arama veya tarih filtresini değiştir.',
    flagNoItemsTitle: 'Henüz feature flag yok',
    flagNoItemsDesc: 'Yeni özellikleri rollout aşamalarında kontrol etmek için flag ekleyebilirsin.',
    flagAddBtn: '+ Yeni Flag',
    flagNoSearchResultsTitle: 'Sonuç bulunamadı',
    flagNoSearchResultsDesc: 'Arama veya tarih filtresini değiştir.',
    promoNoItemsTitle: 'Henüz promo kodu yok',
    promoNoItemsDesc: 'İlk indirim kodunu oluşturarak müşterilerini ödüllendirmeye başla.',
    promoAddBtn: '+ Yeni Kod',
    promoNoSearchResultsTitle: 'Sonuç bulunamadı',
    promoNoSearchResultsDesc: 'Arama veya filtre kriterlerini değiştir.',
    rsvNoItemsTitle: 'Henüz rezervasyon yok',
    rsvNoItemsDesc: 'Müşteri rezervasyonları burada görünür. İstersen elle yeni bir rezervasyon ekleyebilirsin.',
    rsvAddBtn: '+ Yeni Rezervasyon',
    rsvNoSearchResultsTitle: 'Sonuç bulunamadı',
    rsvNoSearchResultsDesc: 'Arama veya tarih filtresini değiştir.',
    // Empty states 3 (Tur 221)
    prnNoItemsTitle: 'Henüz yazıcı yok',
    prnNoItemsDesc: 'ESC/POS uyumlu termal yazıcını ekleyerek mutfak/adisyon çıktısını otomatikleştir.',
    prnAddBtn: '+ Yeni Yazıcı',
    prnNoSearchResultsTitle: 'Sonuç bulunamadı',
    prnNoSearchResultsDesc: 'Arama veya filtre kriterlerini değiştir.',
    notifNoItemsTitle: 'Henüz bildirim yok',
    notifNoItemsDesc: 'Sipariş, ödeme ve sistem olayları geldikçe bildirimler burada görünecek.',
    notifNoSearchResultsTitle: 'Sonuç bulunamadı',
    notifNoSearchResultsDesc: 'Filtre, arama veya tarih kriterlerini değiştir.',
    // Empty states 4 (Tur 222)
    mmNoItemsTitle: 'Henüz menü ürünü yok',
    mmNoItemsDesc: 'İlk kategorini ve ürünlerini ekleyerek menünü oluştur.',
    mmAddBtn: '+ Yeni Ürün',
    mmNoSearchResultsTitle: 'Sonuç bulunamadı',
    mmNoSearchResultsDesc: 'Arama veya kategori filtresini değiştir.',
    trashNoItemsTitle: 'Çöp kutusu boş',
    trashNoItemsDesc: 'Silinen kayıtlar buraya gelir ve buradan geri yüklenebilir.',
    trashNoSearchResultsTitle: 'Sonuç bulunamadı',
    trashNoSearchResultsDesc: 'Arama kriterini değiştir.',
    // Empty states 5 (Tur 223)
    hrPayrollEmptyTitle: 'Bu dönem için bordro yok',
    hrPayrollEmptyDesc: 'Toplu Hesapla butonu ile tüm personellere bordro üret veya tek tek hesapla.',
    wsNoItemsTitle: 'Henüz garson aktivitesi yok',
    wsNoItemsDesc: 'Garsonlar sipariş aldıkça performans verileri burada görünecek.',
    wsNoSearchResultsTitle: 'Sonuç bulunamadı',
    wsNoSearchResultsDesc: 'Arama veya tarih aralığını değiştir.',
    shfNoItemsTitle: 'Bu hafta için vardiya atanmamış',
    shfNoItemsDesc: 'Şablon kullanarak veya hücreye tıklayarak vardiya atayabilirsin.',
    shfAddBtn: '+ Vardiya Ata',
    shfNoSearchResultsTitle: 'Sonuç bulunamadı',
    shfNoSearchResultsDesc: 'Personel aramasını değiştir.',
    gdprAdminEmptyTitle: 'Henüz GDPR talebi yok',
    gdprAdminEmptyDesc: 'KVKK / GDPR veri silme/dışa aktarma talepleri buradan yönetilir.',
    gdprUserEmptyTitle: 'Henüz talep göndermediniz',
    gdprUserEmptyDesc: 'Verilerinizi indirmek veya silinmesini istemek için yeni bir talep oluşturun.',
    gdprNewRequestBtn: '+ Yeni Talep',
    securityNoTwoFa: '2FA henüz aktif değil',
    securityNoTwoFaDesc: 'Hesabınızı korumak için iki faktörlü kimlik doğrulamayı etkinleştirebilirsiniz.',
    securitySetup2fa: 'Etkinleştir',
    // Empty states 7 (Tur 226)
    tableNoItemsTitle: 'Henüz masa yok',
    tableNoItemsDesc: 'İlk masanı ekleyerek sipariş yönetimine başla.',
    tableAddBtn: '+ Yeni Masa',
    tableNoCategoryItemsTitle: 'Bu kategoride masa yok',
    tableNoCategoryItemsDesc: 'Farklı bir kategori seçin veya bu kategoriye masa ekleyin.',
    ordNoItemsTitle: 'Henüz sipariş yok',
    ordNoItemsDesc: 'Yeni siparişler geldikçe burada listelenecek.',
    ordNoSearchResultsTitle: 'Sonuç bulunamadı',
    ordNoSearchResultsDesc: 'Filtre veya tarih kriterlerini değiştir.',
    payNoItemsTitle: 'Henüz ödeme yok',
    payNoItemsDesc: 'Tamamlanan siparişlerin ödemeleri burada görünecek.',
    payNoSearchResultsTitle: 'Sonuç bulunamadı',
    payNoSearchResultsDesc: 'Tarih aralığını değiştir.',
    kitNoItemsTitle: 'Hazırlanacak sipariş yok',
    kitNoItemsDesc: 'Yeni siparişler geldiğinde mutfak ekranında burada görünecek.',
    // Empty states 8 (Tur 227)
    posCartEmptyTitle: 'Sepet boş',
    posCartEmptyDesc: 'Sol panelden ürün seçerek sepete ekleyin.',
    posProductsEmpty: 'Bu kategoride ürün yok',
    posProductsEmptyDesc: 'Farklı bir kategori veya barkod arayın.',
    posHistoryEmpty: 'Geçmiş kayıt yok',
    posHistoryEmptyDesc: 'Bu tarihte satış bulunamadı.',
    posHoldEmpty: 'Bekleyen sipariş yok',
    posHoldEmptyDesc: 'Hold ettiğiniz siparişler burada görünür.',
    cdNoOrdersTitle: 'Henüz sipariş yok',
    cdNoOrdersDesc: 'Bu müşterinin sipariş geçmişi burada listelenir.',
    cdNoLoyaltyTitle: 'Henüz puan hareketi yok',
    cdNoLoyaltyDesc: 'Sipariş tamamlandıkça sadakat puanları biriktirilir.',
    msNoPaymentsTitle: 'Henüz ödeme yok',
    msNoPaymentsDesc: 'Plan yenilendikçe ödeme geçmişiniz burada görünecek.',
    msNoInvoicesTitle: 'Henüz fatura yok',
    msNoInvoicesDesc: 'Faturalar dönem sonunda otomatik üretilir.',
    msInvoicesTitle: 'Faturalar',
    dashTopItemsEmpty: 'Bugün satış yok',
    dashTopItemsEmptyDesc: 'Sipariş geldikçe en çok satanlar burada listelenir.',
    dashActivityEmpty: 'Henüz aktivite yok',
    dashActivityEmptyDesc: 'Son işlemler burada gözükecek.',
    // i18n tail (Tur 211)
    rptVatRatePct: 'KDV %',
    rptVatLabel: 'KDV',
    rptCriticalLabel: 'Kritik',
    rptMarginPct: 'Marj %',
    rptProfitTooltip: 'Kar',
    notifCsvDate: 'Tarih',
    notifCsvSeverity: 'Önem',
    notifCsvType: 'Tip',
    notifCsvTitle: 'Başlık',
    notifCsvMessage: 'Mesaj',
    notifPresetToday: 'Bugün',
    notifPresetLast7Days: 'Son 7 Gün',
    notifPresetThisMonth: 'Bu Ay',
    notifPresetLastMonth: 'Geçen Ay',
    notifClearDate: 'Tarihi Temizle',
    tableBulkPrefixDefault: 'Masa',
    tablePromoCodePlaceholder: 'HOSGELDIN10',
    tableVoucherCodePlaceholder: 'GV-KARAD100',
    giftCustomerNamePh: 'Ahmet Yılmaz',
    giftEmailPh: 'ornek@mail.com',
    // i18n tail (Tur 213)
    custDateLabel: 'Tarih',
    custDateLast7Days: 'Son 7 Gün',
    custDateLast30Days: 'Son 30 Gün',
    custDateThisMonth: 'Bu Ay',
    custDateLastMonth: 'Geçen Ay',
    custClearDate: 'Tarihi Temizle',
    custNewBadge: 'YENİ',
    custProfileLinkTitle: 'Profil sayfasını aç (sipariş geçmişi + sadakat)',
    auditSearchPlaceholder: 'Kullanıcı/işlem ara...',
    supPaymentDescPrefix: 'Tedarikçi ödemesi',
    supTaxNumberShort: 'VKN',
    supActiveLabel: 'Aktif',
    supCashRefPrefix: 'Kasa',
    stockWhatsappMsgFull: 'stoğu kritik seviyede',
    stockWhatsappOrderAsk: 'Sipariş verebilir miyiz?',
    stockWhatsappMsgShort: 'stoğu kritik',
    stockWhatsappOrderShort: 'Sipariş?',
    // i18n tail (Tur 214)
    navManagementPlatform: 'Yönetim Platformu',
    navManagementSystem: 'Yönetim & Sistem',
    navMore: 'Daha',
    checkoutIframeTitle: 'İyzico ödeme',
    checkoutFirstNamePh: 'Ahmet',
    checkoutLastNamePh: 'Yılmaz',
    checkoutCityPh: 'İstanbul',
    customersCampaignSendTitle: 'Kampanya gönder',
    customersCorpNamePlaceholder: 'Örn. ACME Yazılım A.Ş.',
    customersTaxOfficePlaceholder: 'Örn. Kadıköy',
    customersAddressPlaceholder: 'Açık adres (opsiyonel)',
    customersCampaignNamePlaceholder: 'örn: Yılbaşı İndirimi',
    customersCampaignSubjectPlaceholder: 'Sizi özledik!',
    hrEmployeeDetailTitle: 'Personel Detayı',
    hrLinkedAccountTitle: 'Bağlı login hesabını Users sayfasında aç',
    hrCreateAccountTitle: 'Users sayfasında bu personele login hesabı oluşturun',
    hrBulkImportTitle: 'Personel Toplu İçe Aktar (CSV)',
    hrNetTargetPlaceholder: 'örn: 30000',
    hrAnnualSummary: 'Yıllık Özet',
    hrSgkBildirgePDFTitle: 'SGK Aylık Prim ve Hizmet Belgesi PDF',
    hrAllowancesShort: 'Yardımlar',
    hrLeaveReasonPlaceholder: 'örn: Yılbaşı tatili',
    posEditProduct: 'Ürünü düzenle',
    posEditQty: 'Miktarı düzenle',
    posEditPrice: 'Fiyatı düzenle',
    onboardingStep1Title: 'Restoran',
    onboardingStep2Title: 'Masalar',
    onboardingStep3Title: 'Menü',
    onboardingStep4Title: 'Tamam',
    peakHourSticker: '0–23 arası peak',
    peakHourFallbackHint: 'Saatlik dağılım yok — yalnızca tepe saat gösteriliyor',
    dashNoOrdersToday: 'Bugün henüz sipariş yok',
    shiftsBordroBannerPart1: 'Bordro hesaplaması artık',
    shiftsBordroBannerHrLink: 'Personel Yönetimi',
    shiftsBordroBannerPart2: 'sayfasında. Bu sayfa sadece haftalık vardiya planlamadır.',
    reservationsCustomerSearch: 'Müşteri ara...',
    cashTxSearchPlaceholder: 'Açıklama/kategori ara...',
    custSegmentInactive: '💤 İnaktif',
    reportsPrintAction: '🖨️ Yazdır',
    stockApproaching: '⚠️ Yaklaşan',
    stockApproachingHint: 'Min stok seviyesine yaklaşıyor',
    customersLastOrderCol: 'Son Sipariş',
    customersDaysAgo: '{n} gün önce',
    customersToday: 'Bugün',
    customersYesterday: 'Dün',
    customersNever: '—',
    quickActionsTitle: 'Hızlı İşlem',
    quickActionNewOrder: 'Yeni Sipariş',
    quickActionNewTable: 'Yeni Masa',
    quickActionNewCustomer: 'Yeni Müşteri',
    quickActionNewStaff: 'Yeni Personel',
    notifPushEnable: '🔔 Push Bildirim Aç',
    notifPushDisable: '🔕 Push Bildirim Kapat',
    notifPushUnsupported: 'Bu cihazda desteklenmiyor',
    notifPushGranted: 'Push aktif',
    notifPushDenied: 'İzin reddedildi — tarayıcı ayarlarından açın',
    rptColSegment: 'Segment',
    rptColLastOrder: 'Son Sipariş',
    dashOrderChannelsTitle: 'Bugünkü Sipariş Kanalları',
    dashChannelPOS: 'POS',
    dashChannelTable: 'Masa',
    dashChannelOnline: 'Online',
    dashChannelDelivery: 'Paket',
    posItemAddedToast: '✓ {name} eklendi',
    tableDurationHourShort: 'sa',
    settingsCustomerSegments: '👥 Müşteri Segment Eşikleri',
    settingsVipThreshold: 'VIP eşiği (TL, son 12 ay)',
    settingsLoyalThreshold: 'Sadık eşiği (sipariş, son 3 ay)',
    settingsInactiveDays: 'İnaktif eşiği (gün)',
    settingsLostDays: 'Kayıp eşiği (gün)',
    mobileBottomNav: 'Mobil hızlı menü',
    stockBulkReceiptBtn: 'Toplu Sevkiyat',
    stockBulkReceiptTitle: 'Toplu Sevkiyat Girişi',
    stockBulkAdd: 'Eklenecek',
    stockBulkSearch: 'Malzeme ara...',
    stockBulkSubmit: 'Sevkiyatı Kaydet',
    stockBulkSuccessTpl: '{n} malzeme güncellendi',
    a11yCustomerSearch: 'Müşteri ara',
    a11ySendCampaign: 'Kampanya gönder',
    a11yOpenProfile: 'Profili aç',
    hrCloseModal: 'Kapat',
    hrPrevMonth: 'Önceki ay',
    hrNextMonth: 'Sonraki ay',
    hrMuhtasarPDFAriaLabel: 'Muhtasar Beyanname Özeti PDF indir',
    hrBankCSVAriaLabel: 'Banka transfer CSV indir',
    hrPayrollCSVExportAriaLabel: 'Bordro CSV dışa aktar',
    hrPrintPayslipAriaLabel: 'Bordro yazdır',
    hrDownloadPDFAriaLabel: 'PDF indir',
    hrImportEmployeesAriaLabel: 'CSV ile toplu personel ekle',
    tablesPickColorAria: 'Renk seç',
    a11yReportsTablistLabel: 'Rapor sekmeleri',
    a11yDateFiltersLabel: 'Tarih filtreleri',
    a11yExportCsvLabel: 'CSV olarak indir',
    a11yPrintLabel: 'Raporu yazdır',
    loginSubmitting: 'Giriş yapılıyor...',
    loginForgotPasswordAria: 'Şifremi unuttum, sıfırlama sayfasına git',
    loginDemoFill: 'Demo hesap doldur',
    posCartClear: 'Sepeti temizle',
    supplierSearchAriaLabel: 'Tedarikçi ara',
    supCallAria: 'Ara',
    supWhatsappAria: 'WhatsApp ile yaz',
    stockStatusFilterAria: 'Stok durum filtresi',
    notifClearDateAria: 'Tarih filtresini temizle',
    notifDismissReadAria: 'Okunmuş bildirimleri temizle',
    notifDismissVisibleAria: 'Görünen bildirimleri gizle',
    notifListAria: 'Bildirim listesi',
    notifSearchAria: 'Bildirimde ara',
    orderLabel: 'Sipariş',
    kitchenLateHint: 'Gecikmiş!',
    settingsTabsAriaLabel: 'Ayarlar sekmeleri',
    settingsSubTabsAriaLabel: 'Genel alt sekmeleri',
    settingsCustomerSegmentsAria: 'Müşteri segment eşiklerini aç/kapat',
    saveSettingsBtnDisabledAria: 'Kaydedilecek değişiklik yok',
    onbReopenBtnAria: 'Onboarding sihirbazını tekrar aç',
    themeToggleLabel: 'Tema değiştir',
    userProfileLabel: 'Kullanıcı profili',
    headerNavLabel: 'Üst menü',
    onbStepCompleted: 'Tamamlandı',
    onbWizardNav: 'Sihirbaz gezinme',
    onbPrevStep: 'Önceki adım',
    onbNextStep: 'Sonraki adım',
    a11yStatusFilterGroup: 'Sipariş durum filtresi',
    a11yDateRangeGroup: 'Tarih aralığı',
    a11yDeliveryStatsRegion: 'Teslimat istatistikleri',
    a11yOrderCardPrefix: 'Sipariş',
    a11yAdvanceStatusTo: 'Durumu güncelle',
    userSearchAriaLabel: 'İsim veya email ara',
    roleFilterAriaLabel: 'Rol filtresi',
    viewModeLabel: 'Görünüm',
    dateRangePresetsLabel: 'Tarih aralığı önayarları',
    clearDateRange: 'Tarih aralığını temizle',
    dateQuickChipsLabel: 'Tarih hızlı seçimi',
    filterByDateLabel: 'Tarihe göre filtrele',
    callCustomer: 'Müşteriyi ara',
    whatsappContact: 'WhatsApp ile iletişim',
    changeStatusTo: 'Durumu değiştir',
    reservationTime: 'Rezervasyon saati',
    dismissError: 'Hatayı kapat',
    searchRecipesAria: 'Tariflerde ara',
    exportCsvAria: 'CSV olarak dışa aktar',
    addIngredientAria: 'Yeni malzeme ekle',
    recipeStatRegionAria: 'Tarif istatistik özeti',
    shiftPrevWeekAria: 'Önceki hafta',
    shiftNextWeekAria: 'Sonraki hafta',
    shiftsBordroBannerLinkAria: 'Personel Yönetimi sayfasına git',
    shiftStatusOnLeaveSr: 'İzinde',
    shiftSearchStaffAria: 'Personel ara',
    auditDatePresetGroup: 'Tarih ön ayarı',
    a11yCloseError: 'Hatayı kapat',
    a11yDatePresetGroup: 'Tarih ön ayarları',
    trashTabsLabel: 'Çöp kutusu sekmeleri',
    flagSearchAria: 'Feature flag ara',
    flagClearDateAria: 'Tarih filtresini temizle',
    taxGroupClearDates: 'Tarihi Temizle',
    taxGroupFormHeading: 'Vergi grubu formu',
    gdprDownloadPackageAria: 'KVKK veri paketini indir',
    gdprFiltersAria: 'Talep filtreleri',
    webhookDeliverySuccess: 'Başarılı',
    webhookDeliveryFailed: 'Başarısız',
    a11yRefreshJobs: 'Baskı kuyruğunu yenile',
    whiteLabelSearchAria: 'Yapılandırma ara',
    whiteLabelPreviewAria: 'Marka önizleme',
    whiteLabelPrimaryColorPicker: 'Birincil renk seçici',
    whiteLabelSecondaryColorPicker: 'İkincil renk seçici',
    whiteLabelTextColorPicker: 'Metin rengi seçici',
    whiteLabelBgColorPicker: 'Arka plan rengi seçici',
    wsPeriodGroupLabel: 'Dönem seçimi',
    wsSortGroupLabel: 'Sıralama',
    wsDatePresetGroupLabel: 'Tarih hazır seçenekleri',
    wsClearDateLabel: 'Tarihi temizle',
    wsStatRegionLabel: 'Performans özeti',
    deliverySearchPlaceholder: 'Sipariş/müşteri ara...',
    settingsTaxOfficePlaceholder: 'örn: Beşiktaş',
    userHrLinkTitle: 'HR Personel Yönetimine Git',
    platformMgmtNoResults: 'Sonuç bulunamadı',
    platformMgmtNoResultsDesc: 'Arama kriterini değiştir.',
    platformMgmtEmpty: 'Henüz platform yapılandırılmamış',
    platformMgmtEmptyDesc: 'Yemeksepeti/Trendyol/Getir/Migros gibi platformları bağlayarak online siparişlerini buradan yönet.',
    whiteLabelSearchPlaceholder: 'Yapılandırma ara...',
    whiteLabelNoResults: 'Sonuç bulunamadı',
    whiteLabelNoResultsDesc: 'Arama kriterini değiştir.',
    pricingBillingCycleLabel: 'Faturalandırma dönemi',
    pricingMostPopularBadgeLabel: 'En popüler plan rozeti',
    msCurrentSubscriptionRegion: 'Mevcut abonelik',
    hrPayslipWorkingDays: 'Çalışma Günü',
    hrPayslipMonthlyGross: 'Aylık Brüt Ücret',
    hrGarnishmentDeduction: 'İcra Kesintisi',
    hrEmployerCost: 'İşveren Maliyeti',
    hrEmployeeSignature: 'Personel İmza',
    hrYearsOfService: 'Hizmet Yılı',
    hrSeverancePay: 'Kıdem Tazminatı',
    hrNoticePay: 'İhbar Tazminatı',
    hrNoticePeriod: 'İhbar Süresi',
    hrDailyGross: 'Günlük Brüt',
    hrTotalGross: 'Toplam Brüt',
    hrTotalNet: 'Toplam Net',
    cdCustomerInfo: 'Müşteri Bilgileri',
    cdJoinDate: 'Üye Olma Tarihi',
    cdLoyaltyPoints: 'Sadakat Puanı',
    cdCurrentAccount: 'Cari Hesap',
    customersCampaignNameLabel: 'Kampanya Adı',
    customersTargetSegment: 'Hedef Segment',
    customersAllCustomers: 'Tüm Müşteriler',
    customersEmailSubjectLabel: 'Email Konusu',
    customersMessageBody: 'Mesaj İçeriği',
    posEditProductTitle: 'Ürünü Düzenle',
    promoQRHint: 'Müşteri telefon kamerasıyla okutabilir',
    navMainMenu: 'Ana menü',
    reportsRevenueDelta: 'Ciro Değişimi',
    usersLoginBannerPart1: '💡 Bu sayfa ',
    usersLoginBannerStrong: 'login hesaplarını',
    usersLoginBannerPart2: ' yönetir. Personel bordro/izin/belge kayıtları için ',
    usersLoginBannerLink: 'Personel Yönetimi',
    usersLoginBannerPart3: '\'ne gidin.',
    poStatsRegion: 'Sipariş özeti',
    datePresetGroup: 'Tarih önayarları',
    cdStatTotalOrders: 'Toplam Sipariş',
    cdStatTotalSpent: 'Toplam Harcama',
    cdStatAvgOrder: 'Ort. Sipariş',
    cdStatLastOrder: 'Son Sipariş',
    a11yUnreadNotifications: 'okunmamış bildirim',
    sidebarLockedFeatureTitle: 'Bu özellik planınıza dahil değil',
    saSidebarToggle: 'Süperadmin menüyü aç',
    saSidebarNavLabel: 'Süperadmin menü',
    saSidebarClose: 'Menüyü kapat',
    closeMenu: 'Menüyü kapat',
    chainAdminNavLabel: 'Zincir admin menü',
    settingsSegPreviewAria: 'Mevcut segment dağılımı önizlemesi',
    settingsSegPreviewPeople: 'kişi',
    segmentLoyal: 'Sadık',
    segmentInactive: 'İnaktif',
    segmentLost: 'Kayıp',
    lockScreenDigit: 'Rakam',
    lockScreenBackspace: 'Geri sil',
    shortcutDashboard: 'Ana sayfa (Dashboard)',
    deliveryPlatformBreakdown: 'Platform Dağılımı',
    deliveryPlatformOther: 'Diğer',
    deliveryPlatformOrdersShort: 'sip.',
    a11yDeliveryPlatformBreakdown: 'Platform dağılımı',
    stockCategoryBreakdown: 'Kategori Bazlı Stok Dağılımı',
    stockCategoryOther: 'Diğer',
    customersExportExcel: '📊 Excel İndir',
    reportsYearlyMonthlyShow: 'Aylık Detayı Göster (12 ay × 2 yıl)',
    reportsMonthShortList: 'Oca,Şub,Mar,Nis,May,Haz,Tem,Ağu,Eyl,Eki,Kas,Ara',
    sortByLabel: 'Sırala:',
    sortByDate: 'Tarih',
    sortByDiscount: 'İndirim',
    sortByUsage: 'Kullanım',
    voucherSortDate: 'Tarih',
    voucherSortAmount: 'Tutar',
    voucherSortRemaining: 'Kalan',
    voucherSortExpires: 'Son Kullanma',
    supSortProductCount: 'Ürün',
    supSortCreatedAt: 'Eklenme',
    supSortAria: 'Sırala',
    category: 'Kategori',
    stockSortByAria: 'Sırala',
    reportsExportAll: 'Tümünü İndir',
    a11yExportAllLabel: 'Tüm rapor sekmelerini CSV olarak indir',
    customersBulkSelectedLabel: '{n} müşteri seçildi',
    customersBulkDelete: '🗑️ Toplu Sil',
    customersBulkExport: '📊 Seçili CSV İndir',
    customersBulkClear: '❌ Seçimi Temizle',
    customersBulkDeleteConfirm: '{n} müşteri silinecek. Devam edilsin mi?',
    customersBulkSelectAll: 'Tümünü seç',
    customersBulkSelectRow: '{name} seç',
    bulkSelectOrder: 'Sipariş seç',
    bulkSelectAll: 'Tümünü seç',
    bulkActionBar: 'Toplu işlem',
    bulkSelected: '{count} sipariş seçildi',
    bulkAccept: 'Kabul Et',
    bulkPreparing: 'Hazırlanıyor',
    bulkReady: 'Yola Çıktı',
    bulkDelivered: 'Teslim Edildi',
    bulkCancel: 'İptal Et',
    bulkClear: 'Seçimi Temizle',
    bulkConfirm: '{count} sipariş güncellenecek. Devam?',
    bulkSuccess: '{count} sipariş güncellendi.',
    bulkSkipped: 'atlandı',
    bulkNoEligible: 'Seçimde uygun sipariş yok.',
    stockBulkSelectedTpl: '{n} malzeme seçildi',
    stockBulkDelete: 'Toplu Sil',
    stockBulkCategory: 'Toplu Kategori',
    stockBulkDeleteConfirm: '{n} malzeme silinecek. Emin misiniz?',
    stockBulkDeleteDone: '{n} malzeme silindi',
    stockBulkCategoryDone: '{n} malzeme güncellendi',
    stockBulkCategoryLabel: 'Yeni Kategori',
    selectAll: 'Tümünü seç',
    select: 'Seç',
    bulkSelectedCount: '{n} öğe seçildi',
    bulkConfirmAll: 'Hepsini Onayla',
    bulkCancelAll: 'Hepsini İptal Et',
    bulkDelete: 'Toplu Sil',
    bulkSelectRow: 'Seç',
    bulkDeleteConfirm: '{n} kayıt silinsin mi?',
    sortByName: 'Adına göre',
    sortByCapacity: 'Kapasite',
    sortByStatus: 'Durum (boş öne)',
    sortByDuration: 'Süre (uzun öne)',
    bulkChangeRole: 'Toplu Rol Değiştir',
    bulkClearSelection: 'Seçimi Temizle',
    bulkRoleConfirm: 'Seçili {n} kullanıcının rolü değiştirilecek. Onaylıyor musunuz?',
    notifBulkSelected: 'bildirim seçildi',
    notifBulkMarkRead: 'Toplu Okundu İşaretle',
    notifBulkDismiss: 'Toplu Gizle',
    notifBulkClear: 'Seçimi Temizle',
    notifBulkSelectAll: 'Tümünü seç',
    notifBulkSelectItem: 'Seç',
    hrLeavesSelected: 'izin seçildi',
    hrBulkApprove: 'Hepsini Onayla',
    hrBulkReject: 'Hepsini Reddet',
    hrBulkDelete: 'Toplu Sil',
    hrClearSelection: 'Temizle',
    hrSelectAll: 'Tümünü seç',
    hrLeavesBulkDeleteConfirm: 'izni silmek istediğinize emin misiniz?',
    hrBulkLeaveActionDone: 'Toplu işlem tamamlandı.',
    menuBulkSelected: '{n} ürün seçildi',
    menuBulkActivate: 'Aktif Et',
    menuBulkDeactivate: 'Pasif Et',
    menuBulkChangeCategory: 'Toplu Kategori Değiştir',
    menuBulkDelete: 'Sil',
    menuBulkClear: 'Temizle',
    menuBulkDeleteConfirm: '{n} ürün silinecek. Emin misin?',
    poBulkSelected: '{n} PO seçildi',
    poBulkReceive: 'Hepsini Teslim Al',
    poBulkCancel: 'Hepsini İptal Et',
    poBulkDelete: 'Toplu Sil',
    poBulkClear: 'Seçimi Temizle',
    poBulkReceiveConfirm: 'Seçili PO\'ları teslim al?',
    poBulkCancelConfirm: 'Seçili PO\'ları iptal et?',
    poBulkDeleteConfirm: 'Seçili PO\'ları sil?',
    poBulkNoneEligible: 'Uygun PO yok',
    poBulkSkipped: '{n} PO atlandı (uygun değil)',
    poBulkSelectAll: 'Tümünü seç',
    poBulkSelectRow: 'Seç',
    poBulkBar: 'Toplu işlem',
    supBulkSelected: '{n} tedarikçi seçildi',
    supBulkActivate: 'Aktif Et',
    supBulkDeactivate: 'Pasif Et',
    supBulkDelete: 'Toplu Sil',
    supBulkClear: 'Seçimi Temizle',
    supBulkSelectAll: 'Tümünü seç',
    supBulkSelectRow: 'Seç',
    supBulkDeleteConfirm: '{n} tedarikçi silinecek. Emin misiniz?',
    voucherSelectAll: 'Tümünü seç',
    voucherSelectOne: 'Çeki seç',
    voucherSelectedCount: '{n} çek seçildi',
    voucherBulkVoid: 'Toplu Durdur',
    voucherBulkDelete: 'Toplu Sil',
    voucherClearSelection: 'Seçimi Temizle',
    voucherBulkNoActive: 'Aktif çek seçilmedi',
    voucherBulkVoidConfirm: 'X çek durdurulacak. Onayla?',
    voucherBulkDeleteConfirm: 'X çek silinecek. Onayla?',
    voucherBulkVoidDone: '{n} çek durduruldu',
    voucherBulkDeleteDone: '{n} çek silindi',
    selectItem: 'Seç',
    bulkActivate: 'Aktif Et',
    bulkDeactivate: 'Pasif Et',
    clearSelection: 'Seçimi Temizle',
    recipesSelectedSuffix: 'tarif seçildi',
    confirmBulkDeleteRecipes: 'Seçili tarifler silinsin mi?',
    selectAllAria: 'Tümünü seç',
    selectRowAria: 'Seç',
    bulkActionsAria: 'Toplu işlemler',
    refundsSelectedCount: '{n} iade seçildi',
    refundsBulkCsv: 'Seçili CSV İndir',
    refundsClearSelection: 'Seçimi Temizle',
    refundsSelectAll: 'Tümünü seç',
    cmdPaletteTitle: 'Komut Paleti',
    cmdPalettePlaceholder: 'Komut ara veya seç...',
    cmdPaletteNoResults: 'Sonuç bulunamadı',
    cmdPaletteHintNav: '↑↓ ile gez, Enter ile seç',
    cmdPaletteHintClose: 'Esc ile kapat',
    cmdPaletteGroupPages: 'Sayfalar',
    cmdPaletteGroupActions: 'Aksiyonlar',
    cmdPaletteGroupTheme: 'Tema',
    cmdPaletteGroupLanguage: 'Dil',
    cmdPaletteGoDashboard: 'Dashboard\'a Git',
    cmdPaletteGoTables: 'Masalar',
    cmdPaletteGoOrders: 'Siparişler',
    cmdPaletteGoKitchen: 'Mutfak',
    cmdPaletteGoPOS: 'POS',
    cmdPaletteGoCustomers: 'Müşteriler',
    cmdPaletteGoMenu: 'Menü',
    cmdPaletteGoStock: 'Stok',
    cmdPaletteGoReports: 'Raporlar',
    cmdPaletteGoSettings: 'Ayarlar',
    cmdPaletteNewOrder: 'Yeni Sipariş',
    cmdPaletteNewCustomer: 'Yeni Müşteri',
    cmdPaletteNewStaff: 'Yeni Personel',
    cmdPaletteLogout: 'Çıkış Yap',
    cmdPaletteThemeLight: 'Açık Tema',
    cmdPaletteThemeDark: 'Koyu Tema',
    cmdPaletteLangTR: 'Türkçe',
    cmdPaletteLangEN: 'İngilizce',
    cmdPaletteLangAR: 'Arapça',
    shortcutCommandPalette: 'Komut Paleti',
    settingsBackupTitle: '💾 Otomatik Yedek',
    settingsBackupDesc: 'Veritabanı yedeği için zamanlama belirleyin.',
    settingsBackupEnabled: 'Otomatik yedek aktif',
    settingsBackupInterval: 'Yedek Aralığı',
    settingsBackupManual: 'Manuel',
    settingsBackupDaily: 'Günlük',
    settingsBackupWeekly: 'Haftalık',
    settingsBackupMonthly: 'Aylık',
    settingsBackupTime: 'Saat',
    settingsBackupLast: 'Son Yedek',
    settingsBackupRunNow: '💾 Şimdi Yedek Al',
    settingsBackupRunning: 'Yedekleniyor…',
    settingsBackupDone: 'Yedek alındı',
    settingsBackupAria: 'Otomatik yedek konfigürasyonunu aç/kapat',
    refreshLabel: 'Yenile',
    refreshTooltip: 'Otomatik yenileme',
    refreshManual: 'Manuel',
    refresh30s: '30 saniye',
    refresh1m: '1 dakika',
    refresh5m: '5 dakika',
    hrTotalEntitlement: 'Toplam Hak',
    hrTotalUsed: 'Kullanılan',
    hrTotalRemaining: 'Kalan',
    hrPerEmployeeUsage: 'Personel Bazlı Kullanım',
    cdActivityTitle: '30 Gün Aktivite',
    cdActivitySummary: 'Son 30 gün: {orders} sipariş, {spent} harcama, ortalama {avg}/gün',
    cdActivityOrders: 'sipariş',
    posFavorites: 'Favoriler',
    posFavoritesEmpty: 'Henüz favori ürün yok. Ürün kartında ★\'a tıklayın.',
    posFavoritesShowAll: 'Tümü',
    posFavorite: 'Favorilere ekle',
    posUnfavorite: 'Favorilerden çıkar',
    stockScanBarcode: 'Barkod Tara',
    stockBarcode: 'Barkod',
    stockBarcodeInput: 'Barkod (otomatik veya elle gir)',
    stockBarcodePlaceholder: 'Tarayıcıyı kullan veya kod yaz + Enter',
    stockBarcodeNotFound: 'Barkod eşleşmedi: {code}',
    stockBarcodeCreateNew: 'Yeni Malzeme Oluştur',
    stockBarcodeQuickAdd: '+ Stok Ekle',
    stockBarcodeWaiting: 'Tarama bekleniyor...',
    stockBarcodeScanCount: 'Tarama: {n}',
    stockBarcodeAdded: '✓ {name} +{d} {unit}',
    stockBarcodeReason: 'Barkod scan',
    savedFiltersLabel: '⭐ Kayıtlı Filtreler',
    savedFiltersEmpty: 'Henüz kayıt yok',
    savedFiltersSaveBtn: 'Filtreyi Kaydet',
    savedFiltersPromptName: 'Filtre adı:',
    savedFiltersDelete: 'Sil',
    hrPayrollTimeline12m: '12 Aylık Bordro Timeline',
    hrPayrollTimeline12mTotal: '12 ay toplam',
    hrPayrollTimeline12mAvg: 'ortalama',
    hrPayrollTimeline12mPerMonth: 'ay',
    customersFindDuplicates: '🔍 Yinelenen Bul',
    customersDupTitle: 'Yinelenen Müşteriler',
    customersDupSubtitle: '{n} potansiyel grup bulundu (telefon/isim eşleşmesi)',
    customersDupEmpty: 'Yinelenen müşteri bulunamadı.',
    customersDupGroupLabel: 'Grup {i} · {n} müşteri',
    customersDupMerge: 'Birleştir',
    customersDupPickFields: 'Hangi alan kalsın?',
    customersDupPrimary: 'Ana kayıt:',
    customersDupConfirmMerge: 'Onayla ve Birleştir',
    customersDupMergeSuccess: '{n} müşteri birleştirildi.',
    customersDupMergeFailed: 'Birleştirme başarısız.',
    menuCatReorderHint: 'Sürükleyerek kategori sırasını değiştirin',
    categoryChipDragHint: '{name} — sürükleyerek sıralayın',
    dragToReorder: 'sürükleyerek sıralayın',
    dashRecentActivity: 'Son İşlemler',
    feedSystem: 'Sistem',
    feedOrderCreated: 'Sipariş',
    whiteLabelActiveTheme: 'Aktif Tema',
    whiteLabelLogoStatus: 'Logo Durumu',
    whiteLabelBrandName: 'Marka Adı',
    whiteLabelThemeDefault: 'Varsayılan',
    whiteLabelThemeCustom: 'Özel',
    whiteLabelThemeNone: 'Yapılandırma yok',
    whiteLabelLogoLoaded: 'Yüklendi',
    whiteLabelLogoMissing: 'Eksik',
    whiteLabelBrandUnnamed: 'İsimsiz',
    whiteLabelPreviewRefreshed: 'Önizleme yenilendi',
    gdprStatApproved: 'Onaylanmış',
    gdprStatExpired: 'Süresi Geçmiş',
    chainReportsStatBranchCount: 'Toplam Şube',
    chainReportsStatTotalOrders: 'Toplam Sipariş',
    chainReportsStatTotalRevenue: 'Toplam Ciro',
    chainReportsStatActiveBranches: 'Aktif Şube',
    chainReportsDatePresetGroup: 'Tarih ön ayarları',
    superadminRestaurantsStatTotal: 'Toplam Restoran',
    superadminRestaurantsStatActive: 'Aktif',
    superadminRestaurantsStatPassive: 'Pasif',
    superadminRestaurantsStatNewThisMonth: 'Bu Ay Yeni',
    saasSubStatTotal: 'Toplam Abonelik',
    saasSubStatActive: 'Aktif',
    saasSubStatTrial: 'Deneme',
    saasSubStatTroubled: 'İptal/Bekleyen',
    navGroupOperations: 'Operasyon',
    navGroupCommerce: 'Ticari & Mali',
    navGroupStaff: 'Personel',
    navGroupPosAdmin: 'Yazarkasa Yönetim',
    nav_posProducts: 'Ürün Yönetimi',
    nav_posReports: 'Raporlamalar',
    nav_posReceiptSettings: 'Fiş Ayarları',
    // ── PosProducts ──
    posProductsLoadError: 'Ürünler yüklenemedi',
    posProductsBulkDeleteConfirm: '{n} ürün silinecek. Emin misiniz?',
    posProductsBulkDeleteDone: '{n} ürün silindi',
    posProductsNameRequired: 'Ürün adı zorunlu',
    posProductsPriceInvalid: 'Geçerli bir fiyat girin',
    posProductsUpdated: 'Ürün güncellendi',
    posProductsCreated: 'Ürün eklendi',
    posProductsDeleteConfirm: '"{name}" silinecek. Emin misiniz?',
    posProductsDeleted: 'Ürün silindi',
    posProductsImportNoSelection: 'Önce ürün seçin',
    posProductsImportResult: '{n} ürün aktarıldı',
    posProductsImportSkipped: '{n} atlandı',
    posProductsUnlimited: 'Sınırsız',
    posProductsLowStockBadge: 'Stok az',
    posProductsTitle: 'Yazarkasa — Ürün Yönetimi',
    posProductsSubtitle: 'POS satış ürünlerini yönet',
    posProductsAdd: 'Yeni Ürün',
    posProductsImportFromMenu: 'Menüden Aktar',
    posProductsExportExcel: 'Excel İndir',
    posProductsImportExcel: 'Excel Yükle',
    posProductsStatTotal: 'Toplam Ürün',
    posProductsStatActive: 'Aktif Ürün',
    posProductsStatInStock: 'Stokta Olan',
    posProductsStatLowStock: 'Stok Altı',
    posProductsSearchPlaceholder: 'Ad veya barkod ile ara...',
    posProductsCategoryFilter: 'Kategori filtresi',
    posProductsAllCategories: 'Tüm Kategoriler',
    posProductsNoCategory: '— Kategorisiz —',
    posProductsActiveFilterAria: 'Aktif/Pasif filtresi',
    posProductsActiveFilterAll: 'Tümü',
    posProductsActiveFilterActive: 'POS\'ta görünen',
    posProductsActiveFilterInactive: 'Pasif',
    posProductsActiveHint: 'Sadece "POS\'ta görünen" ürünler /pos terminalinde listelenir.',
    posProductsSortAria: 'Sıralama',
    posProductsColName: 'Ad',
    posProductsColPrice: 'Fiyat',
    posProductsColStock: 'Stok',
    posProductsBulkSelected: '{n} ürün seçildi',
    posProductsBulkDelete: 'Toplu Sil',
    posProductsEmptyTitle: 'Henüz ürün yok',
    posProductsColImage: 'Görsel',
    posProductsColBarcode: 'Barkod',
    posProductsColCategory: 'Kategori',
    posProductsColTax: 'Vergi %',
    posProductsColMenuLink: 'Menü Bağlı',
    posProductsColActive: 'Aktif',
    posProductsColActions: 'Aksiyon',
    posProductsMenuLinkedBadge: 'Menüye bağlı',
    posProductsToggleDeactivate: 'Pasifleştir',
    posProductsToggleActivate: 'Aktifleştir',
    posProductsEditAria: '"{name}" ürününü düzenle',
    posProductsDeleteAria: '"{name}" ürününü sil',
    posProductsModalEditTitle: 'Ürünü Düzenle',
    posProductsModalAddTitle: 'Yeni Ürün',
    posProductsStockHint: 'boş = sınırsız',
    posProductsColImageUrl: 'Görsel URL',
    posProductsMenuItemId: 'Menü Ürünü ID',
    posProductsImportFromMenuTitle: 'Menüden POS\'a Aktar',
    posProductsMenuEmptyTitle: 'Menüde ürün yok',
    posProductsMenuEmptyDesc: 'Önce menüye ürün ekleyin.',
    posProductsMenuAllImportedTitle: 'Tüm menü ürünleri zaten POS\'ta',
    posProductsMenuAllImportedDesc: 'Menüdeki tüm ürünler POS\'a aktarılmış.',
    posProductsMenuSelectedCount: '{n} / {total} seçili',
    posProductsMenuAlreadyAddedBadge: 'Eklendi',
    posProductsImportConfirm: 'Aktar',
    // ── PosReports ──
    posReportsExportExcel: '📊 CSV İndir',
    posReportsCloseSession: 'Kasayı Kapat & Z-Rapor',
    posReportsClosingCashConfirm: 'Kasa kapatma sonrası Z-rapor üretilir. Devam etmek istiyor musunuz?',
    posReportsClosingCashLabel: 'Kapanış Kasası (₺)',
    product: 'Ürün',
    qty: 'Adet',
    posReportsNoItems: 'Bu satış için ürün detayı yok.',
    paymentMethod: 'Ödeme',
    posReportsPrintReceipt: '🖨️ Fişi Tekrar Yazdır',
    posReportsTabInstant: 'Anlık Rapor',
    posReportsTabSales: 'Satış Geçmişi',
    posReportsTabZ: 'Z Raporları',
    posReportsSessionLoadFailed: 'Session bilgisi alınamadı.',
    posReportsSalesLoadFailed: 'Satışlar yüklenemedi.',
    posReportsColMetric: 'Metrik',
    posReportsSaleDetailFailed: 'Satış detayı alınamadı.',
    posReportsColDate: 'Tarih',
    posReportsColReceipt: 'Fiş No',
    posReportsColCashier: 'Kasiyer',
    posReportsColItems: 'Ürün',
    posReportsColPayment: 'Ödeme',
    posReportsColTotal: 'Toplam',
    posReportsTitle: 'Yazarkasa — Raporlamalar',
    posReportsSubtitle: 'Satış raporları, X/Z rapor, gün dökümleri.',
    posReportsNoSession: 'Açık POS session yok',
    posReportsNoSessionDesc: 'X/Z rapor üretmek için önce kasayı açmalısınız.',
    posReportsGoToPos: 'Yazarkasaya Git',
    posReportsActiveSession: 'Açık Session',
    posReportsXTitle: 'X-Rapor (Gün İçi Ara)',
    posReportsXDesc: 'Açık session için anlık satış özeti. Session kapanmaz.',
    posReportsGenerateX: '⚡ Şimdi Üret',
    posReportsZTitle: 'Z-Rapor (Gün Sonu)',
    posReportsZDesc: 'Kasa kapatılır ve Z-rapor üretilir. Bu işlem geri alınamaz.',
    posReportsStatSales: 'Satış',
    posReportsStatRevenue: 'Ciro',
    posReportsStatAvg: 'Ort. Sepet',
    posReportsStatToday: 'Bugün',
    posReportsDatePresets: 'Tarih önayarları',
    from: 'Başlangıç',
    to: 'Bitiş',
    posPaySplit: 'Karma',
    posReportsSearchPlaceholder: 'Fiş no veya müşteri...',
    posReportsResultCount: 'Sonuç',
    posReportsNoSales: 'Satış bulunamadı',
    posReportsNoSalesDesc: 'Seçili dönemde kayıtlı satış yok. Tarih aralığını veya filtreleri değiştirin.',
    posReportsViewDetail: 'Detay görüntüle',
    posReportsZComingSoon: 'Z Rapor Listesi — Yakında',
    posReportsZComingSoonDesc: 'Z raporlar her session kapatıldığında otomatik üretilir. Geçmiş Z raporlarının listesi için yöneticinizle iletişime geçin.',
    posReportsViewSales: 'Satış Geçmişi',
    // ── PosReceiptSettings ──
    posReceiptNoPrinterSelected: 'Önce bir varsayılan yazıcı seç.',
    posReceiptTestPrintSent: 'Test fişi yazıcıya gönderildi.',
    posReceiptTestPrintFailed: 'Test fişi gönderilemedi.',
    posReceiptSettingsTitle: 'Yazarkasa — Fiş Ayarları',
    posReceiptSettingsSubtitle: 'Fiş üzerinde görünen bilgileri ve yazıcı ayarlarını yönet.',
    posReceiptSectionInfo: 'Restoran Bilgisi',
    posReceiptInfoHint: 'Bu bilgiler fişin üst-bilgisinde otomatik olarak görünür.',
    posReceiptTaxNumber: 'Vergi Numarası',
    posReceiptLogoUrl: 'Logo URL',
    posReceiptComingSoon: 'Yakında',
    posReceiptLogoHint: 'Termal yazıcı logo desteği için ESC/POS bitmap çıkarımı eklenecek.',
    posReceiptSectionCustomize: 'Fiş Özelleştirme',
    posReceiptHeaderText: 'Fiş Başlık Metni',
    posReceiptHeaderPh: 'Hoşgeldiniz!',
    posReceiptFooterText: 'Fiş Altbilgi Metni',
    posReceiptFooterPh: 'Tekrar bekleriz!',
    posReceiptPaperWidth: 'Kağıt Genişliği',
    posReceiptPaperWidthHint: 'Yazıcı bazında özel genişlik için yazıcı yönetiminden ayar yap.',
    posReceiptTaxDisplay: 'KDV Gösterimi',
    posReceiptAutoPrint: 'Otomatik Yazdırma',
    posReceiptAutoPrintHint: 'Her satışta fişi otomatik olarak varsayılan yazıcıdan yazdır.',
    posReceiptSectionPrinter: 'Yazıcı Ayarları',
    posReceiptDefaultPrinter: 'Varsayılan Fiş Yazıcısı',
    posReceiptNoPrinter: '— Seçilmedi —',
    posReceiptNoPrintersConfigured: 'Henüz yazıcı tanımlı değil.',
    posReceiptManagePrinters: 'Yazıcı Listesini Yönet',
    posReceiptTestPrint: 'Test Fişi Yazdır',
    posReceiptPreview: 'Önizleme',
    // ── POS yönetim navigasyonu (Tur 290 polish) ──
    posAdminNavLabel: 'POS yönetim navigasyonu',
    posAdminToolsLabel: 'Yönetim',
    posAdminProducts: 'Ürün Yönetimi',
    posAdminReports: 'Raporlamalar',
    posAdminReceipt: 'Fiş Ayarları',
    posAdminBackToTerminal: '← POS Terminal',
    posProductsActiveHintCreate: 'Yeni ürünler otomatik olarak aktif eklenir; sonra düzenleme ekranından gizleyebilirsiniz.',
    posProductsActiveHintEdit: 'Aktif olduğunda /pos terminalinde görünür ve satılabilir.',
    posReportsZListTitle: 'Z Raporları geçmişi',
    posReportsZListInfo: 'Her gün sonu kasayı kapattığınızda otomatik Z raporu üretilir. Geçmiş Z raporlarının listesi yakında.',
    posReportsZGoInstant: 'Anlık Rapora Git',
    posReportsZGoSales: 'Satış Geçmişini Gör',
    pageOptPosLabel: 'POS Terminal',
    pageOptPosDesc: 'Ödeme noktası terminali',
    settingsBackupComingSoon: 'Manuel yedek API\'si yakında',
    settingsBackupComingSoonShort: 'yakında',
    settingsTaxSgkAria: 'Vergi ve SGK bilgilerini aç/kapat',
    setTaxSgkSubtitle: 'e-Bildirge / Muhtasar beyannameleri için zorunlu bilgiler.',
    settingsTaxNumberPlaceholder: '10 haneli VKN veya 11 haneli TCKN',
    settingsSgkPlaceholder: 'SGK e-Bildirge sicil no',

    // ── Tur 291 polish keyleri (Customers/Notifications/PosReceipt/POS/CustomerDetail/Reservations) ──
    // Genel
    amount: 'Tutar',
    savedSuccess: 'Kaydedildi',
    table: 'Masa',
    tags: 'Etiketler',
    totalSpent: 'Toplam Harcama',
    visitCount: 'Ziyaret',
    guestName: 'Misafir',
    loyaltyPoints: 'Puan',
    reservationDate: 'Tarih',
    notifications: 'Bildirimler',
    clearDate: 'Tarihi Temizle',
    datePresetThisWeek: 'Bu Hafta',
    // Ödeme yöntemleri
    paymentCash: 'Nakit',
    paymentCard: 'Kart',
    paymentBank: 'Havale/EFT',
    paymentOther: 'Diğer',
    // POS
    posCategoriesLabel: 'Kategoriler',
    posClearSearch: 'Aramayı temizle',
    posCustomerRemove: 'Müşteriyi kaldır',
    posPromoRemove: 'Promo kodunu kaldır',
    posDeleteHeldOrder: 'Bekletilen siparişi sil',
    posSaleNetworkFail: 'Bağlantı hatası — sepetiniz korundu, tekrar deneyin',
    posSessionLoadFailed: 'Oturum yüklenemedi — bağlantınızı kontrol edin',
    // POS Receipt Settings
    posReceiptRestaurantName: 'Restoran Adı',
    posReceiptAddress: 'Adres',
    posReceiptPhone: 'Telefon',
    posReceiptSaveBtn: 'Kaydet',
    posReceiptCancelBtn: 'Vazgeç',
    posReceiptSectionUpcoming: 'Yakında — Deneysel Alanlar',
    posReceiptPreviewCashier: 'Kasiyer: Ahmet',
    posReceiptPreviewReceiptNo: 'FİŞ #12345',
    posReceiptPreviewItem1: 'Köfte',
    posReceiptPreviewItem2: 'Ayran',
    posReceiptPreviewItem3: 'Cacık',
    posReceiptPreviewPhoneLabel: 'Tel',
    posReceiptPreviewTaxNumLabel: 'VKN',
    posReceiptPreviewSubtotal: 'Ara Toplam:',
    posReceiptPreviewVat: 'KDV (%10):',
    posReceiptPreviewTotal: 'TOPLAM:',
    posReceiptPreviewVatIncluded: '(KDV dahil)',
    posReceiptPreviewNoFooter: '(Altbilgi yok)',
    // Notifications
    notifWeeklySummaryTitle: 'Son 7 Gün Özeti',
    notifTotalLabel: 'Toplam',
    notifPeakLabel: 'En yoğun',
    notifBadgeRead: 'okundu',
    notifToday: 'Bugün',
    notifYesterday: 'Dün',
    notifDayBeforeYesterday: 'Önceki gün',
    notifDaysAgoTmpl: '{n} gün önce',
    // Customers — Borç/Ödeme
    customersAddDebtTitle: 'Borç Ekle',
    customersAddPaymentTitle: 'Ödeme Al',
    customersAmountRequired: 'Tutar gerekli (0\'dan büyük olmalı).',
    customersDebtSaved: 'Borç kaydı eklendi.',
    customersPaymentSaved: 'Ödeme kaydı eklendi.',
    customersDebtDescLabel: 'Borç',
    customersDebtDescPlaceholder: 'örn: Mart faturası',
    customersDebtDescPrefix: 'Müşteri',
    customersPaymentDescPlaceholder: 'örn: Hesap kapama',
    customersManualDebtNote: 'Manuel borç kaydı',
    customersManualPaymentNote: 'Manuel ödeme',
    customersAvatarUrlLabel: 'Profil Fotoğrafı URL\'si',
    customersCollectionLabel: 'Tahsilat',
    customersSaveFailed: 'Kaydedilemedi.',
    // Customers — Kampanya
    customersCampaignTitle: 'Kampanya Gönder',
    customersCampaignNameRequired: 'Kampanya adı giriniz.',
    customersCampaignBodyRequired: 'Mesaj içeriği giriniz.',
    customersCampaignSubjectRequired: 'Email konusu giriniz.',
    customersCampaignConfirm: '{n} kişiye {channel} gönderilecek. Onaylıyor musunuz?',
    customersCampaignSendBtn: 'Alıcıya Gönder',
    customersCampaignSending: 'Gönderiliyor…',
    customersCampaignSendFailed: 'Gönderilemedi.',
    customersCampaignEmailSentTmpl: '{sent}/{total} email gönderildi ({failed} başarısız).',
    customersCampaignWaCreatedTmpl: '{n} WhatsApp linki üretildi. Listeden tıklayarak gönder.',
    customersCampaignWaOpenAll: 'Tümünü Aç',
    customersCampaignWaReady: '{n} WhatsApp linki hazır. Her birini ayrı sekmede aç (tarayıcı pop-up engelini açın):',
    customersCampaignWillSend: 'alıcıya gönderilecek',
    customersCampaignNoRecipient: 'Hedef alıcı yok.',
    customersCampaignTipPrefix: 'İpucu',
    customersCampaignTipBody: 'kelimesi her müşterinin adıyla değiştirilir.',
    customersCampaignSamplePrefix: 'Örnek',
    customersCampaignMissingPrefix: 'müşteride',
    customersCampaignMissingSuffix: 'eksik',
    customersCampaignChannelEmail: 'email',
    customersCampaignChannelPhone: 'telefon',
    customersCampaignChannelWhatsapp: 'WhatsApp linki',
    // Customers — Segment
    custSegmentActive: '✅ Aktif',
    custSegmentLost: '😴 Kayıp',
    custSegmentLostRecovery: '😴 Kayıp (Geri Kazanım)',
    custSegmentLoyal: '🏆 Sadık',
    custSegmentNew: '🆕 Yeni',
    custSegmentVip: '⭐ VIP',
    // CustomerDetail
    custDetailCustomerNote: 'Müşteri Notu',
    custDetailGoToCustomers: 'Müşteriler Sayfasına Git',
    custDetailLedgerHint: 'Detaylı borç/ödeme dökümü için Müşteriler sayfasından ledger modal\'ını açın.',
    custDetailNoNote: 'Bu müşteri için henüz not eklenmemiş. Müşteriler sayfasından düzenleyebilirsiniz.',
    custDetailNoTags: 'Etiket eklenmemiş.',
    custDetailTagsLabel: 'Etiketler',
    // ── Tur 292 polish keyleri ──
    actualEnd: 'Gerçek Çıkış',
    actualStart: 'Gerçek Giriş',
    cashTxFilterFrom: 'Başlangıç',
    cashTxFilterTo: 'Bitiş',
    cashTxType: 'Tip',
    chainBranchesEmptyAction: '+ Yeni Şube',
    chainBranchesEmptyDesc: 'İlk şubeni ekleyerek zincir yönetimine başla.',
    chainBranchesNoResults: 'Sonuç bulunamadı',
    chainBranchesNoResultsDesc: 'Arama kriterlerini değiştir.',
    chainBranchesSearchPh: 'Şube ara...',
    chainDashEmptyBranches: 'Henüz şube yok',
    chainDashEmptyBranchesDesc: 'Zincirinize şube eklediğinizde aktivite verileri burada görünecek.',
    chainDashStatActiveOrders: 'Aktif Sipariş',
    chainDashStatTodayRevenue: 'Bugünkü Ciro',
    chainDashStatTotalBranches: 'Toplam Şube',
    chainDashStatTotalStaff: 'Toplam Personel',
    chainDashStatTotalTables: 'Toplam Masa',
    chainMenuEmpty: 'Henüz ürün yok',
    chainMenuEmptyAction: '+ Yeni Ürün',
    chainMenuEmptyDesc: 'Zincir genelinde ortak menü ürünlerini buradan tanımla.',
    chainMenuNoResults: 'Sonuç bulunamadı',
    chainMenuNoResultsDesc: 'Arama kriterini değiştir.',
    chainMenuSearchPh: 'Ürün ara...',
    costPerUnit: 'Birim Maliyet',
    customers: 'Müşteri',
    default: 'Varsayılan',
    endTime: 'Bitiş',
    foodCost: 'Maliyet',
    grossTotal: 'Brüt',
    hour: 'Saat',
    hrIbanPlaceholder: 'TR...',
    hrLast7Days: 'Son 7 Gün',
    hrLastMonth: 'Geçen Ay',
    hrPdfA5Title: 'PDF İndir (A5 yatay)',
    hrPdfFailed: 'PDF oluşturulamadı.',
    hrPdfReady: 'PDF indirildi.',
    hrPopupBlocked: 'Pop-up engellendi. Yazdırmak için izin verin.',
    hrPrintTitle: 'Yazdır (yeni sekme)',
    loginForgotPassword: 'Şifremi unuttum',
    loginRememberMe: 'Beni hatırla',
    margin: 'Marj',
    menuItemName: 'Ürün',
    minStock: 'Min',
    netTotal: 'Net',
    orderDate: 'Sipariş Tarihi',
    orders: 'Sipariş',
    overtimeMinutes: 'Mesai (dk)',
    platformSearchPlaceholder: 'Platform ara...',
    poSearchPlaceholder: 'Sipariş no/tedarikçi ara...',
    posProductsBulkDeleteFailed: '{n} silinemedi',
    posProductsImportFromMenuShort: 'Menü',
    posProductsStockInvalid: 'Geçerli bir stok değeri girin',
    posProductsTaxInvalid: 'Geçerli bir vergi oranı girin',
    posPromoVoucherInputPlaceholder: 'Promo / Voucher kodu',
    posReportsClosingCashInvalid: 'Geçerli bir kapanış kasası girin.',
    posReportsDateFromAria: 'Başlangıç tarihi',
    posReportsDateRangeInvalid: 'Başlangıç tarihi bitişten sonra olamaz.',
    posReportsDateToAria: 'Bitiş tarihi',
    posVoucherCodePlaceholder: 'R-6-20260414-12',
    printerSerialPathPlaceholder: 'COM3 veya /dev/ttyUSB0',
    promoCodeSamplePlaceholder: 'YAZ20',
    promoQrAria: 'QR Kod',
    promoQrTitle: 'QR Kod',
    qrmenuAdd: '+',
    qrmenuDecrement: 'Bir adet azalt',
    qrmenuIncrement: 'Bir adet ekle',
    receivedDate: 'Teslim Tarihi',
    restaurantDetailEmptyUsers: 'Henüz kullanıcı yok',
    restaurantDetailEmptyUsersDesc: 'Bu restoranın kullanıcı kayıtları henüz eklenmemiş.',
    rptSegActive30d: 'Aktif (Son 30g)',
    rptSegAnon: 'Anonim',
    rptSegAvgPerCustomer: 'Müşteri Başı Ortalama',
    rptSegCustomerWord: 'müşteri',
    rptSegEmpty: 'Müşteri yok',
    rptSegLoadFailed: 'Segmentasyon raporu yüklenemedi.',
    rptSegLostDesc: 'Son sipariş 90 gün öncesi',
    rptSegLostHint: '90 gün boyunca alışveriş yapmadı. Geri kazanım kampanyası göndermek için Müşteri sayfasında Kayıp segmentini filtreleyin.',
    rptSegLostLabel: '😴 Kayıp',
    rptSegLoyalDesc: '10 ve üstü sipariş',
    rptSegLoyalLabel: '🏆 Sadık',
    rptSegNewDesc: 'Son 30 gün içinde kayıt',
    rptSegNewLabel: '🆕 Yeni',
    rptSegTotalCustomers: 'Toplam Müşteri',
    rptSegTotalLabel: 'Toplam',
    rptSegTotalRevenue: 'Toplam Ciro',
    rptSegVipDesc: 'Toplam harcama ≥ 5.000 ₺ veya VIP etiketli',
    rptSegVipLabel: '⭐ VIP',
    rptTabSegmentation: '🎯 Segmentasyon',
    searchPlaceholder: 'Tarif ara',
    settingsBackupAutoDesc: 'Veritabanı her gece 03:00\'te otomatik yedeklenir. Manuel yedek için sistem yöneticinizle iletişime geçin.',
    settingsBackupAutoTitle: 'Otomatik Yedekleme Aktif',
    settingsBackupRequestManual: 'Manuel yedek talep et',
    settingsBackupRequestSent: 'Manuel yedek talebiniz alındı. Sistem yöneticisi en kısa sürede sizinle iletişime geçecek.',
    shiftsStaffSearchPlaceholder: 'Personel ara...',
    staff: 'Personel',
    startTime: 'Başlangıç',
    stockAdjustmentsSearchPlaceholder: 'Malzeme/sebep ara...',
    subStatActive: 'Aktif Abonelik',
    subStatCancelled: 'İptal Edilmiş',
    subStatMonthlyRevenue: 'Toplam Aylık Ciro',
    subStatRenewingSoon: 'Yenileme Yaklaşan',
    subStatRenewingSoonSub: '7 gün içinde',
    subscriptionMonthlyAmount: 'Aylık Tutar',
    superDashStatActiveSubs: 'Aktif Abonelik',
    superDashStatMonthlyMRR: 'Aylık MRR',
    superDashStatTotalRestaurants: 'Toplam Restoran',
    superDashStatTotalUsers: 'Toplam Kullanıcı',
    superadminDashEmptyRestaurants: 'Henüz restoran yok',
    superadminDashEmptyRestaurantsDesc: 'Restoranlar restaflex.com üzerinden kayıt olduktan sonra burada görünür.',
    superadminPlansDescPh: 'Plan açıklaması...',
    superadminPlansEmpty: 'Henüz plan yok',
    superadminPlansEmptyAction: '+ Yeni Plan',
    superadminPlansEmptyDesc: 'İlk SaaS planını oluşturarak abonelik tekliflerini başlat.',
    superadminPlansNamePh: 'örn. Starter, Pro, Enterprise',
    superadminPlansNoResults: 'Sonuç bulunamadı',
    superadminPlansNoResultsDesc: 'Arama kriterlerini değiştir.',
    superadminPlansSearchPh: 'Plan ara...',
    superadminRestaurantsCreatedTitle: 'Restoran Oluşturuldu',
    superadminRestaurantsEmpty: 'Henüz restoran yok',
    superadminRestaurantsEmptyDesc: 'Restoranlar restaflex.com üzerinden kayıt olduktan sonra burada görünür.',
    superadminRestaurantsNoResults: 'Sonuç bulunamadı',
    superadminRestaurantsNoResultsDesc: 'Arama kriterini değiştir.',
    superadminRestaurantsSearchPh: 'Restoran ara...',
    superadminSubsEmpty: 'Henüz abonelik yok',
    superadminSubsEmptyDesc: 'Restoranlar plana geçtiğinde abonelikler burada görünür.',
    superadminSubsNoResults: 'Sonuç bulunamadı',
    superadminSubsNoResultsDesc: 'Filtre veya arama kriterlerini değiştir.',
    superadminSubsSearchPh: 'Restoran ara...',
    supplier: 'Tedarikçi',
    supplierAddress: 'Adres',
    supplierContact: 'İlgili Kişi',
    tag: 'Etiket',
    userRole: 'Rol',
    vouchersQrAria: 'QR Kod',
    vouchersQrCodePlaceholder: 'GV-XXXXXXXX',
    vouchersTitle: 'QR Kod',
    waiterStatsSearchPlaceholder: 'Garson ara...',

    // ── Tur 293-294 polish keyleri ──
    // Zincir & şube placeholder
    chainBranchesAdminEmailPh: 'yonetici@ornek.com',
    chainBranchesAdminNamePh: 'Ad Soyad',
    chainBranchesEmailPh: 'sube@ornek.com',
    chainBranchesPhonePh: '05xx xxx xx xx',
    // Dashboard belge & garson
    dashDocExpired: 'Dolmuş',
    dashDocMore: 'belge daha…',
    dashTopWaiterTitle: 'Bugünkü Yıldız Personel',
    // Genel UI
    deleting: 'Siliniyor...',
    ok: 'Tamam',
    langSwitchTo: 'Dile geç',
    // Error boundary & 404
    errorBoundaryDesc: 'Bu sayfa beklenmedik bir hatayla karşılaştı. Tekrar deneyebilir veya ana sayfaya dönebilirsiniz.',
    errorBoundaryGoHome: 'Ana Sayfa',
    errorBoundaryRefresh: 'Yenile',
    errorBoundaryTitle: 'Bir Şeyler Ters Gitti',
    notFoundDesc: 'Aradığınız sayfa kaldırılmış, taşınmış veya hiç var olmamış olabilir.',
    notFoundGoBack: '← Geri dön',
    notFoundGoHome: '🏠 Ana Sayfa',
    notFoundTitle: 'Sayfa bulunamadı',
    // Feature gate
    featureGateChoosePlan: 'Plan Seç',
    featureGateInlineUpgrade: 'Planı Yükselt',
    featureGateNoSubDesc: 'Bu özelliği kullanmak için bir plan seçmeniz gerekiyor.',
    featureGateSeeAllPlans: 'Tüm Planları Gör',
    featureGateUpgradeDesc: 'Bu özellik mevcut planınıza dahil değildir. Daha fazlası için planınızı yükseltin.',
    featureGateUpgradePlan: 'Planı Yükselt',
    // Feature isimleri
    featureNameAdvancedAnalytics: 'Gelişmiş Analitik',
    featureNameKitchenDisplay: 'Mutfak Ekranı',
    featureNameQrMenu: 'QR Menü',
    featureNameRecipeSystem: 'Reçete Sistemi',
    featureNameStockManagement: 'Stok Yönetimi',
    featureNameWaiterManagement: 'Garson Yönetimi',
    // HR toast & validasyon
    hrBankFileDownloaded: 'Banka transfer dosyası indirildi.',
    hrCsvDownloaded: 'CSV indirildi.',
    hrDocumentAdded: 'Belge eklendi.',
    hrDocumentDeleteConfirm: 'Bu belgeyi silmek istediğinize emin misiniz?',
    hrDocumentDeleted: 'Belge silindi.',
    hrDocumentEmployeeRequired: 'Personel seçiniz.',
    hrDocumentTitleRequired: 'Belge başlığı giriniz.',
    hrEmployeeAdded: 'Personel eklendi.',
    hrEmployeeDeleted: 'Personel silindi.',
    hrEmployeeUpdated: 'Personel güncellendi.',
    hrImportFormatHintDate: 'Tarih formatı:',
    hrImportFormatHintSeparator: 'Ayraç: noktalı virgül (;) veya virgül (,). UTF-8.',
    hrImportFormatHintType: 'Çalışma türü:',
    hrLeaveApproved: 'İzin onaylandı.',
    hrLeaveCreated: 'İzin talebi oluşturuldu.',
    hrLeaveDateRangeRequired: 'Tarih aralığı giriniz.',
    hrLeaveDeleted: 'İzin silindi.',
    hrLeaveEmployeeRequired: 'Personel seçiniz.',
    hrLeaveEndBeforeStart: 'Bitiş tarihi başlangıçtan önce olamaz.',
    hrLeaveRejected: 'İzin reddedildi.',
    hrMuhtasarPdfDownloaded: 'Muhtasar PDF indirildi.',
    hrPayrollApproved: 'Bordro onaylandı.',
    hrPayrollBulkComputed: 'Toplu hesaplama tamamlandı.',
    hrPayrollDeclaration: 'İşbu bordrodaki tutarı eksiksiz aldığımı beyan ederim.',
    hrPayrollEmployeeRequired: 'Personel seçiniz.',
    hrPayrollEmpty: 'Bordro yok.',
    hrPayrollMarkedPaid: 'Ödendi olarak işaretlendi.',
    hrPayrollNetTargetRequired: 'Net hedef giriniz.',
    hrPayrollSaved: 'Bordro kaydedildi.',
    hrSalaryRequired: 'Brüt maaş giriniz.',
    hrSgkPdfDownloaded: 'SGK Bildirge PDF indirildi.',
    hrTcInvalid: 'TC Kimlik No 11 haneli rakam olmalıdır.',
    // Sipariş durumları
    orderStatusPreparing: 'Hazırlanıyor',
    orderStatusReady: 'Hazır',
    orderStatusServed: 'Servis Edildi',
    // Yıllık trend / Net Kâr
    reportsDeltaDecrease: 'düşüş',
    reportsDeltaIncrease: 'artış',
    reportsNetProfitDelta: 'Net Kâr Değişimi',
    reportsYearlyEmptyDesc: 'Aylık breakdown — backend endpoint\'i hazır olduğunda otomatik aktifleşir.',
    reportsYearlyEmptyTitle: 'Yıllık trend grafiği için veri bulunmuyor.',
    reportsYearlyPrevYear: 'Geçen yıl',
    reportsYearlyRevenueLabel: 'Ciro (Toplam Gelir)',
    reportsYearlyThisYear: 'Bu yıl',
    // Restoran detay (superadmin)
    restaurantDetailColEmail: 'E-posta',
    restaurantDetailColName: 'Ad',
    restaurantDetailColRegistered: 'Kayıt',
    restaurantDetailColRole: 'Rol',
    restaurantDetailOccupiedTables: 'Dolu Masa',
    restaurantDetailTableCount: 'Masa Sayısı',
    restaurantDetailTodayOrderStatus: 'Bugünkü Sipariş Durumu',
    restaurantDetailTotalTables: 'Toplam Masa',
    restaurantDetailUserCount: 'Kullanıcı Sayısı',
    restaurantDetailUsers: 'Kullanıcılar',
    // Sidebar & impersonation & abonelik
    sidebarChainImpersonationBanner: 'Zincir Yönetimi Altında',
    sidebarChainReturnToPanel: 'Zincir Paneline Dön',
    subStatusTrial: 'Deneme',
    // Superadmin Dashboard
    superadminDashActiveRest: 'Aktif Restoran',
    superadminDashActiveSubLbl: 'Aktif Abonelik',
    superadminDashAddRestaurant: 'Restoran Ekle',
    superadminDashColPlan: 'Plan',
    superadminDashColRestaurant: 'Restoran',
    superadminDashColStatus: 'Durum',
    superadminDashColTodayOrders: 'Bugün Sipariş',
    superadminDashColTodayRevenue: 'Bugün Ciro',
    superadminDashDetail: 'Detay',
    superadminDashMrr: 'MRR',
    superadminDashMrrSub: 'Aylık Tekrarlayan Gelir',
    superadminDashPayingRest: 'Ödeme yapan restoran',
    superadminDashRestaurantStats: 'Restoran İstatistikleri',
    superadminDashRestaurants: 'Restoranlar',
    superadminDashSaasMetrics: 'SaaS Metrikleri',
    superadminDashThisMonthRev: 'Bu Ay Gelir',
    superadminDashThisMonthRevSub: 'Bu ayki toplam tahsilat',
    superadminDashTodayTotalRev: 'Bugünkü Toplam Ciro',
    superadminDashTotalRest: 'Toplam Restoran',
    superadminDashTrialLbl: 'Deneme',
    superadminDashTrialUserSub: 'Ücretsiz deneme kullanıcısı',
    superadminLoadFailed: 'Veriler yüklenemedi.',
    // Superadmin Plans
    superadminPlansColActions: 'İşlemler',
    superadminPlansColMonthly: 'Aylık',
    superadminPlansColPlan: 'Plan',
    superadminPlansColStatus: 'Durum',
    superadminPlansColSubs: 'Abonelik',
    superadminPlansColTables: 'Masa',
    superadminPlansColUsers: 'Kullanıcı',
    superadminPlansColYearly: 'Yıllık',
    superadminPlansCreateTitle: 'Yeni Plan Oluştur',
    superadminPlansEditTitle: 'Planı Düzenle',
    superadminPlansFeatures: 'özellik',
    superadminPlansFieldActive: 'Plan Aktif',
    superadminPlansFieldDesc: 'Açıklama',
    superadminPlansFieldFeatures: 'Özellikler',
    superadminPlansFieldMaxTables: 'Maks. Masa',
    superadminPlansFieldMaxUsers: 'Maks. Kullanıcı',
    superadminPlansFieldMonthly: 'Aylık Fiyat (₺)',
    superadminPlansFieldName: 'Plan Adı',
    superadminPlansFieldYearly: 'Yıllık Fiyat (₺)',
    superadminPlansLoadFailed: 'Planlar yüklenemedi.',
    superadminPlansNewPlan: 'Yeni Plan',
    superadminPlansStatMonthlyTotal: 'Aylık Toplam Fiyat',
    superadminPlansStatTotal: 'Toplam Plan',
    superadminPlansSubtitle: 'Abonelik planlarını yönetin',
    superadminPlansTitle: 'SaaS Planları',
    // Superadmin Restaurants
    superadminRestaurantDeleteConfirm: 'Bu restoranı ve tüm verilerini silmek istediğinize emin misiniz?',
    superadminRestaurantNameSlugRequired: 'Ad ve slug zorunludur.',
    superadminRestaurantsActivate: 'Aktife Al',
    superadminRestaurantsAdd: 'Restoran Ekle',
    superadminRestaurantsAddTitle: 'Yeni Restoran Ekle',
    superadminRestaurantsCredsEmail: 'E-posta:',
    superadminRestaurantsCredsIntro: 'Restoran başarıyla oluşturuldu. Admin giriş bilgileri:',
    superadminRestaurantsCredsPassword: 'Şifre:',
    superadminRestaurantsCredsWarn: 'Bu bilgileri restoran adminine iletmeyi unutmayın.',
    superadminRestaurantsDeactivate: 'Pasife Al',
    superadminRestaurantsDetail: 'Detay',
    superadminRestaurantsEditTitle: 'Restoran Düzenle',
    superadminRestaurantsFieldAdminPwd: 'Admin Şifresi (boş = admin123)',
    superadminRestaurantsFieldEmail: 'E-posta',
    superadminRestaurantsFieldName: 'Restoran Adı',
    superadminRestaurantsFieldOwner: 'Sahip Adı',
    superadminRestaurantsFieldPhone: 'Telefon',
    superadminRestaurantsFieldPlan: 'Plan',
    superadminRestaurantsFieldSlug: 'Slug * (URL kimliği)',
    superadminRestaurantsLoadFailed: 'Restoranlar yüklenemedi.',
    superadminRestaurantsTablesLbl: 'masa',
    superadminRestaurantsTitle: 'Restoranlar',
    superadminRestaurantsUsersLbl: 'kullanıcı',
    superadminStatusUpdateFailed: 'Durum güncellenemedi.',
    // Superadmin Subscriptions
    superadminSubsActivate: 'Aktifleştir',
    superadminSubsActiveLbl: 'Aktif',
    superadminSubsActiveSub: 'Aktif abonelik',
    superadminSubsCancelledLbl: 'İptal',
    superadminSubsCancelledSub: 'İptal edilmiş',
    superadminSubsColAction: 'İşlem',
    superadminSubsColAmount: 'Tutar',
    superadminSubsColEndDate: 'Bitiş Tarihi',
    superadminSubsColPeriod: 'Dönem',
    superadminSubsColPlan: 'Plan',
    superadminSubsColRestaurant: 'Restoran',
    superadminSubsColStatus: 'Durum',
    superadminSubsCycleMonthly: 'Aylık',
    superadminSubsCycleYearly: 'Yıllık',
    superadminSubsDaysLeft: 'gün kaldı',
    superadminSubsEnded: 'Sona erdi',
    superadminSubsEndsToday: 'Bugün bitiyor',
    superadminSubsMrr: 'MRR',
    superadminSubsMrrSub: 'Aylık Tekrarlayan Gelir',
    superadminSubsRecordsShowing: 'kayıt gösteriliyor',
    superadminSubsSubtitle: 'Tüm restoran aboneliklerini görüntüleyin ve yönetin',
    superadminSubsTabActive: 'Aktif',
    superadminSubsTabAll: 'Tümü',
    superadminSubsTabCancelled: 'İptal',
    superadminSubsTabExpired: 'Süresi Dolmuş',
    superadminSubsTabPastDue: 'Gecikmiş',
    superadminSubsTabTrial: 'Deneme',
    superadminSubsThisMonthLbl: 'Bu Ay',
    superadminSubsThisMonthSub: 'Bu ayki tahsilat',
    superadminSubsTitle: 'Abonelikler',
    superadminSubsTrialLbl: 'Deneme',
    superadminSubsTrialSub: 'Ücretsiz deneme',

    // ── Tur 296-297 polish keyleri ──
    addFailed: 'Eklenemedi.',
    approveFailed: 'Onaylanamadı.',
    clearDateFilter: 'Tarihi Temizle',
    createFailed: 'Oluşturulamadı.',
    hrAssignFailed: 'Atanamadı.',
    hrBulkCalculationFailed: 'Toplu hesaplama hatası.',
    hrCalculationFailed: 'Hesaplama hatası.',
    hrDocumentsLoadFailed: 'Belgeler yüklenemedi.',
    hrEmployeesLoadFailed: 'Personeller yüklenemedi.',
    hrImportFailed: 'İçe aktarılamadı.',
    hrLeavesLoadFailed: 'İzinler yüklenemedi.',
    hrMarkFailed: 'İşaretlenemedi.',
    hrPayrollsLoadFailed: 'Bordrolar yüklenemedi.',
    hrSeveranceFailed: 'Kıdem hesaplanamadı.',
    loginEmailPh: 'ornek@restoran.com',
    offlineBannerOffline: 'Bağlantı kesildi — değişiklikler kaybolabilir, lütfen ağı kontrol edin.',
    offlineBannerReconnected: 'Bağlantı yeniden kuruldu.',
    onboardingGoToDashboard: "Dashboard'a Git",

    // ── Tur 298 sprint keyleri ──
    paginationPrev: '← Geri',
    paginationNext: 'İleri →',
    paginationPageOf: 'Sayfa {page} / {total}',
    paginationAria: 'Sayfalama',
    serverErrorTitle: 'Sunucu hatası',
    serverErrorDesc: 'Geçici bir sorun var. Lütfen biraz sonra tekrar deneyin veya yöneticinizle iletişime geçin.',
    serverErrorRetry: '🔄 Yeniden Dene',
    serverErrorDetails: 'Hata detayı (geliştirici)',
    forbiddenTitle: 'Erişim engellendi',
    forbiddenDesc: 'Bu sayfayı görüntülemek için yetkiniz bulunmuyor. Yöneticinize başvurun.',
    forbiddenCurrentRole: 'Mevcut rolünüz',
    posCartRestoredBadge: '🔄 Önceki sepetiniz yüklendi',
    dashWidgetEditBtn: '⚙️ Düzenle',
    dashWidgetEditTitle: "Widget'ları Düzenle",
    dashWidgetEditDesc: "Görünmesini istemediğin widget'ları kapat",
    dashWidgetSaveBtn: 'Kaydet',
    dashWidgetReset: 'Varsayılana Dön',
    chainReportsPrintAria: 'Zincir raporunu yazdır',
    hrPrintAria: 'Bordroyu yazdır',
    shiftPrintAria: 'Vardiyayı yazdır',
    // ── Tur 299 sprint keyleri ──
    posReceiptSectionDisplay: '📺 Müşteri Ekranı (POS Display)',
    posReceiptDisplayAdUrlsLabel: 'Promosyon Görselleri (URL listesi)',
    posReceiptDisplayAdUrlsPlaceholder: 'https://example.com/promo1.jpg\nhttps://example.com/promo2.jpg',
    posReceiptDisplayAdUrlsHelp: 'POS Display müşteri ekranı boş iken (sepet boşken) gösterilecek promosyon görselleri. Birden fazla URL eklerseniz 8 saniye aralıkla otomatik döner (carousel).',
    posReceiptDisplayAdPreviewTitle: 'Önizleme',
    posReceiptDisplayAdRemove: 'Kaldır',
    posReceiptDisplayAdInvalidUrl: 'Geçersiz URL',
    posReportsZStatTotal: 'Toplam Z Raporu',
    posReportsZStatRevenue: 'Toplam Ciro',
    posReportsZStatAvg: 'Ortalama Z',
    posReportsZStatThisWeek: 'Bu Hafta',
    posReportsZColZNo: 'Z No',
    posReportsZColCashier: 'Kasiyer',
    posReportsZColSales: 'Satış',
    posReportsZEmpty: 'Henüz Z raporu yok',
    posReportsZEmptyDesc: "Açık POS session'ını kapatınca otomatik Z raporu üretilir.",
    posReportsZLoadFailed: 'Z raporları yüklenemedi.',

    // Tur 301-304 — polish + i18n tail
    selectedCount: 'seçildi',
    chainStaffBulkPartial: 'işlem başarısız oldu',
    chainReportsSortGroup: 'Sıralama',
    tablesCustomerRemoveBtn: 'Kaldır',
    reportsStaffPerformanceToday: 'Personel Performansı (Bugün)',
    reportsOrdersShort: 'sipariş',
    deliveryDatePresetLast7Days: 'Son 7 Gün',
    deliveryDatePresetLast30Days: 'Son 30 Gün',
    deliveryDatePresetThisMonth: 'Bu Ay',
    deliveryDatePresetLastMonth: 'Geçen Ay',
    usersPinHelpHint: '(4 hane — POS hızlı giriş, opsiyonel)',

    // Tur 305 — auth/superadmin i18n tail + empty states
    saasPlanNameRequired: 'Plan adı zorunludur.',
    saasPlanMonthlyPriceInvalid: 'Aylık fiyat geçerli olmalıdır.',
    saasPlanUpdated: 'Plan güncellendi.',
    saasPlanCreated: 'Plan oluşturuldu.',
    saasPlanDeleted: 'Plan silindi.',
    saasPlanDeleteConfirmTmpl: '"{name}" planını silmek istediğinize emin misiniz? Bu işlem geri alınamaz.',
    saasSubActivateConfirmTmpl: '{name} için aboneliği manuel olarak aktifleştirmek istediğinize emin misiniz?',
    saasSubActivated: 'Abonelik aktifleştirildi.',
    saasSubActivateError: 'Aktifleştirilemedi.',
    prnNoJobsTitle: 'Yazıcı kuyruğu boş',
    prnNoJobsDesc: 'Henüz yazıcıya gönderilen iş yok.',

    // Tur 306 — form validation + HR empty states
    formNameRequired: 'İsim zorunludur',
    formEmailInvalid: 'Geçerli email girin',
    formPhoneInvalid: 'Geçerli telefon girin (en az 7 hane)',
    userPinFourDigits: 'PIN 4 haneli rakam olmalıdır',
    hrEmptyEmployeesTitle: 'Henüz personel eklenmemiş',
    hrEmptyEmployeesDesc: '"Yeni Personel" ile ilk personeli ekleyin.',
    hrEmptyLeavesDesc: 'Yeni izin talebi oluşturun veya filtreyi sıfırlayın.',
    hrEmptyDocumentsTitle: 'Belge bulunamadı',
    hrEmptyDocumentsDesc: 'Yeni belge yükleyin veya filtreleri sıfırlayın.',

    // Tur 307 — promo/voucher form validation
    promoCodeRequired: 'Kod zorunludur',
    promoDiscountInvalid: 'Geçerli indirim değeri girin',
    voucherAmountInvalid: 'Geçerli tutar girin',

    // Tur 308 — i18n derin son tarama (HR + POS + saved filters)
    hrDocTypeKimlik: 'Kimlik Fotokopisi',
    hrDocTypeIkametgah: 'İkametgah',
    hrDocTypeDiploma: 'Diploma',
    hrDocTypeSaglikRaporu: 'Sağlık Raporu',
    hrDocTypeIsSozlesmesi: 'İş Sözleşmesi',
    hrDocTypeSgkBildirim: 'SGK Bildirimi',
    hrDocTypeOther: 'Diğer',
    hrDocumentExpiryOptional: 'Geçerlilik Son Tarihi (opsiyonel)',
    hrLeaveTypeAnnual: 'Yıllık İzin',
    hrLeaveTypeSick: 'Hastalık',
    hrLeaveTypeMaternity: 'Doğum (Analık)',
    hrLeaveTypePaternity: 'Babalık',
    hrLeaveTypeUnpaid: 'Ücretsiz',
    hrLeaveTypeOther: 'Diğer',
    hrEmployeeDeleteConfirm: '"{name}" adlı personeli silmek istediğinize emin misiniz?',
    hrPayrollBulkCalcConfirm: '{period} için tüm personellerin bordrosu hesaplansın mı?',
    hrBulkLeaveAssignConfirm: '{count} personele {days} gün {type} izin atanacak. Onaylıyor musunuz?',
    hrLeaveActionApprove: 'Onayla',
    hrLeaveActionReject: 'Reddet',
    hrLeaveActionDelete: 'Sil',
    hrLeaveActionConfirm: 'Bu izin talebini {action} istediğinize emin misiniz?',
    hrPayslipDocType: 'ÜCRET BORDROSU',
    hrPayslipPeriodLabel: 'Dönem',
    hrPayslipDocNoLabel: 'Belge No',
    hrPayslipGeneratedLabel: 'Üretim',
    hrPayslipEarningsHeader: 'KAZANÇLAR',
    hrPayslipOvertimeRow: '(+) Fazla Mesai (1.5x)',
    hrPayslipWeeklyHolidayRow: '(+) Hafta Tatili (1.5x)',
    hrPayslipPublicHolidayRow: '(+) Resmi Tatil (2x)',
    hrPayslipBonusRow: '(+) Prim / Bonus',
    hrPayslipGrossTotalRow: 'BRÜT KAZANÇLAR TOPLAMI',
    hrPayslipAllowancesHeader: 'YARDIMLAR (Vergisiz, Nete Dahil)',
    hrPayslipAllowancesTotalRow: 'YARDIMLAR TOPLAMI',
    hrPayslipLegalDeductionsHeader: 'KANUNİ KESİNTİLER',
    hrPayslipSgkEmployeeRow: 'SGK İşçi Kesintisi (%14)',
    hrPayslipUnemploymentEmployeeRow: 'İşsizlik İşçi (%1)',
    hrPayslipStampTaxRow: 'Damga Vergisi (%0.759)',
    hrPayslipLegalDeductionsTotalRow: 'KANUNİ KESİNTİLER TOPLAMI',
    hrPayslipCustomDeductionsHeader: 'ÖZEL KESİNTİLER',
    hrPayslipBesPaymentRow: 'BES Katkısı',
    hrPayslipCustomDeductionsTotalRow: 'ÖZEL KESİNTİLER TOPLAMI',
    hrPayslipNetSalaryLabel: 'NET MAAŞ (Ele Geçen)',
    hrPayslipSgkEmployerRow: 'SGK İşveren (%20.5)',
    hrPayslipUnemploymentEmployerRow: 'İşsizlik İşveren (%2)',
    hrPayslipFootnote: 'Bu bordro İş Kanunu ve SGK mevzuatına (2024) uygun olarak hesaplanmıştır. Asgari ücret gelir vergisi ve damga vergisi istisnası uygulanmıştır (7349 sayılı kanun).',
    hrPayslipEmployerSignLabel: 'İşveren İmza & Kaşe',
    posRefundConfirm: '{receipt} — ₺{total} iade edilsin mi?',
    savedFiltersNameRequired: 'Filtre adı zorunludur',
    savedFiltersSaved: 'Filtre kaydedildi',

    // Tur 311 — PWA install prompt
    pwaInstallTitle: 'Uygulamayı Yükle',
    pwaInstallDesc: 'RestaFlex\'i ana ekranınıza ekleyin; offline çalışır, hızlı açılır, tam ekran deneyim sunar.',
    pwaInstallBtn: 'Yükle',
    pwaInstallDismiss: 'Daha sonra',
    pwaInstalled: 'Uygulama yüklü',

    // Tur 312 — bu hafta yeni HR modal i18n eksiklikleri
    hrEmploymentFullTime: 'Tam Zamanlı',
    hrEmploymentPartTime: 'Part Time',
    hrEmploymentSeasonal: 'Mevsimlik',
    hrPayrollStatusDraft: 'Taslak',
    hrPayrollStatusApproved: 'Onaylandı',
    hrPayrollStatusPaid: 'Ödendi',
    hrProfilePhotoUrl: "Profil Fotoğrafı URL'si",
    reportsMonthLongList: 'Ocak,Şubat,Mart,Nisan,Mayıs,Haziran,Temmuz,Ağustos,Eylül,Ekim,Kasım,Aralık',
    posSalesHistoryLoadFailed: 'Geçmiş yüklenemedi',
    posPrinterNotFound: 'Yazıcı bulunamadı',

    // Tur 315 — keyboard shortcut + tooltip audit
    shortcutHelpAlt: 'Klavye kısayolları',
    shortcutHr: 'Personel',
    shortcutUsers: 'Kullanıcılar',
    shortcutReservations: 'Rezervasyonlar',
    shortcutTrash: 'Çöp Kutusu',
    cmdPaletteGoHR: 'Personel sayfasına git',
    cmdPaletteGoUsers: 'Kullanıcılar sayfasına git',
    cmdPaletteGoReservations: 'Rezervasyonlar sayfasına git',
    cmdPaletteGoTrash: 'Çöp Kutusu sayfasına git',
    customerTagRemove: 'Etiketi kaldır',

    // Tur 316 — ÖKC Onboarding + Settings + POSTerminal + Hatalar (65 key)
    // 1. Onboarding Sihirbazı (30)
    okcOnboardingTitle: 'ÖKC Kurulum Sihirbazı',
    okcOnboardingClose: 'Kapat',
    okcOnboardingNext: 'İleri',
    okcOnboardingBack: 'Geri',
    okcOnboardingSkip: 'Sihirbazı Atla',
    okcOnboardingFinish: 'Bitir',
    okcOnboardingStep1Title: 'Hoş Geldin',
    okcOnboardingStep1Desc: 'RestaFlex Desktop\'a hoş geldin. Yazarkasanı birlikte kuralım.',
    okcOnboardingStep2Title: 'Yetkili Servis Kontrolü',
    okcOnboardingStep2Desc: 'Cihazınız yetkili servis tarafından bilgisayarınızla eşleştirildi mi?',
    okcOnboardingStep2Yes: 'Evet, eşleştirildi',
    okcOnboardingStep2No: 'Hayır, henüz değil',
    okcOnboardingStep3Title: 'Bağlantı Türü',
    okcOnboardingStep3Usb: 'USB ile',
    okcOnboardingStep3Ethernet: 'Ethernet ile',
    okcOnboardingStep3WifiWarn: 'Kablosuz bağlantı yasaldır değildir (GİB).',
    okcOnboardingStep4Title: 'Cihaz Keşfi',
    okcOnboardingStep4Scan: 'Cihazları Tara',
    okcOnboardingStep4Scanning: 'Taranıyor...',
    okcOnboardingStep4Empty: 'Cihaz bulunamadı. Manuel ekle.',
    okcOnboardingStep4Manual: 'Manuel Ekle',
    okcOnboardingStep5Title: 'Cihaz Bilgileri',
    okcOnboardingStep5Vendor: 'Üretici',
    okcOnboardingStep5Model: 'Model',
    okcOnboardingStep5DeviceName: 'Cihaz Adı',
    okcOnboardingStep6Title: 'Eşleştirme',
    okcOnboardingStep6Pairing: 'Eşleştiriliyor...',
    okcOnboardingStep6Success: 'Eşleştirildi (AES-256 + HMAC-SHA256)',
    okcOnboardingStep7Title: 'Test Satışı',
    okcOnboardingStep8Title: 'Hazırsın!',
    // 2. Settings → Yazarkasa (15)
    okcWizardStart: 'Sihirbazı Başlat',
    okcWizardStartDesc: 'Kurulum sihirbazı ile cihazını adım adım ekle.',
    okcDevicesTitle: 'Yazarkasa Cihazları',
    okcDevicesDesc: 'Bağlı tüm ÖKC cihazlarınızı yönetin.',
    okcAddDevice: '+ Cihaz Ekle',
    okcNoDevices: 'Henüz cihaz eklenmedi',
    okcNoDevicesDesc: 'Sihirbazı başlat veya manuel cihaz ekle.',
    okcEditDevice: 'Düzenle',
    okcMakeActive: 'Varsayılan yap',
    okcTest: 'Bağlantıyı Test Et',
    okcTestingConnection: 'Test ediliyor...',
    okcTestSuccess: 'Bağlantı başarılı',
    okcTestFailed: 'Bağlantı başarısız',
    okcDesktopOnly: 'Sadece masaüstünde',
    okcDesktopOnlyDesc: 'Bu özellik RestaFlex Desktop uygulamasında çalışır.',
    // 3. POSTerminal Entegrasyonu (10)
    posOkcEnabled: 'Yazarkasa Aktif',
    posOkcDisabled: 'Yazarkasa Kapalı',
    posOkcSaleSuccess: 'Satış tamamlandı — Fiş No: {receiptNo}',
    posOkcFailed: 'Yazarkasa hatası',
    posOkcFallbackConfirm: 'Yazarkasa çalışmıyor. Sadece backend kaydı yapılsın mı?',
    posSaleComplete: 'Satış başarıyla tamamlandı',
    posOkcXReport: 'X-Rapor Üret',
    posOkcZReport: 'Z-Rapor Üret (Gün Sonu)',
    posOkcZReportConfirm: 'Mali günü kapatmak istiyor musun?',
    posOkcCustomerDisplayBroadcast: 'Müşteri ekranı güncellendi',
    // 4. Hata Mesajları (10)
    okcErrConnRefused: 'Cihaz bağlantı reddetti — IP/Port kontrol et',
    okcErrPairTimeout: 'Eşleştirme zaman aşımı',
    okcErrFiscalDayClosed: 'Mali gün kapalı — Z-rapor üretildi',
    okcErrFiscalDayOpen: 'Mali gün hâlâ açık — Z-rapor üretilemez',
    okcErrTsmUnreachable: 'TSM sunucusu erişilemez — yetkili servis ara',
    okcErrInvalidHmac: 'HMAC doğrulaması başarısız — yeniden eşleştir',
    okcErrPaperOut: 'Yazıcıda kağıt yok',
    okcErrLicenseExpired: 'Cihaz lisansı süresi doldu — yetkili servis ara',
    okcErrUnknownDevice: 'Cihaz tanımlı değil',
    okcErrDeviceBusy: 'Cihaz meşgul — birkaç saniye sonra dene',
    // QR / Sepet backend hata kodları
    qrErrorItemsEmpty: 'Sepet boş',
    qrErrorMinOrder: 'Minimum sipariş tutarı {min}₺',
    qrErrorInvalidPhone: 'Geçersiz telefon',
    qrErrorInvalidQuantity: 'Geçersiz miktar',
    qrErrorInvalidToken: 'Geçersiz veya süresi dolmuş bağlantı',
    qrErrorRateLimited: 'Çok fazla istek, lütfen bekleyin',
    qrErrorGeneric: 'Bir hata oluştu',
    qrErrorTokenInvalid: 'Token geçersiz veya süresi dolmuş',
    qrErrorNetwork: 'Ağ bağlantısı yok — internetinizi kontrol edin',
    // QR Menü kart varyantları
    qrCardVariantNeoBrutalist: 'Neo-Brütalist',
    qrCardVariantGlass: 'Cam',
    qrCardVariantGradientGlow: 'Gradyan Parıltı',
    qrCardVariantEditorial: 'Editöryel',
    qrCardVariantMinimalistMono: 'Minimal Mono',
    qrCardVariantPaper: 'Kağıt',
    qrCardVariantRetroPop: 'Retro Pop',
    qrCardVariantArtDeco: 'Art Deco',
  },

  en: {
    // General
    save: 'Save',
    saving: 'Saving...',
    cancel: 'Cancel',
    delete: 'Delete',
    add: 'Add',
    edit: 'Edit',
    close: 'Close',
    openMenu: 'Open menu',
    hideSidebar: 'Hide menu',
    showSidebar: 'Show menu',
    back: 'Back',
    search: 'Search',
    loading: 'Loading...',
    update: 'Update',
    all: 'All',
    noData: 'No data found',
    actions: 'Actions',
    status: 'Status',
    date: 'Date',
    total: 'Total',
    name: 'Name',
    description: 'Description',
    price: 'Price',
    quantity: 'Quantity',
    active: 'Active',
    passive: 'Passive',
    // Login
    loginTitle: 'Sign in to your account',
    email: 'Email',
    password: 'Password',
    loginBtn: 'Sign In',
    loggingIn: 'Signing in...',
    forgotPassword: 'Forgot Password',
    loginError: 'Login failed.',
    emailRequired: 'Email and password are required.',

    // Navigation
    nav_dashboard: 'Dashboard',
    nav_tables: 'Tables',
    nav_reservations: 'Reservations',
    nav_shifts: 'Shifts',
    nav_hr: 'HR',
    nav_orders: 'Orders',
    nav_menu: 'Menu',
    nav_kitchen: 'Kitchen',
    nav_stock: 'Stock',
    nav_recipes: 'Recipes',
    nav_suppliers: 'Suppliers',
    nav_purchase_orders: 'Purchases',
    nav_cash_transactions: 'Cash Transactions',
    nav_refunds: 'Refunds',
    nav_stock_history: 'Stock History',
    nav_payments: 'Cashier',
    nav_delivery: 'Delivery',
    nav_couriers: 'Couriers',
    nav_platforms: 'Platform Management',
    nav_pos: 'POS Terminal',
    nav_printers: 'Printers',
    nav_customers: 'Customers',
    nav_promo: 'Promotions',
    nav_gifts: 'Gift Vouchers',
    nav_users: 'Users',
    nav_waiterStats: 'Waiter Tracking',
    nav_reports: 'Reports',
    nav_settings: 'Settings',
    nav_gdpr: 'GDPR / Privacy',
    nav_webhooks: 'Webhook Integrations',
    nav_audit_logs: 'Audit Logs',
    nav_trash: 'Trash',
    nav_security: 'Security & 2FA',
    nav_tax_groups: 'Tax Groups',
    nav_feature_flags: 'Feature Flags',
    nav_whitelabel: 'White-label',
    nav_subscription: 'My Subscription',
    logout: 'Logout',

    // Roles
    role_admin: 'Admin',
    role_waiter: 'Waiter',
    role_kitchen: 'Kitchen',
    role_cashier: 'Cashier',
    chainStaffTitle: 'Staff Management',
    chainStaffSubtitle: 'View and manage staff across all branches in the chain.',
    chainStaffAdd: 'Add Staff',
    chainStaffTotal: 'Total Staff',
    chainStaffBranchFilter: 'Filter by Branch:',
    chainStaffAllBranches: 'All Branches',
    chainStaffClearFilter: 'Clear Filter',
    chainStaffShowing: 'staff showing',
    chainStaffNameCol: 'Name',
    chainStaffBranch: 'Branch',
    chainStaffRegDate: 'Registration Date',
    chainStaffDeleting: 'Deleting...',
    chainStaffNotFound: 'No staff found',
    chainStaffNoInBranch: 'No staff in this branch.',
    chainStaffBranchSelect: 'Select Branch',
    chainStaffFullName: 'Full Name',
    chainStaffEmailPlaceholder: 'staff@example.com',
    chainStaffPwHint: 'Min 6 chars',
    chainStaffLoadError: 'An error occurred while loading staff data.',
    chainStaffBranchRequired: 'Please select a branch.',
    chainStaffPwTooShort: 'Password must be at least 6 characters.',
    chainStaffEmailReq: 'Email is required.',
    chainStaffNoResultsTitle: 'No results found',
    chainStaffNoResultsDesc: 'Adjust branch, search or date filter.',
    chainStaffEmptyTitle: 'No staff yet',
    chainStaffEmptyDesc: 'Add staff to branches to start tracking.',
    chainReportsEmptyDesc: 'Reports will appear here as data is collected from branches.',
    chainReportsNoRangeDesc: 'Try a different date range.',
    chainDashTitleSuffix: 'Chain Management Panel',
    chainDashSubtitle: 'Track all your branches performance on a single screen.',
    chainDashChain: 'Chain',
    chainDashToday: 'Today',
    chainDashLast7Days: 'Last 7 Days',
    chainDashLast30Days: 'Last 30 Days',
    chainDashThisMonth: 'This Month',
    chainDashStart: 'Start',
    chainDashEnd: 'End',
    chainDashFilter: 'Filter',
    chainDashTotalRevenue: 'Total Revenue',
    chainDashBranchCount: 'Branch Count',
    chainDashTotalTables: 'Total Tables',
    chainDashPerformance: 'Branch Performance',
    chainDashNoBranchData: 'No branch data for selected date range.',
    chainDashDetails: 'Branch Details',
    chainDashRevenue: 'Revenue',
    chainDashOrder: 'Orders',
    chainDashTable: 'Tables',
    chainDashOrderUnit: 'orders',
    chainDashLoadError: 'An error occurred while loading data.',
    chainBranchesTitle: 'Branch Management',
    chainBranchesSubtitle: 'View and manage all branches in the chain.',
    chainBranchesAdd: 'Add New Branch',
    chainBranchStatTotal: 'Total Branches',
    chainBranchStatActive: 'Active',
    chainBranchStatInactive: 'Inactive',
    chainBranchStatTables: 'Total Tables',
    chainBranchesEmpty: 'No branches added yet.',
    chainBranchesTableUnit: 'tables',
    chainBranchesUserUnit: 'users',
    chainBranchesEntering: 'Entering...',
    chainBranchesEnter: 'Enter Branch',
    chainBranchesMakeActive: 'Activate',
    chainBranchesMakePassive: 'Deactivate',
    chainBranchesInfo: 'Branch Information',
    chainBranchesNameLabel: 'Branch Name',
    chainBranchesAdminInfo: 'Admin Information',
    chainBranchesAdminName: 'Admin Name',
    chainBranchesAdminEmail: 'Admin Email',
    chainBranchesCreateBtn: 'Create Branch',
    chainBranchesEditTitle: 'Edit Branch',
    chainBranchesNameRequired: 'Branch name is required.',
    chainBranchesEmailRequired: 'Email is required.',
    chainBranchesLoadError: 'An error occurred while loading branches.',
    chainBranchesCreateError: 'Could not create branch.',
    chainBranchesUpdateError: 'Could not update branch.',
    chainBranchesStatusError: 'Could not update branch status.',
    chainBranchesEnterError: 'Could not enter branch.',
    chainBranchesNamePh: 'e.g., Kadıköy Branch',
    chainBranchesAddressPh: 'Branch address',
    chainBranchesPwPh: 'Password',
    chainReportsTitle: 'Chain Reports & Analytics',
    chainReportsSubtitle: 'View detailed performance analysis for all your branches.',
    chainReportsQuickSelect: 'Quick Select',
    chainReportsAllBranches: 'All Branches',
    chainReportsFetch: 'Fetch Report',
    chainReportsLoadError: 'An error occurred while loading report data.',
    chainReportsTotalOrders: 'Total Orders',
    chainReportsAvgOrder: 'Avg. Order Value',
    chainReportsBestBranch: 'Best Branch',
    chainReportsBranchCompare: 'Branch Comparison',
    chainReportsAvgAmount: 'Avg. Amount',
    chainReportsStaffCol: 'Staff',
    chainReportsRevenueShare: 'Revenue Share',
    chainReportsDailyTrend: 'Daily Trend',
    chainReportsHourlyDist: 'Hourly Distribution (Average)',
    chainReportsAvgRevenue: 'Avg. Revenue',
    chainReportsAvgOrders: 'Avg. Orders',
    chainReportsTopItems: 'Top Selling Products (Chain-wide)',
    chainReportsBranchesSuffix: 'branches',
    chainReportsWeekdayAvg: 'Average Revenue by Day of Week',
    chainReportsPaymentMethods: 'Payment Methods (By Branch)',
    chainReportsSplit: 'Split',
    chainReportsEmpty: 'Filter to view a report.',
    chainReportsDay0: 'Sunday',
    chainReportsDay1: 'Monday',
    chainReportsDay2: 'Tuesday',
    chainReportsDay3: 'Wednesday',
    chainReportsDay4: 'Thursday',
    chainReportsDay5: 'Friday',
    chainReportsDay6: 'Saturday',
    chainMenuTitle: 'Menu Management',
    chainMenuStatTotal: 'Total Items',
    chainMenuStatActive: 'Active',
    chainMenuStatInactive: 'Inactive',
    chainMenuStatCategories: 'Categories',
    chainMenuSubtitle: 'View branch menus or manage a shared menu across the chain.',
    chainMenuBranchMenus: 'Branch Menus',
    chainMenuChainMenu: 'Chain Menu',
    chainMenuNoBranches: 'No branches yet',
    chainMenuNoPlan: 'No plan',
    chainMenuViewMenu: 'View Menu',
    chainMenuInfoText: 'When items are added/updated they are applied to all branches automatically. Locked 🔒 items also update prices; for unlocked items each branch keeps its own price. The "Apply to Branches" button can be used for newly added branches.',
    chainMenuApplying: 'Applying...',
    chainMenuApplyToBranches: '🔄 Apply to Branches',
    chainMenuAddItem: '+ Add Item',
    chainMenuNoItems: 'No items added yet',
    chainMenuNoItemsHint: 'Add items to the chain menu to apply them to all branches.',
    chainMenuItemsUnit: 'items',
    chainMenuLocked: '🔒 Locked',
    chainMenuFree: 'Free',
    chainMenuBranchMenuSubtitle: 'Branch Menu',
    chainMenuEmptyBranchMenu: 'This branch has no menu yet',
    chainMenuEmptyBranchHint: 'You can apply items to the branch from the chain menu.',
    chainMenuPriceLocked: '🔒 Price Locked',
    chainMenuUnlockPrice: 'Unlock price',
    chainMenuLockPrice: 'Lock price',
    chainMenuManageChainMenu: 'Manage Chain Menu',
    chainMenuEditItem: 'Edit Item',
    chainMenuNewItem: 'Add New Item',
    chainMenuItemName: 'Item Name',
    chainMenuItemNamePh: 'Item name',
    chainMenuPriceLabel: 'Price (₺)',
    chainMenuDescriptionPlaceholder: 'Item description (optional)',
    chainMenuPriceLockLabel: '🔒 Lock Price',
    chainMenuPriceLockHint: 'Branch admin cannot change the price of this item.',
    chainMenuBranchAvailableHint: 'Item is visible in the branch menu and can be ordered.',
    chainMenuUpdate: 'Update',
    chainMenuCategoryPlaceholder: 'e.g., Main Courses',
    chainMenuLockedItem: '🔒 Locked Item',
    chainMenuLockedItemHint: 'Updates branch prices during synchronization.',
    chainMenuAvailableHint: 'Item is visible in the menu and can be ordered.',
    chainMenuApplyQuestion: 'Which branches do you want to apply to? If not selected, it will apply to all branches.',
    chainMenuBranchesSelectedSuffix: 'branches selected.',
    chainMenuAllBranchesApply: 'Will be applied to all branches.',
    chainMenuApply: 'Apply',
    chainMenuLoadFailed: 'Menu could not be loaded.',
    chainMenuNameRequired: 'Item name is required.',
    chainMenuInvalidPrice: 'Please enter a valid price.',
    chainMenuPriceLockFailed: 'Could not update price lock.',
    chainMenuStatusUpdateFailed: 'Could not update status.',
    chainMenuSyncDone: 'Synchronization completed.',
    chainMenuSyncFailed: 'Failed.',
    lockScreenTitle: 'Screen Locked',
    lockScreenNoPin: 'No PIN set yet.',
    lockScreenNoPinHint: 'Tap the button to continue.',
    lockScreenUnlock: 'Unlock',
    lockScreenPinFromSettings: '⚙️ You can set a PIN from Settings',
    lockScreenResetTitle: 'Reset PIN',
    lockScreenResetDesc: 'All stored PINs will be removed and your session will end. Log in again to set a new PIN.',
    lockScreenResetConfirm: 'Yes, Log Out and Reset',
    lockScreenResetBack: 'Go Back',
    lockScreenEnterPin: 'Enter your PIN',
    lockScreenWrongPin: 'Wrong PIN',
    lockScreenForgotPin: 'I forgot my PIN',
    subBannerNoActive: 'You have no active subscription',
    subBannerNoActiveDesc: 'Choose a plan to use the system.',
    subBannerChoosePlan: 'Choose Plan',
    subBannerTrialEnding: 'Your trial is ending!',
    subBannerSubEnding: 'Your subscription is ending!',
    subBannerTodayEnd: 'Ends today!',
    subBannerDaysLeft: 'days left.',
    subBannerRenewSoon: 'Renew now.',
    subBannerRenew: 'Renew Subscription',
    subBannerRenewNow: 'Renew Now',
    subBannerTrialHeader: '14-day free trial',
    subBannerTrialHint: 'Explore all features for free!',
    subBannerTrialDaysLeft: 'days left.',
    subBannerExpired: 'Your subscription has expired',
    subBannerExpiredDesc: 'Renew your subscription to access services.',
    cookieBannerTitle: 'Cookies & Privacy:',
    cookieBannerDesc: 'We use required cookies to provide better service. You can optionally allow analytics and marketing cookies.',
    cookieBannerManage: 'Manage options',
    cookieBannerOnlyRequired: 'Only Required',
    cookieBannerAcceptAll: 'Accept All',
    cookieBannerSaveChoices: 'Save My Choices',
    cookieBannerDetailsTitle: 'Cookie Preferences',
    cookieCategoryRequired: 'Required Cookies',
    cookieCategoryRequiredDesc: 'Needed for the site to work.',
    cookieCategoryAnalytics: 'Analytics Cookies',
    cookieCategoryAnalyticsDesc: 'For usage statistics.',
    cookieCategoryMarketing: 'Marketing Cookies',
    cookieCategoryMarketingDesc: 'For personalized content.',
    chainAdminTitle: 'Chain Admin',
    chainAdminSubtitle: 'RestaFlex Chain Management',
    chainAdminRoleLabel: 'Chain Administrator',
    caNavBranches: 'Branches',
    caNavReports: 'Reports',
    caNavAnalytics: 'Analytics',
    caNavChainMenu: 'Chain Menu',
    caNavStaff: 'Staff',
    superAdminTitle: 'SuperAdmin',
    superAdminSubtitle: 'RestaFlex Management Center',
    saNavRestaurants: 'Restaurants',
    saNavPlans: 'Plans',
    saNavSubscriptions: 'Subscriptions',
    receiptTitle: 'Receipt',
    receiptSubtitle: 'Restaurant Management System',
    receiptSplit: 'Split (Cash + Card)',
    receiptProduct: 'Item',
    receiptUnit: 'Unit',
    receiptGrandTotal: 'TOTAL',
    receiptPaymentLabel: 'Payment:',
    receiptThanks: 'Thank you!',
    receiptThanksLong: 'Thank you for choosing us.',
    activityRecentOrders: 'Active Orders',
    activityTodayReservations: "Today's Reservations",
    activityLowStock: 'Low Stock',
    activitySeeAll: 'See all',
    activityNoOrders: 'No active orders.',
    activityNoReservations: 'No reservations for today.',
    activityNoLowStock: 'No low stock items.',
    activityItemsUnit: 'items',
    activityGuestsUnit: 'guests',
    activityCriticalLevel: 'Critical',
    role_superadmin: 'Super Admin',

    // Settings
    settingsTitle: 'Settings',
    tab_notifications: 'Notifications',
    restaurantName: 'Restaurant Name',
    ownerName: 'Owner Name',
    phone: 'Phone',
    address: 'Address',
    theme: 'Theme',
    theme_light: 'Light',
    theme_dark: 'Dark',
    theme_system: 'System',
    languageSelect: 'Select Language',
    kitchenSound: 'Kitchen Sound Notification',
    kitchenSoundDesc: 'Play sound when new order arrives',
    autoPrint: 'Auto Print',
    autoPrintDesc: 'Automatically print receipt on order confirmation',
    webPush: 'Web Push Notifications',
    menuTitle: 'Menu Title',
    settingsSaved: 'Settings saved.',
    // Dashboard
    totalOrders: 'Total Orders',
    trendBadgeTooltip: 'Compared to yesterday same hour',
    partialLoadError: 'Some data could not be loaded.',
    kpiTotalTables: 'Total Tables',
    kpiOccupiedTables: 'Occupied',
    kpiOccupancy: 'Occupancy',
    kpiActiveOrders: 'Active Orders',
    kpiAvgTicket: 'Avg. Ticket',
    kpiTodayRevenue: "Today's Revenue",
    kpiTodaySales: "Today's Sales",
    kpiOpenOrders: 'Open Orders',
    kpiLowStock: 'Low Stock',
    kpiPendingReservations: 'Pending Reservations',
    kpiMonthlyNetProfit: 'Net Profit (Month)',
    kpiActiveCouriers: 'Active Couriers',
    kpiActiveShifts: 'Active Shifts',
    actionItemsTitle: 'Today\'s To-Dos',
    actionReadyOrders: 'ready orders',
    actionReadyOrdersDesc: 'Awaiting service',
    actionPendingReservations: 'reservation approvals',
    actionPendingReservationsDesc: 'Pending',
    actionCriticalStock: 'critical stock',
    actionUnassignedDeliveries: 'deliveries',
    actionUnassignedDeliveriesDesc: 'No courier assigned',
    kpiThisMonth: 'this month',
    kpiToday: 'today',
    kpiLive: 'live',
    chartHourly: 'Hourly Revenue',
    chartDaily: 'Daily Revenue',
    chartWeekly: 'Weekly Revenue',
    chartHourlyHint: 'Today · 24 hours',
    chartDailyHint: 'Last 7 days',
    chartWeeklyHint: 'Last 8 weeks',
    periodHourly: 'Hourly',
    periodDaily: 'Daily',
    periodWeekly: 'Weekly',
    chartPeriodLabel: 'Time range',
    chartNoData: 'No data for this period',
    sectionActiveOrders: 'Active Orders',
    viewAll: 'View All',
    noActiveOrders: 'No active orders',
    dailySummary: 'Daily Summary',
    totalTransactions: 'Total Transactions',
    totalRevenueLabel: 'Total Revenue',
    noPaymentsToday: 'No payments today yet',
    quickActions: 'Quick Actions',
    criticalStockAlert: '⚠️ Low Stock Alert',
    topItemsTitle: '⭐ Top Sellers (Today)',
    unitPieces: 'pcs',

    // Notification Center (Notifications + Header NotificationBell)
    severityCritical: 'Critical',
    severityWarning: 'Warning',
    severityInfo: 'Info',
    notifSeverityLabel: 'Severity:',
    notifSearchPlaceholder: 'Search notifications...',
    viewModeList: 'List',
    viewModeKanban: 'Kanban',
    newCustomerBadge: 'New customer (last 30 days)',
    notifStatusLabel: 'Status:',
    notifUnread: 'Unread',
    notifRead: 'Read',
    notifShowDismissed: 'Show dismissed',
    notifCountSuffix: 'notifications',
    notifMarkVisibleRead: 'Mark visible as read',
    notifRestoreAll: 'Restore dismissed',
    notifNoMatch: 'No notifications match filters.',
    notifNewLabel: 'New',
    notifDismissedLabel: 'Dismissed',
    notifGoToPage: '→ Go to related page',
    notifMarkRead: 'Mark as read',
    notifRestore: 'Restore',
    notifMarkAllReadTitle: 'Mark all as read',
    notifMarkAllReadShort: 'Read ✓',
    notifDismissAllTitle: 'Dismiss all notifications',
    notifDismissAllShort: 'Dismiss all',
    notifEmpty: 'No new notifications.',
    notifViewAll: 'View all notifications →',
    notifUnreadCountSuffix: 'unread',
    notifDismissOne: 'Dismiss notification',
    notifAllCaughtUp: 'All caught up',
    notifNoReadYet: 'No read notifications yet',
    notifFilterAll: 'All',
    notifFilterUnread: 'Unread',
    notifFilterRead: 'Read',
    notifBadgeUnread: 'unread',
    notifBadgeTotal: 'total',
    reportsExportCSV: 'Download CSV',
    reportsCSVNotAvailable: 'CSV is not available for this report.',
    timeAgoSuffix: 'ago',
    themeLightMode: 'Light Mode',
    themeDarkMode: 'Dark Mode',

    // Customers (Customers + CustomerDetail)
    customersTitle: 'Customers',
    customersSubtitle: 'Customer management and loyalty program',
    newCustomer: 'New Customer',
    editCustomer: 'Edit Customer',
    customerSearchPlaceholder: 'Search by name, phone or email...',
    noCustomersYet: 'No customers yet',
    addFirstCustomer: 'Add your first customer',
    customerLoadError: 'Could not load customer',
    customerNotFound: 'Customer not found',
    deleteConfirm: 'Are you sure you want to delete this item?',
    deleteCustomerConfirm: 'Are you sure you want to delete this customer?',
    genericError: 'An error occurred',
    deleteFailed: 'Could not be deleted',
    birthdaySoon: 'Birthday is approaching',
    colCustomer: 'Customer',
    colContact: 'Contact',
    colSpend: 'Spending',
    colVisits: 'Visits',
    points: 'Points',
    loyaltyAction: 'Point Action',
    addPointsBtn: '+ Add Points',
    redeemPointsBtn: '- Redeem Points',
    loyaltyHistoryTitle: 'Point History',
    notes: 'Notes',
    fullName: 'Full Name',
    phoneLabel: 'Phone',
    emailLabel: 'Email',
    birthdayLabel: 'Birth Date',
    customerNotesPlaceholder: 'Preferences, allergies...',
    pointsEarned: 'Points earned',
    pointsRedeemed: 'Points redeemed',

    // CustomerDetail
    backToCustomers: '← Back to customers',
    loyaltyLabel: 'Loyalty',
    pointsUnit: 'pts',
    totalSpentLabel: 'Total Spent',
    lastOrderLabel: 'Last Order',
    descriptionOptional: 'Description (optional)',
    useAction: 'Use',
    orderHistoryTitle: '📋 Order History',
    recordsSuffix: 'records',
    noPhoneMatchSuffix: '· (no phone — match not possible)',
    noOrdersForPhone: 'No orders match this phone number.',
    addPhoneForOrders: 'Add a phone number to match orders.',
    paymentPaid: '✓ Paid',
    paymentPending: '○ Pending',
    loyaltyActivityTitle: '⭐ Loyalty Activity',
    noLoyaltyActivity: 'No loyalty activity yet.',
    successPointsAdded: '✓ Points added',
    successPointsRedeemed: '✓ Points redeemed',
    pointsAddError: 'Could not add points',
    pointsRedeemError: 'Could not redeem points',
    orderServedShort: 'Served',

    // Orders page + Header pageTitles
    ordersLoadError: 'Could not load orders.',
    orderDetailLoadError: 'Could not load order details.',
    itemRemoveError: 'Could not remove item.',
    statusUpdateError: 'Could not update status.',
    orderDeleteError: 'Could not delete order.',
    menuLoadError: 'Could not load menu.',
    itemAddError: 'Could not add item.',
    refresh: 'Refresh',
    addItem: 'Add Item',
    colTableTime: 'Table / Time',
    colItems: 'Items',
    colAmount: 'Amount',
    colAction: 'Action',
    detail: 'Detail',
    itemsSuffix: 'items',
    orderNotFound: 'No orders found',
    ordersSuffix: 'orders',
    totalLabel: 'Total',
    orderPrefix: 'Order',
    cancelOrderConfirm: 'Are you sure you want to cancel this order?',
    markReady: '✓ Mark Ready',
    markServed: '🚀 Mark Served',
    cancelOrderBtn: '🗑️ Cancel Order',
    addItemBtn: '➕ Add Item',

    // Header pageTitles (route → title)
    pageTableManagement: 'Table Management',
    pageOrderManagement: 'Order Management',
    pageMenuManagement: 'Menu Management',
    pageKitchenScreen: 'Kitchen Screen',
    pageStockManagement: 'Stock Management',
    pageRecipeSystem: 'Recipe System',
    pagePaymentsCash: 'Payments & Cash',
    pageUserManagement: 'User Management',
    roleAdmin: 'Admin',
    roleWaiter: 'Waiter',
    roleKitchen: 'Kitchen',

    // Reservations
    resStatusPending: 'Pending',
    resStatusConfirmed: 'Confirmed',
    resStatusConfirmedShort: 'OK',
    resStatusArrived: 'Arrived',
    resStatusCompleted: 'Completed',
    resStatusNoShow: 'No-show',
    totalGuests: 'Total Guests',
    editReservation: 'Edit Reservation',
    newReservation: 'New Reservation',
    create: 'Create',
    reservationsTitle: 'Reservations',
    reservationsSubtitle: 'Table reservation management',
    customerName: 'Customer Name',
    partySize: 'Party Size',
    durationMin: 'Duration (min)',
    tableOptional: 'Table (optional)',
    noTableSelected: '-- No table selected --',
    capacityPersons: 'persons',
    persons: 'persons',
    minShort: 'min',
    dateLabel: 'Date:',
    statusFilterLabel: 'Status:',
    clear: 'Clear',
    reservationStatTotal: 'Total',
    reservationStatConfirmed: 'Confirmed',
    reservationStatPending: 'Pending',
    reservationStatCancelled: 'Cancelled',
    reservationNotFound: 'No reservations found',
    reservationEmptyHint: 'Use the + button to add a new reservation',
    deleteReservationConfirm: 'Are you sure you want to delete this reservation?',
    timeLabel: 'Time',
    notesPlaceholder: 'Special request, allergy, birthday, etc.',
    // Stock
    stockLoadError: 'Could not load stock data.',
    allFieldsRequired: 'All fields are required.',
    invalidQuantity: 'Quantity must be a valid non-negative number.',
    invalidCriticalLevel: 'Critical level must be a valid non-negative number.',
    saveFailed: 'Could not save.',
    updateStock: 'Update Stock',
    newIngredient: 'New Ingredient',
    supplierName: 'Supplier name',
    reorderQuantity: 'Reorder quantity',
    ingredient: 'Ingredient',
    ingredientName: 'Ingredient Name',
    totalIngredients: 'Total Ingredients',
    criticalStock: 'Critical Stock',
    normalStock: 'Normal Stock',
    addIngredient: '+ Add Ingredient',
    unit: 'Unit',
    criticalLevel: 'Critical Level',
    supplierOptional: '📦 Supplier (Optional)',
    phoneWhatsapp: 'Phone (WhatsApp)',
    supplierEmailHint: 'When stock drops below critical level, WhatsApp and email order links are auto-generated in admin emails.',
    ingredientNotFound: 'No ingredients found',
    statusCritical: '⚠️ Critical',
    statusNormal: '✓ Normal',
    deleteIngredientConfirm: 'Are you sure you want to delete this ingredient?',
    criticalCount: 'Critical',
    // MenuManagement
    dataLoadError: 'Could not load data.',
    variantAddError: 'Could not add variant.',
    variantDeleteError: 'Could not delete variant.',
    enterValidValue: 'Please enter a valid value.',
    bulkPriceUpdateError: 'Could not bulk update prices.',
    categoryNameRequired: 'Category name is required.',
    categorySaveError: 'Could not save category.',
    categoryDeleteError: 'Could not delete category.',
    nameAndPriceRequired: 'Name and price are required.',
    menuItemSaveError: 'Could not save menu item.',
    menuItemDeleteError: 'Could not delete menu item.',
    aiScanFailed: 'AI scan failed. Please try a clearer photo.',
    excelDownloadError: 'Could not download Excel.',
    importFailed: 'Import failed.',
    editCategory: 'Edit Category',
    newCategory: 'New Category',
    categoryName: 'Category name',
    optional: 'Optional',
    editProduct: 'Edit Product',
    newProduct: 'New Product',
    productName: 'Product name',
    variantsExample: 'Small / Medium / Large',
    bulkPriceUpdate: 'Bulk Price Update',
    updating: 'Updating...',
    apply: 'Apply',
    adding: 'Adding...',
    qrMenuCode: 'QR Menu Code',
    // Kitchen
    justNow: 'Just now',
    actionFailed: 'Action failed.',

    // Tables page
    tablesLoadError: 'Could not load tables.',
    orderCreateError: 'Could not create order.',
    tableNameRequired: 'Table name is required.',
    tableAddError: 'Could not add table.',
    tablesAddError: 'Could not add tables.',
    tableDeleteError: 'Could not delete table.',
    tableCloseError: 'Could not close table.',
    paymentFailed: 'Payment failed.',
    invalidPromoCode: 'Invalid promo code',
    invalidGiftVoucher: 'Invalid gift voucher',
    addOrder: '➕ Add Order',
    closeTable: '✕ Close Table',
    deleteTableAction: '🗑️ Delete Table',
    tableNotSpecified: 'Table not specified',
    searchTableHint: 'Search tables...',
    noTablesYet: 'No tables yet',
    noTableMatching: 'no tables found',
    statusEmpty: 'Empty',
    statusOccupied: 'Occupied',
    statusReserved: 'Reserved',
    allFloors: 'All Floors',
    categoriesNav: '⚙️ Categories',
    addFloorCategory: '+ Add floor / zone category',
    addTableShort: '+ Table',
    seenLabel: '• Seen',
    markSeen: 'Mark Seen',
    resolvedLabel: 'Resolved',
    hide: '▲ Hide',
    show: '▼ Show',
    ordersSheetTitle: 'Orders',
    checkoutTitle: 'Checkout',
    noPendingOrders: 'No orders pending payment',
    markReadyShort: '✓ Ready',
    orderSubtotal: 'order total',
    closeCheck: '💰 Close Check',
    addNewOrder: '➕ Add New Order',
    createOrderTitle: 'Create Order',
    orderNotePlaceholder: 'Order note...',
    addNewTable: 'Add New Table',
    paymentMixed: 'Mixed',
    categoryNameLabel: 'Category Name',

    // Onboarding wizard
    onbTitle: 'Welcome! 🎊',
    onbSubtitle: 'Let\'s set up your restaurant in a few steps',
    onbStepRestaurant: 'Restaurant',
    onbStepTables: 'Tables',
    onbStepMenu: 'Menu',
    onbStepDone: 'Done',
    onbStep1Hint: 'Enter basic info about your restaurant. You can change later from Settings.',
    onbRestaurantName: 'Restaurant Name',
    onbOwnerName: 'Owner',
    onbAddress: 'Address',
    onbNameRequired: 'Restaurant name is required',
    onbContinue: 'Continue →',
    onbSkip: 'Skip This Step',
    onbDoneTitle: 'Setup Complete!',
    onbDoneHint: 'You can now start managing your restaurant.',
    onbGoDashboard: 'Go to Dashboard',
    onbStep2Hint: 'Optional: add a floor/zone category, then create tables in bulk.',
    onbCategoriesLabel: 'Categories',
    onbCategoryNamePh: 'New category (e.g., Garden, Hall)',
    onbBulkTablesTitle: 'Create tables in bulk',
    onbPrefix: 'Prefix',
    onbCount: 'Count',
    onbCapacity: 'Capacity',
    onbStep3Hint: 'Add menu categories, then quickly define a few items. Detailed menu is managed in Menu Management.',
    onbMenuCategoriesLabel: 'Menu Categories',
    onbMenuCategoryPh: 'New category (e.g., Soups, Drinks)',
    onbQuickItemTitle: 'Quick add item',
    onbNeedCategoryFirst: 'Add at least one category first.',
    onbReopenTitle: 'Setup Wizard',
    onbReopenDesc: 'Re-open the step-by-step wizard for restaurant info, tables and menu.',
    onbReopenBtn: 'Open Wizard',

    // Sound preferences
    soundPresetTitle: 'Notification Sound',
    soundPresetDesc: 'Sound played on the kitchen screen when a new order arrives.',
    soundPreset_beep: 'Beep',
    soundPreset_chime: 'Chime',
    soundPreset_bell: 'Bell',
    soundVolumeLabel: 'Volume',
    soundTestBtn: 'Test Sound',

    // DeliveryOrders i18n tail
    deliveryOrdersTitle: 'Delivery Orders',
    deliveryOrdersSubtitle: 'Orders from all platforms',
    deliveryEmptyTitle: 'No delivery orders found',
    deliveryEmptyFiltered: 'Try changing filters and search again',
    deliveryEmptyDefault: 'Orders will appear here once platform integrations are active',
    activeOrders: 'Active Orders',
    completedCancelled: 'Completed / Cancelled',
    paidOnline: 'Paid Online',
    payOnDelivery: 'Pay on Delivery',
    cancelledByRestaurant: 'Cancelled by restaurant',
    statusUpdateFailed: 'Status could not be updated.',
    loadFailed: 'Could not load data.',
    filterAll: 'All',
    prevPage: 'Previous',
    nextPage: 'Next',

    // Users i18n tail
    role: 'Role',
    registrationDate: 'Registered',
    totalUsers: 'Total users',
    addUser: 'Add User',
    editUserTitle: 'Edit User',
    newUserTitle: 'New User',
    newPasswordOptional: 'New Password (leave blank to keep current)',
    userNameEmailRequired: 'Name and email are required.',
    invalidEmailAddress: 'Please enter a valid email address.',
    passwordRequired: 'Password is required.',
    passwordMinChars: 'Password must be at least 6 characters.',
    deleteUserConfirm: 'Are you sure you want to delete this user?',

    // Tables.js checkout sheet i18n tail
    discountAndTreat: 'Discount / Comp',
    amountMode: 'Amount',
    percentMode: 'Rate',
    treatLabel: 'Comp',
    promoCodeAndVoucher: 'Promo Code / Gift Voucher',
    promoCodeShort: 'Promo',
    giftVoucher: 'Gift Voucher',
    removeAction: 'Remove',
    balanceLabel: 'Balance',
    amountToPay: 'Amount to Pay',
    amountsMatch: 'Amounts match',
    remainingLabel: 'Remaining',
    processing: 'Processing...',
    treatCloseBill: 'Comp — Close Bill',
    takePayment: 'Take Payment',

    // Payments + Reports i18n tail
    dailyCashReport: 'Daily Cash Report',
    transactionCount: 'Transactions',
    paymentList: 'Payment List',
    paymentTypeCol: 'Payment Type',
    timeCol: 'Time',
    noPaymentsForDate: 'No payment records for this date',
    dateRangeSalesReport: 'Date Range Sales Report',
    startDate: 'From',
    endDate: 'To',
    runReport: 'Run Report',
    periodTotalRevenue: 'Period Total Revenue',
    selectDateRange: 'Please select start and end dates.',
    reportLoadFailed: 'Could not load report data.',
    salesReportLoadFailed: 'Could not load sales report.',
    advancedReports: 'Advanced Reports',
    advancedReportsSubtitle: 'Sales analytics and detailed revenue reports',
    reportsTabReports: 'Reports',
    reportsTabBI: 'BI Dashboard',
    reportsTabDetail: 'Detail Reports',
    periodToday: 'Today',
    periodThisWeek: 'This Week',
    periodThisMonth: 'This Month',
    periodCustomDate: 'Custom Date',
    reportLoadingMsg: 'Loading report...',
    noDataYet: 'No data yet',
    selectDateRangeAndRun: 'Pick a date range and click Run Report',
    noDataForPeriod: 'No data found for this period',

    // Tables.js create-order/add-table sheet i18n tail
    noProductInCategory: 'No products in this category',
    noteOptionalLabel: 'Note (optional)',
    itemSuffix: 'items',
    creating: 'Creating...',
    createOrderBtn: 'Create Order',
    singleTableMode: 'Single Table',
    bulkAddMode: 'Bulk Add',
    tableNameLabel: 'Table Name',
    capacityPeople: 'Capacity (people)',
    categoryFloorZone: 'Category (Floor / Zone)',
    uncategorized: 'Uncategorized',
    addTableBtn: 'Add Table',
    prefixLabel: 'Prefix',
    countLabel: 'Count',
    maxLabel: 'max.',
    startNumber: 'Start Number',
    tablesToCreate: 'Tables to create',
    countSuffix: 'items',
    categoryLabel: 'Category',
    invalidPrefixCount: 'Enter a valid prefix and count (1-50).',

    // Reports.js BI tab + Reports tab tail
    showBtn: 'Show',
    biLoadFailed: 'Could not load BI dashboard data.',
    dashboardLoadingMsg: 'Loading dashboard...',
    hourlyOrderDensity: 'Hourly Order Density',
    noDataForDate: 'No data for this date',
    topSellingItems: 'Top Selling Items',
    waiterPerformance: 'Waiter Performance',
    deliveryPlatformSummary: 'Delivery Platform Summary',
    platformCol: 'Platform',
    orderShortCol: 'Orders',
    revenueCol: 'Revenue',
    cancelledCol: 'Cancelled',
    orderCountSuffix: 'orders',
    orderCountCol: 'Order Count',
    cashCollected: 'Cash Collected',
    cardCollected: 'Card Collected',
    totalCollected: 'Total Collected',
    paymentTypeBreakdown: 'Payment Type Breakdown',
    hourlyBreakdown: 'Hourly Breakdown',
    unknown: 'Unknown',

    // Reports.js Detail tab i18n tail
    detailLoadFailed: 'Could not load detail report data.',
    categoryBasedSales: 'Sales by Category',
    noDataInRange: 'No data in this range',
    paymentChannelsTrend: 'Payment Channels Trend',
    vatReportTitle: 'VAT Report (Tax Filing)',
    vatRate: 'VAT Rate',
    grossAmount: 'Gross Amount',
    vatLabel: 'VAT',
    netAmount: 'Net Amount',
    stockStatusTitle: 'Stock Status',
    criticalStockShort: 'critical stock',
    noStockRecord: 'No stock records found',
    unitCol: 'Unit',
    criticalThreshold: 'Critical Threshold',
    criticalBadge: 'Critical',
    normalBadge: 'Normal',

    // Settings.js i18n tail
    tabGeneral: 'General',
    tabInterface: 'Interface',
    tabNotifications: 'Notifications',
    tabQRMenu: 'QR Menu',
    tabCurrency: 'Currency',
    criticalStockAlertLabel: 'Critical Stock Alert',
    criticalStockAlertDesc: 'Notify when stock drops to critical level',
    recipeStockDeduction: 'Recipe Stock Deduction',
    recipeStockDeductionDesc: 'Deduct recipe ingredients from stock when order is served',
    settingsLoadFailed: 'Settings could not be loaded.',
    currencyUpdated: 'Currency updated.',
    updateFailedShort: 'Could not be updated.',
    notifsDisabledMsg: 'Notifications disabled.',
    notifsEnabledMsg: 'Notifications enabled!',
    vapidNotConfigured: 'VAPID not configured.',
    operationFailed: 'Operation failed.',
    pushTestBody: 'Push notifications are working!',
    testNotifSent: 'Test notification sent.',
    testNotifFailed: 'Could not send test.',
    saveFailedShort: 'Save failed.',
    updateCurrencyBtn: 'Update Currency',
    saveSettingsBtn: 'Save Settings',
    pushNotSupported: 'This browser does not support push notifications.',
    pushEnabledDevice: 'Push notifications are enabled on this device. You will receive alerts for new orders.',
    pushEnableHint: 'Enable to receive instant browser alerts for new orders.',

    // Recipes.js i18n tail
    selectMenuItem: 'Select Menu Item',
    selectPlaceholder: 'Select',
    recipeLabel: 'Recipe',
    addIngredientBtn: 'Add Ingredient',
    recipeLoadFailed: 'Could not load recipe.',
    recipeAddFailed: 'Could not add recipe.',
    portionCalculator: 'Portion Calculator',
    maxPortions: 'max portions',
    limitingIngredient: 'Limiting Ingredient',
    portionAfterRecipe: 'Calculated after recipe is defined',
    addIngredientToRecipe: 'Add Ingredient to Recipe',
    quantityPerPortion: 'Quantity (per portion)',

    // GiftVouchers.js i18n tail
    giftVouchersTitle: 'Gift Vouchers',
    giftVouchersSubtitle: 'Create and manage gift vouchers',
    newVoucherBtn: 'New Gift Voucher',
    queryCode: 'Query Code',
    queryBtn: 'Query',
    validVoucher: 'Valid Gift Voucher',
    remainingBalance: 'Remaining Balance',
    invalidCode: 'Invalid code',
    errorOccurred: 'An error occurred',
    deleteVoucherConfirm: 'Are you sure you want to delete this gift voucher?',
    noVouchersYet: 'No gift vouchers yet',
    createFirstVoucher: 'Create your first gift voucher',
    printAction: 'Print',
    usedLabel: 'used',
    expiredLabel: 'Expired',
    endsLabel: 'Ends',
    customCodeOptional: 'Custom Code (optional)',
    autoGeneratedPh: 'Auto-generated',
    endDateLabel: 'End Date',
    notesLabel: 'Notes',
    customMessagePh: 'Custom message...',
    createBtn: 'Create',
    dearLabel: 'Dear',
    expiresLabel: 'Expires',

    // PromoCodes.js i18n tail
    promoCodesTitle: 'Promo Codes',
    promoCodesSubtitle: 'Manage discount and promotion codes',
    newCodeBtn: 'New Code',
    noPromoCodesYet: 'No promo codes yet',
    createFirstPromoCode: 'Create your first promo code',
    deletePromoConfirm: 'Are you sure you want to delete this promo code?',
    namelessCampaign: 'Unnamed campaign',
    discountSuffix: 'off',
    minShortLabel: 'Min',
    usageLabel: 'Usage',
    activeStatus: 'Active',
    inactiveStatus: 'Inactive',
    setActive: 'Activate',
    setInactive: 'Deactivate',
    editCodeTitle: 'Edit Code',
    newPromoCodeTitle: 'New Promo Code',
    codeLabel: 'Code',
    campaignName: 'Campaign Name',
    summerSalePh: 'Summer sale',
    discountTypeLabel: 'Discount Type',
    percentOption: 'Percentage (%)',
    fixedAmountOption: 'Fixed Amount (₺)',
    amountOption: 'Amount (₺)',
    minOrderLabel: 'Min. Order',
    maxUsageLabel: 'Max Usage',
    unlimitedPh: 'Unlimited',
    updateBtn: 'Update',

    // WaiterStats.js i18n tail
    waiterStatsSubtitle: 'Order and revenue statistics per staff member',
    waiterDataLoadFailed: 'Could not load waiter data.',
    sortLabel: 'Sort',
    averageOrder: 'Average Order',
    topPerformance: 'Top Performer',
    staffList: 'Staff List',
    staffCountSuffix: 'staff',
    dataLoadingMsg: 'Loading data...',
    tryDifferentPeriod: 'Try selecting a different period',
    waiterNameCol: 'Waiter Name',
    avgOrderCol: 'Avg. Order',
    lastActivityCol: 'Last Activity',

    // Checkout.js i18n tail
    planInfoMissing: 'Plan info is missing.',
    planInfoLoadFailed: 'Could not load plan info.',
    firstNameRequired: 'First name is required',
    lastNameRequired: 'Last name is required',
    phoneRequired: 'Phone is required',
    phoneInvalid: 'Enter a valid phone number',
    cityRequired: 'City is required',
    addressRequired: 'Address is required',
    paymentFormLoadFailed: 'Payment form could not be loaded. Please try again.',
    paymentStartFailed: 'Payment could not be started. Please try again.',
    securePayment: 'Secure Payment',
    iyzicoProtected: 'Payment protected by iyzico',
    paymentHeader: 'Payment',
    enterBillingInfo: 'Enter your billing information',
    billingInfoTitle: 'Billing Information',
    firstNameLabel: 'First Name',
    lastNameLabel: 'Last Name',
    cityLabel: 'City',
    addressPh: 'District, Street, Building No...',
    paymentFormPreparing: 'Preparing payment form...',
    proceedToPayment: 'Proceed to Payment',
    sslEncrypted: 'SSL Encrypted',
    iyzicoSecured: 'iyzico Secured',
    orderSummary: 'Order Summary',
    yearlyBilling: 'Yearly billing',
    monthlyBilling: 'Monthly billing',
    yearShort: 'yr',
    monthShort: 'mo',
    yearlyBonusHint: 'With yearly payment, you get 2 months free!',
    userSuffix: 'users',
    freeTrialDays: '14-day free trial',
    cancelAnytime: 'Cancel anytime',
    planLabel: 'Plan',

    // Orders
    orderPreparing: 'Preparing',
    orderReady: 'Ready',
    orderCancelled: 'Cancelled',
    tableNo: 'Table',

    // Payments
    cash: 'Cash',
    card: 'Card',
    online: 'Online',
    discount: 'Discount',
    tax: 'Tax',
    subtotal: 'Subtotal',
    // Delivery
    delivery_new: 'New',
    delivery_accepted: 'Accepted',
    delivery_preparing: 'Preparing',
    delivery_ready: 'Ready',
    delivery_delivered: 'Delivered',
    delivery_cancelled: 'Cancelled',

    // Password Reset
    newPassword: 'New Password',
    // General states
    // === Batch i18n merge (agent outputs) ===
    posDisplayThanks: 'Thank you!',
    posDisplayPaymentReceived: 'Your payment has been received, have a nice day.',
    posDisplayPaymentPending: 'Payment Pending',
    posDisplayWaitForCashier: 'Please wait for the cashier...',
    posDisplayTellCashier: 'Tell your order to the cashier',
    posDisplayCustomerScreen: 'Customer Screen',
    posDisplayAdAlt: 'Promotion',
    posDisplayAdHint: 'Admin can add promotional images from Settings → Receipt Settings.',
    posDisplayPerUnit: 'unit',
    posDisplayDiscount: 'Discount',
    posDisplayVatIncluded: 'VAT (included)',
    paymentResultTokenMissing: 'Payment token information not found.',
    paymentResultFailedGeneric: 'Payment failed.',
    paymentResultFetchError: 'Could not retrieve payment result. Please contact support.',
    paymentResultChecking: 'Checking Payment',
    paymentResultVerifying: 'Please wait, your payment is being verified...',
    paymentResultSuccess: 'Payment Successful!',
    paymentResultSuccessDesc: 'Your subscription has been created successfully. You now have access to all features.',
    paymentResultPlan: 'Plan',
    paymentResultBillingCycle: 'Period',
    paymentResultYearly: 'Yearly',
    paymentResultMonthly: 'Monthly',
    paymentResultAmountPaid: 'Amount Paid',
    paymentResultValidUntil: 'Valid Until',
    paymentResultTransactionId: 'Transaction ID',
    paymentResultGoToDashboard: 'Go to Dashboard',
    paymentResultViewSubscription: 'View My Subscription',
    paymentResultReceiptSent: 'The payment receipt has been sent to your email address.',
    paymentResultFailed: 'Payment Failed',
    paymentResultFailedDesc: 'The payment could not be completed.',
    paymentResultRetry: 'Try Again',
    paymentResultBackToPlans: 'Back to Plans',
    paymentResultGoHome: 'Go to Home Page',
    paymentResultSupportPrefix: 'If the issue persists, contact',
    paymentResultSupportSuffix: 'for support.',
    securityTitle: 'Security',
    securityProtectAccount: 'protect your account',
    security2FATitle: 'Two-Factor Authentication (TOTP)',
    security2FADescription: 'Extra protection with Authenticator (Google/Authy/1Password)',
    securityActive: 'Active',
    securityInactive: 'Inactive',
    securityBackupCodes: 'Backup Codes',
    securityShownOnce: 'Shown only once',
    securityBackupCodesHint: 'Use these codes if you lose access to your Authenticator. Save them in a safe place.',
    securitySavedClose: 'I saved them, close',
    securityScanQRStep: '1. Scan the QR code below with your Authenticator app.',
    securityManualCode: 'Manual code',
    securityEnterCodeStep: '2. Enter the 6-digit code from the app:',
    securityVerifying: 'Verifying...',
    security2FAEnable: 'Enable',
    security2FADisable: 'Disable 2FA',
    security2FASetup: 'Set up 2FA',
    securityPreparing: 'Preparing...',
    securityEnterPasswordTOTP: 'Enter your password and TOTP code.',
    securityTOTPCode: '6-digit TOTP code',
    securitySetupFailed: 'Setup could not be started.',
    securityCodeInvalid: 'Invalid code.',
    securityDisableFailed: 'Could not be disabled.',
    gdprTitle: 'GDPR / KVKK',
    gdprSubtitle: 'Personal data rights and privacy management',
    gdprTabRights: 'My GDPR Rights',
    gdprTabRequest: 'Submit Request',
    gdprTabMyRequests: 'My Requests',
    gdprTabAdmin: 'Admin Panel',
    gdprTypeExport: 'Data Export',
    gdprTypeDelete: 'Data Deletion (Right to be Forgotten)',
    gdprTypeRectify: 'Data Rectification',
    gdprTypeRestrict: 'Processing Restriction',
    gdprTypeObject: 'Object to Processing',
    gdprStatusPending: 'Pending',
    gdprStatusProcessing: 'Processing',
    gdprStatusCompleted: 'Completed',
    gdprStatusRejected: 'Rejected',
    gdprStatTotal: 'Total Requests',
    gdprStatPending: 'Pending',
    gdprStatCompleted: 'Completed',
    gdprStatRejected: 'Rejected',
    gdprRightsHeading: 'Your Rights Under GDPR / KVKK Law No. 6698',
    gdprRightsIntro: 'Under the Personal Data Protection Law (KVKK) and the European General Data Protection Regulation (GDPR), you have the following rights:',
    gdprRightInfoTitle: 'Right to Information',
    gdprRightInfoDesc: 'You have the right to learn whether your personal data is being processed.',
    gdprRightPortabilityTitle: 'Data Portability',
    gdprRightPortabilityDesc: 'You can request that your processed personal data be provided to you in a structured and machine-readable format.',
    gdprRightRectifyTitle: 'Right to Rectification',
    gdprRightRectifyDesc: 'You can request the correction of inaccurate or incomplete personal data.',
    gdprRightDeleteTitle: 'Right to Erasure / Be Forgotten',
    gdprRightDeleteDesc: 'You can request the deletion or destruction of your personal data.',
    gdprRightObjectTitle: 'Object to Processing',
    gdprRightObjectDesc: 'You can object to the processing of your personal data.',
    gdprRightRestrictTitle: 'Restrict Processing',
    gdprRightRestrictDesc: 'Under certain conditions, you can request that the processing of your personal data be restricted.',
    gdprDataController: 'Data Controller',
    gdprControllerInfo: 'RestaFlex — Your requests will be answered within 30 days at the latest. For questions:',
    gdprCreateRequest: 'Create Request',
    gdprNewRequest: 'New GDPR Request',
    gdprRequestType: 'Request Type',
    gdprDescriptionOptional: 'Description (optional)',
    gdprDescriptionPlaceholder: 'Additional information about your request...',
    gdprSubmitting: 'Submitting...',
    gdprSubmitRequest: 'Submit Request',
    gdprDownloadNow: 'Would you like to download your data now?',
    gdprDownloadPackage: 'Download my data package (JSON)',
    gdprNoRequests: 'You have not submitted any requests yet.',
    gdprResponse: 'Response',
    gdprTotalConsent: 'Total Consent',
    gdprAnalyticsAccepted: 'Analytics Accepted',
    gdprAnalyticsRejected: 'Analytics Rejected',
    gdprMarketingAccepted: 'Marketing Accepted',
    gdprAllStatuses: 'All Statuses',
    gdprAllTypes: 'All Types',
    gdprFilter: 'Filter',
    gdprNoRequestsFound: 'No requests found.',
    gdprProcess: 'Process',
    gdprProcessRequest: 'Process Request',
    gdprStatus: 'Status',
    gdprResponseNote: 'Response Note',
    gdprResponsePlaceholder: 'Response to be sent to the user...',
    gdprExportFailed: 'Data could not be exported.',
    pricingTrialBadge: '14-Day Free Trial — No Credit Card Required',
    pricingTitleLine1: 'Choose the Right Plan',
    pricingTitleHighlight: 'For Your',
    pricingTitleLine2: 'Restaurant',
    pricingSubtitle: 'Manage your tables, orders, and kitchen from a single platform with RestaFlex.',
    pricingMonthly: 'Monthly',
    pricingYearly: 'Yearly',
    pricingTwoMonthsFree: '2 MONTHS FREE',
    pricingPlansLoadError: 'Failed to load plans.',
    pricingNoPlansFound: 'No plans found. Please try again later.',
    pricingMostPopular: 'MOST POPULAR',
    pricingYearlySavingsPrefix: 'Save',
    pricingYearlySavingsSuffix: 'yearly!',
    pricingTablesSuffix: 'tables',
    pricingStartFreeTrial: 'Start 14-Day Free Trial',
    pricingComparisonTitle: 'Feature Comparison',
    pricingComparisonSubtitle: 'Which plan fits you? Compare and decide.',
    pricingFeatureColumn: 'Feature',
    pricingPriceMonthly: 'Price (Monthly)',
    pricingMaxTables: 'Max. Tables',
    pricingMaxUsers: 'Max. Users',
    pricingFeatureQrMenu: 'QR Menu',
    pricingFeatureTableManagement: 'Table Management',
    pricingFeatureOrderManagement: 'Order Management',
    pricingFeatureKitchenDisplay: 'Kitchen Display',
    pricingFeaturePaymentSystem: 'Payment System',
    pricingFeatureStockManagement: 'Stock Management',
    pricingFeatureRecipeSystem: 'Recipe System',
    pricingFeatureWaiterManagement: 'Waiter Management',
    pricingFeatureAdvancedAnalytics: 'Advanced Analytics',
    pricingFeatureApiAccess: 'API Access',
    pricingFaqTitle: 'Frequently Asked Questions',
    pricingFaqSubtitle: 'Answers to the questions on your mind.',
    pricingFaq1Q: 'What happens when the trial ends?',
    pricingFaq1A: 'When your 14-day free trial ends, your account is suspended. Your data is not deleted; select a plan to continue where you left off.',
    pricingFaq2Q: 'Can I cancel anytime?',
    pricingFaq2A: 'Yes, you can cancel your subscription at any time. When you cancel, you continue to receive service until the end of the current period, and you are not charged for the next period.',
    pricingFaq3Q: 'Can I change my plan?',
    pricingFaq3A: 'Yes, you can upgrade or downgrade your plan anytime. Upgrades take effect immediately, while downgrades apply at the end of the current period.',
    pricingFaq4Q: 'Is payment secure?',
    pricingFaq4A: 'All payments are securely processed via the iyzico infrastructure with 256-bit SSL encryption. Your card details are not stored in our system.',
    pricingCtaTitle: 'Get Started Now',
    pricingCtaSubtitle: 'Use all features free for 14 days. No credit card required.',
    pricingCtaTryFree: 'Try for Free',
    pricingCtaChoosePlan: 'Choose My Plan',
    webhooksTitle: 'Webhook Integrations',
    webhooksSubtitle: 'Integrate Zapier, Make.com or your custom systems with real-time events.',
    webhookNewButton: '+ New Webhook',
    webhookNewTitle: 'Add New Webhook',
    webhookEditTitle: 'Edit Webhook',
    webhookHintZapier: 'Paste Trigger URL here',
    webhookHintMake: 'Custom Webhook module URL',
    webhookHintN8n: 'Webhook node trigger URL',
    webhookHintCustomLabel: 'Custom system',
    webhookHintCustomDesc: 'Any HTTPS endpoint',
    webhookStatTotal: 'Total Webhooks',
    webhookStatFailing: 'Failing',
    webhookEmptyTitle: 'No webhooks yet',
    webhookEmptyDesc: 'Add a webhook to integrate with Zapier or Make.com.',
    webhookErrorsLabel: 'errors',
    webhookErrorLabel: 'Error',
    webhookLastTriggered: 'Last triggered',
    webhookTestSend: 'Test',
    webhookTestSent: 'Test webhook sent.',
    webhookTestFailed: 'Failed to send test.',
    webhookDeliveryHistory: 'Delivery History',
    webhookNoDeliveries: 'No delivery records yet.',
    webhookDeleteConfirm: 'Delete this webhook?',
    webhookUpdateFailed: 'Update failed.',
    webhookNameRequired: 'Name is required.',
    webhookUrlRequired: 'URL is required.',
    webhookEventRequired: 'Select at least one event.',
    webhookUrlInvalid: 'Enter a valid URL.',
    webhookNameLabel: 'Name',
    webhookNamePlaceholder: 'E.g. Zapier Order Notification',
    webhookEndpointLabel: 'Webhook URL',
    webhookHttpsRecommended: '(HTTPS recommended)',
    webhookEventsLabel: 'Events',
    webhookSecretLabel: 'Signing Secret',
    webhookSecretHint: '— optional, auto-generated if left empty',
    webhookSecretPlaceholder: 'Your own secret or leave empty',
    webhookSecurityLabel: 'Security',
    webhookSecurityPart1: 'Each request is signed and sent with',
    webhookSecurityPart2: 'header.',
    webhookSecurityPart3: 'You can verify this header in Zapier\'s Custom Request.',
    webhookSaving: 'Saving…',
    webhookEventOrderCreated: 'Order Created',
    webhookEventOrderStatusChanged: 'Order Status Changed',
    webhookEventPaymentCompleted: 'Payment Completed',
    webhookEventReservationCreated: 'Reservation Created',
    webhookEventReservationStatusChanged: 'Reservation Status Changed',
    webhookEventCustomerCreated: 'New Customer Registered',
    webhookEventDeliveryOrderCreated: 'Delivery Order Received',
    webhookEventDeliveryOrderStatusChanged: 'Delivery Status Changed',
    subscriptionStatusTrial: 'Trial',
    subscriptionStatusCancelled: 'Cancelled',
    subscriptionStatusExpired: 'Expired',
    subscriptionStatusPastDue: 'Past Due',
    subscriptionLoadError: 'Failed to load data.',
    subscriptionCancelSuccess: 'Your subscription has been cancelled. You will continue to receive service until the end of the current period.',
    subscriptionCancelError: 'Cancellation failed.',
    subscriptionTitle: 'My Subscription',
    subscriptionSubtitle: 'Manage your subscription status and update your plan.',
    subscriptionWord: 'subscription',
    subscriptionTrialPeriod: 'Trial Period',
    subscriptionTrialEnd: 'Trial End',
    subscriptionNextPayment: 'Next Payment',
    subscriptionDaysRemaining: 'Days Remaining',
    subscriptionDaysUnit: 'days',
    subscriptionEnded: 'Ended',
    subscriptionTimeUsage: 'Time usage',
    subscriptionDaysLeft: 'days left',
    subscriptionNoActive: 'You have no active subscription',
    subscriptionNeedPlan: 'You need to choose a plan to use the system.',
    subscriptionChoosePlan: 'Choose Plan',
    subscriptionChangePlan: 'Change Plan',
    subscriptionCurrentPlan: 'Current Plan',
    subscriptionMaxTables: 'Max.',
    subscriptionTablesUnit: 'tables',
    subscriptionMaxUsers: 'Max.',
    subscriptionUsersUnit: 'users',
    subscriptionUpgradeBtn: 'Upgrade',
    subscriptionDowngradeBtn: 'Downgrade',
    subscriptionStartBtn: 'Start',
    subscriptionActivePlan: 'Active Plan',
    subscriptionPaymentHistory: 'Payment History',
    subscriptionDateCol: 'Date',
    subscriptionPeriodCol: 'Period',
    subscriptionPaymentSuccess: 'Successful',
    subscriptionPaymentFailed: 'Failed',
    subscriptionCancelTitle: 'Cancel Subscription',
    subscriptionCancelInfo: 'If you cancel your subscription, you will continue to receive service until the end of the current period. The cancellation is irreversible.',
    subscriptionCancelInfoTrial: 'Your trial will end immediately and you will lose access to all features.',
    subscriptionCancelConfirm: 'Your subscription will be cancelled at the end of the current period.',
    subscriptionCancelConfirmTrial: 'Your trial will be cancelled immediately. Are you sure?',
    subscriptionCancelAccessUntil: 'Your access will remain active until {date}.',
    subscriptionCancelScheduled: 'Your subscription is scheduled for cancellation',
    subscriptionAccessUntil: 'Your access is active until:',
    subscriptionCancelling: 'Cancelling...',
    subscriptionCancelYes: 'Yes, Cancel',
    printersTitle: 'Printers',
    printersSubtitle: 'Manage receipt, kitchen and barcode printers',
    printerAddBtn: 'Add Printer',
    printerAddFirstBtn: 'Add First Printer',
    printerAddTitle: 'Add Printer',
    printerEditTitle: 'Edit Printer',
    printerEmptyTitle: 'No printers added yet',
    printerEmptySubtitle: 'Add a printer to manage your receipts',
    printerJobsTab: 'Print Queue',
    printerJobQueueTitle: 'Print Job Queue',
    printerNoJobs: 'No jobs in queue',
    printerDefault: 'Default',
    printerTypeReceipt: 'Receipt',
    printerTypeKitchen: 'Kitchen',
    printerTypeBar: 'Bar',
    printerConnectionNetwork: 'Network (IP)',
    printerConnectionUsb: 'USB',
    printerConnectionSerial: 'Serial Port',
    printerConnectionLabel: 'Connection',
    printerAddressLabel: 'Address',
    printerPortLabel: 'Port',
    printerComPortLabel: 'COM Port',
    printerPaperWidthLabel: 'Paper Width',
    printerNameLabel: 'Printer Name',
    printerNamePlaceholder: 'e.g. Cashier Printer',
    printerTypeLabel: 'Type',
    printerIpLabel: 'IP Address',
    printerNameRequired: 'Printer name is required.',
    printerIpRequired: 'IP address is required.',
    printerComPortRequired: 'COM port is required.',
    printerDeleteConfirm: 'Are you sure you want to delete this printer?',
    printerRetryFailed: 'Retry failed.',
    printerOnline: 'Online',
    printerOffline: 'Offline',
    printerTestSent: 'Test page sent',
    printerTestFailed: 'Test failed',
    printerStatusBtn: 'Status',
    printerTestBtn: 'Test',
    printerRetryBtn: 'Retry',
    printerLabel: 'Printer',
    printerAttempt: 'attempt',
    printerJobStatusPending: 'Pending',
    printerJobStatusPrinting: 'Printing',
    printerJobStatusDone: 'Done',
    printerJobStatusFailed: 'Failed',
    printerStatTotal: 'Total Printers',
    printerStatActive: 'Active',
    printerStatInactive: 'Inactive',
    printerStatPending: 'Pending Jobs',
    printerIsDefaultTitle: 'Default Printer',
    printerIsDefaultHint: 'Auto-selected for operations of this type',
    printerIsActiveHint: 'No jobs sent to inactive printers',
    whiteLabelTitle: 'White-label Management',
    whiteLabelSubtitle: 'Custom brand configurations for partners',
    whiteLabelNewConfig: 'New Config',
    whiteLabelNewConfigTitle: 'New White-label Config',
    whiteLabelEditConfig: 'Edit Config',
    whiteLabelStatTotal: 'Total Configs',
    whiteLabelStatActive: 'Active',
    whiteLabelStatPassive: 'Passive',
    whiteLabelStatusActive: 'Active',
    whiteLabelStatusPassive: 'Passive',
    whiteLabelEmptyTitle: 'No white-label configs yet',
    whiteLabelEmptyDesc: 'Create custom brands for partners',
    whiteLabelRestaurantsSuffix: 'restaurants',
    whiteLabelDetailTitle: 'Detail',
    whiteLabelSlug: 'Slug',
    whiteLabelDomain: 'Domain',
    whiteLabelSupportEmail: 'Support Email',
    whiteLabelSupportPhone: 'Support Phone',
    whiteLabelBrandingUrl: 'Branding URL',
    whiteLabelLinkedRestaurants: 'Linked Restaurants',
    whiteLabelNoRestaurants: 'No restaurants assigned yet.',
    whiteLabelUnassignTitle: 'Unassign',
    whiteLabelPartnerName: 'Partner Name',
    whiteLabelPartnerNamePlaceholder: 'E.g. Acme Restaurant Solutions',
    whiteLabelAppName: 'App Name',
    whiteLabelLogoUrl: 'Logo URL',
    whiteLabelPrimaryColor: 'Primary Color',
    whiteLabelSecondaryColor: 'Secondary Color',
    whiteLabelTextColor: 'Text Color',
    whiteLabelBgColor: 'Background Color',
    whiteLabelCustomDomain: 'Custom Domain',
    whiteLabelFooterText: 'Footer Text',
    whiteLabelFooterPlaceholder: '© 2026 Partner Name. All rights reserved.',
    whiteLabelCustomCss: 'Custom CSS',
    whiteLabelHidePoweredBy: 'Hide "Powered by RestaFlex"',
    whiteLabelPreview: 'Preview',
    whiteLabelSaving: 'Saving...',
    whiteLabelNameSlugRequired: 'Name and slug are required.',
    whiteLabelSlugPattern: 'Slug can only contain lowercase letters, digits and hyphens.',
    whiteLabelDeleteConfirm: 'This white-label config will be deleted. Linked restaurants will be unassigned. Continue?',
    whiteLabelLoadError: 'Failed to load data.',
    whiteLabelDetailError: 'Failed to load detail.',
    whiteLabelDeleteError: 'Delete error.',
    whiteLabelUpdateError: 'Update error.',
    whiteLabelUnassignError: 'Unassign error.',
    qrmenuWaiterCalled: 'Waiter called! Someone will be at your table shortly.',
    qrmenuWaiterCallFailed: 'Call could not be sent. Please try again.',
    qrmenuLoadFailed: 'Menu could not be loaded.',
    qrmenuPaymentVerifyFailed: 'Payment could not be verified. Please contact the restaurant.',
    qrmenuDefaultTitle: 'Restaurant Menu',
    qrmenuEnterName: 'Please enter your name.',
    qrmenuRestaurantNotFound: 'Restaurant information not found. Please scan the QR code again.',
    qrmenuOrderFailed: 'Order could not be sent. Please try again.',
    // QR Menü tema sistemi (Faz B+E1)
    qrThemeTitle: 'Theme',
    qrThemeDesc: 'Choose from 44 ready-made themes. Each theme includes fonts, colors and layout.',
    qrThemeAllCats: 'All',
    qrThemeSearchPh: 'Search themes (name, font, layout...)',
    qrThemeNoMatch: 'No matching theme found.',
    qrThemeDarkOnly: 'Dark only',
    qrThemeRandom: 'Random',
    qrThemeFav: 'Add to favorites',
    qrThemeUnfav: 'Remove from favorites',
    qrThemeFavoritesOnly: 'Favorites',
    qrThemeClearFilters: 'Clear Filters',
    qrThemeRecent: 'Recently Used',
    qrThemeCategoryFilter: 'Theme category filter',
    qrThemeLivePreview: 'Live Preview',
    qrThemeCatClassic: 'Classic',
    qrThemeCatCafe: 'Café',
    qrThemeCatFastFood: 'Fast Food',
    qrThemeCatModern: 'Modern',
    qrThemeCatTropical: 'Tropical',
    qrThemeCatBakery: 'Bakery',
    qrThemeCatPub: 'Pub/Bar',
    qrThemeCatEthnic: 'Ethnic / Cuisine',
    qrThemeCatCorporate: 'Corporate',
    qrCustomOverrideTitle: 'Theme Color Override (Optional)',
    qrCustomOverrideDesc: 'Overrides selected theme colors. Leave empty to use theme defaults.',
    qrCustomPrimary: 'Primary Color',
    qrCustomSecondary: 'Secondary Color',
    qrCustomFont: 'Font Override',
    qrCustomFontTheme: 'Theme default',
    qrThemeSampleItem: 'Sample Item',
    qrThemePreviewItem: 'Latte',
    qrThemeSampleDesc: 'brief description',
    qrThemeDarkLabel: 'Dark theme',
    qrThemeDarkShort: 'Dark',
    qrVariantPreviewLabel: 'style preview',
    qrLayoutPrefix: 'Layout',
    qrPublicUrlTitle: 'Public Menu URL',
    qrPublicUrlDesc: 'Public menu URL customers will scan to reach',
    qrScanForMenu: 'Scan QR code to view menu',
    printQr: 'Print QR Code',
    popupBlocked: 'Popup blocked. Please allow popups.',
    downloadFailed: 'Download failed.',
    downloadSvg: 'Download SVG',
    linkCopied: 'Link copied',
    copyFailed: 'Could not copy',
    copy: 'Copy',
    qrLogoTitle: 'Restaurant Logo',
    qrLogoDesc: 'Logo to display at the top of the QR menu (PNG/JPG/WEBP, max 2MB)',
    qrLogoUploadBtn: 'Upload Logo',
    qrLogoUpload: 'Upload Logo',
    qrLogoUploaded: 'Logo uploaded.',
    qrLogoRemove: 'Remove Logo',
    qrLogoSize: 'Logo Size',
    qrLogoMaxSize: 'Max file size: 2MB',
    qrThemeCategory: 'Theme Category',
    qrThemeSearch: 'Search Theme',
    qrThemeNotFound: 'Theme not found',
    qrThemeReset: 'Reset Theme',
    qrDisplayTitle: 'Display & Behavior',
    qrDisplayDesc: 'Manage what the customer sees on the QR menu',
    qrLayoutLabel: 'Layout',
    qrLayoutGrid: 'Grid',
    qrLayoutList: 'List',
    qrLayoutMagazine: 'Magazine',
    qrShowImages: 'Show product images',
    qrShowDescriptions: 'Show product descriptions',
    qrShowPrices: 'Show prices',
    qrShowAllergens: 'Show allergen info',
    qrShowCalories: 'Show calorie info',
    qrActiveTheme: 'Active Theme',
    qrCartDisabledHint: 'QR cart feature disabled — customers can only view the menu, cannot order.',
    qrCartDisabledInfo: 'This restaurant does not accept QR orders, please call a waiter.',
    qrCartEmpty: 'Your cart is empty — add items from the menu',
    qrEnableCart: 'Cart & order (QR) feature',
    qrEnableWaiterCall: 'Waiter call button',
    qrWelcomeMsg: 'Welcome Message',
    qrWelcomeMsgPh: 'Welcome, we hope you enjoy your choice!',
    qrCartSendToWaiter: 'Send Order via QR',
    qrCartTitle: 'Your Order is Ready',
    qrCartSubtitle: 'Show this QR to your waiter',
    qrCartGenerating: 'Generating QR code...',
    qrCartGenFail: 'Could not generate QR.',
    qrCartTotal: 'Total',
    qrCartInstruction: 'Call your waiter and ask them to scan this QR code. Your order will be placed automatically.',
    qrCartRegenerate: 'Expired — Generate New QR',
    qrCartClaimed: 'Order Received!',
    qrCartClaimedSub: 'Being prepared, will reach you shortly.',
    qrCartOrderNo: 'Order No',
    qrCartRejectedTitle: 'Cart Rejected',
    qrCartRejectedSub: 'The waiter couldn\'t approve your cart. Please review your cart and try again, or talk to the waiter.',
    qrCartTryAgain: 'Try Again',
    qrCartZoom: 'Zoom QR',
    zoomImage: 'Zoom image',
    qrCartZoomHint: 'Tap to close',
    qrCartShare: 'Share QR',
    qrCartShareTitle: 'Order QR Code',
    qrCartShareText: 'Order code to show the waiter',
    qrCartAutoClose: 'Auto-closing…',
    qrCartCloseNow: 'Close Now',
    qrCartRetrying: 'Retrying',
    confirmRemoveImage: 'Are you sure you want to delete this product\'s image?',
    qrPending: 'pending QR',
    qrPendingCartsTitle: 'Pending QR Carts',
    qrPendingCartsSub: 'customers awaiting order — tap to review',
    qrPendingCartsSub2: 'carts awaiting your approval',
    qrNoPendingCarts: 'No pending carts',
    qrCartClaimFail: 'Could not claim cart.',
    qrAcceptToOrder: 'Convert to Order',
    qrCartPickTable: 'Pick Table',
    qrCartPickTableHint: 'Which table is this cart for?',
    qrCartNoTables: 'No tables found.',
    tableOccupied: 'Occupied',
    qrCartReject: 'Reject',
    qrCartCallCustomer: 'Call Customer',
    qrCartRejectConfirm: 'Are you sure you want to reject this QR cart?',
    qrCartRejectReason: 'Waiter rejected',
    qrCartRejectFail: 'Could not reject cart.',
    qrCartRejected: 'Cart rejected',
    qrCartBulkClaim: 'Claim All',
    qrCartBulkClaimConfirm: 'Convert all pending carts to orders?',
    qrCartBulkOk: 'carts converted',
    qrCartBulkFail: 'failed',
    qrCartBulkReject: 'Reject All',
    qrCartBulkRejectConfirm: 'Reject all pending carts? This action cannot be undone.',
    qrCartBulkRejectOk: 'carts rejected',
    sortBy: 'Sort by',
    sortNewestFirst: 'Newest first',
    sortOldestFirst: 'Oldest first',
    sortTotalDesc: 'Highest total',
    qrPendingSearchPh: 'Search customer, phone, table or token…',
    qrPendingNoMatch: 'No matching cart',
    qrPendingEmptyHint: "Customers' QR orders will appear here",
    orderSourceQrOnline: 'QR Order',
    orderStatQrToday: 'QR Today',
    soundMute: 'Mute',
    soundUnmute: 'Unmute',
    retry: 'Retry',
    qrMinOrder: 'Minimum Order Amount',
    qrMinOrderHint: 'Set to 0 for no minimum. QR cart orders below this amount will be rejected.',
    qrMinOrderWarn: 'Min order',
    qrMinOrderMissing: 'Remaining',
    qrMinOrderMet: 'Minimum order met',
    clearCartBtn: 'Clear Cart',
    clearCartConfirm: 'Clear the entire cart?',
    qrResetSettings: 'Reset QR Menu Settings',
    qrResetConfirm: 'Reset QR menu settings to defaults? All theme/logo/layout/card changes will be cleared.',
    qrResetDone: 'Reset to defaults. Click Save to apply.',
    qrExportConfig: 'Export Theme Config as JSON',
    qrExportConfigError: 'Export failed',
    qrImportConfig: 'Import Theme Config from JSON',
    qrImportConfigOk: 'Settings imported. Click Save to apply.',
    qrImportConfigError: 'Invalid JSON or could not parse.',
    viewDetails: 'View details',
    hideDetails: 'Hide details',
    tap: 'tap',
    torchOn: 'Torch On',
    torchOff: 'Torch Off',
    flipCamera: 'Flip Camera',
    pickImageSourcePrompt: 'Where do you want to pick the image from?',
    camera: 'Camera',
    gallery: 'Gallery',
    cameraPermDenied: 'Camera permission denied',
    viewPendingCarts: 'View Pending Carts',
    scan: 'Scan',
    // Mobile scan ekranı
    scanQrTitle: 'Scan QR Order',
    scanQrHint: 'Frame the QR code on the customer\'s phone',
    scanQrFetching: 'Fetching cart...',
    scanQrInvalidPayload: 'Invalid QR code.',
    scanQrExpired: 'Cart has expired.',
    scanQrAlreadyClaimed: 'Cart has already been claimed.',
    scanQrNotFound: 'Cart not found.',
    scanQrFetchFail: 'Could not fetch cart.',
    scanQrCartReady: 'Cart Ready',
    scanQrCustomer: 'Customer',
    scanQrNote: 'Customer Note',
    scanQrTotal: 'Total',
    scanQrReject: 'Cancel',
    scanQrAccept: 'Accept Order',
    scanQrSuccess: 'Order accepted!',
    scanQrOrderNo: 'Order No',
    scanQrViewOrder: 'View Order',
    scanQrScanMore: 'New Scan',
    cameraPermNeeded: 'Camera permission required',
    cameraPermDesc: 'You must grant camera access to scan QR codes.',
    grantPermission: 'Grant Permission',
    // Görsel yükleme
    menuMgmtUploadImage: 'Upload Image',
    menuMgmtChangeImage: 'Change Image',
    menuMgmtRemoveImage: 'Remove Image',
    menuSearchPh: 'Search product or description…',
    menuNoMatch: 'No matching product',
    menuMgmtImageHint: 'JPEG/PNG/WEBP/GIF, max 2MB',
    menuMgmtDropHere: 'Drop here',
    menuMgmtDragOrClick: 'Drag or click',
    uploading: 'Uploading…',
    invalidFileType: 'Only image files are accepted.',
    fileTooLarge: 'File must be under 2MB.',
    uploadFailed: 'Upload failed.',
    productImage: 'Product Image',
    pickImage: 'Pick Image',
    changeImage: 'Change Image',
    imageUploaded: 'Image uploaded',
    imageRemoved: 'Image removed',
    removeFailed: 'Removal failed',
    cameraRollPermDenied: 'Gallery permission denied',
    qrmenuOrderReceived: 'Order Received!',
    qrmenuOrderSentToKitchen: 'Your order has been sent to the kitchen. It will be prepared shortly.',
    qrmenuApproxReadyIn: 'Ready in about',
    qrmenuMinutes: 'minutes',
    qrmenuOrderNo: 'Order No',
    qrmenuBackToMenu: 'Back to Menu',
    qrmenuSecurePayment: 'Secure Payment',
    qrmenuPlaceOrder: 'Place Order',
    qrmenuYourCart: 'Your Cart',
    qrmenuYourInfo: 'Your Information',
    qrmenuFullNameLabel: 'Full Name *',
    qrmenuFullNamePlaceholder: 'Your Full Name',
    qrmenuPhoneLabel: 'Phone (optional)',
    qrmenuEmailLabel: 'Email (for receipt)',
    qrmenuNoteLabel: 'Note (optional)',
    qrmenuNotePlaceholder: 'Allergies, special requests...',
    qrmenuPaymentMethod: 'Payment Method',
    qrmenuPayCash: 'Cash (Pay at Table)',
    qrmenuPayCardTable: 'Card (Pay at Table)',
    qrmenuPayOnline: 'Online Payment (Pay Now)',
    qrmenuSelected: 'Selected',
    qrmenuSending: 'Sending...',
    qrmenuGoToPayment: 'Proceed to Payment',
    qrmenuDigitalMenu: 'Digital Menu',
    qrmenuAll: 'All',
    qrmenuAllergenFilter: 'Allergen Filter',
    qrmenuAllergenFilterHint: 'Select allergens you want to exclude:',
    // ── 14 Mandatory Allergens (label + desc) — EN ──
    allergenGlutenLabel: 'Gluten',
    allergenGlutenDesc: 'Wheat, barley, oats and derivatives',
    allergenCrustaceansLabel: 'Crustaceans',
    allergenCrustaceansDesc: 'Shrimp, crab, lobster and derivatives',
    allergenEggsLabel: 'Eggs',
    allergenEggsDesc: 'Eggs and egg products',
    allergenFishLabel: 'Fish',
    allergenFishDesc: 'Fish and fish products',
    allergenPeanutsLabel: 'Peanuts',
    allergenPeanutsDesc: 'Peanuts and derivatives',
    allergenSoyLabel: 'Soy',
    allergenSoyDesc: 'Soybeans and derivatives',
    allergenMilkLabel: 'Milk / Lactose',
    allergenMilkDesc: 'Milk and dairy products (including lactose)',
    allergenNutsLabel: 'Tree Nuts',
    allergenNutsDesc: 'Almonds, hazelnuts, walnuts, pistachios, cashews etc.',
    allergenCeleryLabel: 'Celery',
    allergenCeleryDesc: 'Celery stalk, seeds and derivatives',
    allergenMustardLabel: 'Mustard',
    allergenMustardDesc: 'Mustard seeds, leaves and derivatives',
    allergenSesameLabel: 'Sesame',
    allergenSesameDesc: 'Sesame seeds and derivatives',
    allergenSulphitesLabel: 'Sulphites',
    allergenSulphitesDesc: 'Sulphur dioxide (SO₂) and sulphites',
    allergenLupinLabel: 'Lupin',
    allergenLupinDesc: 'Lupin flour, seeds and derivatives',
    allergenMolluscsLabel: 'Molluscs',
    allergenMolluscsDesc: 'Mussels, oysters, squid, octopus etc.',
    qrmenuClearFilter: 'Clear filter',
    qrmenuItemsCount: 'items',
    qrmenuNoItemsInCategory: 'No items found in this category',
    qrmenuCheckoutBtn: 'Confirm Cart',
    qrmenuFooterHint: 'Add items to your cart to place an order',
    qrmenuCallingWaiter: 'Calling waiter...',
    qrmenuCallWaiter: 'Call Waiter',
    qrmenuAllergens: 'Allergens',
    qrmenuOption: 'Option',
    qrmenuSpecialRequestPlaceholder: 'Special request, allergy...',
    qrmenuClose: 'Close',
    qrmenuAddToCart: 'Add to Cart',
    shiftsTitle: 'Shifts & Attendance',
    shiftAutoGenerate: 'Auto-Generate',
    shiftCopyWeek: 'Copy Week',
    shiftPrintBtn: 'Print',
    shiftAddAssignment: 'Add Assignment',
    shiftStatTotal: 'Total Assignments',
    shiftStatActive: 'On Duty',
    shiftStatStaff: 'Scheduled',
    shiftStatClosed: 'Completed',
    shiftStatusScheduled: 'Scheduled',
    shiftStatusCheckedIn: 'On Duty',
    shiftStatusCheckedOut: 'Checked Out',
    shiftStatusAbsent: 'Absent',
    shiftStatusLate: 'Late',
    shiftTabWeekly: 'Weekly Plan',
    shiftTabTemplates: 'Shift Templates',
    shiftTabSummary: 'Attendance Summary',
    shiftTabBordro: 'Payroll',
    shiftTodayBtn: 'Today',
    shiftPrintTitle: 'Weekly Shift Plan',
    shiftCheckInBtn: 'Check In',
    shiftCheckOutBtn: 'Check Out',
    shiftAbsentBtn: 'Absent',
    shiftStaffHeader: 'Staff',
    shiftNoAssignmentsThisWeek: 'No assignments this week',
    shiftPrintedAt: 'Printed at',
    shiftNewTemplate: 'New Template',
    shiftNoTemplatesYet: 'No shift templates yet',
    shiftNoSummaryData: 'No attendance data for this week',
    shiftColShift: 'Shift',
    shiftColLate: 'Late',
    shiftColTotalHours: 'Total Hours',
    shiftColOvertime: 'Overtime',
    shiftHourShort: 'h',
    shiftMinShort: 'm',
    shiftEditAssignment: 'Edit Assignment',
    shiftNewAssignment: 'New Assignment',
    shiftSelectPlaceholder: 'Select...',
    shiftTemplateLabelOptional: 'Shift Template (optional)',
    shiftManualEntry: 'Enter manually',
    shiftNoteLabel: 'Note',
    shiftNotePlaceholder: 'Optional note...',
    shiftEditTemplate: 'Edit Template',
    shiftNameLabel: 'Shift Name',
    shiftNamePlaceholder: 'e.g. Morning Shift',
    shiftColorLabel: 'Color',
    shiftCopyDescription: 'all assignments from this week will be copied to the selected week.',
    shiftTargetWeek: 'Target Week (Monday)',
    shiftWeekLabel: 'Week',
    shiftCopying: 'Copying...',
    shiftCopyBtn: 'Copy',
    shiftAutoModalTitle: 'Auto-Generate Shifts',
    shiftAutoDescription: 'Weekly shift assignments are generated for selected staff based on restaurant operating hours.',
    shiftWeekMondayLabel: 'Week (Monday)',
    shiftUseRestaurantHours: 'Use restaurant hours',
    shiftIncludeWeekend: 'Include weekend (7 days)',
    shiftSelectStaff: 'Select Staff',
    shiftSelectAll: 'Select All',
    shiftClearSelection: 'Clear',
    shiftNoStaffFound: 'No staff found',
    shiftStaffSelected: 'staff selected',
    shiftAutoGenerating: 'Generating...',
    shiftAutoCreateForStaff: 'Staff - Generate',
    shiftSelectStaffError: 'Please select a staff member',
    shiftSummaryLoadFailed: 'Failed to load summary',
    shiftMarkAbsentConfirm: 'Mark as absent?',
    shiftDeleteAssignConfirm: 'Delete this assignment?',
    shiftDeleteTemplateConfirm: 'Delete this shift template?',
    shiftTemplateNameRequired: 'Shift name is required',
    shiftCopyInserted: 'assignments copied',
    shiftCopySkipped: 'conflicts skipped',
    shiftCopyFailed: 'Copy failed',
    shiftAutoSelectAtLeastOne: 'Please select at least one staff member',
    shiftAutoCreated: 'assignments created',
    shiftAutoFailed: 'Auto-generation failed',
    dayMon: 'Mon',
    dayTue: 'Tue',
    dayWed: 'Wed',
    dayThu: 'Thu',
    dayFri: 'Fri',
    daySat: 'Sat',
    daySun: 'Sun',
    menuStatTotal: 'Total Items',
    menuStatActive: 'Active',
    menuStatInactive: 'Inactive',
    menuStatCategories: 'Categories',
    menuMgmtTitle: 'Menu Management',
    menuMgmtProductSuffix: 'products',
    menuMgmtCategorySuffix: 'categories',
    menuMgmtAiScan: 'AI Scan',
    menuMgmtExcelDownload: 'Download Excel',
    menuMgmtExcelUpload: 'Upload Excel',
    menuMgmtBulkPrice: 'Bulk Price',
    menuMgmtQrCode: 'QR Code',
    menuMgmtProductsTab: 'Products',
    menuMgmtCategoriesTab: 'Categories',
    menuMgmtAddProduct: 'Add Product',
    menuMgmtAddCategory: 'Add Category',
    menuMgmtNoCategoriesYet: 'No categories yet',
    menuMgmtNoMenuItems: 'No menu items found',
    menuMgmtProduct: 'Product',
    menuMgmtCategoryDeleteConfirm: 'Are you sure you want to delete this category?',
    menuMgmtItemDeleteConfirm: 'Are you sure you want to delete this menu item?',
    menuMgmtImageGallery: 'Image Gallery',
    menuMgmtItemsWithoutImage: 'Items Without Image',
    menuMgmtPrinter: 'Printer',
    menuMgmtDefaultKitchenPrinter: 'Default kitchen printer',
    menuMgmtPrinterRouteHint: 'Orders for this category will be routed to the selected printer.',
    menuMgmtDetailsTab: 'Details',
    menuMgmtVariantsTab: 'Variants',
    menuMgmtPriceTry: 'Price (TRY)',
    menuMgmtSelectCategory: 'Select Category',
    menuMgmtImageUrl: 'Product Image',
    menuMgmtTaxGroup: 'VAT Group',
    menuMgmtTaxGroupNone: '— None / Manual VAT —',
    menuMgmtTaxGroupHint: 'If a group is selected, the VAT rate is taken automatically from the group.',
    menuMgmtAllergens: 'Allergens',
    menuMgmtSelectedSuffix: 'selected',
    menuMgmtVisibleOnMenu: 'Active (visible on menu)',
    menuMgmtVariantsHint: 'E.g.: Small (-5₺), Medium (0₺), Large (+5₺). Base price:',
    menuMgmtNoVariantsYet: 'No variants yet',
    menuMgmtAddNewVariant: 'Add New Variant',
    menuMgmtVariantPriceDiffHint: 'Price difference: enter a positive (+) or negative (-) value; zero is also allowed.',
    menuMgmtBulkWarning: '⚠️ This action permanently updates all product prices in the selected category.',
    menuMgmtAllCategories: 'All Categories',
    menuMgmtUpdateType: 'Update Type',
    menuMgmtIncreasePercent: 'Increase by Percent (%)',
    menuMgmtDecreasePercent: 'Decrease by Percent (%)',
    menuMgmtIncreaseFixed: 'Increase by Fixed Amount (₺)',
    menuMgmtDecreaseFixed: 'Decrease by Fixed Amount (₺)',
    menuMgmtSetFixed: 'Set Fixed Price (₺)',
    menuMgmtValueLabel: 'Value',
    menuMgmtPreview: 'Preview:',
    menuMgmtItemsAffected: 'products will be affected',
    menuMgmtAiScanTitle: 'Scan Menu Photo with AI',
    menuMgmtAiScanDesc: 'Upload a menu photo. Gemini AI automatically reads food/beverage names and prices.',
    menuMgmtClickToChoosePhoto: 'Click to select a photo',
    menuMgmtPhotoFormats: 'JPG, PNG, WEBP supported',
    menuMgmtAiAnalyzing: 'Gemini AI is analyzing...',
    menuMgmtItemsFound: 'products found',
    menuMgmtSelectAll: 'Select All',
    menuMgmtImportTitle: 'Import Menu via Excel',
    menuMgmtImportFormatLabel: 'Template format:',
    menuMgmtImportFormatDesc: 'The columns Name, Category, Price, VAT Rate, Description and Active are required. Use the Download Excel button to get the template (an Import Template sheet is included).',
    menuMgmtFileProcessing: 'Processing file...',
    menuMgmtClickToChooseExcel: 'Click to select an Excel file',
    menuMgmtXlsxSupported: '.xlsx format supported',
    menuMgmtImportComplete: 'Import Complete',
    menuMgmtInserted: 'Inserted',
    menuMgmtSkipped: 'Skipped',
    menuMgmtQrDesc: 'Customers can scan this code to view the digital menu',
    menuMgmtPreviewMenu: 'Preview menu',
    menuMgmtQrPastingHint: 'You can paste this QR code on tables or menu cards',
    posSessionOpenTitle: 'Open Register',
    posSessionOpenSub: 'Enter the opening cash amount',
    posOpeningCashLabel: 'Opening Cash (₺)',
    posOpening: 'Opening...',
    posOpenSession: 'Open Register',
    posPayment: 'Payment',
    posTotalAmount: 'Total Amount',
    posSplitPayment: 'Split',
    posAmountReceived: 'Amount received',
    posChange: 'Change',
    posCardChargePrefix: 'Charging',
    posCardChargeSuffix: 'to card',
    posAmountsMatch: 'Amounts match',
    posRemaining: 'Remaining',
    posProcessing: 'Processing...',
    posCompleteSale: 'Complete Sale',
    posZReport: 'Z Report',
    posNewProductBtn: '+ New product',
    posNewProductTitle: 'Add new product',
    posImportFromMenuBtn: '📋 Import from menu',
    posImportFromMenuTitle: 'Import to POS from menu',
    posImportSelectAll: 'Select all',
    posImportAlreadyAdded: 'Added',
    posImportConfirmBtn: 'Import',
    posImportNoSelection: 'Select products first',
    posImportResult: '{n} products imported',
    posImportSkipped: '{n} skipped',
    posPrintBtn: '🖨️ Print',
    posPrintingBtn: 'Printing...',
    posReportPrintQueued: 'Report queued for printing',
    posReportPrintFailed: 'Print failed',
    posSaleCount: 'Sale Count',
    posGrossTotal: 'Gross Total',
    posOpeningCash: 'Opening Cash',
    posClosingCash: 'Closing Cash',
    posCashDifference: 'Cash Difference',
    posTopSellers: 'Top Sellers',
    posUnits: 'units',
    posOk: 'OK',
    posXReport: 'X Report',
    posStock: 'Stock',
    posAddedSuffix: 'added',
    posBarcodeNotFound: 'Barcode not found',
    posKeyboardToggle: 'On-screen keyboard',
    posKeyboardEnabled: 'Keyboard on',
    posKeyboardDisabled: 'Keyboard off',
    posKeyboardClose: 'Close keyboard',
    posKeyboardModeNumeric: 'Numeric',
    posKeyboardModeFull: 'Letters',
    posKeyboardEnter: 'Enter',
    posKeyboardSpace: 'Space',
    posKeyboardBackspace: 'Backspace',
    posProductsLoadFailed: 'Could not load products',
    posSessionOpened: 'Register opened',
    posSessionOpenFailed: 'Could not open register',
    posReceiptNotFound: 'Receipt not found',
    posRefundedSuffix: 'refunded',
    posRefundFailed: 'Refund failed',
    posSaleCompleted: 'Sale completed',
    posSaleFailed: 'Sale could not be completed',
    posSessionClosed: 'Register closed',
    posSessionCloseFailed: 'Could not close register',
    posXReportFailed: 'Could not get X report',
    posExcelDownloadFailed: 'Could not download Excel',
    posImportedSuffix: 'added',
    posUpdatedSuffix: 'updated',
    posImportFailed: 'Import failed',
    posRefundProcess: 'Refund Process',
    posRefundSearchHint: 'Find sale by receipt number',
    posReceiptNo: 'Receipt No',
    posCashier: 'Cashier',
    posStatusCompleted: 'Completed',
    posStatusRefunded: 'Refunded',
    posStatusCancelled: 'Cancelled',
    posNoteLabel: 'Note',
    posAlreadyRefunded: 'This sale has already been refunded/cancelled — cannot refund again.',
    posRefunding: 'Refunding...',
    posRefundAction: 'Refund',
    posCustomerSearch: 'Search customer... (optional)',
    posUseLoyaltyPoints: 'points redeem',
    posPromoPlaceholder: 'Promo / Voucher code',
    posPromoApply: 'Apply',
    posPromoApplied: 'applied',
    posPromoInvalid: 'Invalid code',
    posPromoDiscount: 'Promo discount',
    posHoldOrder: 'Hold Order',
    posHeldOrders: 'Held Orders',
    posHeldOrdersHint: 'Select an order to recall',
    posNoHeldOrders: 'No held orders',
    posRecallOrder: 'Recall',
    posOrderHeld: 'Order held',
    posOrderRecalled: 'Order recalled',
    posTip: 'Tip',
    posTipNone: 'None',
    posBeforeTip: 'Before tip',
    posTitle: 'POS',
    posOpen: 'Open',
    posRevenue: 'revenue',
    posSales: 'sales',
    posSalesHistory: 'Sales History',
    posSalesHistoryEmpty: 'No sales found for this date',
    posReprintReceipt: 'Reprint',
    posPrintReceiptBtn: 'Print Receipt',
    posHistoryTitle: 'Sales History',
    posHistoryCashier: 'Cashier',
    posHistoryPayment: 'Payment',
    posHistoryRefundBtn: 'Refund',
    posTerminalSend: 'Send to Terminal',
    posTerminalSent: 'Sent to terminal',
    posTerminalNoConfig: 'Terminal IP not configured',
    posEInvoiceBtn: 'E-Invoice',
    posEInvoiceTitle: 'E-Invoice / E-Archive Invoice',
    posEInvoiceVkn: 'Tax ID / National ID',
    posEInvoiceCreate: 'Create Invoice',
    posEInvoiceNote: 'GIB integration not active. Enable from accounting integration settings.',
    posHistoryToday: 'Today',
    posHistoryYesterday: 'Yesterday',
    posHistorySaleCount: 'sales',
    posHistoryTip: 'Tip',
    posCustomerScreenTitle: 'Open customer display',
    posXReportBtn: 'X Report',
    posCloseSession: 'Close Register',
    posSearchPlaceholder: 'Search product or barcode...',
    posExportTitle: 'Export products to Excel',
    posImportTitle: 'Import products from Excel',
    posOpenSessionFirst: 'Open the register first',
    posProductsLoading: 'Loading products...',
    posProductNotFound: 'Product not found',
    posCart: 'Cart',
    posRefund: 'Refund',
    posNoTableTakeaway: 'No table / Takeaway',
    posPricesVatInclusive: 'Prices VAT Inclusive',
    posPricesVatExclusive: 'Prices VAT Exclusive',
    posCartEmpty: 'Cart is empty',
    posDecreaseQty: 'Decrease quantity',
    posIncreaseQty: 'Increase quantity',
    posRemove: 'Remove',
    posAddNote: 'Add note...',
    posTakePayment: 'Take Payment',
    posSessionCloseTitle: 'Close Register',
    posSessionCloseSub: 'Enter the current cash amount',
    posClosingCashLabel: 'Closing Cash (₺)',
    posClosing: 'Closing...',

    // === Tur 39 batch ===
    resetPwdInvalidLinkTitle: 'Invalid Link',
    resetPwdInvalidLinkDesc: 'The password reset link is invalid or missing.',
    resetPwdRequestNewLink: 'Request New Link',
    resetPwdMinLength: 'Password must be at least 6 characters.',
    resetPwdMismatch: 'Passwords do not match.',
    resetPwdGenericError: 'An error occurred. The link may have expired.',
    resetPwdTitle: 'Set New Password',
    resetPwdSubtitle: 'Enter a new password for your account.',
    resetPwdSuccess: 'Your password has been updated successfully!',
    resetPwdRedirecting: 'You will be redirected to the login page shortly...',
    resetPwdSignIn: 'Sign In',
    resetPwdMinLengthPlaceholder: 'At least 6 characters',
    resetPwdConfirm: 'Confirm Password',
    resetPwdSaving: 'Saving...',
    resetPwdUpdateBtn: 'Update Password',
    resetPwdBackToLogin: 'Back to login',
    forgotPwdEmailRequired: 'Email address is required.',
    forgotPwdGenericError: 'An error occurred. Please try again.',
    forgotPwdTitle: 'Forgot Password',
    forgotPwdSubtitle: 'Enter your email address and we\'ll send you a password reset link.',
    forgotPwdSentTitle: 'Password reset link sent!',
    forgotPwdSentDesc: 'Click the link sent to this address to reset your password.',
    forgotPwdBackToLogin: 'Back to login',
    forgotPwdSending: 'Sending...',
    forgotPwdSendLink: 'Send Reset Link',
    auditLoadFailed: 'Could not load audit logs.',
    auditStatTotal: 'Total Logs',
    auditStatToday: 'Today',
    auditStatPerUser: 'Per User',
    auditStatTopAction: 'Top Action',
    auditTitle: 'Audit Logs',
    auditSubtitle: 'Who did what to which record and when? Critical operations are recorded here.',
    auditActionLabel: 'Action',
    auditEntityLabel: 'Entity',
    auditApply: 'Apply',
    auditClear: 'Clear',
    auditNoRecords: 'No records found.',
    auditDate: 'Date',
    auditUser: 'User',
    auditIp: 'IP',
    auditBefore: 'Before',
    auditAfter: 'After',
    auditTotal: 'Total',
    auditRecords: 'records',
    flagKeyFormatError: 'flag_key must contain lowercase letters, digits and underscore only (e.g. new_dashboard).',
    flagRolloutRangeError: 'Rollout must be between 0 and 100.',
    flagDeleteConfirm: 'Are you sure you want to delete this feature flag?',
    flagGlobal: 'GLOBAL',
    flagTitle: 'Feature Flags',
    flagSubtitle: 'Toggle features with gradual rollout. Restaurant-specific records override global. Rollout % selects stably based on restaurant ID hash.',
    flagNewBtn: 'New Flag',
    flagKey: 'Key',
    flagScope: 'Scope',
    flagRollout: 'Rollout %',
    flagThisRestaurant: 'This Restaurant',
    flagOptional: 'Optional',
    flagEmpty: 'No feature flags yet.',
    taxGroupNameRequired: 'Name is required.',
    taxGroupRateRangeError: 'Rate must be between 0 and 100.',
    taxGroupDeleteConfirm: 'Are you sure you want to delete this tax group?',
    taxGroupTitle: 'Tax Groups',
    taxGroupSubtitle: 'Define your VAT rates and assign them to menu items. The default group is used for new products without a specified rate.',
    taxGroupNewBtn: 'New Group',
    taxGroupName: 'Name',
    taxGroupRate: 'Rate',
    taxGroupDefault: 'Default',
    taxGroupEmpty: 'No tax groups.',
    taxGroupNamePlaceholder: 'VAT 10%',

    // === Tur 40 batch ===
    settingsHeaderDesc: 'Manage your restaurant and application preferences',
    restaurantInfoTitle: 'Restaurant Information',
    restaurantNamePh: 'Your restaurant name',
    restaurantAddressPh: 'Restaurant address',
    workingHoursLabel: 'Working Hours',
    workingHoursDesc: 'Automatic shift creation and other features use these hours.',
    openingHourLabel: 'Opening Hour',
    closingHourLabel: 'Closing Hour',
    loginAfterPageTitle: 'Page After Login',
    loginAfterPageDesc: 'Which page would you like to be redirected to after logging in?',
    adisyonBadge: 'Check',
    coverImageTitle: 'Cover Image',
    coverImageDesc: 'URL of the cover photo shown at the top of the menu',
    coverImagePreviewAlt: 'Cover preview',
    restaurantMenuFallback: 'Restaurant Menu',
    imageUrlLabel: 'Image URL',
    menuTitleDesc: 'If left empty, the restaurant name is used',
    accentColorTitle: 'Accent Color',
    accentColorDesc: 'Used for prices, category selection and buttons',
    customColorLabel: 'Custom color:',
    footerTextTitle: 'Footer Text',
    footerTextDesc: 'Text shown at the bottom of the menu',
    footerTextPh: 'Please call our waiter to place an order',
    previewMenuBtn: 'Preview Menu',
    defaultCurrencyTitle: 'Default Currency',
    defaultCurrencyDesc: 'Currency for your restaurant\'s menu and invoices. Multi-currency is supported (EUR/USD etc. for tourist areas).',
    currencyChangeWarning: 'This change does not convert existing menu prices. Only the display and labels of new orders are affected. A separate management screen is planned for exchange rates.',
    currencyTRYName: 'Turkish Lira',
    currencyUSDName: 'US Dollar',
    currencyEURName: 'Euro',
    currencyGBPName: 'British Pound',
    currencyCHFName: 'Swiss Franc',
    currencyJPYName: 'Japanese Yen',
    currencyAEDName: 'UAE Dirham',
    currencySARName: 'Saudi Riyal',
    pageOptDashboardLabel: 'Dashboard',
    pageOptDashboardDesc: 'Main statistics screen',
    pageOptTablesLabel: 'Tables',
    pageOptTablesDesc: 'Go directly to the check screen',
    pageOptOrdersLabel: 'Orders',
    pageOptOrdersDesc: 'Order list screen',
    pageOptKitchenLabel: 'Kitchen Screen',
    pageOptKitchenDesc: 'Kitchen tracking screen',
    colorOrange: 'Orange',
    colorRed: 'Red',
    colorPurple: 'Purple',
    colorBlue: 'Blue',
    colorGreen: 'Green',
    colorYellow: 'Yellow',
    colorPink: 'Pink',
    colorDark: 'Dark',
    platformMgmtTitle: 'Platform Management',
    platformStatTotal: 'Total Platforms',
    platformStatConfigured: 'Configured',
    platformStatActive: 'Active',
    platformStatTested: 'Tests Passed',
    platformMgmtSubtitle: 'Manage delivery platform integrations.',
    platformMgmtLoadFailed: 'Could not load platforms.',
    platformMgmtToggleFailed: 'Toggle failed.',
    platformMgmtConnectionOk: 'Connection successful.',
    platformMgmtConnectionError: 'Connection error.',
    platformMgmtNotConfigured: 'Not configured',
    platformMgmtTesting: 'Testing...',
    platformMgmtTestBtn: '🔌 Test',
    platformMgmtConfigure: 'Configure',
    platformMgmtDeactivate: '⏸ Deactivate',
    platformMgmtActivate: '▶ Activate',
    platformMgmtSettingsSuffix: 'Settings',
    platformMgmtChangePlaceholder: '(enter to change)',
    platformMgmtSaving: 'Saving...',
    trashStatTotal: 'Total Deleted',
    trashStatOrders: 'Orders',
    trashStatCustomers: 'Customers',
    trashStatMenuItems: 'Menu Items',
    trashTitle: 'Trash',
    trashSubtitle: 'Deleted records are archived here. Use the button on the right to restore.',
    trashOrdersTab: 'Orders',
    trashMenuItemsTab: 'Menu Items',
    trashCustomersTab: 'Customers',
    trashRestaurantsTab: 'Restaurants',
    trashLoadFailed: 'Could not load.',
    trashRestoreConfirm: 'Are you sure you want to restore this record?',
    trashRestoreFailed: 'Could not restore.',
    trashEmpty: 'No deleted records in this category. 🎉',
    trashActionCol: 'Action',
    trashRestoreBtn: '↩️ Restore',
    tablesDeleteConfirmSuffix: 'Are you sure you want to delete this table?',
    tablesCloseConfirmSuffix: 'Are you sure you want to close this table?',
    tablesCategoryDeleteConfirmSuffix: 'Are you sure you want to delete this category? Tables will become uncategorized.',
    tablesTablePrefix: 'Table',
    tablesWaiterCallTitle: 'Waiter Call',
    tablesWaitingSuffix: 'waiting',
    tablesManageAriaSuffix: 'manage this table',
    tablesManageCategoriesTitle: 'Floor & Zone Categories',
    tablesTableLower: 'tables',
    tablesAddNewCategory: 'Add New Category',
    tablesCategoryPlaceholder: 'e.g. 1st Floor, Terrace, Garden...',
    tablesChooseColor: 'Choose color',
    tablesPreviewLabel: 'Preview',
    tablesAddCategoryBtn: 'Add Category',
    tablesTableNamePlaceholder: 'Table 11',
    tableSeatingDuration: 'Seated for',
    kitchenMinShort: 'min',
    kitchenHourShort: 'h',
    kitchenLate: 'late',
    kitchenRemaining: 'remaining',
    kitchenConnectionError: 'Connection error — try refreshing.',
    kitchenScreenTitle: 'Kitchen Display',
    kitchenWaitingLabel: 'Waiting',
    kitchenServedLabel: 'Served',
    kitchenStatServed: 'Served Today',
    kitchenStatPrepTime: 'Est. Time (min)',
    kitchenPanelBtn: 'Panel',
    kitchenWaitingOrders: 'Waiting Orders',
    kitchenEmptyQueue: 'No waiting orders',
    kitchenServeBtn: 'Serve',
    loginTotpRequired: 'TOTP code is required.',
    loginCodeVerifyFailed: 'Code could not be verified.',
    loginTwoFactorTitle: 'Two-Factor Authentication',
    loginTwoFactorHint: 'Enter the 6-digit code from your authenticator app (or an 8-digit backup code).',
    loginVerifying: 'Verifying...',
    loginVerifyAndEnter: 'Verify and Sign In',
    loginDifferentAccount: 'Sign in with a different account',
    loginTestAccounts: 'Test Accounts:',
    loginTestSuperAdmin: 'SuperAdmin',
    loginTestAdmin: 'Admin',
    loginTestWaiter: 'Waiter',
    loginTestKitchen: 'Kitchen',
    loginTestChainAdmin: 'Chain Admin',
    loginTestDemoChain: 'Demo Chain',
    reportsChartSR: 'Chart',

    // === Tur 44 Quick Start ===
    quickStartTitle: 'Quick Start',
    quickStartSubtitle: 'Just a few steps to get your restaurant up and running.',
    qsRestaurantInfo: 'Enter restaurant details',
    qsAddFirstTable: 'Add your first table',
    qsAddMenuItem: 'Add a menu item',
    qsAddStaff: 'Add staff',
    quickStartOrWizard: 'Or walk through with the wizard:',

    // === Tur 50 shortcuts ===
    shortcutsTitle: 'Keyboard Shortcuts',
    shortcutHelp: 'Toggle shortcut help',
    shortcutHome: 'Go home',
    shortcutTables: 'Tables',
    shortcutOrders: 'Orders',
    shortcutKitchen: 'Kitchen display',
    shortcutReports: 'Reports',
    shortcutSettings: 'Settings',
    shortcutMenu: 'Menu management',
    shortcutCustomers: 'Customers',
    shortcutPOS: 'POS terminal',
    shortcutClose: 'Close modal',
    shortcutHint: 'Tip: press keys in quick succession, not held down.',

    // === FAZ K3.1 Customer order tracking ===
    orderTrackTitle: 'Order Tracking',
    orderTrackStatusTitle: 'Order Status',
    orderTrackAccepted: 'Your order is received',
    orderTrackPreparing: 'Restaurant is preparing',
    orderTrackOnTheWay: 'Courier is on the way',
    orderTrackDelivered: 'Delivered',
    orderTrackInProgress: 'In progress...',
    orderTrackEta: 'Estimated arrival',
    orderTrackEtaPrefix: 'About',
    orderTrackEtaMinutes: 'minutes',
    orderTrackCourier: 'Your courier',
    orderTrackRestaurant: 'Restaurant',
    orderTrackYou: 'Your address',
    orderTrackMap: 'Map',
    orderTrackLocationUpdating: 'Location updating...',
    orderTrackLocationWaiting: 'Waiting for courier location...',
    orderTrackInvalidToken: 'Invalid tracking link',
    orderTrackInvalidTokenDesc: 'This order tracking link is invalid or has expired.',
    orderTrackNetworkError: 'Connection error',
    orderTrackAutoRefresh: 'Page auto-refreshes every 30 seconds',
    orderTrackEtaWaiting: 'ETA calculating — updates once courier sends location',
    orderTrackCancelled: 'Order has been cancelled',

    // === Tur 51 a11y ===
    skipToMain: 'Skip to main content',

    // === Tur 55 confirm ===
    confirmBtn: 'Confirm',
    confirmDefaultTitle: 'Confirmation',

    // === Onboarding Tour ===
    tourSkip: 'Skip',
    tourNext: 'Next',
    tourPrev: 'Back',
    tourFinish: 'Finish',
    tourGetStarted: 'Let\'s Get Started',
    tourGoTo: 'Go to page',
    tourStep1Title: 'Welcome to RestaFlex!',
    tourStep1Body: 'A quick 2-minute tour to show you where the main features live. You can skip at any time.',
    tourStep2Title: 'Dashboard & KPIs',
    tourStep2Body: 'See your daily revenue, order count and top-selling items at a glance. Track your performance in real time.',
    tourStep3Title: 'Menu Management',
    tourStep3Body: 'Manage categories, products, variants and prices here. Changes automatically reflect on your QR menu.',
    tourStep4Title: 'Tables & Orders',
    tourStep4Body: 'Table layout, order flow, kitchen routing and payment — all in one screen. Run the whole operation from here.',
    tourStep5Title: 'Settings',
    tourStep5Body: 'Restaurant info, printers, webhooks, users and all other configuration options live in Settings.',
    // UI-01: "Management & Integrations" section inside Settings
    settingsIntegrationsTitle: 'Management & Integrations',
    settingsIntegrationsSub: 'Quick access to printers, webhook integrations, GDPR and white-label settings.',
    tabAdmin: 'Admin',
    settingsAdminSub: 'Tax groups, audit logs, security and all system administration pages.',
    settingsSectionDataSafety: 'Data & Security',
    settingsSectionIntegrations: 'Integrations',
    settingsSectionConfig: 'Configuration',
    customerTagFilterLabel: 'Tag filter',
    customerTagToggleHint: 'Filter by this tag',
    whatsappBtnTitle: 'WhatsApp',
    whatsappOrderRef: 'Re: order',
    payrollDescPrefix: 'Payroll payment',
    payrollHoursHeader: 'Worked',
    payrollRateHeader: 'Rate',
    payrollScheduledHeader: 'Scheduled',
    payrollOvertimeHeader: 'Overtime min',
    csvAvgOrder: 'Avg Order',
    csvRevenuePerCustomer: 'Per Customer',
    recentAuditTitle: 'Recent Admin Actions',
    statusPreparing: 'Preparing',
    statusReady: 'Ready',
    kitchenReadyBtn: 'Ready',
    datePresetLast7: 'Last 7 days',
    datePresetLast30: 'Last 30 days',
    datePresetLast90: 'Last 90 days',
    datePresetThisMonth: 'This Month',
    datePresetLastMonth: 'Last Month',
    segmentQuickLabel: 'Quick',
    segmentBirthday: 'Birthday soon',
    segmentNewCustomer: 'New customer',
    segmentVIP: 'VIP',
    dateChipToday: '📅 Today',
    dateChipTomorrow: '➡️ Tomorrow',
    dateChipAll: '🗓️ All',
    dateChipYesterday: '⬅️ Yesterday',
    promoStatusActive: 'Active',
    promoStatusExpired: 'Expired',
    voucherStatusUsed: 'Used up',
    printerSearchPlaceholder: 'Search printer name / IP...',
    webhookSearchPlaceholder: 'Search webhook (URL/label)...',
    taxGroupSearchPlaceholder: 'Search tax group (name/rate)...',
    flagSearchPlaceholder: 'Search flag (key/description)...',
    plnProfitLoss: 'Profit & Loss Report',
    nav_chain: 'Chain Management',
    stockSearchPlaceholder: 'Search ingredient...',
    promoSearchPlaceholder: 'Search code or description...',
    voucherSearchPlaceholder: 'Search code...',
    refundSearchPlaceholder: 'Search table, reason, order #...',
    notifDismissRead: 'Clear read',
    notifDismissReadHint: 'Hide read notifications',
    notifDismissVisible: 'Hide visible',
    notifDismissVisibleHint: 'Hide filtered notifications',
    peakHourTitle: 'Peak Hour',
    recipeItemSearchPlaceholder: 'Type or pick a menu item...',
    recipeItemSearchHint: 'Search across {N} items',
    items: 'items',
    foodCostPctLabel: 'Food Cost',
    foodCostPctTooltip: 'Recipe cost / Sell price',
    bulkTagBtn: '🏷️➕ Bulk Add Tags',
    bulkTagModalTitle: 'Bulk Tag Addition',
    bulkTagModalDesc: 'The following tags will be added to {count} customers',
    bulkTagApplyBtn: 'Apply',
    bulkTagSuccess: 'Tags added',
    bulkTagFailed: 'Some customers could not be updated',
    avgOrderValue: 'Avg Order',
    copyAllBtn: 'Copy All',
    downloadTxtBtn: 'Download TXT',
    customersStatTotal: 'Total',
    stockTotalValue: 'Stock Value',
    deliveryStatPending: 'Pending',
    deliveryStatDelivered: 'Delivered',
    deliveryStatCancelled: 'Cancelled',
    deliveryStatRevenue: 'Total Revenue',
    supplierStatTotal: 'Total Suppliers',
    supplierStatActive: 'Active',
    supplierStatInactive: 'Inactive',
    supplierStatProducts: 'Total Products',
    cashStatIncome: 'Income',
    cashStatExpense: 'Expense',
    cashStatNet: 'Net Balance',
    cashStatCount: 'Transactions',
    paymentStatTotal: 'Total Revenue',
    paymentStatCompleted: 'Completed',
    paymentStatPending: 'Pending',
    paymentStatAvg: 'Average Payment',
    tableStatTotal: 'Total Tables',
    tableStatOccupied: 'Occupied',
    tableStatReserved: 'Reserved',
    tableStatFree: 'Free',
    promoStatActive: 'Active',
    promoStatExpired: 'Expired',
    promoStatUsage: 'Total Usage',
    promoStatTotal: 'Total Discount',
    voucherStatActive: 'Active',
    voucherStatTotalValue: 'Total Value',
    voucherStatUsed: 'Used',
    voucherStatCount: 'Total Vouchers',
    userSearchPlaceholder: 'Search name or email...',
    menuItemSearchPlaceholder: 'Search item...',
    // Empty-state copy for list pages
    emptyUsersTitle: 'No users yet',
    emptyUsersHint: 'Get started by adding your first team member.',
    emptyRecipeTitle: 'No recipe defined',
    emptyRecipeHint: 'Add the first ingredient to build this item\'s recipe.',
    // Suppliers
    supplierTitle: 'Suppliers',
    supplierSubtitle: 'Manage your stock and raw material suppliers.',
    supplierAdd: 'Add Supplier',
    supplierEditTitle: 'Edit Supplier',
    supplierNewTitle: 'New Supplier',
    supplierContactPerson: 'Contact Person',
    supplierTaxNumber: 'Tax Number',
    supplierNotes: 'Notes',
    supplierTotal: 'Total',
    supplierActive: 'Active',
    supplierInactive: 'Inactive',
    supplierLedger: 'Ledger',
    supplierLedgerTitle: 'Account Ledger',
    supplierLedgerDebit: 'Debit',
    supplierLedgerCredit: 'Credit',
    supplierLedgerBalance: 'Balance',
    supplierLedgerEmpty: 'No activity',
    supplierLedgerEmptyHint: 'No received orders or payments yet for this supplier.',
    supplierShowInactive: 'Show inactive',
    supplierEmptyTitle: 'No suppliers yet',
    supplierEmptyHint: 'Get started by adding your first supplier.',
    supplierNameRequired: 'Company name is required.',
    supplierLoadError: 'Could not load suppliers.',
    supplierSearchPlaceholder: 'Search supplier...',
    supplierSelect: 'Select supplier',
    // Purchase Orders (ERP-02 Part 4)
    poTitle: 'Purchase Orders',
    poSubtitle: 'Purchase orders for ingredients from suppliers.',
    poNew: 'New Order',
    poEdit: 'Edit Order',
    poNumber: 'Order #',
    poSupplier: 'Supplier',
    poDate: 'Date',
    poExpectedDate: 'Expected Date',
    poReceivedDate: 'Received Date',
    poStatus_draft: 'Draft',
    poStatus_sent: 'Sent',
    poStatus_received: 'Received',
    poStatus_cancelled: 'Cancelled',
    poItems: 'Items',
    poAddRow: '+ Add Row',
    poIngredient: 'Ingredient',
    poQuantity: 'Quantity',
    poUnitPrice: 'Unit ₺',
    poLineTotal: 'Total',
    poGrandTotal: 'GRAND TOTAL',
    poNotes: 'Notes',
    poMarkReceived: 'Mark Received',
    poReceiveConfirm: 'Mark this order as received? Stock will auto-update.',
    poStatTotal: 'Total Orders',
    poStatPending: 'Pending',
    poStatCompleted: 'Completed',
    poStatTotalAmount: 'Total Amount',
    poStatThisMonth: 'This Month',
    paymentStatCount: 'Payment Count',
    paymentStatFailed: 'Failed',
    datePresetGroupLabel: 'Date presets',
    datePresetLast7Days: 'Last 7 Days',
    datePresetLast30Days: 'Last 30 Days',
    tableStatCapacity: 'Total Capacity',
    promoStatDiscount: 'Total Discount',
    voucherStatRedeemed: 'Redeemed',
    voucherStatRedeemedValue: 'Redeemed Value',
    notifReadFilterLabel: 'Read status filter',
    loginDemoGroupAria: 'Demo account shortcuts',
    loginDemoTitle: 'Demo Accounts',
    loginDemoDevOnly: 'Visible only in development',
    loginDemoSuperadmin: 'Super Admin',
    loginDemoAdmin: 'Admin (demo restaurant)',
    loginDemoWaiter: 'Waiter',
    loginDemoKitchen: 'Kitchen',
    onbStepperAriaLabel: 'Onboarding steps',
    onbProgressBarLabel: 'Onboarding progress',
    onbCompletedSuffix: 'completed',
    peakHourChartAria: 'Hourly order intensity',
    peakHourSourceLive: 'Live data',
    peakHourSourceOrders: 'From order history',
    peakHourSourceDemo: 'Demo data',
    peakHourLegendHigh: 'Peak (>75%)',
    peakHourLegendMid: 'Medium (40–75%)',
    peakHourLegendLow: 'Low (<40%)',
    reportsDownloadCSV: 'Download CSV',
    a11yDownloadCsvLabel: 'Download CSV',
    metricCol: 'Metric',
    valueCol: 'Value',
    amountCol: 'Amount (₺)',
    amountExtraCol: 'Extra (₺)',
    settingsDirtyBadge: 'Unsaved changes',
    hrTotalPayrolls: 'Total Payrolls',
    hrTotalNetSalary: 'Total Net Salary',
    hrRemainingLeave: 'Remaining Leave',
    hrDocumentCount: 'Document Count',
    hrYears: 'yr',
    hrWeeks: 'wk',
    hrLast6Payrolls: 'Last 6 Payrolls',
    hrPeriod: 'Period',
    hrNetShort: 'Net',
    hrSGKShort: 'SSI',
    hrNoPayrollRecord: 'No payroll records.',
    hrLast30DaysShifts: 'Last 30 Days Shifts',
    hrShowAllShifts: 'show all shifts →',
    hrNoLinkedAccountShifts: 'No login account linked to this employee — shifts cannot be displayed.',
    hrNoShiftsLast30Days: 'No shift records in the last 30 days.',
    hrMoreShifts: 'more shifts…',
    hrSeveranceNoticeTitle: 'Severance & Notice',
    hrSeveranceNoticeDesc: 'Estimated calculation based on tenure.',
    hrCalculateSeveranceNotice: 'Calculate Severance & Notice',
    hrCSVImportEmployeesTitle: 'Bulk add employees via CSV',
    hrImport: 'Import',
    hrImporting: 'Importing…',
    hrRowsImport: 'rows import',
    hrColAccount: 'Account',
    hrAccountLinked: 'Linked',
    hrNoAccount: 'No Account',
    hrDetail: 'Details',
    hrAnnualPayrollSummary: 'Annual Payroll Summary',
    hrColEmployerCostShort: 'Emp. Cost',
    hrPeople: 'people',
    hrNoDataFound: 'No data found.',
    hrPreviousMonth: 'Previous month',
    hrMuhtasarSummaryTitle: 'Withholding Tax Summary',
    hrMuhtasarSummaryAria: 'Download withholding tax summary PDF',
    hrMuhtasarPDFBtn: 'Withholding PDF',
    hrBankTransferCSVTitle: 'Download bank transfer CSV',
    hrBankFileBtn: 'Bank File',
    hrCSVExport: 'CSV Export',
    hrCustomDeduction: 'Custom Deduction',
    hrDownloadPDF: 'Download PDF',
    hrToday: 'Today',
    hrDayMon: 'Mon',
    hrDayTue: 'Tue',
    hrDayWed: 'Wed',
    hrDayThu: 'Thu',
    hrDayFri: 'Fri',
    hrDaySat: 'Sat',
    hrDaySun: 'Sun',
    hrMore: 'more',
    hrViewList: 'List',
    hrViewCalendar: 'Calendar',
    hrClearDate: 'Clear Date',
    hrLast30Days: 'Last 30 Days',
    hrExpiringDocuments: 'Expiring/Expired',
    channel: 'Channel',
    customersMessageBodyPlaceholder: 'Hello {name}, we are happy to see you again. Special 20% discount this month...',
    settingsPushTestBtn: 'Test',
    tablesCustomerOptionalLabel: 'Customer (optional — for loyalty)',
    orderStatTodayRevenue: 'Today Revenue',
    reservationStatWeekTotal: 'This Week Total',
    refundStatCount: 'Total Refunds',
    refundStatAmount: 'Total Refund Amount',
    refundStatPending: 'Pending',
    refundStatCompleted: 'Completed',
    auditStatTotalFiltered: 'Total Records',
    auditStatLast24h: 'Last 24 Hours',
    auditStatCritical: 'Critical Action',
    auditStatUniqueUsers: 'Unique Users',
    stockStatTotalItems: 'Total Items',
    stockStatLowStock: 'Low Stock',
    stockStatValue: 'Stock Value',
    stockStatCategoryCount: 'Category Count',
    courierStatActiveCouriers: 'Active Couriers',
    courierStatAssignedDeliveries: 'Assigned Deliveries',
    courierStatDeliveredToday: 'Delivered Today',
    shiftStatTodayActive: 'Active Today',
    shiftStatOpenShifts: 'Open Shifts',
    shiftStatWeekHours: 'Week Total Hours',
    shiftStatTotalStaff: 'Total Staff',
    wsPodiumLabel: 'Top 3 waiters',
    wsPodiumFirst: 'First',
    wsPodiumSecond: 'Second',
    wsPodiumThird: 'Third',
    kitchenOldestOrder: 'Oldest Order',
    kitchenAvgWait: 'Avg Wait',
    posDisplayQueueOverview: 'Order Status',
    posDisplayQueuePreparing: 'Preparing',
    posDisplayQueueReady: 'Ready',
    posDisplayQueueAvgWait: 'Avg Wait',
    posSummaryTodayCount: 'Today Sales',
    posSummaryUnitsSuffix: 'units',
    posSummaryTodayRevenue: 'Today Revenue',
    posSummaryRevenueSub: 'total',
    posSummaryAvgBasket: 'Avg Basket',
    posSummaryAvgBasketSub: 'per sale',
    posSummaryOpenSession: 'Open Session',
    posSummarySessionActive: 'Active',
    posSummarySessionClosed: 'Closed',
    posSummarySessionNone: 'No session',
    trashStatOthers: 'Others',
    recipeOverviewRegionAria: 'Recipe summary',
    recipeOverviewTotal: 'Total Recipes',
    recipeOverviewAvgCost: 'Avg Cost',
    recipeOverviewMargin: 'Avg Margin',
    recipeOverviewLinked: 'Linked Menu Items',
    flagStatPartial: 'Partial Rollout',
    featureFlagSearchPlaceholder: 'Search flag...',
    webhookOverviewTotal: 'Total Subscriptions',
    webhookOverviewActive: 'Active',
    webhookOverviewDeliveries24h: 'Last 24h Deliveries',
    webhookOverviewFailed: 'Failed',
    printerStatTodayJobs: 'Today Jobs',
    printerStatPendingJobs: 'Pending Jobs',
    taxStatTotalGroups: 'Total Groups',
    taxStatDefaultCount: 'Default',
    taxStatMaxRate: 'Max Rate',
    taxStatMinRate: 'Min Rate',
    chainStaffSearchPlaceholder: 'Search name or email...',
    chainStaffActive: 'Active',
    chainStaffBranchCount: 'Branch Count',
    chainStaffTopRole: 'Roles',
    supplierStatOutstanding: 'Outstanding',
    supplierStatPoThisMonth: 'This Month POs',
    supplierStatRecent30d: 'Added Last 30d',
    supplierActiveFilterAria: 'Active filter',
    clearDates: 'Clear Dates',
    role_chain_admin: 'Chain Admin',
    poEmptyTitle: 'No purchase orders yet',
    poEmptyHint: 'Create your first purchase order.',
    poNoItemsError: 'Add at least one item.',
    poSupplierRequired: 'Select a supplier.',
    courierTitle: 'Couriers',
    courierSubtitle: 'Manage your delivery couriers.',
    courierAdd: 'Add Courier',
    courierEditTitle: 'Edit Courier',
    courierNewTitle: 'New Courier',
    courierName: 'Full Name',
    courierVehicle: 'Vehicle',
    courierVehicle_motorbike: 'Motorbike',
    courierVehicle_bicycle: 'Bicycle',
    courierVehicle_car: 'Car',
    courierVehicle_walking: 'Walking',
    courierLicensePlate: 'License Plate',
    courierNotes: 'Notes',
    courierActive: 'Active',
    courierInactive: 'Inactive',
    courierLocation: 'Location',
    courierLocationTitle: 'Update Location',
    courierLat: 'Latitude',
    courierLng: 'Longitude',
    courierStatTotal: 'Total Couriers',
    courierStatActive: 'Active',
    courierStatOnDelivery: 'On Delivery',
    courierStatIdle: 'Idle',
    courierStatus: 'Status',
    courierStatusPlaceholder: 'On route / At customer / At restaurant',
    courierLastSeen: 'Last seen',
    courierUseMyLocation: 'Use my current location',
    courierShowInactive: 'Show inactive',
    courierEmptyTitle: 'No couriers yet',
    courierEmptyHint: 'Add your first courier to start delivery flow.',
    courierNameRequired: 'Name is required.',
    courierPhoneRequired: 'Phone is required.',
    courierLoadError: 'Could not load couriers.',
    courierSearchPlaceholder: 'Search courier...',
    courierAssignNone: 'Unassigned',
    courierRating: 'Courier Rating',
    courierRatingPrompt: 'How would you rate this delivery?',
    courierAvgRating: 'Avg. Rating',
    courierRatingError: 'Rating could not be saved',
    courierRatingDone: 'Your rating has been saved',
    qrClaimedToday: 'claimed',
    qrConversionRate: 'conversion',
    stockCostPerUnit: 'Cost per Unit (₺)',
    stockCostHint: '— for food cost calculation',
    foodCostTitle: 'Cost Analysis',
    foodCostUnitCost: 'Unit Cost',
    foodCostSellPrice: 'Sell Price',
    foodCostMargin: 'Margin',
    foodCostMissing: 'Some ingredients are missing unit cost — add via Stock page.',
    foodCostAnalysisTitle: 'Cost & Margin Analysis',
    foodCostAvgMargin: 'Avg. margin',
    foodCostMissingShort: 'missing cost',
    foodCostNoData: 'No items with recipes. Create recipes via Recipes page.',
    foodCostTargetMargin: 'Target Margin',
    foodCostSuggested: 'Suggested ₺',
    cogsTitle: 'Daily COGS (Cost of Goods Sold)',
    cogsTotal: 'COGS',
    cogsTotalRevenue: 'Revenue',
    cogsGrossProfit: 'Gross Profit',
    customerTags: 'Tags',
    customerTagsHint: 'segmentation (vip, vegan, no-spice...)',
    customerTagAddPlaceholder: 'Type tag, press Enter or comma to add',
    customerAllTags: 'All tags',
    customerClearTag: 'Clear tag',
    segmentTitle: 'Customer Segmentation',
    segmentTagsCount: 'segments',
    segmentNoData: 'No segment data yet. Add tags to customers.',
    // ERP-07 Part 1 — Cash transactions
    cashTxTitle: 'Cash Transactions',
    cashTxSubtitle: 'Track restaurant income and expenses.',
    cashTxNew: 'New Transaction',
    cashTxEdit: 'Edit Transaction',
    cashTxTypeIn: 'Income',
    cashTxTypeOut: 'Expense',
    cashTxAmount: 'Amount (₺)',
    cashTxCategory: 'Category',
    cashTxDate: 'Date',
    cashTxMethod: 'Method',
    cashTxMethod_cash: 'Cash',
    cashTxMethod_bank: 'Bank',
    cashTxMethod_card: 'Card',
    cashTxMethod_other: 'Other',
    cashTxDescription: 'Description',
    cashTxStatTotalIn: 'Total Income',
    cashTxStatTotalOut: 'Total Expense',
    cashTxStatBalance: 'Balance',
    cashTxFilterType: 'Type',
    cashTxFilterAll: 'All',
    cashTxClearFilters: 'Clear filters',
    cashTxEmptyTitle: 'No transactions yet',
    cashTxEmptyHint: 'Add your first income/expense.',
    cashTxAmountRequired: 'Amount is required (>0).',
    cashTxCategory_sale: 'Sale',
    cashTxCategory_supplier: 'Supplier',
    cashTxCategory_rent: 'Rent',
    cashTxCategory_salary: 'Salary',
    cashTxCategory_tax: 'Tax',
    cashTxCategory_utilities: 'Utilities',
    cashTxCategory_other: 'Other',
    cashTxAuto: 'Auto',
    cashTxAutoHint: 'Auto-generated from a linked record (purchase order/payment).',
    cashTxSyncPayments: 'Sync from Payments',
    cashTxSyncConfirm: 'Import paid payments not yet synced as income entries?',
    cashTxSyncResult: '{n} entries added.',
    pnlTabTitle: 'P&L',
    pnlSubtitle: 'Net profit/loss for the selected period from income, COGS and expenses.',
    pnlIncome: 'Total Income',
    pnlCogs: 'COGS',
    pnlGrossProfit: 'Gross Profit',
    pnlExpense: 'Total Expense',
    pnlNetProfit: 'Net Profit',
    pnlIncomeBreakdown: 'Income Breakdown',
    pnlExpenseBreakdown: 'Expense Breakdown',
    pnlEmptyTitle: 'No data',
    pnlEmptyHint: 'No cash transactions for this period.',
    customerLedger: 'Ledger',
    customerLedgerTitle: 'Account Ledger',
    customerLedgerDebit: 'Debit',
    customerLedgerCredit: 'Credit',
    customerLedgerBalance: 'Balance',
    customerLedgerOrder: 'Order',
    customerLedgerPayment: 'Payment',
    customerLedgerEmpty: 'No activity',
    customerLedgerEmptyHint: 'No orders or payments yet for this customer.',
    supplierMakePayment: 'Make Payment',
    supplierPaymentAmount: 'Amount (₺)',
    supplierPaymentMethod: 'Method',
    supplierPaymentDate: 'Date',
    supplierPaymentNote: 'Note',
    supplierPaymentSave: 'Save',
    userHourlyRate: 'Hourly Rate (₺)',
    userPayroll: 'Payroll',
    payrollTitle: 'Payroll',
    payrollPeriodStart: 'Start',
    payrollPeriodEnd: 'End',
    payrollCalculate: 'Calculate',
    payrollShifts: 'Shifts',
    payrollHours: 'Hours',
    payrollOvertimeHours: 'OT Hours',
    payrollRegularPay: 'Regular Pay',
    payrollOvertimePay: 'OT Pay',
    payrollTotal: 'Total',
    payrollPay: 'Pay Salary',
    payrollPaid: 'Salary payment recorded as cash transaction.',
    payrollEmpty: 'No shifts',
    payrollEmptyHint: 'No shifts in this period.',
    payrollNoRate: 'No hourly rate set — pay calculated as 0.',
    payrollReportTabTitle: 'Payroll',
    payrollReportTitle: 'Staff Payroll Report',
    payrollReportSubtitle: 'Shifts × hourly rate for all staff in the selected period.',
    payrollReportStaff: 'Staff',
    payrollReportEmployee: 'Employee',
    payrollReportEmpty: 'No shift records for this period.',
    exportCsv: 'Export CSV',
    msgWhatsApp: 'Open in WhatsApp',
    stockOrderWhatsapp: 'Order',
    stockAdjustBtn: 'Adjust',
    stockAdjustQuick: 'Quick Stock Adjust',
    stockAdjustCurrent: 'Current stock',
    stockAdjustAdd: 'Add (incoming)',
    stockAdjustRemove: 'Remove (waste/usage)',
    stockAdjustAmount: 'Amount',
    stockAdjustNewQty: 'New stock',
    stockAdjustNegative: 'New stock cannot be negative',
    stockAdjustReasonOptional: 'Reason (optional)',
    stockAdjustReasonPlaceholder: 'e.g., supplier delivery, waste, count correction',
    stockAdjustHistory: 'History',
    stockAdjustNoHistory: 'No adjustment records yet.',
    wasteWidgetTitle: 'Stock Movement',
    wasteWidgetGoStock: 'Go to stock',
    wasteTotal: 'Waste',
    wasteIncoming: 'Incoming',
    wasteIncomingDesc: 'From supplier',
    wasteItemsCount: 'items',
    wasteTopList: 'Top waste',
    refundsTitle: 'Refunds',
    refundsSubtitle: 'All refund records',
    refundStatTotal: 'Total Refunded',
    refundsTotalAmount: 'Total Refunded',
    refundsCount: 'Refund Count',
    refundsAvg: 'Average Refund',
    refundsFilterFrom: 'From',
    refundsFilterTo: 'To',
    refundsFilterApply: 'Filter',
    refundsFilterClear: 'Clear',
    refundsFilterMonth: 'This Month',
    refundsColPayment: 'Payment #',
    refundsColOrderTable: 'Order / Table',
    refundsColMethod: 'Method',
    refundsColReason: 'Reason',
    refundsEmptyTitle: 'No refunds',
    refundsEmptyHint: 'No refunds have been made yet.',
    stockHistoryTitle: 'Stock History',
    stockHistorySubtitle: 'All stock in/out records',
    stockHistoryTotal: 'Total Records',
    stockHistoryIn: 'In',
    stockHistoryOut: 'Out',
    stockHistoryNetValue: 'Net Value',
    stockHistoryFilterType: 'Type',
    stockHistoryFilterIngredient: 'Ingredient',
    stockHistoryFilterAll: 'All',
    stockHistoryColMovement: 'Movement',
    stockHistoryColBefore: 'Before → After',
    stockHistoryColValue: 'Value (₺)',
    stockHistoryColUser: 'User',
    stockHistoryEmpty: 'No records',
    stockHistoryEmptyHint: 'No stock adjustments for this filter.',
    msgSms: 'Send SMS',
    msgEmail: 'Send email',

    // Tur 197
    orderStatTotal: 'Total',
    orderStatPreparing: 'Preparing',
    orderStatReady: 'Ready',
    orderStatServed: 'Served',
    datePresetToday: 'Today',
    datePreset7Days: 'Last 7 Days',
    datePreset30Days: 'Last 30 Days',
    datePresetClear: '✕ Clear Date',
    recipeStatSteps: 'Recipe Steps',
    recipeStatCost: 'Total Cost',
    recipeStatPrice: 'Sale Price',
    recipeStatMargin: 'Gross Margin',
    webhookStatSuccess: 'Last Success',
    flagStatTotal: 'Total',
    flagStatEnabled: 'Enabled',
    flagStatDisabled: 'Disabled',
    taxStatTotal: 'Total',
    taxStatDefault: 'Default',
    taxStatRange: 'Range',
    // HR (Tur 210)
    hrPageTitle: 'HR Management',
    hrPageSubtitle: 'Payroll, leave and HR operations',
    hrTabEmployees: 'Employees',
    hrTabPayroll: 'Payroll',
    hrTabLeaves: 'Leaves',
    hrTabDocuments: 'Documents',
    hrNewEmployee: 'New Employee',
    hrEditEmployee: 'Edit Employee',
    hrFirstName: 'First Name',
    hrLastName: 'Last Name',
    hrTcKimlik: 'National ID',
    hrElevenDigit: '11 digits',
    hrBirthDate: 'Birth Date',
    hrHireDate: 'Hire Date',
    hrDepartment: 'Department',
    hrPosition: 'Position',
    hrEmploymentType: 'Employment Type',
    hrGrossSalaryRequired: 'Gross Salary (₺) *',
    hrGrossSalaryPlaceholder: 'e.g. 25000',
    hrHourlyRateOptional: 'Hourly Rate (₺, optional)',
    hrIban: 'IBAN',
    hrPhone: 'Phone',
    hrEmail: 'Email',
    hrAddress: 'Address',
    hrNotes: 'Notes',
    hrActiveEmployee: 'Active Employee',
    hrCancel: 'Cancel',
    hrSave: 'Save',
    hrSaving: 'Saving…',
    hrEmployeesRegistered: 'employees registered',
    hrTotalEmployees: 'Total Employees',
    hrActive: 'Active',
    hrPassive: 'Inactive',
    hrMonthlyTotalGross: 'Monthly Total Gross',
    hrColFullName: 'Full Name',
    hrColDepartment: 'Department',
    hrColPosition: 'Position',
    hrColHireDate: 'Hire Date',
    hrColEmploymentType: 'Type',
    hrColGrossSalary: 'Gross Salary',
    hrColStatus: 'Status',
    hrColActions: 'Actions',
    hrNoEmployeesYet: 'No employees added yet.',
    hrDelete: 'Delete',
    hrCalculatePayroll: 'Calculate Payroll',
    hrEmployee: 'Employee',
    hrSelectPlaceholder: '-- Select --',
    hrYear: 'Year',
    hrMonth: 'Month',
    hrWorkingDaysTotal: 'Working Days (total)',
    hrWorkedDays: 'Days Worked',
    hrOvertimeHours: 'Overtime (hours)',
    hrBonus: 'Bonus (₺)',
    hrAdvance: 'Advance (₺)',
    hrCalculate: 'Calculate',
    hrCalculating: 'Calculating…',
    hrCalculationSummary: 'Calculation Summary',
    hrGrossSalary: 'Gross Salary',
    hrOvertimePay: 'Overtime Pay',
    hrBonusPremium: 'Bonus / Premium',
    hrSgkEmployee: 'SGK Employee (14%)',
    hrUnemploymentEmployee: 'Unemployment (1%)',
    hrIncomeTax: 'Income Tax',
    hrStampTax: 'Stamp Tax',
    hrAdvanceDeduction: 'Advance Deduction',
    hrNetSalary: 'NET SALARY',
    hrSgkEmployerShare: 'SGK Employer Share',
    hrTotalCost: 'Total Cost',
    hrThisMonthTotalCost: 'Total Cost This Month',
    hrTotalNetPayment: 'Total Net Payment',
    hrPendingApproval: 'Pending Approval',
    hrBulkCalculate: 'Bulk Calculate',
    hrColGross: 'Gross',
    hrColSgkEmployee: 'SGK Emp.',
    hrColUnemployment: 'Unempl.',
    hrColIncomeTaxShort: 'Inc. Tax',
    hrColStampTax: 'Stamp',
    hrColDeductions: 'Deductions',
    hrColNetSalary: 'Net Salary',
    hrColSgkEmployer: 'SGK Empr.',
    hrColTotalCost: 'Total Cost',
    hrNoPayrollForPeriod: 'No payroll found for this period.',
    hrApprove: 'Approve',
    hrPaid: 'Paid',
    hrPrint: 'Print',
    hrCreateLeaveRequest: 'Create Leave Request',
    hrLeaveType: 'Leave Type',
    hrStartDate: 'Start Date',
    hrEndDate: 'End Date',
    hrDescriptionReason: 'Description / Reason',
    hrSubmitRequest: 'Submit Request',
    hrAllEmployees: 'All Employees',
    hrAllStatuses: 'All Statuses',
    hrPending: 'Pending',
    hrApproved: 'Approved',
    hrRejected: 'Rejected',
    hrLeaveRequest: 'Leave Request',
    hrTotalLeaves: 'Total Leaves',
    hrEntitlement: 'Entitlement',
    hrUsed: 'Used',
    hrRemaining: 'Remaining',
    hrDays: 'days',
    hrStart: 'Start',
    hrEnd: 'End',
    hrDay: 'Day',
    hrNoLeavesFound: 'No leave records found.',
    hrReject: 'Reject',
    hrAddDocument: 'Add Document',
    hrDocumentType: 'Document Type',
    hrTitle: 'Title',
    hrDocumentTitlePlaceholder: 'Document title',
    hrFileUrl: 'File URL',
    hrAdd: 'Add',
    hrTotalDocuments: 'Total Documents',
    hrThisMonth: 'This Month',
    hrEmployeeCount: 'Employee Count',
    hrNoDocumentsFound: 'No documents found.',
    hrView: 'View',
    hrSearchEmployee: 'Search employee...',
    hrBulkLeaveTitle: 'Bulk Add Leave',
    hrBulkLeaveBtn: 'Bulk Leave',
    hrBulkLeaveHint: 'Assign leave to all employees at once for new year, religious holidays, or official holidays.',
    hrBulkScope: 'Scope',
    hrBulkAllActive: 'All active employees',
    hrBulkSelected: 'Selected employees',
    hrBulkCreate: 'Bulk Assign',
    hrStatus: 'Status',
    hrSelectDateRange: 'Enter date range.',
    hrEndBeforeStart: 'End date cannot be before start date.',
    hrSelectAtLeastOne: 'Select at least 1 employee.',
    hrNoActiveEmployees: 'No active employees.',
    hrCalcModeGross: '📥 Gross → Net',
    hrCalcModeNet: '📤 Net → Gross',
    hrNetTarget: 'Net Target (₺)',
    hrEstimatedGross: 'Estimated Gross',
    hrIterations: 'iterations',
    // HR mevzuat genişletme (Tur 229)
    hrOptionalAllowancesDeductions: 'Monthly Allowances & Deductions (Optional)',
    hrMaritalStatus: 'Marital Status',
    hrMaritalSingle: 'Single',
    hrMaritalMarried: 'Married',
    hrMaritalWidowed: 'Widowed',
    hrMaritalDivorced: 'Divorced',
    hrChildrenCount: 'Number of Children',
    hrMonthlyAllowancesTaxFree: 'Monthly Allowances (tax-free, added to net)',
    hrMealAllowance: 'Meal Card',
    hrTransportAllowance: 'Transport',
    hrFamilyAllowance: 'Family Allowance',
    hrChildAllowance: 'Child Allowance',
    hrMonthlyDeductions: 'Monthly Deductions',
    hrUnionDues: 'Union Dues',
    hrBesPayment: 'BES (Pension)',
    hrWeeklyHolidayHours: 'Weekly Holiday Overtime (hours)',
    hrWeeklyHolidayHint: '1.5x rate',
    hrPublicHolidayHours: 'Public Holiday Overtime (hours)',
    hrPublicHolidayHint: '2x rate',
    hrAllowancesAndSpecialDeductions: 'Allowances & Special Deductions',
    hrSpecialDeductions: 'Special Deductions',
    hrAlimony: 'Alimony',
    hrGarnishment: 'Garnishment',
    hrWeeklyHolidayPay: 'Weekly Holiday Pay',
    hrPublicHolidayPay: 'Public Holiday Pay',
    stockLowAlert: '⚠️ {count} ingredients critically low',
    settingsSavedAt: 'Saved',
    // Tur 248 i18n tail sweep
    custCorporateLabel: 'Corporate',
    custTypeLabel: 'Customer Type',
    custIndividual: 'Individual',
    custCorporateInfo: 'Corporate Info',
    custCompanyName: 'Company Name',
    custTaxNumber: 'Tax No',
    custTaxOffice: 'Tax Office',
    custCreditLimit: 'Credit Limit (₺)',
    custAddressLabel: 'Address',
    custLedgerAddDebt: 'Add Debt',
    custLedgerTakePayment: 'Take Payment',
    setTaxSgkSection: 'Tax & SGK Info (for e-Bildirge / Muhtasar)',
    setTaxNumberLabel: 'Tax Number',
    setTaxOfficeLabel: 'Tax Office',
    setSgkSicilNo: 'SGK Workplace ID',
    setTaxSgkHint: 'This info is used automatically in SGK Bildirge and Muhtasar PDFs.',
    dashDocExpiryTitle: 'Document Expiry',
    dashViewAll: 'all →',
    dashDocExpiryEmpty: 'No expiring/expired documents',
    rptTopSpendersTitle: 'Top 10 Spenders',
    rptViewAll: 'all →',
    rptNoDataShort: 'No data yet',
    hrSgkSicilNoLabel: 'SGK Sicil No (optional)',
    hrSgkSicilNoPlaceholder: 'For SGK monthly premium service report',
    hrSgkBildirgeBtn: 'SGK Bildirge',
    hrSearchLeave: 'Search leave...',
    hrSearchDocument: 'Search document...',
    // Couriers (Tur 216)
    crGeoNotSupported: 'Browser does not support geolocation',
    crGeoFailed: 'Could not get location',
    crFillAtLeastOne: 'Fill at least one field',
    crAgoNow: 'now',
    crAgoMin: 'min ago',
    crAgoHour: 'h ago',
    crAgoDay: 'd ago',
    crLast7Days: 'Last 7 Days',
    crLast30Days: 'Last 30 Days',
    crThisMonth: 'This Month',
    crLastMonth: 'Last Month',
    crClearDate: 'Clear Date',
    loginEmailPlaceholder: 'example@restaurant.com',
    // Empty states (Tur 218)
    stockNoItemsTitle: 'No ingredients yet',
    stockNoItemsDesc: 'Add your first ingredient to start tracking inventory.',
    stockAddItem: '+ New Ingredient',
    stockNoSearchResultsTitle: 'No results found',
    stockNoSearchResultsDesc: 'Try changing search or filter criteria.',
    rcpNoItemsTitle: 'No recipes yet',
    rcpNoItemsDesc: 'Add recipes for menu items to track their costs.',
    rcpNoSearchResultsTitle: 'No results found',
    rcpNoSearchResultsDesc: 'Try changing search criteria.',
    whkNoItemsTitle: 'No webhook subscriptions yet',
    whkNoItemsDesc: 'Add a subscription to broadcast events to Zapier, Make or your own server.',
    whkAddBtn: '+ New Subscription',
    whkNoSearchResultsTitle: 'No results found',
    whkNoSearchResultsDesc: 'Change URL or event search.',
    auditNoItemsTitle: 'No log records yet',
    auditNoItemsDesc: 'System actions will be logged here.',
    auditNoSearchResultsTitle: 'No results found',
    auditNoSearchResultsDesc: 'Change search or date filter.',
    // Empty states 2 (Tur 219)
    taxNoItemsTitle: 'No tax groups yet',
    taxNoItemsDesc: 'Group VAT rates to quickly tag menu items.',
    taxAddBtn: '+ New Tax Group',
    taxNoSearchResultsTitle: 'No results found',
    taxNoSearchResultsDesc: 'Change search or date filter.',
    flagNoItemsTitle: 'No feature flags yet',
    flagNoItemsDesc: 'Use flags to control rollout of new features.',
    flagAddBtn: '+ New Flag',
    flagNoSearchResultsTitle: 'No results found',
    flagNoSearchResultsDesc: 'Change search or date filter.',
    promoNoItemsTitle: 'No promo codes yet',
    promoNoItemsDesc: 'Create your first discount code to reward your customers.',
    promoAddBtn: '+ New Code',
    promoNoSearchResultsTitle: 'No results found',
    promoNoSearchResultsDesc: 'Change search or filter criteria.',
    rsvNoItemsTitle: 'No reservations yet',
    rsvNoItemsDesc: 'Customer reservations will show up here. You can add one manually too.',
    rsvAddBtn: '+ New Reservation',
    rsvNoSearchResultsTitle: 'No results found',
    rsvNoSearchResultsDesc: 'Change search or date filter.',
    // Empty states 3 (Tur 221)
    prnNoItemsTitle: 'No printers yet',
    prnNoItemsDesc: 'Add an ESC/POS thermal printer to automate kitchen/receipt output.',
    prnAddBtn: '+ New Printer',
    prnNoSearchResultsTitle: 'No results found',
    prnNoSearchResultsDesc: 'Change search or filter criteria.',
    notifNoItemsTitle: 'No notifications yet',
    notifNoItemsDesc: 'Order, payment and system events will appear here as they happen.',
    notifNoSearchResultsTitle: 'No results found',
    notifNoSearchResultsDesc: 'Change filter, search or date criteria.',
    // Empty states 4 (Tur 222)
    mmNoItemsTitle: 'No menu items yet',
    mmNoItemsDesc: 'Add your first category and products to build your menu.',
    mmAddBtn: '+ New Item',
    mmNoSearchResultsTitle: 'No results found',
    mmNoSearchResultsDesc: 'Change search or category filter.',
    trashNoItemsTitle: 'Trash is empty',
    trashNoItemsDesc: 'Deleted records appear here and can be restored.',
    trashNoSearchResultsTitle: 'No results found',
    trashNoSearchResultsDesc: 'Change search criteria.',
    // Empty states 5 (Tur 223)
    hrPayrollEmptyTitle: 'No payroll for this period',
    hrPayrollEmptyDesc: 'Use "Bulk Calculate" to generate payrolls for all employees, or calculate one at a time.',
    wsNoItemsTitle: 'No waiter activity yet',
    wsNoItemsDesc: 'Performance data will appear here as waiters take orders.',
    wsNoSearchResultsTitle: 'No results found',
    wsNoSearchResultsDesc: 'Change search or date range.',
    shfNoItemsTitle: 'No shifts assigned for this week',
    shfNoItemsDesc: 'Use a template or click on a cell to assign a shift.',
    shfAddBtn: '+ Assign Shift',
    shfNoSearchResultsTitle: 'No results found',
    shfNoSearchResultsDesc: 'Change staff search.',
    gdprAdminEmptyTitle: 'No GDPR requests yet',
    gdprAdminEmptyDesc: 'Manage KVKK / GDPR data export/erasure requests from here.',
    gdprUserEmptyTitle: 'No requests sent yet',
    gdprUserEmptyDesc: 'Create a new request to download or delete your data.',
    gdprNewRequestBtn: '+ New Request',
    securityNoTwoFa: '2FA is not active yet',
    securityNoTwoFaDesc: 'You can enable two-factor authentication to protect your account.',
    securitySetup2fa: 'Enable',
    // Empty states 7 (Tur 226)
    tableNoItemsTitle: 'No tables yet',
    tableNoItemsDesc: 'Add your first table to start managing orders.',
    tableAddBtn: '+ New Table',
    tableNoCategoryItemsTitle: 'No tables in this category',
    tableNoCategoryItemsDesc: 'Choose a different category or add tables to this one.',
    ordNoItemsTitle: 'No orders yet',
    ordNoItemsDesc: 'New orders will appear here as they come in.',
    ordNoSearchResultsTitle: 'No results found',
    ordNoSearchResultsDesc: 'Change filter or date criteria.',
    payNoItemsTitle: 'No payments yet',
    payNoItemsDesc: 'Payments for completed orders will appear here.',
    payNoSearchResultsTitle: 'No results found',
    payNoSearchResultsDesc: 'Change date range.',
    kitNoItemsTitle: 'No orders to prepare',
    kitNoItemsDesc: 'New orders will appear here when they come in.',
    // Empty states 8 (Tur 227)
    posCartEmptyTitle: 'Cart is empty',
    posCartEmptyDesc: 'Select products from the left panel to add to cart.',
    posProductsEmpty: 'No products in this category',
    posProductsEmptyDesc: 'Try a different category or barcode search.',
    posHistoryEmpty: 'No history yet',
    posHistoryEmptyDesc: 'No sales found for this date.',
    posHoldEmpty: 'No held orders',
    posHoldEmptyDesc: 'Orders you hold will appear here.',
    cdNoOrdersTitle: 'No orders yet',
    cdNoOrdersDesc: 'This customer’s order history will appear here.',
    cdNoLoyaltyTitle: 'No loyalty activity yet',
    cdNoLoyaltyDesc: 'Loyalty points are earned as orders are completed.',
    msNoPaymentsTitle: 'No payments yet',
    msNoPaymentsDesc: 'Your payment history will appear here as your plan renews.',
    msNoInvoicesTitle: 'No invoices yet',
    msNoInvoicesDesc: 'Invoices are generated automatically at period end.',
    msInvoicesTitle: 'Invoices',
    dashTopItemsEmpty: 'No sales today',
    dashTopItemsEmptyDesc: 'Top sellers will appear here as orders come in.',
    dashActivityEmpty: 'No activity yet',
    dashActivityEmptyDesc: 'Recent actions will appear here.',
    // i18n tail (Tur 211)
    rptVatRatePct: 'VAT %',
    rptVatLabel: 'VAT',
    rptCriticalLabel: 'Critical',
    rptMarginPct: 'Margin %',
    rptProfitTooltip: 'Profit',
    notifCsvDate: 'Date',
    notifCsvSeverity: 'Severity',
    notifCsvType: 'Type',
    notifCsvTitle: 'Title',
    notifCsvMessage: 'Message',
    notifPresetToday: 'Today',
    notifPresetLast7Days: 'Last 7 Days',
    notifPresetThisMonth: 'This Month',
    notifPresetLastMonth: 'Last Month',
    notifClearDate: 'Clear Date',
    tableBulkPrefixDefault: 'Table',
    tablePromoCodePlaceholder: 'WELCOME10',
    tableVoucherCodePlaceholder: 'GV-KARAD100',
    giftCustomerNamePh: 'John Smith',
    giftEmailPh: 'example@mail.com',
    // i18n tail (Tur 213)
    custDateLabel: 'Date',
    custDateLast7Days: 'Last 7 Days',
    custDateLast30Days: 'Last 30 Days',
    custDateThisMonth: 'This Month',
    custDateLastMonth: 'Last Month',
    custClearDate: 'Clear Date',
    custNewBadge: 'NEW',
    custProfileLinkTitle: 'Open profile page (order history + loyalty)',
    auditSearchPlaceholder: 'Search user/action...',
    supPaymentDescPrefix: 'Supplier payment',
    supTaxNumberShort: 'TaxNo',
    supActiveLabel: 'Active',
    supCashRefPrefix: 'Cash',
    stockWhatsappMsgFull: 'stock is critically low',
    stockWhatsappOrderAsk: 'Can we place an order?',
    stockWhatsappMsgShort: 'stock critical',
    stockWhatsappOrderShort: 'Order?',
    // i18n tail (Tur 214)
    navManagementPlatform: 'Management Platform',
    navManagementSystem: 'Admin & System',
    navMore: 'More',
    checkoutIframeTitle: 'Iyzico payment',
    checkoutFirstNamePh: 'John',
    checkoutLastNamePh: 'Smith',
    checkoutCityPh: 'Istanbul',
    customersCampaignSendTitle: 'Send campaign',
    customersCorpNamePlaceholder: 'e.g. ACME Software Inc.',
    customersTaxOfficePlaceholder: 'e.g. Kadikoy',
    customersAddressPlaceholder: 'Full address (optional)',
    customersCampaignNamePlaceholder: 'e.g. New Year Discount',
    customersCampaignSubjectPlaceholder: 'We miss you!',
    hrEmployeeDetailTitle: 'Employee Details',
    hrLinkedAccountTitle: 'Open linked login account in Users page',
    hrCreateAccountTitle: 'Create a login account for this employee in Users page',
    hrBulkImportTitle: 'Bulk Import Employees (CSV)',
    hrNetTargetPlaceholder: 'e.g. 30000',
    hrAnnualSummary: 'Annual Summary',
    hrSgkBildirgePDFTitle: 'SGK Monthly Premium and Service Document PDF',
    hrAllowancesShort: 'Allowances',
    hrLeaveReasonPlaceholder: 'e.g. New Year holiday',
    posEditProduct: 'Edit product',
    posEditQty: 'Edit quantity',
    posEditPrice: 'Edit price',
    onboardingStep1Title: 'Restaurant',
    onboardingStep2Title: 'Tables',
    onboardingStep3Title: 'Menu',
    onboardingStep4Title: 'Done',
    peakHourSticker: 'Peak among 0–23',
    peakHourFallbackHint: 'No hourly distribution — showing peak only',
    dashNoOrdersToday: 'No orders yet today',
    shiftsBordroBannerPart1: 'Payroll calculation has moved to',
    shiftsBordroBannerHrLink: 'HR Management',
    shiftsBordroBannerPart2: 'page. This page is for weekly shift planning only.',
    reservationsCustomerSearch: 'Search customer...',
    cashTxSearchPlaceholder: 'Search description/category...',
    custSegmentInactive: '💤 Inactive',
    reportsPrintAction: '🖨️ Print',
    stockApproaching: '⚠️ Approaching',
    stockApproachingHint: 'Approaching minimum stock level',
    customersLastOrderCol: 'Last Order',
    customersDaysAgo: '{n} days ago',
    customersToday: 'Today',
    customersYesterday: 'Yesterday',
    customersNever: '—',
    quickActionsTitle: 'Quick Actions',
    quickActionNewOrder: 'New Order',
    quickActionNewTable: 'New Table',
    quickActionNewCustomer: 'New Customer',
    quickActionNewStaff: 'New Staff',
    notifPushEnable: '🔔 Enable Push',
    notifPushDisable: '🔕 Disable Push',
    notifPushUnsupported: 'Not supported on this device',
    notifPushGranted: 'Push enabled',
    notifPushDenied: 'Permission denied — enable in browser settings',
    rptColSegment: 'Segment',
    rptColLastOrder: 'Last Order',
    dashOrderChannelsTitle: "Today's Order Channels",
    dashChannelPOS: 'POS',
    dashChannelTable: 'Table',
    dashChannelOnline: 'Online',
    dashChannelDelivery: 'Delivery',
    posItemAddedToast: '✓ {name} added',
    tableDurationHourShort: 'h',
    settingsCustomerSegments: '👥 Customer Segment Thresholds',
    settingsVipThreshold: 'VIP threshold (TL, last 12 months)',
    settingsLoyalThreshold: 'Loyal threshold (orders, last 3 months)',
    settingsInactiveDays: 'Inactive threshold (days)',
    settingsLostDays: 'Lost threshold (days)',
    mobileBottomNav: 'Mobile quick menu',
    stockBulkReceiptBtn: 'Bulk Receipt',
    stockBulkReceiptTitle: 'Bulk Stock Receipt',
    stockBulkAdd: 'Add',
    stockBulkSearch: 'Search ingredient...',
    stockBulkSubmit: 'Save Receipt',
    stockBulkSuccessTpl: '{n} ingredients updated',
    a11yCustomerSearch: 'Search customer',
    a11ySendCampaign: 'Send campaign',
    a11yOpenProfile: 'Open profile',
    hrCloseModal: 'Close',
    hrPrevMonth: 'Previous month',
    hrNextMonth: 'Next month',
    hrMuhtasarPDFAriaLabel: 'Download tax withholding summary PDF',
    hrBankCSVAriaLabel: 'Download bank transfer CSV',
    hrPayrollCSVExportAriaLabel: 'Export payroll CSV',
    hrPrintPayslipAriaLabel: 'Print payslip',
    hrDownloadPDFAriaLabel: 'Download PDF',
    hrImportEmployeesAriaLabel: 'Bulk import employees via CSV',
    tablesPickColorAria: 'Pick color',
    a11yReportsTablistLabel: 'Report tabs',
    a11yDateFiltersLabel: 'Date filters',
    a11yExportCsvLabel: 'Download as CSV',
    a11yPrintLabel: 'Print report',
    loginSubmitting: 'Signing in...',
    loginForgotPasswordAria: 'Forgot password, go to reset page',
    loginDemoFill: 'Fill demo account',
    posCartClear: 'Clear cart',
    supplierSearchAriaLabel: 'Search suppliers',
    supCallAria: 'Call',
    supWhatsappAria: 'Message on WhatsApp',
    stockStatusFilterAria: 'Stock status filter',
    notifClearDateAria: 'Clear date filter',
    notifDismissReadAria: 'Dismiss read notifications',
    notifDismissVisibleAria: 'Dismiss visible notifications',
    notifListAria: 'Notifications list',
    notifSearchAria: 'Search notifications',
    orderLabel: 'Order',
    kitchenLateHint: 'Late!',
    settingsTabsAriaLabel: 'Settings tabs',
    settingsSubTabsAriaLabel: 'General sub-tabs',
    settingsCustomerSegmentsAria: 'Toggle customer segment thresholds',
    saveSettingsBtnDisabledAria: 'No changes to save',
    onbReopenBtnAria: 'Reopen onboarding wizard',
    themeToggleLabel: 'Toggle theme',
    userProfileLabel: 'User profile',
    headerNavLabel: 'Header navigation',
    onbStepCompleted: 'Completed',
    onbWizardNav: 'Wizard navigation',
    onbPrevStep: 'Previous step',
    onbNextStep: 'Next step',
    a11yStatusFilterGroup: 'Order status filter',
    a11yDateRangeGroup: 'Date range',
    a11yDeliveryStatsRegion: 'Delivery statistics',
    a11yOrderCardPrefix: 'Order',
    a11yAdvanceStatusTo: 'Advance status',
    userSearchAriaLabel: 'Search name or email',
    roleFilterAriaLabel: 'Role filter',
    viewModeLabel: 'View',
    dateRangePresetsLabel: 'Date range presets',
    clearDateRange: 'Clear date range',
    dateQuickChipsLabel: 'Quick date filter',
    filterByDateLabel: 'Filter by date',
    callCustomer: 'Call customer',
    whatsappContact: 'Contact via WhatsApp',
    changeStatusTo: 'Change status to',
    reservationTime: 'Reservation time',
    dismissError: 'Dismiss error',
    searchRecipesAria: 'Search recipes',
    exportCsvAria: 'Export as CSV',
    addIngredientAria: 'Add new ingredient',
    recipeStatRegionAria: 'Recipe statistics overview',
    shiftPrevWeekAria: 'Previous week',
    shiftNextWeekAria: 'Next week',
    shiftsBordroBannerLinkAria: 'Go to HR page',
    shiftStatusOnLeaveSr: 'On leave',
    shiftSearchStaffAria: 'Search staff',
    auditDatePresetGroup: 'Date preset',
    a11yCloseError: 'Close error',
    a11yDatePresetGroup: 'Date presets',
    trashTabsLabel: 'Trash entity tabs',
    flagSearchAria: 'Search feature flags',
    flagClearDateAria: 'Clear date filter',
    taxGroupClearDates: 'Clear Dates',
    taxGroupFormHeading: 'Tax group form',
    gdprDownloadPackageAria: 'Download GDPR data package',
    gdprFiltersAria: 'Request filters',
    webhookDeliverySuccess: 'Successful',
    webhookDeliveryFailed: 'Failed',
    a11yRefreshJobs: 'Refresh print queue',
    whiteLabelSearchAria: 'Search configuration',
    whiteLabelPreviewAria: 'Brand preview',
    whiteLabelPrimaryColorPicker: 'Primary color picker',
    whiteLabelSecondaryColorPicker: 'Secondary color picker',
    whiteLabelTextColorPicker: 'Text color picker',
    whiteLabelBgColorPicker: 'Background color picker',
    wsPeriodGroupLabel: 'Period selection',
    wsSortGroupLabel: 'Sorting',
    wsDatePresetGroupLabel: 'Date presets',
    wsClearDateLabel: 'Clear date',
    wsStatRegionLabel: 'Performance summary',
    deliverySearchPlaceholder: 'Search order/customer...',
    settingsTaxOfficePlaceholder: 'e.g. Beşiktaş',
    userHrLinkTitle: 'Go to HR Staff Management',
    platformMgmtNoResults: 'No results found',
    platformMgmtNoResultsDesc: 'Try a different search term.',
    platformMgmtEmpty: 'No platforms configured yet',
    platformMgmtEmptyDesc: 'Connect platforms like Yemeksepeti/Trendyol/Getir/Migros to manage online orders from here.',
    whiteLabelSearchPlaceholder: 'Search configuration...',
    whiteLabelNoResults: 'No results found',
    whiteLabelNoResultsDesc: 'Adjust your search criteria.',
    pricingBillingCycleLabel: 'Billing cycle',
    pricingMostPopularBadgeLabel: 'Most popular plan badge',
    msCurrentSubscriptionRegion: 'Current subscription',
    hrPayslipWorkingDays: 'Working Days',
    hrPayslipMonthlyGross: 'Monthly Gross Salary',
    hrGarnishmentDeduction: 'Garnishment Deduction',
    hrEmployerCost: 'Employer Cost',
    hrEmployeeSignature: 'Employee Signature',
    hrYearsOfService: 'Years of Service',
    hrSeverancePay: 'Severance Pay',
    hrNoticePay: 'Notice Pay',
    hrNoticePeriod: 'Notice Period',
    hrDailyGross: 'Daily Gross',
    hrTotalGross: 'Total Gross',
    hrTotalNet: 'Total Net',
    cdCustomerInfo: 'Customer Information',
    cdJoinDate: 'Member Since',
    cdLoyaltyPoints: 'Loyalty Points',
    cdCurrentAccount: 'Current Account',
    customersCampaignNameLabel: 'Campaign Name',
    customersTargetSegment: 'Target Segment',
    customersAllCustomers: 'All Customers',
    customersEmailSubjectLabel: 'Email Subject',
    customersMessageBody: 'Message Body',
    posEditProductTitle: 'Edit Product',
    promoQRHint: 'Customers can scan with their phone camera',
    navMainMenu: 'Main menu',
    reportsRevenueDelta: 'Revenue Change',
    usersLoginBannerPart1: '💡 This page manages ',
    usersLoginBannerStrong: 'login accounts',
    usersLoginBannerPart2: '. For staff payroll/leave/document records go to ',
    usersLoginBannerLink: 'HR Management',
    usersLoginBannerPart3: '.',
    poStatsRegion: 'Order summary',
    datePresetGroup: 'Date presets',
    cdStatTotalOrders: 'Total Orders',
    cdStatTotalSpent: 'Total Spent',
    cdStatAvgOrder: 'Avg Order',
    cdStatLastOrder: 'Last Order',
    a11yUnreadNotifications: 'unread notifications',
    sidebarLockedFeatureTitle: 'This feature is not included in your plan',
    saSidebarToggle: 'Open superadmin menu',
    saSidebarNavLabel: 'Superadmin menu',
    saSidebarClose: 'Close menu',
    closeMenu: 'Close menu',
    chainAdminNavLabel: 'Chain admin menu',
    settingsSegPreviewAria: 'Current segment distribution preview',
    settingsSegPreviewPeople: 'people',
    segmentLoyal: 'Loyal',
    segmentInactive: 'Inactive',
    segmentLost: 'Lost',
    lockScreenDigit: 'Digit',
    lockScreenBackspace: 'Backspace',
    shortcutDashboard: 'Dashboard',
    deliveryPlatformBreakdown: 'Platform Breakdown',
    deliveryPlatformOther: 'Other',
    deliveryPlatformOrdersShort: 'ord.',
    a11yDeliveryPlatformBreakdown: 'Platform breakdown',
    stockCategoryBreakdown: 'Stock Distribution by Category',
    stockCategoryOther: 'Other',
    customersExportExcel: '📊 Export Excel',
    reportsYearlyMonthlyShow: 'Show monthly breakdown (12 months × 2 years)',
    reportsMonthShortList: 'Jan,Feb,Mar,Apr,May,Jun,Jul,Aug,Sep,Oct,Nov,Dec',
    sortByLabel: 'Sort:',
    sortByDate: 'Date',
    sortByDiscount: 'Discount',
    sortByUsage: 'Usage',
    voucherSortDate: 'Date',
    voucherSortAmount: 'Amount',
    voucherSortRemaining: 'Remaining',
    voucherSortExpires: 'Expires',
    supSortProductCount: 'Products',
    supSortCreatedAt: 'Added',
    supSortAria: 'Sort',
    category: 'Category',
    stockSortByAria: 'Sort by',
    reportsExportAll: 'Download All',
    a11yExportAllLabel: 'Download all report tabs as CSV',
    customersBulkSelectedLabel: '{n} customers selected',
    customersBulkDelete: '🗑️ Bulk Delete',
    customersBulkExport: '📊 Export Selected CSV',
    customersBulkClear: '❌ Clear Selection',
    customersBulkDeleteConfirm: '{n} customers will be deleted. Continue?',
    customersBulkSelectAll: 'Select all',
    customersBulkSelectRow: 'Select {name}',
    bulkSelectOrder: 'Select order',
    bulkSelectAll: 'Select all',
    bulkActionBar: 'Bulk action',
    bulkSelected: '{count} orders selected',
    bulkAccept: 'Accept',
    bulkPreparing: 'Preparing',
    bulkReady: 'Out for delivery',
    bulkDelivered: 'Delivered',
    bulkCancel: 'Cancel',
    bulkClear: 'Clear selection',
    bulkConfirm: 'Update {count} orders. Continue?',
    bulkSuccess: '{count} orders updated.',
    bulkSkipped: 'skipped',
    bulkNoEligible: 'No eligible orders in selection.',
    stockBulkSelectedTpl: '{n} items selected',
    stockBulkDelete: 'Bulk Delete',
    stockBulkCategory: 'Bulk Category',
    stockBulkDeleteConfirm: 'Delete {n} items. Are you sure?',
    stockBulkDeleteDone: '{n} items deleted',
    stockBulkCategoryDone: '{n} items updated',
    stockBulkCategoryLabel: 'New Category',
    selectAll: 'Select all',
    select: 'Select',
    bulkSelectedCount: '{n} items selected',
    bulkConfirmAll: 'Confirm All',
    bulkCancelAll: 'Cancel All',
    bulkDelete: 'Bulk Delete',
    bulkSelectRow: 'Select',
    bulkDeleteConfirm: 'Delete {n} records?',
    sortByName: 'By name',
    sortByCapacity: 'Capacity',
    sortByStatus: 'Status (free first)',
    sortByDuration: 'Duration (longest first)',
    bulkChangeRole: 'Bulk Change Role',
    bulkClearSelection: 'Clear Selection',
    bulkRoleConfirm: 'Role will be changed for {n} selected users. Confirm?',
    notifBulkSelected: 'notifications selected',
    notifBulkMarkRead: 'Mark all as Read',
    notifBulkDismiss: 'Bulk Dismiss',
    notifBulkClear: 'Clear Selection',
    notifBulkSelectAll: 'Select all',
    notifBulkSelectItem: 'Select',
    hrLeavesSelected: 'leave(s) selected',
    hrBulkApprove: 'Approve All',
    hrBulkReject: 'Reject All',
    hrBulkDelete: 'Bulk Delete',
    hrClearSelection: 'Clear',
    hrSelectAll: 'Select all',
    hrLeavesBulkDeleteConfirm: 'leaves — confirm delete?',
    hrBulkLeaveActionDone: 'Bulk action completed.',
    menuBulkSelected: '{n} items selected',
    menuBulkActivate: 'Activate',
    menuBulkDeactivate: 'Deactivate',
    menuBulkChangeCategory: 'Bulk Change Category',
    menuBulkDelete: 'Delete',
    menuBulkClear: 'Clear',
    menuBulkDeleteConfirm: '{n} items will be deleted. Are you sure?',
    poBulkSelected: '{n} POs selected',
    poBulkReceive: 'Receive All',
    poBulkCancel: 'Cancel All',
    poBulkDelete: 'Bulk Delete',
    poBulkClear: 'Clear Selection',
    poBulkReceiveConfirm: 'Receive selected POs?',
    poBulkCancelConfirm: 'Cancel selected POs?',
    poBulkDeleteConfirm: 'Delete selected POs?',
    poBulkNoneEligible: 'No eligible POs',
    poBulkSkipped: '{n} POs skipped (not eligible)',
    poBulkSelectAll: 'Select all',
    poBulkSelectRow: 'Select',
    poBulkBar: 'Bulk action',
    supBulkSelected: '{n} suppliers selected',
    supBulkActivate: 'Activate',
    supBulkDeactivate: 'Deactivate',
    supBulkDelete: 'Bulk Delete',
    supBulkClear: 'Clear Selection',
    supBulkSelectAll: 'Select all',
    supBulkSelectRow: 'Select',
    supBulkDeleteConfirm: '{n} suppliers will be deleted. Are you sure?',
    voucherSelectAll: 'Select all',
    voucherSelectOne: 'Select voucher',
    voucherSelectedCount: '{n} vouchers selected',
    voucherBulkVoid: 'Bulk Void',
    voucherBulkDelete: 'Bulk Delete',
    voucherClearSelection: 'Clear Selection',
    voucherBulkNoActive: 'No active vouchers selected',
    voucherBulkVoidConfirm: 'X vouchers will be voided. Confirm?',
    voucherBulkDeleteConfirm: 'X vouchers will be deleted. Confirm?',
    voucherBulkVoidDone: '{n} vouchers voided',
    voucherBulkDeleteDone: '{n} vouchers deleted',
    selectItem: 'Select',
    bulkActivate: 'Activate',
    bulkDeactivate: 'Deactivate',
    clearSelection: 'Clear Selection',
    recipesSelectedSuffix: 'recipes selected',
    confirmBulkDeleteRecipes: 'Delete selected recipes?',
    selectAllAria: 'Select all',
    selectRowAria: 'Select',
    bulkActionsAria: 'Bulk actions',
    refundsSelectedCount: '{n} refund(s) selected',
    refundsBulkCsv: 'Export selected CSV',
    refundsClearSelection: 'Clear selection',
    refundsSelectAll: 'Select all',
    cmdPaletteTitle: 'Command Palette',
    cmdPalettePlaceholder: 'Search commands...',
    cmdPaletteNoResults: 'No results',
    cmdPaletteHintNav: '↑↓ navigate, Enter select',
    cmdPaletteHintClose: 'Esc to close',
    cmdPaletteGroupPages: 'Pages',
    cmdPaletteGroupActions: 'Actions',
    cmdPaletteGroupTheme: 'Theme',
    cmdPaletteGroupLanguage: 'Language',
    cmdPaletteGoDashboard: 'Go to Dashboard',
    cmdPaletteGoTables: 'Tables',
    cmdPaletteGoOrders: 'Orders',
    cmdPaletteGoKitchen: 'Kitchen',
    cmdPaletteGoPOS: 'POS',
    cmdPaletteGoCustomers: 'Customers',
    cmdPaletteGoMenu: 'Menu',
    cmdPaletteGoStock: 'Stock',
    cmdPaletteGoReports: 'Reports',
    cmdPaletteGoSettings: 'Settings',
    cmdPaletteNewOrder: 'New Order',
    cmdPaletteNewCustomer: 'New Customer',
    cmdPaletteNewStaff: 'New Staff',
    cmdPaletteLogout: 'Logout',
    cmdPaletteThemeLight: 'Light Theme',
    cmdPaletteThemeDark: 'Dark Theme',
    cmdPaletteLangTR: 'Turkish',
    cmdPaletteLangEN: 'English',
    cmdPaletteLangAR: 'Arabic',
    shortcutCommandPalette: 'Command Palette',
    settingsBackupTitle: '💾 Auto Backup',
    settingsBackupDesc: 'Schedule database backups.',
    settingsBackupEnabled: 'Auto backup enabled',
    settingsBackupInterval: 'Backup Interval',
    settingsBackupManual: 'Manual',
    settingsBackupDaily: 'Daily',
    settingsBackupWeekly: 'Weekly',
    settingsBackupMonthly: 'Monthly',
    settingsBackupTime: 'Time',
    settingsBackupLast: 'Last Backup',
    settingsBackupRunNow: '💾 Backup Now',
    settingsBackupRunning: 'Backing up…',
    settingsBackupDone: 'Backup completed',
    settingsBackupAria: 'Toggle auto backup config',
    refreshLabel: 'Refresh',
    refreshTooltip: 'Auto refresh',
    refreshManual: 'Manual',
    refresh30s: '30 seconds',
    refresh1m: '1 minute',
    refresh5m: '5 minutes',
    hrTotalEntitlement: 'Total Entitlement',
    hrTotalUsed: 'Used',
    hrTotalRemaining: 'Remaining',
    hrPerEmployeeUsage: 'Per-Employee Usage',
    cdActivityTitle: '30-Day Activity',
    cdActivitySummary: 'Last 30 days: {orders} orders, {spent} spent, avg {avg}/day',
    cdActivityOrders: 'orders',
    posFavorites: 'Favorites',
    posFavoritesEmpty: 'No favorites yet. Tap ★ on a product.',
    posFavoritesShowAll: 'Show all',
    posFavorite: 'Add to favorites',
    posUnfavorite: 'Remove from favorites',
    stockScanBarcode: 'Scan Barcode',
    stockBarcode: 'Barcode',
    stockBarcodeInput: 'Barcode (auto or manual)',
    stockBarcodePlaceholder: 'Use scanner or type code + Enter',
    stockBarcodeNotFound: 'Barcode not matched: {code}',
    stockBarcodeCreateNew: 'Create New Ingredient',
    stockBarcodeQuickAdd: '+ Add Stock',
    stockBarcodeWaiting: 'Waiting for scan...',
    stockBarcodeScanCount: 'Scans: {n}',
    stockBarcodeAdded: '✓ {name} +{d} {unit}',
    stockBarcodeReason: 'Barcode scan',
    savedFiltersLabel: '⭐ Saved Filters',
    savedFiltersEmpty: 'No saved filters yet',
    savedFiltersSaveBtn: 'Save Filter',
    savedFiltersPromptName: 'Filter name:',
    savedFiltersDelete: 'Delete',
    hrPayrollTimeline12m: '12-Month Payroll Timeline',
    hrPayrollTimeline12mTotal: '12-month total',
    hrPayrollTimeline12mAvg: 'avg',
    hrPayrollTimeline12mPerMonth: 'month',
    customersFindDuplicates: '🔍 Find Duplicates',
    customersDupTitle: 'Duplicate Customers',
    customersDupSubtitle: '{n} potential groups found (phone/name match)',
    customersDupEmpty: 'No duplicates found.',
    customersDupGroupLabel: 'Group {i} · {n} customers',
    customersDupMerge: 'Merge',
    customersDupPickFields: 'Which field to keep?',
    customersDupPrimary: 'Primary record:',
    customersDupConfirmMerge: 'Confirm & Merge',
    customersDupMergeSuccess: '{n} customers merged.',
    customersDupMergeFailed: 'Merge failed.',
    menuCatReorderHint: 'Drag to reorder categories',
    categoryChipDragHint: '{name} — drag to reorder',
    dragToReorder: 'drag to reorder',
    dashRecentActivity: 'Recent Activity',
    feedSystem: 'System',
    feedOrderCreated: 'Order',
    whiteLabelActiveTheme: 'Active Theme',
    whiteLabelLogoStatus: 'Logo Status',
    whiteLabelBrandName: 'Brand Name',
    whiteLabelThemeDefault: 'Default',
    whiteLabelThemeCustom: 'Custom',
    whiteLabelThemeNone: 'Not configured',
    whiteLabelLogoLoaded: 'Loaded',
    whiteLabelLogoMissing: 'Missing',
    whiteLabelBrandUnnamed: 'Unnamed',
    whiteLabelPreviewRefreshed: 'Preview refreshed',
    gdprStatApproved: 'Approved',
    gdprStatExpired: 'Expired',
    chainReportsStatBranchCount: 'Total Branches',
    chainReportsStatTotalOrders: 'Total Orders',
    chainReportsStatTotalRevenue: 'Total Revenue',
    chainReportsStatActiveBranches: 'Active Branches',
    chainReportsDatePresetGroup: 'Date presets',
    superadminRestaurantsStatTotal: 'Total Restaurants',
    superadminRestaurantsStatActive: 'Active',
    superadminRestaurantsStatPassive: 'Inactive',
    superadminRestaurantsStatNewThisMonth: 'New This Month',
    saasSubStatTotal: 'Total Subscriptions',
    saasSubStatActive: 'Active',
    saasSubStatTrial: 'Trial',
    saasSubStatTroubled: 'Cancelled/Pending',
    navGroupOperations: 'Operations',
    navGroupCommerce: 'Commerce & Finance',
    navGroupStaff: 'Staff',
    navGroupPosAdmin: 'POS Management',
    nav_posProducts: 'Product Management',
    nav_posReports: 'Reports',
    nav_posReceiptSettings: 'Receipt Settings',
    // ── PosProducts ──
    posProductsLoadError: 'Failed to load products',
    posProductsBulkDeleteConfirm: '{n} products will be deleted. Are you sure?',
    posProductsBulkDeleteDone: '{n} products deleted',
    posProductsNameRequired: 'Product name is required',
    posProductsPriceInvalid: 'Enter a valid price',
    posProductsUpdated: 'Product updated',
    posProductsCreated: 'Product added',
    posProductsDeleteConfirm: '"{name}" will be deleted. Are you sure?',
    posProductsDeleted: 'Product deleted',
    posProductsImportNoSelection: 'Select a product first',
    posProductsImportResult: '{n} products imported',
    posProductsImportSkipped: '{n} skipped',
    posProductsUnlimited: 'Unlimited',
    posProductsLowStockBadge: 'Low stock',
    posProductsTitle: 'POS — Product Management',
    posProductsSubtitle: 'Manage POS sales products',
    posProductsAdd: 'New Product',
    posProductsImportFromMenu: 'Import from Menu',
    posProductsExportExcel: 'Download Excel',
    posProductsImportExcel: 'Upload Excel',
    posProductsStatTotal: 'Total Products',
    posProductsStatActive: 'Active Products',
    posProductsStatInStock: 'In Stock',
    posProductsStatLowStock: 'Low Stock',
    posProductsSearchPlaceholder: 'Search by name or barcode...',
    posProductsCategoryFilter: 'Category filter',
    posProductsAllCategories: 'All Categories',
    posProductsNoCategory: '— No Category —',
    posProductsActiveFilterAria: 'Active/inactive filter',
    posProductsActiveFilterAll: 'All',
    posProductsActiveFilterActive: 'Visible on POS',
    posProductsActiveFilterInactive: 'Inactive',
    posProductsActiveHint: 'Only "Visible on POS" products appear on the /pos terminal.',
    posProductsSortAria: 'Sort',
    posProductsColName: 'Name',
    posProductsColPrice: 'Price',
    posProductsColStock: 'Stock',
    posProductsBulkSelected: '{n} products selected',
    posProductsBulkDelete: 'Bulk Delete',
    posProductsEmptyTitle: 'No products yet',
    posProductsColImage: 'Image',
    posProductsColBarcode: 'Barcode',
    posProductsColCategory: 'Category',
    posProductsColTax: 'VAT %',
    posProductsColMenuLink: 'Menu Linked',
    posProductsColActive: 'Active',
    posProductsColActions: 'Actions',
    posProductsMenuLinkedBadge: 'Linked to menu',
    posProductsToggleDeactivate: 'Deactivate',
    posProductsToggleActivate: 'Activate',
    posProductsEditAria: 'Edit product "{name}"',
    posProductsDeleteAria: 'Delete product "{name}"',
    posProductsModalEditTitle: 'Edit Product',
    posProductsModalAddTitle: 'New Product',
    posProductsStockHint: 'empty = unlimited',
    posProductsColImageUrl: 'Image URL',
    posProductsMenuItemId: 'Menu Item ID',
    posProductsImportFromMenuTitle: 'Import from Menu to POS',
    posProductsMenuEmptyTitle: 'No products in menu',
    posProductsMenuEmptyDesc: 'Add products to the menu first.',
    posProductsMenuAllImportedTitle: 'All menu products are already on POS',
    posProductsMenuAllImportedDesc: 'All menu products have been imported to POS.',
    posProductsMenuSelectedCount: '{n} / {total} selected',
    posProductsMenuAlreadyAddedBadge: 'Added',
    posProductsImportConfirm: 'Import',
    // ── PosReports ──
    posReportsExportExcel: '📊 Download CSV',
    posReportsCloseSession: 'Close Register & Z-Report',
    posReportsClosingCashConfirm: 'A Z-report will be generated after closing the register. Continue?',
    posReportsClosingCashLabel: 'Closing Cash (₺)',
    product: 'Product',
    qty: 'Qty',
    posReportsNoItems: 'No item details for this sale.',
    paymentMethod: 'Payment',
    posReportsPrintReceipt: '🖨️ Reprint Receipt',
    posReportsTabInstant: 'Instant Report',
    posReportsTabSales: 'Sales History',
    posReportsTabZ: 'Z Reports',
    posReportsSessionLoadFailed: 'Could not load session info.',
    posReportsSalesLoadFailed: 'Could not load sales.',
    posReportsColMetric: 'Metric',
    posReportsSaleDetailFailed: 'Could not load sale details.',
    posReportsColDate: 'Date',
    posReportsColReceipt: 'Receipt No',
    posReportsColCashier: 'Cashier',
    posReportsColItems: 'Products',
    posReportsColPayment: 'Payment',
    posReportsColTotal: 'Total',
    posReportsTitle: 'POS — Reports',
    posReportsSubtitle: 'Sales reports, X/Z reports, daily breakdowns.',
    posReportsNoSession: 'No open POS session',
    posReportsNoSessionDesc: 'You must open the register first to generate X/Z reports.',
    posReportsGoToPos: 'Go to POS',
    posReportsActiveSession: 'Open Session',
    posReportsXTitle: 'X-Report (Mid-Day)',
    posReportsXDesc: 'Live sales summary for the open session. Session stays open.',
    posReportsGenerateX: '⚡ Generate Now',
    posReportsZTitle: 'Z-Report (End of Day)',
    posReportsZDesc: 'Closes the register and generates a Z-report. This action is irreversible.',
    posReportsStatSales: 'Sales',
    posReportsStatRevenue: 'Revenue',
    posReportsStatAvg: 'Avg. Cart',
    posReportsStatToday: 'Today',
    posReportsDatePresets: 'Date presets',
    from: 'From',
    to: 'To',
    posPaySplit: 'Split',
    posReportsSearchPlaceholder: 'Receipt no or customer...',
    posReportsResultCount: 'Results',
    posReportsNoSales: 'No sales found',
    posReportsNoSalesDesc: 'No sales recorded in the selected period. Change the date range or filters.',
    posReportsViewDetail: 'View detail',
    posReportsZComingSoon: 'Z Report List — Coming Soon',
    posReportsZComingSoonDesc: 'Z reports are generated automatically when each session is closed. For a list of past Z reports, contact your administrator.',
    posReportsViewSales: 'Sales History',
    // ── PosReceiptSettings ──
    posReceiptNoPrinterSelected: 'Select a default printer first.',
    posReceiptTestPrintSent: 'Test receipt sent to printer.',
    posReceiptTestPrintFailed: 'Failed to send test receipt.',
    posReceiptSettingsTitle: 'POS — Receipt Settings',
    posReceiptSettingsSubtitle: 'Manage information shown on receipts and printer settings.',
    posReceiptSectionInfo: 'Restaurant Info',
    posReceiptInfoHint: 'This information appears automatically in the receipt header.',
    posReceiptTaxNumber: 'Tax Number',
    posReceiptLogoUrl: 'Logo URL',
    posReceiptComingSoon: 'Coming soon',
    posReceiptLogoHint: 'ESC/POS bitmap rendering will be added for thermal printer logo support.',
    posReceiptSectionCustomize: 'Receipt Customization',
    posReceiptHeaderText: 'Receipt Header Text',
    posReceiptHeaderPh: 'Welcome!',
    posReceiptFooterText: 'Receipt Footer Text',
    posReceiptFooterPh: 'See you again!',
    posReceiptPaperWidth: 'Paper Width',
    posReceiptPaperWidthHint: 'For per-printer custom width, configure it from printer management.',
    posReceiptTaxDisplay: 'VAT Display',
    posReceiptAutoPrint: 'Auto Print',
    posReceiptAutoPrintHint: 'Automatically print the receipt from the default printer for every sale.',
    posReceiptSectionPrinter: 'Printer Settings',
    posReceiptDefaultPrinter: 'Default Receipt Printer',
    posReceiptNoPrinter: '— Not selected —',
    posReceiptNoPrintersConfigured: 'No printers configured yet.',
    posReceiptManagePrinters: 'Manage Printer List',
    posReceiptTestPrint: 'Print Test Receipt',
    posReceiptPreview: 'Preview',
    // ── POS admin navigation (Tur 290 polish) ──
    posAdminNavLabel: 'POS admin navigation',
    posAdminToolsLabel: 'Admin',
    posAdminProducts: 'Product Management',
    posAdminReports: 'Reports',
    posAdminReceipt: 'Receipt Settings',
    posAdminBackToTerminal: '← POS Terminal',
    posProductsActiveHintCreate: 'New products are added as active automatically; you can hide them later from the edit screen.',
    posProductsActiveHintEdit: 'When active, the product appears on the /pos terminal and can be sold.',
    posReportsZListTitle: 'Z Report history',
    posReportsZListInfo: 'A Z report is automatically generated whenever you close the cash register at end of day. History list of past Z reports is coming soon.',
    posReportsZGoInstant: 'Go to Instant Report',
    posReportsZGoSales: 'View Sales History',
    pageOptPosLabel: 'POS Terminal',
    pageOptPosDesc: 'Point-of-sale terminal',
    settingsBackupComingSoon: 'Manual backup API coming soon',
    settingsBackupComingSoonShort: 'soon',
    settingsTaxSgkAria: 'Toggle tax and SGK details',
    setTaxSgkSubtitle: 'Required fields for e-Bildirge / withholding tax declarations.',
    settingsTaxNumberPlaceholder: '10-digit VKN or 11-digit TCKN',
    settingsSgkPlaceholder: 'SGK e-Bildirge registration no',

    // ── Tur 291 polish keys (Customers/Notifications/PosReceipt/POS/CustomerDetail/Reservations) ──
    // General
    amount: 'Amount',
    savedSuccess: 'Saved',
    table: 'Table',
    tags: 'Tags',
    totalSpent: 'Total Spent',
    visitCount: 'Visits',
    guestName: 'Guest',
    loyaltyPoints: 'Points',
    reservationDate: 'Date',
    notifications: 'Notifications',
    clearDate: 'Clear Date',
    datePresetThisWeek: 'This Week',
    // Payment methods
    paymentCash: 'Cash',
    paymentCard: 'Card',
    paymentBank: 'Bank Transfer',
    paymentOther: 'Other',
    // POS
    posCategoriesLabel: 'Categories',
    posClearSearch: 'Clear search',
    posCustomerRemove: 'Remove customer',
    posPromoRemove: 'Remove promo code',
    posDeleteHeldOrder: 'Delete held order',
    posSaleNetworkFail: 'Connection error — your cart is preserved, please retry',
    posSessionLoadFailed: 'Could not load session — check your connection',
    // POS Receipt Settings
    posReceiptRestaurantName: 'Restaurant Name',
    posReceiptAddress: 'Address',
    posReceiptPhone: 'Phone',
    posReceiptSaveBtn: 'Save',
    posReceiptCancelBtn: 'Cancel',
    posReceiptSectionUpcoming: 'Coming Soon — Experimental Fields',
    posReceiptPreviewCashier: 'Cashier: Ahmet',
    posReceiptPreviewReceiptNo: 'RECEIPT #12345',
    posReceiptPreviewItem1: 'Meatballs',
    posReceiptPreviewItem2: 'Ayran',
    posReceiptPreviewItem3: 'Tzatziki',
    posReceiptPreviewPhoneLabel: 'Tel',
    posReceiptPreviewTaxNumLabel: 'Tax No',
    posReceiptPreviewSubtotal: 'Subtotal:',
    posReceiptPreviewVat: 'VAT (10%):',
    posReceiptPreviewTotal: 'TOTAL:',
    posReceiptPreviewVatIncluded: '(VAT included)',
    posReceiptPreviewNoFooter: '(No footer)',
    // Notifications
    notifWeeklySummaryTitle: 'Last 7 Days Summary',
    notifTotalLabel: 'Total',
    notifPeakLabel: 'Peak',
    notifBadgeRead: 'read',
    notifToday: 'Today',
    notifYesterday: 'Yesterday',
    notifDayBeforeYesterday: 'Day before yesterday',
    notifDaysAgoTmpl: '{n} days ago',
    // Customers — Debt/Payment
    customersAddDebtTitle: 'Add Debt',
    customersAddPaymentTitle: 'Receive Payment',
    customersAmountRequired: 'Amount is required (must be greater than 0).',
    customersDebtSaved: 'Debt entry added.',
    customersPaymentSaved: 'Payment entry added.',
    customersDebtDescLabel: 'Debt',
    customersDebtDescPlaceholder: 'e.g. March invoice',
    customersDebtDescPrefix: 'Customer',
    customersPaymentDescPlaceholder: 'e.g. Account closing',
    customersManualDebtNote: 'Manual debt entry',
    customersManualPaymentNote: 'Manual payment',
    customersAvatarUrlLabel: 'Avatar URL',
    customersCollectionLabel: 'Collection',
    customersSaveFailed: 'Could not save.',
    // Customers — Campaign
    customersCampaignTitle: 'Send Campaign',
    customersCampaignNameRequired: 'Please enter a campaign name.',
    customersCampaignBodyRequired: 'Please enter the message body.',
    customersCampaignSubjectRequired: 'Please enter the email subject.',
    customersCampaignConfirm: 'About to send {channel} to {n} recipients. Confirm?',
    customersCampaignSendBtn: 'Send to Recipients',
    customersCampaignSending: 'Sending…',
    customersCampaignSendFailed: 'Could not send.',
    customersCampaignEmailSentTmpl: '{sent}/{total} emails sent ({failed} failed).',
    customersCampaignWaCreatedTmpl: '{n} WhatsApp links created. Click each from the list to send.',
    customersCampaignWaOpenAll: 'Open All',
    customersCampaignWaReady: '{n} WhatsApp links are ready. Open each in a new tab (allow browser pop-ups):',
    customersCampaignWillSend: 'recipients will be sent',
    customersCampaignNoRecipient: 'No recipients found.',
    customersCampaignTipPrefix: 'Tip',
    customersCampaignTipBody: 'is replaced with each customer\'s name.',
    customersCampaignSamplePrefix: 'Example',
    customersCampaignMissingPrefix: 'customers missing',
    customersCampaignMissingSuffix: '',
    customersCampaignChannelEmail: 'email',
    customersCampaignChannelPhone: 'phone',
    customersCampaignChannelWhatsapp: 'WhatsApp link',
    // Customers — Segment
    custSegmentActive: '✅ Active',
    custSegmentLost: '😴 Lost',
    custSegmentLostRecovery: '😴 Lost (Recovery)',
    custSegmentLoyal: '🏆 Loyal',
    custSegmentNew: '🆕 New',
    custSegmentVip: '⭐ VIP',
    // CustomerDetail
    custDetailCustomerNote: 'Customer Note',
    custDetailGoToCustomers: 'Go to Customers',
    custDetailLedgerHint: 'Open the ledger modal from the Customers page for a detailed debt/payment breakdown.',
    custDetailNoNote: 'No notes added for this customer yet. You can edit it from the Customers page.',
    custDetailNoTags: 'No tags added.',
    custDetailTagsLabel: 'Tags',
    // ── Tur 292 polish keyleri ──
    actualEnd: 'Actual End',
    actualStart: 'Actual Start',
    cashTxFilterFrom: 'From',
    cashTxFilterTo: 'To',
    cashTxType: 'Type',
    chainBranchesEmptyAction: '+ New Branch',
    chainBranchesEmptyDesc: 'Add your first branch to start managing the chain.',
    chainBranchesNoResults: 'No results found',
    chainBranchesNoResultsDesc: 'Try changing the search criteria.',
    chainBranchesSearchPh: 'Search branch...',
    chainDashEmptyBranches: 'No branches yet',
    chainDashEmptyBranchesDesc: 'Once you add branches to your chain, activity data will appear here.',
    chainDashStatActiveOrders: 'Active Orders',
    chainDashStatTodayRevenue: 'Today\'s Revenue',
    chainDashStatTotalBranches: 'Total Branches',
    chainDashStatTotalStaff: 'Total Staff',
    chainDashStatTotalTables: 'Total Tables',
    chainMenuEmpty: 'No products yet',
    chainMenuEmptyAction: '+ New Product',
    chainMenuEmptyDesc: 'Define shared menu items across the chain here.',
    chainMenuNoResults: 'No results found',
    chainMenuNoResultsDesc: 'Try changing the search criteria.',
    chainMenuSearchPh: 'Search product...',
    costPerUnit: 'Unit Cost',
    customers: 'Customers',
    default: 'Default',
    endTime: 'End',
    foodCost: 'Cost',
    grossTotal: 'Gross',
    hour: 'Hour',
    hrIbanPlaceholder: 'TR...',
    hrLast7Days: 'Last 7 Days',
    hrLastMonth: 'Last Month',
    hrPdfA5Title: 'Download PDF (A5 landscape)',
    hrPdfFailed: 'Failed to generate PDF.',
    hrPdfReady: 'PDF downloaded.',
    hrPopupBlocked: 'Pop-up blocked. Please allow it to print.',
    hrPrintTitle: 'Print (new tab)',
    loginForgotPassword: 'Forgot my password',
    loginRememberMe: 'Remember me',
    margin: 'Margin',
    menuItemName: 'Product',
    minStock: 'Min',
    netTotal: 'Net',
    orderDate: 'Order Date',
    orders: 'Orders',
    overtimeMinutes: 'Overtime (min)',
    platformSearchPlaceholder: 'Search platform...',
    poSearchPlaceholder: 'Search order no/supplier...',
    posProductsBulkDeleteFailed: '{n} could not be deleted',
    posProductsImportFromMenuShort: 'Menu',
    posProductsStockInvalid: 'Enter a valid stock value',
    posProductsTaxInvalid: 'Enter a valid tax rate',
    posPromoVoucherInputPlaceholder: 'Promo / Voucher code',
    posReportsClosingCashInvalid: 'Enter a valid closing cash amount.',
    posReportsDateFromAria: 'Start date',
    posReportsDateRangeInvalid: 'Start date cannot be after end date.',
    posReportsDateToAria: 'End date',
    posVoucherCodePlaceholder: 'R-6-20260414-12',
    printerSerialPathPlaceholder: 'COM3 or /dev/ttyUSB0',
    promoCodeSamplePlaceholder: 'SUMMER20',
    promoQrAria: 'QR Code',
    promoQrTitle: 'QR Code',
    qrmenuAdd: '+',
    qrmenuDecrement: 'Decrease by one',
    qrmenuIncrement: 'Add one more',
    receivedDate: 'Received Date',
    restaurantDetailEmptyUsers: 'No users yet',
    restaurantDetailEmptyUsersDesc: 'This restaurant\'s user records have not been added yet.',
    rptSegActive30d: 'Active (Last 30d)',
    rptSegAnon: 'Anonymous',
    rptSegAvgPerCustomer: 'Average per Customer',
    rptSegCustomerWord: 'customers',
    rptSegEmpty: 'No customers',
    rptSegLoadFailed: 'Failed to load segmentation report.',
    rptSegLostDesc: 'Last order over 90 days ago',
    rptSegLostHint: 'Hasn\'t shopped for 90 days. To send a recovery campaign, filter the Lost segment on the Customer page.',
    rptSegLostLabel: '😴 Lost',
    rptSegLoyalDesc: '10 or more orders',
    rptSegLoyalLabel: '🏆 Loyal',
    rptSegNewDesc: 'Registered in the last 30 days',
    rptSegNewLabel: '🆕 New',
    rptSegTotalCustomers: 'Total Customers',
    rptSegTotalLabel: 'Total',
    rptSegTotalRevenue: 'Total Revenue',
    rptSegVipDesc: 'Total spend ≥ 5,000 ₺ or VIP tagged',
    rptSegVipLabel: '⭐ VIP',
    rptTabSegmentation: '🎯 Segmentation',
    searchPlaceholder: 'Search recipe',
    settingsBackupAutoDesc: 'Database is automatically backed up every night at 03:00. Contact your system administrator for a manual backup.',
    settingsBackupAutoTitle: 'Automatic Backup Active',
    settingsBackupRequestManual: 'Request manual backup',
    settingsBackupRequestSent: 'Your manual backup request has been received. The system administrator will contact you shortly.',
    shiftsStaffSearchPlaceholder: 'Search staff...',
    staff: 'Staff',
    startTime: 'Start',
    stockAdjustmentsSearchPlaceholder: 'Search ingredient/reason...',
    subStatActive: 'Active Subscription',
    subStatCancelled: 'Cancelled',
    subStatMonthlyRevenue: 'Total Monthly Revenue',
    subStatRenewingSoon: 'Renewing Soon',
    subStatRenewingSoonSub: 'Within 7 days',
    subscriptionMonthlyAmount: 'Monthly Amount',
    superDashStatActiveSubs: 'Active Subscriptions',
    superDashStatMonthlyMRR: 'Monthly MRR',
    superDashStatTotalRestaurants: 'Total Restaurants',
    superDashStatTotalUsers: 'Total Users',
    superadminDashEmptyRestaurants: 'No restaurants yet',
    superadminDashEmptyRestaurantsDesc: 'Restaurants will appear here once they register via restaflex.com.',
    superadminPlansDescPh: 'Plan description...',
    superadminPlansEmpty: 'No plans yet',
    superadminPlansEmptyAction: '+ New Plan',
    superadminPlansEmptyDesc: 'Create your first SaaS plan to start subscription offerings.',
    superadminPlansNamePh: 'e.g. Starter, Pro, Enterprise',
    superadminPlansNoResults: 'No results found',
    superadminPlansNoResultsDesc: 'Try changing the search criteria.',
    superadminPlansSearchPh: 'Search plan...',
    superadminRestaurantsCreatedTitle: 'Restaurant Created',
    superadminRestaurantsEmpty: 'No restaurants yet',
    superadminRestaurantsEmptyDesc: 'Restaurants will appear here once they register via restaflex.com.',
    superadminRestaurantsNoResults: 'No results found',
    superadminRestaurantsNoResultsDesc: 'Try changing the search criteria.',
    superadminRestaurantsSearchPh: 'Search restaurant...',
    superadminSubsEmpty: 'No subscriptions yet',
    superadminSubsEmptyDesc: 'Subscriptions will appear here once restaurants switch to a plan.',
    superadminSubsNoResults: 'No results found',
    superadminSubsNoResultsDesc: 'Try changing the filter or search criteria.',
    superadminSubsSearchPh: 'Search restaurant...',
    supplier: 'Supplier',
    supplierAddress: 'Address',
    supplierContact: 'Contact Person',
    tag: 'Tag',
    userRole: 'Role',
    vouchersQrAria: 'QR Code',
    vouchersQrCodePlaceholder: 'GV-XXXXXXXX',
    vouchersTitle: 'QR Code',
    waiterStatsSearchPlaceholder: 'Search waiter...',

    // ── Tur 293-294 polish keys ──
    // Chain & branch placeholders
    chainBranchesAdminEmailPh: 'manager@example.com',
    chainBranchesAdminNamePh: 'Full Name',
    chainBranchesEmailPh: 'branch@example.com',
    chainBranchesPhonePh: '05xx xxx xx xx',
    // Dashboard documents & top waiter
    dashDocExpired: 'Expired',
    dashDocMore: 'more documents…',
    dashTopWaiterTitle: 'Today\'s Star Staff',
    // General UI
    deleting: 'Deleting...',
    ok: 'OK',
    langSwitchTo: 'Switch language to',
    // Error boundary & 404
    errorBoundaryDesc: 'This page encountered an unexpected error. You can try again or return to the home page.',
    errorBoundaryGoHome: 'Home',
    errorBoundaryRefresh: 'Refresh',
    errorBoundaryTitle: 'Something Went Wrong',
    notFoundDesc: 'The page you are looking for may have been removed, moved or never existed.',
    notFoundGoBack: '← Go back',
    notFoundGoHome: '🏠 Home',
    notFoundTitle: 'Page not found',
    // Feature gate
    featureGateChoosePlan: 'Choose plan',
    featureGateInlineUpgrade: 'Upgrade plan',
    featureGateNoSubDesc: 'You need to choose a plan to use this feature.',
    featureGateSeeAllPlans: 'See all plans',
    featureGateUpgradeDesc: 'This feature is not included in your current plan. Upgrade your plan for more.',
    featureGateUpgradePlan: 'Upgrade plan',
    // Feature names
    featureNameAdvancedAnalytics: 'Advanced Analytics',
    featureNameKitchenDisplay: 'Kitchen Display',
    featureNameQrMenu: 'QR Menu',
    featureNameRecipeSystem: 'Recipe System',
    featureNameStockManagement: 'Stock Management',
    featureNameWaiterManagement: 'Waiter Management',
    // HR toasts & validation
    hrBankFileDownloaded: 'Bank transfer file downloaded.',
    hrCsvDownloaded: 'CSV downloaded.',
    hrDocumentAdded: 'Document added.',
    hrDocumentDeleteConfirm: 'Are you sure you want to delete this document?',
    hrDocumentDeleted: 'Document deleted.',
    hrDocumentEmployeeRequired: 'Please select a staff member.',
    hrDocumentTitleRequired: 'Please enter a document title.',
    hrEmployeeAdded: 'Staff member added.',
    hrEmployeeDeleted: 'Staff member deleted.',
    hrEmployeeUpdated: 'Staff member updated.',
    hrImportFormatHintDate: 'Date format:',
    hrImportFormatHintSeparator: 'Separator: semicolon (;) or comma (,). UTF-8.',
    hrImportFormatHintType: 'Employment type:',
    hrLeaveApproved: 'Leave approved.',
    hrLeaveCreated: 'Leave request created.',
    hrLeaveDateRangeRequired: 'Please enter a date range.',
    hrLeaveDeleted: 'Leave deleted.',
    hrLeaveEmployeeRequired: 'Please select a staff member.',
    hrLeaveEndBeforeStart: 'End date cannot be before start date.',
    hrLeaveRejected: 'Leave rejected.',
    hrMuhtasarPdfDownloaded: 'Withholding tax PDF downloaded.',
    hrPayrollApproved: 'Payroll approved.',
    hrPayrollBulkComputed: 'Bulk computation completed.',
    hrPayrollDeclaration: 'I declare that I have received the amount in this payroll in full.',
    hrPayrollEmployeeRequired: 'Please select a staff member.',
    hrPayrollEmpty: 'No payroll.',
    hrPayrollMarkedPaid: 'Marked as paid.',
    hrPayrollNetTargetRequired: 'Please enter a net target.',
    hrPayrollSaved: 'Payroll saved.',
    hrSalaryRequired: 'Please enter a gross salary.',
    hrSgkPdfDownloaded: 'SGK declaration PDF downloaded.',
    hrTcInvalid: 'National ID must be 11 digits.',
    // Order statuses
    orderStatusPreparing: 'Preparing',
    orderStatusReady: 'Ready',
    orderStatusServed: 'Served',
    // Yearly trend / net profit
    reportsDeltaDecrease: 'decrease',
    reportsDeltaIncrease: 'increase',
    reportsNetProfitDelta: 'Net Profit Change',
    reportsYearlyEmptyDesc: 'Monthly breakdown — will be activated automatically once the backend endpoint is ready.',
    reportsYearlyEmptyTitle: 'No data available for the yearly trend chart.',
    reportsYearlyPrevYear: 'Last year',
    reportsYearlyRevenueLabel: 'Revenue (Total Income)',
    reportsYearlyThisYear: 'This year',
    // Restaurant detail (superadmin)
    restaurantDetailColEmail: 'Email',
    restaurantDetailColName: 'Name',
    restaurantDetailColRegistered: 'Registered',
    restaurantDetailColRole: 'Role',
    restaurantDetailOccupiedTables: 'Occupied Tables',
    restaurantDetailTableCount: 'Table Count',
    restaurantDetailTodayOrderStatus: 'Today\'s Order Status',
    restaurantDetailTotalTables: 'Total Tables',
    restaurantDetailUserCount: 'User Count',
    restaurantDetailUsers: 'Users',
    // Sidebar & impersonation & subscription
    sidebarChainImpersonationBanner: 'Under Chain Management',
    sidebarChainReturnToPanel: 'Return to Chain Panel',
    subStatusTrial: 'Trial',
    // Superadmin Dashboard
    superadminDashActiveRest: 'Active Restaurant',
    superadminDashActiveSubLbl: 'Active Subscription',
    superadminDashAddRestaurant: 'Add Restaurant',
    superadminDashColPlan: 'Plan',
    superadminDashColRestaurant: 'Restaurant',
    superadminDashColStatus: 'Status',
    superadminDashColTodayOrders: 'Today Orders',
    superadminDashColTodayRevenue: 'Today Revenue',
    superadminDashDetail: 'Detail',
    superadminDashMrr: 'MRR',
    superadminDashMrrSub: 'Monthly Recurring Revenue',
    superadminDashPayingRest: 'Paying restaurant',
    superadminDashRestaurantStats: 'Restaurant Statistics',
    superadminDashRestaurants: 'Restaurants',
    superadminDashSaasMetrics: 'SaaS Metrics',
    superadminDashThisMonthRev: 'This Month Revenue',
    superadminDashThisMonthRevSub: 'Total collections this month',
    superadminDashTodayTotalRev: 'Today\'s Total Revenue',
    superadminDashTotalRest: 'Total Restaurants',
    superadminDashTrialLbl: 'Trial',
    superadminDashTrialUserSub: 'Free trial user',
    superadminLoadFailed: 'Failed to load data.',
    // Superadmin Plans
    superadminPlansColActions: 'Actions',
    superadminPlansColMonthly: 'Monthly',
    superadminPlansColPlan: 'Plan',
    superadminPlansColStatus: 'Status',
    superadminPlansColSubs: 'Subscriptions',
    superadminPlansColTables: 'Tables',
    superadminPlansColUsers: 'Users',
    superadminPlansColYearly: 'Yearly',
    superadminPlansCreateTitle: 'Create New Plan',
    superadminPlansEditTitle: 'Edit Plan',
    superadminPlansFeatures: 'features',
    superadminPlansFieldActive: 'Plan Active',
    superadminPlansFieldDesc: 'Description',
    superadminPlansFieldFeatures: 'Features',
    superadminPlansFieldMaxTables: 'Max Tables',
    superadminPlansFieldMaxUsers: 'Max Users',
    superadminPlansFieldMonthly: 'Monthly Price (₺)',
    superadminPlansFieldName: 'Plan name',
    superadminPlansFieldYearly: 'Yearly Price (₺)',
    superadminPlansLoadFailed: 'Failed to load plans.',
    superadminPlansNewPlan: 'New Plan',
    superadminPlansStatMonthlyTotal: 'Total Monthly Price',
    superadminPlansStatTotal: 'Total Plans',
    superadminPlansSubtitle: 'Manage subscription plans',
    superadminPlansTitle: 'SaaS Plans',
    // Superadmin Restaurants
    superadminRestaurantDeleteConfirm: 'Are you sure you want to delete this restaurant and all its data?',
    superadminRestaurantNameSlugRequired: 'Name and slug are required.',
    superadminRestaurantsActivate: 'Activate',
    superadminRestaurantsAdd: 'Add Restaurant',
    superadminRestaurantsAddTitle: 'Add New Restaurant',
    superadminRestaurantsCredsEmail: 'Email:',
    superadminRestaurantsCredsIntro: 'Restaurant created successfully. Admin login credentials:',
    superadminRestaurantsCredsPassword: 'Password:',
    superadminRestaurantsCredsWarn: 'Remember to share these credentials with the restaurant admin.',
    superadminRestaurantsDeactivate: 'Deactivate',
    superadminRestaurantsDetail: 'Detail',
    superadminRestaurantsEditTitle: 'Edit Restaurant',
    superadminRestaurantsFieldAdminPwd: 'Admin Password (empty = admin123)',
    superadminRestaurantsFieldEmail: 'Email',
    superadminRestaurantsFieldName: 'Restaurant Name',
    superadminRestaurantsFieldOwner: 'Owner Name',
    superadminRestaurantsFieldPhone: 'Phone',
    superadminRestaurantsFieldPlan: 'Plan',
    superadminRestaurantsFieldSlug: 'Slug * (URL identifier)',
    superadminRestaurantsLoadFailed: 'Failed to load restaurants.',
    superadminRestaurantsTablesLbl: 'tables',
    superadminRestaurantsTitle: 'Restaurants',
    superadminRestaurantsUsersLbl: 'users',
    superadminStatusUpdateFailed: 'Failed to update status.',
    // Superadmin Subscriptions
    superadminSubsActivate: 'Activate',
    superadminSubsActiveLbl: 'Active',
    superadminSubsActiveSub: 'Active subscription',
    superadminSubsCancelledLbl: 'Cancelled',
    superadminSubsCancelledSub: 'Cancelled',
    superadminSubsColAction: 'Action',
    superadminSubsColAmount: 'Amount',
    superadminSubsColEndDate: 'End Date',
    superadminSubsColPeriod: 'Period',
    superadminSubsColPlan: 'Plan',
    superadminSubsColRestaurant: 'Restaurant',
    superadminSubsColStatus: 'Status',
    superadminSubsCycleMonthly: 'Monthly',
    superadminSubsCycleYearly: 'Yearly',
    superadminSubsDaysLeft: 'days left',
    superadminSubsEnded: 'Ended',
    superadminSubsEndsToday: 'Ends today',
    superadminSubsMrr: 'MRR',
    superadminSubsMrrSub: 'Monthly Recurring Revenue',
    superadminSubsRecordsShowing: 'records showing',
    superadminSubsSubtitle: 'View and manage all restaurant subscriptions',
    superadminSubsTabActive: 'Active',
    superadminSubsTabAll: 'All',
    superadminSubsTabCancelled: 'Cancelled',
    superadminSubsTabExpired: 'Expired',
    superadminSubsTabPastDue: 'Past Due',
    superadminSubsTabTrial: 'Trial',
    superadminSubsThisMonthLbl: 'This Month',
    superadminSubsThisMonthSub: 'Collections this month',
    superadminSubsTitle: 'Subscriptions',
    superadminSubsTrialLbl: 'Trial',
    superadminSubsTrialSub: 'Free trial',

    // ── Tour 296-297 polish keys ──
    addFailed: 'Could not add.',
    approveFailed: 'Could not approve.',
    clearDateFilter: 'Clear Date',
    createFailed: 'Could not create.',
    hrAssignFailed: 'Could not assign.',
    hrBulkCalculationFailed: 'Bulk calculation error.',
    hrCalculationFailed: 'Calculation error.',
    hrDocumentsLoadFailed: 'Could not load documents.',
    hrEmployeesLoadFailed: 'Could not load employees.',
    hrImportFailed: 'Could not import.',
    hrLeavesLoadFailed: 'Could not load leaves.',
    hrMarkFailed: 'Could not mark.',
    hrPayrollsLoadFailed: 'Could not load payrolls.',
    hrSeveranceFailed: 'Could not calculate severance.',
    loginEmailPh: 'example@restaurant.com',
    offlineBannerOffline: 'Connection lost — changes may be lost, please check your network.',
    offlineBannerReconnected: 'Connection reestablished.',
    onboardingGoToDashboard: 'Go to Dashboard',

    // ── Tur 298 sprint keyleri ──
    paginationPrev: '← Previous',
    paginationNext: 'Next →',
    paginationPageOf: 'Page {page} of {total}',
    paginationAria: 'Pagination',
    serverErrorTitle: 'Server error',
    serverErrorDesc: 'There was a temporary issue. Please try again or contact your administrator.',
    serverErrorRetry: '🔄 Retry',
    serverErrorDetails: 'Error details (developer)',
    forbiddenTitle: 'Access denied',
    forbiddenDesc: "You don't have permission to view this page. Please contact your administrator.",
    forbiddenCurrentRole: 'Your current role',
    posCartRestoredBadge: '🔄 Previous cart restored',
    dashWidgetEditBtn: '⚙️ Customize',
    dashWidgetEditTitle: 'Customize widgets',
    dashWidgetEditDesc: 'Toggle widgets you want to hide',
    dashWidgetSaveBtn: 'Save',
    dashWidgetReset: 'Reset to default',
    chainReportsPrintAria: 'Print chain report',
    hrPrintAria: 'Print payroll',
    shiftPrintAria: 'Print shift',
    // ── Tur 299 sprint keys ──
    posReceiptSectionDisplay: '📺 Customer Display (POS Display)',
    posReceiptDisplayAdUrlsLabel: 'Promotion Images (URL list)',
    posReceiptDisplayAdUrlsPlaceholder: 'https://example.com/promo1.jpg\nhttps://example.com/promo2.jpg',
    posReceiptDisplayAdUrlsHelp: 'Promotion images shown on the POS Display customer screen while idle (when the cart is empty). If multiple URLs are added, they rotate automatically every 8 seconds (carousel).',
    posReceiptDisplayAdPreviewTitle: 'Preview',
    posReceiptDisplayAdRemove: 'Remove',
    posReceiptDisplayAdInvalidUrl: 'Invalid URL',
    posReportsZStatTotal: 'Total Z Reports',
    posReportsZStatRevenue: 'Total Revenue',
    posReportsZStatAvg: 'Average Z',
    posReportsZStatThisWeek: 'This Week',
    posReportsZColZNo: 'Z No',
    posReportsZColCashier: 'Cashier',
    posReportsZColSales: 'Sales',
    posReportsZEmpty: 'No Z reports yet',
    posReportsZEmptyDesc: 'A Z report is generated automatically when you close an open POS session.',
    posReportsZLoadFailed: 'Failed to load Z reports.',

    // Tour 301-304 — polish + i18n tail
    selectedCount: 'selected',
    chainStaffBulkPartial: 'operations failed',
    chainReportsSortGroup: 'Sort',
    tablesCustomerRemoveBtn: 'Remove',
    reportsStaffPerformanceToday: 'Staff Performance (Today)',
    reportsOrdersShort: 'orders',
    deliveryDatePresetLast7Days: 'Last 7 Days',
    deliveryDatePresetLast30Days: 'Last 30 Days',
    deliveryDatePresetThisMonth: 'This Month',
    deliveryDatePresetLastMonth: 'Last Month',
    usersPinHelpHint: '(4 digits — POS quick login, optional)',

    // Tour 305 — auth/superadmin i18n tail + empty states
    saasPlanNameRequired: 'Plan name is required.',
    saasPlanMonthlyPriceInvalid: 'Monthly price must be valid.',
    saasPlanUpdated: 'Plan updated.',
    saasPlanCreated: 'Plan created.',
    saasPlanDeleted: 'Plan deleted.',
    saasPlanDeleteConfirmTmpl: 'Are you sure you want to delete the "{name}" plan? This action cannot be undone.',
    saasSubActivateConfirmTmpl: 'Are you sure you want to manually activate the subscription for {name}?',
    saasSubActivated: 'Subscription activated.',
    saasSubActivateError: 'Could not activate.',
    prnNoJobsTitle: 'Print queue is empty',
    prnNoJobsDesc: 'No jobs sent to printers yet.',

    // Tour 306 — form validation + HR empty states
    formNameRequired: 'Name is required',
    formEmailInvalid: 'Enter a valid email',
    formPhoneInvalid: 'Enter a valid phone (min 7 digits)',
    userPinFourDigits: 'PIN must be 4 digits',
    hrEmptyEmployeesTitle: 'No employees yet',
    hrEmptyEmployeesDesc: 'Use "New Employee" to add your first employee.',
    hrEmptyLeavesDesc: 'Create a new leave request or clear filters.',
    hrEmptyDocumentsTitle: 'No documents found',
    hrEmptyDocumentsDesc: 'Upload a new document or clear filters.',

    // Tour 307 — promo/voucher form validation
    promoCodeRequired: 'Code is required',
    promoDiscountInvalid: 'Enter a valid discount value',
    voucherAmountInvalid: 'Enter a valid amount',

    // Tour 308 — deep i18n scan (HR + POS + saved filters)
    hrDocTypeKimlik: 'ID Photocopy',
    hrDocTypeIkametgah: 'Residence',
    hrDocTypeDiploma: 'Diploma',
    hrDocTypeSaglikRaporu: 'Health Report',
    hrDocTypeIsSozlesmesi: 'Employment Contract',
    hrDocTypeSgkBildirim: 'SSI Notification',
    hrDocTypeOther: 'Other',
    hrDocumentExpiryOptional: 'Expiry Date (optional)',
    hrLeaveTypeAnnual: 'Annual Leave',
    hrLeaveTypeSick: 'Sick',
    hrLeaveTypeMaternity: 'Maternity',
    hrLeaveTypePaternity: 'Paternity',
    hrLeaveTypeUnpaid: 'Unpaid',
    hrLeaveTypeOther: 'Other',
    hrEmployeeDeleteConfirm: 'Are you sure you want to delete employee "{name}"?',
    hrPayrollBulkCalcConfirm: 'Calculate payroll for all employees for {period}?',
    hrBulkLeaveAssignConfirm: 'Assign {days} days of {type} leave to {count} employees. Continue?',
    hrLeaveActionApprove: 'Approve',
    hrLeaveActionReject: 'Reject',
    hrLeaveActionDelete: 'Delete',
    hrLeaveActionConfirm: 'Are you sure you want to {action} this leave request?',
    hrPayslipDocType: 'PAYSLIP',
    hrPayslipPeriodLabel: 'Period',
    hrPayslipDocNoLabel: 'Doc No',
    hrPayslipGeneratedLabel: 'Generated',
    hrPayslipEarningsHeader: 'EARNINGS',
    hrPayslipOvertimeRow: '(+) Overtime (1.5x)',
    hrPayslipWeeklyHolidayRow: '(+) Weekly Holiday (1.5x)',
    hrPayslipPublicHolidayRow: '(+) Public Holiday (2x)',
    hrPayslipBonusRow: '(+) Bonus',
    hrPayslipGrossTotalRow: 'GROSS EARNINGS TOTAL',
    hrPayslipAllowancesHeader: 'ALLOWANCES (Tax-free, added to net)',
    hrPayslipAllowancesTotalRow: 'ALLOWANCES TOTAL',
    hrPayslipLegalDeductionsHeader: 'LEGAL DEDUCTIONS',
    hrPayslipSgkEmployeeRow: 'SSI Employee (14%)',
    hrPayslipUnemploymentEmployeeRow: 'Unemployment Employee (1%)',
    hrPayslipStampTaxRow: 'Stamp Tax (0.759%)',
    hrPayslipLegalDeductionsTotalRow: 'LEGAL DEDUCTIONS TOTAL',
    hrPayslipCustomDeductionsHeader: 'CUSTOM DEDUCTIONS',
    hrPayslipBesPaymentRow: 'Private Pension (BES)',
    hrPayslipCustomDeductionsTotalRow: 'CUSTOM DEDUCTIONS TOTAL',
    hrPayslipNetSalaryLabel: 'NET SALARY (Take-home)',
    hrPayslipSgkEmployerRow: 'SSI Employer (20.5%)',
    hrPayslipUnemploymentEmployerRow: 'Unemployment Employer (2%)',
    hrPayslipFootnote: 'This payslip is calculated in accordance with Labor Law and SSI regulations (2024). Minimum wage income tax and stamp tax exemption applied (Law 7349).',
    hrPayslipEmployerSignLabel: 'Employer Signature & Stamp',
    posRefundConfirm: 'Refund {receipt} — ₺{total}?',
    savedFiltersNameRequired: 'Filter name is required',
    savedFiltersSaved: 'Filter saved',

    // Tour 311 — PWA install prompt
    pwaInstallTitle: 'Install App',
    pwaInstallDesc: 'Add RestaFlex to your home screen — works offline, opens fast, full-screen experience.',
    pwaInstallBtn: 'Install',
    pwaInstallDismiss: 'Later',
    pwaInstalled: 'App installed',

    // Tour 312 — this week new HR modal i18n gaps
    hrEmploymentFullTime: 'Full-time',
    hrEmploymentPartTime: 'Part-time',
    hrEmploymentSeasonal: 'Seasonal',
    hrPayrollStatusDraft: 'Draft',
    hrPayrollStatusApproved: 'Approved',
    hrPayrollStatusPaid: 'Paid',
    hrProfilePhotoUrl: 'Profile Photo URL',
    reportsMonthLongList: 'January,February,March,April,May,June,July,August,September,October,November,December',
    posSalesHistoryLoadFailed: 'History could not load',
    posPrinterNotFound: 'Printer not found',

    // Tour 315 — keyboard shortcut + tooltip audit
    shortcutHelpAlt: 'Keyboard shortcuts',
    shortcutHr: 'HR',
    shortcutUsers: 'Users',
    shortcutReservations: 'Reservations',
    shortcutTrash: 'Trash',
    cmdPaletteGoHR: 'Go to HR',
    cmdPaletteGoUsers: 'Go to Users',
    cmdPaletteGoReservations: 'Go to Reservations',
    cmdPaletteGoTrash: 'Go to Trash',
    customerTagRemove: 'Remove tag',

    // Tour 316 — OKC Onboarding + Settings + POSTerminal + Errors (65 keys)
    // 1. Onboarding Wizard (30)
    okcOnboardingTitle: 'OKC Setup Wizard',
    okcOnboardingClose: 'Close',
    okcOnboardingNext: 'Next',
    okcOnboardingBack: 'Back',
    okcOnboardingSkip: 'Skip Wizard',
    okcOnboardingFinish: 'Finish',
    okcOnboardingStep1Title: 'Welcome',
    okcOnboardingStep1Desc: 'Welcome to RestaFlex Desktop. Let\'s set up your fiscal printer together.',
    okcOnboardingStep2Title: 'Authorized Service Check',
    okcOnboardingStep2Desc: 'Has your device been paired with this computer by an authorized service?',
    okcOnboardingStep2Yes: 'Yes, paired',
    okcOnboardingStep2No: 'No, not yet',
    okcOnboardingStep3Title: 'Connection Type',
    okcOnboardingStep3Usb: 'Via USB',
    okcOnboardingStep3Ethernet: 'Via Ethernet',
    okcOnboardingStep3WifiWarn: 'Wireless connection is not legal (Tax Authority).',
    okcOnboardingStep4Title: 'Device Discovery',
    okcOnboardingStep4Scan: 'Scan Devices',
    okcOnboardingStep4Scanning: 'Scanning...',
    okcOnboardingStep4Empty: 'No devices found. Add manually.',
    okcOnboardingStep4Manual: 'Add Manually',
    okcOnboardingStep5Title: 'Device Details',
    okcOnboardingStep5Vendor: 'Vendor',
    okcOnboardingStep5Model: 'Model',
    okcOnboardingStep5DeviceName: 'Device Name',
    okcOnboardingStep6Title: 'Pairing',
    okcOnboardingStep6Pairing: 'Pairing...',
    okcOnboardingStep6Success: 'Paired (AES-256 + HMAC-SHA256)',
    okcOnboardingStep7Title: 'Test Sale',
    okcOnboardingStep8Title: 'You\'re Ready!',
    // 2. Settings → Fiscal Printer (15)
    okcWizardStart: 'Start Wizard',
    okcWizardStartDesc: 'Step-by-step setup with the wizard.',
    okcDevicesTitle: 'Fiscal Devices',
    okcDevicesDesc: 'Manage all connected OKC devices.',
    okcAddDevice: '+ Add Device',
    okcNoDevices: 'No devices added yet',
    okcNoDevicesDesc: 'Start the wizard or add manually.',
    okcEditDevice: 'Edit',
    okcMakeActive: 'Set as default',
    okcTest: 'Test Connection',
    okcTestingConnection: 'Testing...',
    okcTestSuccess: 'Connection successful',
    okcTestFailed: 'Connection failed',
    okcDesktopOnly: 'Desktop only',
    okcDesktopOnlyDesc: 'This feature works in RestaFlex Desktop app.',
    // 3. POSTerminal Integration (10)
    posOkcEnabled: 'Fiscal Printer On',
    posOkcDisabled: 'Fiscal Printer Off',
    posOkcSaleSuccess: 'Sale complete — Receipt: {receiptNo}',
    posOkcFailed: 'Fiscal printer error',
    posOkcFallbackConfirm: 'Fiscal printer down. Record only on backend?',
    posSaleComplete: 'Sale completed successfully',
    posOkcXReport: 'Generate X-Report',
    posOkcZReport: 'Generate Z-Report (Day End)',
    posOkcZReportConfirm: 'Close the fiscal day?',
    posOkcCustomerDisplayBroadcast: 'Customer display updated',
    // 4. Error Messages (10)
    okcErrConnRefused: 'Device refused connection — check IP/port',
    okcErrPairTimeout: 'Pairing timeout',
    okcErrFiscalDayClosed: 'Fiscal day closed — Z-report issued',
    okcErrFiscalDayOpen: 'Fiscal day still open — cannot Z-report',
    okcErrTsmUnreachable: 'TSM server unreachable — call service',
    okcErrInvalidHmac: 'HMAC validation failed — re-pair',
    okcErrPaperOut: 'Out of paper',
    okcErrLicenseExpired: 'Device license expired — call service',
    okcErrUnknownDevice: 'Device not registered',
    okcErrDeviceBusy: 'Device busy — try again',
    // QR / Cart backend error codes
    qrErrorItemsEmpty: 'Cart is empty',
    qrErrorMinOrder: 'Minimum order amount {min}₺',
    qrErrorInvalidPhone: 'Invalid phone',
    qrErrorInvalidQuantity: 'Invalid quantity',
    qrErrorInvalidToken: 'Invalid or expired link',
    qrErrorRateLimited: 'Too many requests, please wait',
    qrErrorGeneric: 'An error occurred',
    qrErrorTokenInvalid: 'Token invalid or expired',
    qrErrorNetwork: 'No network — check your internet connection',
    // QR menu card variants
    qrCardVariantNeoBrutalist: 'Neo-Brutalist',
    qrCardVariantGlass: 'Glass',
    qrCardVariantGradientGlow: 'Gradient Glow',
    qrCardVariantEditorial: 'Editorial',
    qrCardVariantMinimalistMono: 'Minimalist Mono',
    qrCardVariantPaper: 'Paper',
    qrCardVariantRetroPop: 'Retro Pop',
    qrCardVariantArtDeco: 'Art Deco',
  },

  ar: {
    // عام
    save: 'حفظ',
    saving: 'جاري الحفظ...',
    cancel: 'إلغاء',
    delete: 'حذف',
    add: 'إضافة',
    edit: 'تعديل',
    close: 'إغلاق',
    openMenu: 'فتح القائمة',
    hideSidebar: 'إخفاء القائمة',
    showSidebar: 'إظهار القائمة',
    back: 'رجوع',
    search: 'بحث',
    loading: 'جاري التحميل...',
    update: 'تحديث',
    all: 'الكل',
    noData: 'لا توجد بيانات',
    actions: 'إجراءات',
    status: 'الحالة',
    date: 'التاريخ',
    total: 'الإجمالي',
    name: 'الاسم',
    description: 'الوصف',
    price: 'السعر',
    quantity: 'الكمية',
    active: 'نشط',
    passive: 'غير نشط',
    // تسجيل الدخول
    loginTitle: 'تسجيل الدخول إلى حسابك',
    email: 'البريد الإلكتروني',
    password: 'كلمة المرور',
    loginBtn: 'تسجيل الدخول',
    loggingIn: 'جاري تسجيل الدخول...',
    forgotPassword: 'نسيت كلمة المرور',
    loginError: 'فشل تسجيل الدخول.',
    emailRequired: 'البريد الإلكتروني وكلمة المرور مطلوبان.',

    // التنقل
    nav_dashboard: 'لوحة التحكم',
    nav_tables: 'الطاولات',
    nav_reservations: 'الحجوزات',
    nav_shifts: 'المناوبات',
    nav_hr: 'الموارد البشرية',
    nav_orders: 'الطلبات',
    nav_menu: 'القائمة',
    nav_kitchen: 'المطبخ',
    nav_stock: 'المخزون',
    nav_recipes: 'الوصفات',
    nav_suppliers: 'الموردون',
    nav_purchase_orders: 'المشتريات',
    nav_cash_transactions: 'حركات النقد',
    nav_refunds: 'الاستردادات',
    nav_stock_history: 'سجل المخزون',
    nav_payments: 'الصندوق',
    nav_delivery: 'التوصيل',
    nav_couriers: 'المندوبون',
    nav_platforms: 'إدارة المنصات',
    nav_pos: 'نقطة البيع',
    nav_printers: 'الطابعات',
    nav_customers: 'العملاء',
    nav_promo: 'العروض',
    nav_gifts: 'قسائم الهدايا',
    nav_users: 'المستخدمون',
    nav_waiterStats: 'متابعة النادل',
    nav_reports: 'التقارير',
    nav_settings: 'الإعدادات',
    nav_gdpr: 'KVKK / الخصوصية',
    nav_webhooks: 'تكاملات Webhook',
    nav_audit_logs: 'سجلات التدقيق',
    nav_trash: 'سلة المحذوفات',
    nav_security: 'الأمان و 2FA',
    nav_tax_groups: 'مجموعات الضرائب',
    nav_feature_flags: 'علامات الميزات',
    nav_whitelabel: 'العلامة البيضاء',
    nav_subscription: 'اشتراكي',
    logout: 'تسجيل الخروج',

    // الأدوار
    role_admin: 'مدير',
    role_waiter: 'نادل',
    role_kitchen: 'مطبخ',
    role_cashier: 'أمين الصندوق',
    chainStaffTitle: 'إدارة الموظفين',
    chainStaffSubtitle: 'عرض وإدارة الموظفين في جميع فروع السلسلة.',
    chainStaffAdd: 'إضافة موظف',
    chainStaffTotal: 'إجمالي الموظفين',
    chainStaffBranchFilter: 'تصفية حسب الفرع:',
    chainStaffAllBranches: 'جميع الفروع',
    chainStaffClearFilter: 'مسح التصفية',
    chainStaffShowing: 'موظف معروض',
    chainStaffNameCol: 'الاسم',
    chainStaffBranch: 'الفرع',
    chainStaffRegDate: 'تاريخ التسجيل',
    chainStaffDeleting: 'جاري الحذف...',
    chainStaffNotFound: 'لم يتم العثور على موظفين',
    chainStaffNoInBranch: 'لا يوجد موظفون في هذا الفرع.',
    chainStaffBranchSelect: 'اختر الفرع',
    chainStaffFullName: 'الاسم الكامل',
    chainStaffEmailPlaceholder: 'staff@example.com',
    chainStaffPwHint: 'حد أدنى 6 أحرف',
    chainStaffLoadError: 'حدث خطأ أثناء تحميل بيانات الموظفين.',
    chainStaffBranchRequired: 'يرجى اختيار فرع.',
    chainStaffPwTooShort: 'يجب أن تكون كلمة المرور 6 أحرف على الأقل.',
    chainStaffEmailReq: 'البريد الإلكتروني مطلوب.',
    chainStaffNoResultsTitle: 'لا توجد نتائج',
    chainStaffNoResultsDesc: 'غيّر الفرع أو البحث أو فلتر التاريخ.',
    chainStaffEmptyTitle: 'لا يوجد موظفون بعد',
    chainStaffEmptyDesc: 'أضف موظفين إلى الفروع لبدء التتبع.',
    chainReportsEmptyDesc: 'ستظهر التقارير هنا عند جمع البيانات من الفروع.',
    chainReportsNoRangeDesc: 'جرّب نطاقًا زمنيًا مختلفًا.',
    chainDashTitleSuffix: 'لوحة إدارة السلسلة',
    chainDashSubtitle: 'تتبع أداء جميع فروعك من شاشة واحدة.',
    chainDashChain: 'السلسلة',
    chainDashToday: 'اليوم',
    chainDashLast7Days: 'آخر 7 أيام',
    chainDashLast30Days: 'آخر 30 يوماً',
    chainDashThisMonth: 'هذا الشهر',
    chainDashStart: 'البداية',
    chainDashEnd: 'النهاية',
    chainDashFilter: 'تصفية',
    chainDashTotalRevenue: 'إجمالي الإيرادات',
    chainDashBranchCount: 'عدد الفروع',
    chainDashTotalTables: 'إجمالي الطاولات',
    chainDashPerformance: 'أداء الفروع',
    chainDashNoBranchData: 'لا توجد بيانات فروع للنطاق الزمني المحدد.',
    chainDashDetails: 'تفاصيل الفروع',
    chainDashRevenue: 'الإيرادات',
    chainDashOrder: 'الطلبات',
    chainDashTable: 'الطاولات',
    chainDashOrderUnit: 'طلب',
    chainDashLoadError: 'حدث خطأ أثناء تحميل البيانات.',
    chainBranchesTitle: 'إدارة الفروع',
    chainBranchesSubtitle: 'عرض وإدارة جميع الفروع المرتبطة بالسلسلة.',
    chainBranchesAdd: 'إضافة فرع جديد',
    chainBranchStatTotal: 'إجمالي الفروع',
    chainBranchStatActive: 'نشط',
    chainBranchStatInactive: 'غير نشط',
    chainBranchStatTables: 'إجمالي الطاولات',
    chainBranchesEmpty: 'لم تتم إضافة أي فرع بعد.',
    chainBranchesTableUnit: 'طاولة',
    chainBranchesUserUnit: 'مستخدم',
    chainBranchesEntering: 'جاري الدخول...',
    chainBranchesEnter: 'دخول الفرع',
    chainBranchesMakeActive: 'تفعيل',
    chainBranchesMakePassive: 'تعطيل',
    chainBranchesInfo: 'معلومات الفرع',
    chainBranchesNameLabel: 'اسم الفرع',
    chainBranchesAdminInfo: 'معلومات المدير',
    chainBranchesAdminName: 'اسم المدير',
    chainBranchesAdminEmail: 'البريد الإلكتروني للمدير',
    chainBranchesCreateBtn: 'إنشاء الفرع',
    chainBranchesEditTitle: 'تعديل الفرع',
    chainBranchesNameRequired: 'اسم الفرع مطلوب.',
    chainBranchesEmailRequired: 'البريد الإلكتروني مطلوب.',
    chainBranchesLoadError: 'حدث خطأ أثناء تحميل الفروع.',
    chainBranchesCreateError: 'تعذر إنشاء الفرع.',
    chainBranchesUpdateError: 'تعذر تحديث الفرع.',
    chainBranchesStatusError: 'تعذر تحديث حالة الفرع.',
    chainBranchesEnterError: 'تعذر الدخول إلى الفرع.',
    chainBranchesNamePh: 'مثال: فرع قاضي كوي',
    chainBranchesAddressPh: 'عنوان الفرع',
    chainBranchesPwPh: 'كلمة المرور',
    chainReportsTitle: 'تقارير السلسلة والتحليلات',
    chainReportsSubtitle: 'عرض تحليل الأداء التفصيلي لجميع فروعك.',
    chainReportsQuickSelect: 'اختيار سريع',
    chainReportsAllBranches: 'جميع الفروع',
    chainReportsFetch: 'جلب التقرير',
    chainReportsLoadError: 'حدث خطأ أثناء تحميل بيانات التقرير.',
    chainReportsTotalOrders: 'إجمالي الطلبات',
    chainReportsAvgOrder: 'متوسط قيمة الطلب',
    chainReportsBestBranch: 'أفضل فرع',
    chainReportsBranchCompare: 'مقارنة الفروع',
    chainReportsAvgAmount: 'متوسط المبلغ',
    chainReportsStaffCol: 'الموظفون',
    chainReportsRevenueShare: 'حصة الإيرادات',
    chainReportsDailyTrend: 'الاتجاه اليومي',
    chainReportsHourlyDist: 'التوزيع الساعي (المتوسط)',
    chainReportsAvgRevenue: 'متوسط الإيرادات',
    chainReportsAvgOrders: 'متوسط الطلبات',
    chainReportsTopItems: 'المنتجات الأكثر مبيعاً (على مستوى السلسلة)',
    chainReportsBranchesSuffix: 'فرع',
    chainReportsWeekdayAvg: 'متوسط الإيرادات حسب أيام الأسبوع',
    chainReportsPaymentMethods: 'طرق الدفع (حسب الفرع)',
    chainReportsSplit: 'مختلط',
    chainReportsEmpty: 'قم بالتصفية لعرض تقرير.',
    chainReportsDay0: 'الأحد',
    chainReportsDay1: 'الإثنين',
    chainReportsDay2: 'الثلاثاء',
    chainReportsDay3: 'الأربعاء',
    chainReportsDay4: 'الخميس',
    chainReportsDay5: 'الجمعة',
    chainReportsDay6: 'السبت',
    chainMenuTitle: 'إدارة القائمة',
    chainMenuStatTotal: 'إجمالي المنتجات',
    chainMenuStatActive: 'نشط',
    chainMenuStatInactive: 'غير نشط',
    chainMenuStatCategories: 'الفئات',
    chainMenuSubtitle: 'عرض قوائع الفروع أو إدارة قائمة مشتركة على مستوى السلسلة.',
    chainMenuBranchMenus: 'قوائم الفروع',
    chainMenuChainMenu: 'قائمة السلسلة',
    chainMenuNoBranches: 'لا توجد فروع بعد',
    chainMenuNoPlan: 'لا توجد خطة',
    chainMenuViewMenu: 'عرض القائمة',
    chainMenuInfoText: 'عند إضافة/تحديث المنتجات يتم تطبيقها تلقائياً على جميع الفروع. المنتجات المقفلة 🔒 تُحدّث السعر أيضاً؛ أما غير المقفلة فيحتفظ كل فرع بسعره الخاص. يمكن استخدام زر "تطبيق على الفروع" للفروع المضافة حديثاً.',
    chainMenuApplying: 'جاري التطبيق...',
    chainMenuApplyToBranches: '🔄 تطبيق على الفروع',
    chainMenuAddItem: '+ إضافة منتج',
    chainMenuNoItems: 'لم تتم إضافة منتجات بعد',
    chainMenuNoItemsHint: 'أضف منتجات إلى قائمة السلسلة لتطبيقها على جميع الفروع.',
    chainMenuItemsUnit: 'منتج',
    chainMenuLocked: '🔒 مقفل',
    chainMenuFree: 'حر',
    chainMenuBranchMenuSubtitle: 'قائمة الفرع',
    chainMenuEmptyBranchMenu: 'لا توجد قائمة في هذا الفرع بعد',
    chainMenuEmptyBranchHint: 'يمكنك تطبيق المنتجات على الفرع من قائمة السلسلة.',
    chainMenuPriceLocked: '🔒 السعر مقفل',
    chainMenuUnlockPrice: 'إلغاء قفل السعر',
    chainMenuLockPrice: 'قفل السعر',
    chainMenuManageChainMenu: 'إدارة قائمة السلسلة',
    chainMenuEditItem: 'تعديل المنتج',
    chainMenuNewItem: 'إضافة منتج جديد',
    chainMenuItemName: 'اسم المنتج',
    chainMenuItemNamePh: 'اسم المنتج',
    chainMenuPriceLabel: 'السعر (₺)',
    chainMenuDescriptionPlaceholder: 'وصف المنتج (اختياري)',
    chainMenuPriceLockLabel: '🔒 قفل السعر',
    chainMenuPriceLockHint: 'لا يستطيع مدير الفرع تغيير سعر هذا المنتج.',
    chainMenuBranchAvailableHint: 'المنتج مرئي في قائمة الفرع ويمكن طلبه.',
    chainMenuUpdate: 'تحديث',
    chainMenuCategoryPlaceholder: 'مثال: الأطباق الرئيسية',
    chainMenuLockedItem: '🔒 منتج مقفل',
    chainMenuLockedItemHint: 'يقوم بتحديث أسعار الفروع أثناء المزامنة.',
    chainMenuAvailableHint: 'المنتج مرئي في القائمة ويمكن طلبه.',
    chainMenuApplyQuestion: 'على أي فروع تريد التطبيق؟ إن لم تحدد، سيتم التطبيق على جميع الفروع.',
    chainMenuBranchesSelectedSuffix: 'فرع محدد.',
    chainMenuAllBranchesApply: 'سيتم التطبيق على جميع الفروع.',
    chainMenuApply: 'تطبيق',
    chainMenuLoadFailed: 'تعذر تحميل القائمة.',
    chainMenuNameRequired: 'اسم المنتج مطلوب.',
    chainMenuInvalidPrice: 'يرجى إدخال سعر صالح.',
    chainMenuPriceLockFailed: 'تعذر تحديث قفل السعر.',
    chainMenuStatusUpdateFailed: 'تعذر تحديث الحالة.',
    chainMenuSyncDone: 'اكتملت المزامنة.',
    chainMenuSyncFailed: 'فشل.',
    lockScreenTitle: 'الشاشة مقفلة',
    lockScreenNoPin: 'لم يتم تعيين رمز PIN بعد.',
    lockScreenNoPinHint: 'انقر على الزر للمتابعة.',
    lockScreenUnlock: 'فتح القفل',
    lockScreenPinFromSettings: '⚙️ يمكنك تعيين رمز PIN من الإعدادات',
    lockScreenResetTitle: 'إعادة تعيين PIN',
    lockScreenResetDesc: 'سيتم حذف جميع رموز PIN المسجلة وإنهاء جلستك. قم بتسجيل الدخول مرة أخرى لتعيين رمز PIN جديد.',
    lockScreenResetConfirm: 'نعم، تسجيل الخروج وإعادة التعيين',
    lockScreenResetBack: 'رجوع',
    lockScreenEnterPin: 'أدخل رمز PIN',
    lockScreenWrongPin: 'رمز PIN خاطئ',
    lockScreenForgotPin: 'نسيت رمز PIN',
    subBannerNoActive: 'ليس لديك اشتراك نشط',
    subBannerNoActiveDesc: 'اختر خطة لاستخدام النظام.',
    subBannerChoosePlan: 'اختر خطة',
    subBannerTrialEnding: 'تجربتك تنتهي قريباً!',
    subBannerSubEnding: 'اشتراكك ينتهي قريباً!',
    subBannerTodayEnd: 'ينتهي اليوم!',
    subBannerDaysLeft: 'أيام متبقية.',
    subBannerRenewSoon: 'قم بالتجديد الآن.',
    subBannerRenew: 'تجديد الاشتراك',
    subBannerRenewNow: 'جدد الآن',
    subBannerTrialHeader: 'تجربة مجانية لمدة 14 يوماً',
    subBannerTrialHint: 'استكشف جميع الميزات مجاناً!',
    subBannerTrialDaysLeft: 'أيام متبقية.',
    subBannerExpired: 'انتهى اشتراكك',
    subBannerExpiredDesc: 'جدد اشتراكك للوصول إلى الخدمات.',
    cookieBannerTitle: 'ملفات تعريف الارتباط والخصوصية:',
    cookieBannerDesc: 'نستخدم ملفات تعريف الارتباط الأساسية لتقديم خدمة أفضل. يمكنك اختيارياً السماح بملفات تعريف الارتباط للتحليلات والتسويق.',
    cookieBannerManage: 'إدارة الخيارات',
    cookieBannerOnlyRequired: 'الأساسية فقط',
    cookieBannerAcceptAll: 'قبول الكل',
    cookieBannerSaveChoices: 'حفظ خياراتي',
    cookieBannerDetailsTitle: 'تفضيلات ملفات تعريف الارتباط',
    cookieCategoryRequired: 'ملفات تعريف الارتباط الأساسية',
    cookieCategoryRequiredDesc: 'ضرورية لعمل الموقع.',
    cookieCategoryAnalytics: 'ملفات تعريف الارتباط التحليلية',
    cookieCategoryAnalyticsDesc: 'لإحصائيات الاستخدام.',
    cookieCategoryMarketing: 'ملفات تعريف الارتباط التسويقية',
    cookieCategoryMarketingDesc: 'للمحتوى المخصص.',
    chainAdminTitle: 'مدير السلسلة',
    chainAdminSubtitle: 'إدارة سلسلة RestaFlex',
    chainAdminRoleLabel: 'مدير السلسلة',
    caNavBranches: 'الفروع',
    caNavReports: 'التقارير',
    caNavAnalytics: 'التحليلات',
    caNavChainMenu: 'قائمة السلسلة',
    caNavStaff: 'الموظفون',
    superAdminTitle: 'SuperAdmin',
    superAdminSubtitle: 'مركز إدارة RestaFlex',
    saNavRestaurants: 'المطاعم',
    saNavPlans: 'الخطط',
    saNavSubscriptions: 'الاشتراكات',
    receiptTitle: 'إيصال',
    receiptSubtitle: 'نظام إدارة المطاعم',
    receiptSplit: 'مختلط (نقدي + بطاقة)',
    receiptProduct: 'الصنف',
    receiptUnit: 'الوحدة',
    receiptGrandTotal: 'الإجمالي',
    receiptPaymentLabel: 'الدفع:',
    receiptThanks: 'شكراً لك!',
    receiptThanksLong: 'شكراً لاختيارك لنا.',
    activityRecentOrders: 'الطلبات النشطة',
    activityTodayReservations: 'حجوزات اليوم',
    activityLowStock: 'مخزون منخفض',
    activitySeeAll: 'الكل',
    activityNoOrders: 'لا توجد طلبات نشطة.',
    activityNoReservations: 'لا توجد حجوزات لليوم.',
    activityNoLowStock: 'لا توجد مواد منخفضة المخزون.',
    activityItemsUnit: 'عناصر',
    activityGuestsUnit: 'ضيوف',
    activityCriticalLevel: 'حرج',
    role_superadmin: 'المشرف العام',

    // الإعدادات
    settingsTitle: 'الإعدادات',
    tab_notifications: 'الإشعارات',
    restaurantName: 'اسم المطعم',
    ownerName: 'اسم المالك',
    phone: 'الهاتف',
    address: 'العنوان',
    theme: 'المظهر',
    theme_light: 'فاتح',
    theme_dark: 'داكن',
    theme_system: 'النظام',
    languageSelect: 'اختر اللغة',
    kitchenSound: 'صوت إشعار المطبخ',
    kitchenSoundDesc: 'تشغيل الصوت عند وصول طلب جديد',
    autoPrint: 'طباعة تلقائية',
    autoPrintDesc: 'طباعة الإيصال تلقائياً عند تأكيد الطلب',
    webPush: 'إشعارات الويب',
    menuTitle: 'عنوان القائمة',
    settingsSaved: 'تم حفظ الإعدادات.',
    // لوحة التحكم
    totalOrders: 'إجمالي الطلبات',
    trendBadgeTooltip: 'مقارنة بالأمس في نفس الساعة',
    partialLoadError: 'تعذر تحميل بعض البيانات.',
    kpiTotalTables: 'إجمالي الطاولات',
    kpiOccupiedTables: 'مشغولة',
    kpiOccupancy: 'الإشغال',
    kpiActiveOrders: 'الطلبات النشطة',
    kpiAvgTicket: 'متوسط السلة',
    kpiTodayRevenue: 'إيرادات اليوم',
    kpiTodaySales: 'مبيعات اليوم',
    kpiOpenOrders: 'الطلبات المفتوحة',
    kpiLowStock: 'مخزون منخفض',
    kpiPendingReservations: 'حجوزات معلقة',
    kpiMonthlyNetProfit: 'صافي الربح (الشهر)',
    kpiActiveCouriers: 'مندوبون نشطون',
    kpiActiveShifts: 'مناوبات نشطة',
    actionItemsTitle: 'مهام اليوم',
    actionReadyOrders: 'طلبات جاهزة',
    actionReadyOrdersDesc: 'بانتظار التقديم',
    actionPendingReservations: 'موافقات حجز',
    actionPendingReservationsDesc: 'معلق',
    actionCriticalStock: 'مخزون حرج',
    actionUnassignedDeliveries: 'توصيلات',
    actionUnassignedDeliveriesDesc: 'بدون مندوب',
    kpiThisMonth: 'هذا الشهر',
    kpiToday: 'اليوم',
    kpiLive: 'مباشر',
    chartHourly: 'الإيرادات بالساعة',
    chartDaily: 'الإيرادات اليومية',
    chartWeekly: 'الإيرادات الأسبوعية',
    chartHourlyHint: 'اليوم · 24 ساعة',
    chartDailyHint: 'آخر 7 أيام',
    chartWeeklyHint: 'آخر 8 أسابيع',
    periodHourly: 'بالساعة',
    periodDaily: 'يومي',
    periodWeekly: 'أسبوعي',
    chartPeriodLabel: 'النطاق الزمني',
    chartNoData: 'لا توجد بيانات لهذه الفترة',
    sectionActiveOrders: 'الطلبات النشطة',
    viewAll: 'عرض الكل',
    noActiveOrders: 'لا توجد طلبات نشطة',
    dailySummary: 'الملخص اليومي',
    totalTransactions: 'إجمالي المعاملات',
    totalRevenueLabel: 'إجمالي الإيرادات',
    noPaymentsToday: 'لم يتم استلام أي مدفوعات اليوم',
    quickActions: 'إجراءات سريعة',
    criticalStockAlert: '⚠️ تنبيه مخزون منخفض',
    topItemsTitle: '⭐ الأكثر مبيعاً (اليوم)',
    unitPieces: 'قطعة',

    // مركز الإشعارات (Notifications + Header)
    severityCritical: 'حرج',
    severityWarning: 'تحذير',
    severityInfo: 'معلومات',
    notifSeverityLabel: 'الأهمية:',
    notifSearchPlaceholder: 'البحث في الإشعارات...',
    viewModeList: 'قائمة',
    viewModeKanban: 'كانبان',
    newCustomerBadge: 'عميل جديد (آخر 30 يومًا)',
    notifStatusLabel: 'الحالة:',
    notifUnread: 'غير مقروء',
    notifRead: 'مقروء',
    notifShowDismissed: 'إظهار المحذوفة',
    notifCountSuffix: 'إشعار',
    notifMarkVisibleRead: 'تحديد المرئي كمقروء',
    notifRestoreAll: 'استعادة المحذوفة',
    notifNoMatch: 'لا توجد إشعارات تطابق الفلاتر.',
    notifNewLabel: 'جديد',
    notifDismissedLabel: 'محذوف',
    notifGoToPage: '← الذهاب إلى الصفحة',
    notifMarkRead: 'تحديد كمقروء',
    notifRestore: 'استعادة',
    notifMarkAllReadTitle: 'تحديد الكل كمقروء',
    notifMarkAllReadShort: 'مقروء ✓',
    notifDismissAllTitle: 'حذف جميع الإشعارات',
    notifDismissAllShort: 'حذف الكل',
    notifEmpty: 'لا توجد إشعارات جديدة.',
    notifViewAll: 'عرض جميع الإشعارات ←',
    notifUnreadCountSuffix: 'غير مقروء',
    notifDismissOne: 'حذف الإشعار',
    notifAllCaughtUp: 'تمت قراءة جميع الإشعارات',
    notifNoReadYet: 'لا توجد إشعارات مقروءة بعد',
    notifFilterAll: 'الكل',
    notifFilterUnread: 'غير المقروءة',
    notifFilterRead: 'المقروءة',
    notifBadgeUnread: 'غير مقروءة',
    notifBadgeTotal: 'الإجمالي',
    reportsExportCSV: 'تنزيل CSV',
    reportsCSVNotAvailable: 'ملف CSV غير متاح لهذا التقرير.',
    timeAgoSuffix: 'قبل',
    themeLightMode: 'الوضع الفاتح',
    themeDarkMode: 'الوضع الداكن',

    // العملاء (Customers + CustomerDetail)
    customersTitle: 'العملاء',
    customersSubtitle: 'إدارة العملاء وبرنامج الولاء',
    newCustomer: 'عميل جديد',
    editCustomer: 'تعديل العميل',
    customerSearchPlaceholder: 'ابحث بالاسم أو الهاتف أو البريد...',
    noCustomersYet: 'لا يوجد عملاء بعد',
    addFirstCustomer: 'أضف عميلك الأول',
    customerLoadError: 'تعذر تحميل العميل',
    customerNotFound: 'العميل غير موجود',
    deleteConfirm: 'هل أنت متأكد من حذف هذا العنصر؟',
    deleteCustomerConfirm: 'هل أنت متأكد من حذف هذا العميل؟',
    genericError: 'حدث خطأ',
    deleteFailed: 'تعذر الحذف',
    birthdaySoon: 'يقترب عيد الميلاد',
    colCustomer: 'العميل',
    colContact: 'الاتصال',
    colSpend: 'الإنفاق',
    colVisits: 'الزيارات',
    points: 'النقاط',
    loyaltyAction: 'عملية النقاط',
    addPointsBtn: '+ إضافة نقاط',
    redeemPointsBtn: '- استخدام النقاط',
    loyaltyHistoryTitle: 'سجل النقاط',
    notes: 'الملاحظات',
    fullName: 'الاسم الكامل',
    phoneLabel: 'الهاتف',
    emailLabel: 'البريد',
    birthdayLabel: 'تاريخ الميلاد',
    customerNotesPlaceholder: 'التفضيلات، الحساسية...',
    pointsEarned: 'تم كسب النقاط',
    pointsRedeemed: 'تم استخدام النقاط',

    // CustomerDetail
    backToCustomers: '→ العودة إلى العملاء',
    loyaltyLabel: 'الولاء',
    pointsUnit: 'نقطة',
    totalSpentLabel: 'إجمالي الإنفاق',
    lastOrderLabel: 'آخر طلب',
    descriptionOptional: 'الوصف (اختياري)',
    useAction: 'استخدم',
    orderHistoryTitle: '📋 سجل الطلبات',
    recordsSuffix: 'سجل',
    noPhoneMatchSuffix: '· (لا هاتف — المطابقة غير ممكنة)',
    noOrdersForPhone: 'لا توجد طلبات مطابقة لهذا الهاتف.',
    addPhoneForOrders: 'أضف رقم هاتف لمطابقة الطلبات.',
    paymentPaid: '✓ مدفوع',
    paymentPending: '○ معلق',
    loyaltyActivityTitle: '⭐ نشاط الولاء',
    noLoyaltyActivity: 'لا يوجد نشاط ولاء بعد.',
    successPointsAdded: '✓ تمت إضافة النقاط',
    successPointsRedeemed: '✓ تم استخدام النقاط',
    pointsAddError: 'تعذر إضافة النقاط',
    pointsRedeemError: 'تعذر استخدام النقاط',
    orderServedShort: 'مقدم',

    // Orders + Header pageTitles
    ordersLoadError: 'تعذر تحميل الطلبات.',
    orderDetailLoadError: 'تعذر تحميل تفاصيل الطلب.',
    itemRemoveError: 'تعذر إزالة المنتج.',
    statusUpdateError: 'تعذر تحديث الحالة.',
    orderDeleteError: 'تعذر حذف الطلب.',
    menuLoadError: 'تعذر تحميل القائمة.',
    itemAddError: 'تعذر إضافة المنتج.',
    refresh: 'تحديث',
    addItem: 'إضافة منتج',
    colTableTime: 'الطاولة / الوقت',
    colItems: 'الأصناف',
    colAmount: 'المبلغ',
    colAction: 'الإجراء',
    detail: 'تفاصيل',
    itemsSuffix: 'صنف',
    orderNotFound: 'لا توجد طلبات',
    ordersSuffix: 'طلب',
    totalLabel: 'الإجمالي',
    orderPrefix: 'طلب',
    cancelOrderConfirm: 'هل أنت متأكد من إلغاء هذا الطلب؟',
    markReady: '✓ تحديد كجاهز',
    markServed: '🚀 تم التقديم',
    cancelOrderBtn: '🗑️ إلغاء الطلب',
    addItemBtn: '➕ إضافة منتج',

    // Header pageTitles (route → title)
    pageTableManagement: 'إدارة الطاولات',
    pageOrderManagement: 'إدارة الطلبات',
    pageMenuManagement: 'إدارة القائمة',
    pageKitchenScreen: 'شاشة المطبخ',
    pageStockManagement: 'إدارة المخزون',
    pageRecipeSystem: 'نظام الوصفات',
    pagePaymentsCash: 'المدفوعات والكاشير',
    pageUserManagement: 'إدارة المستخدمين',
    roleAdmin: 'مسؤول',
    roleWaiter: 'نادل',
    roleKitchen: 'مطبخ',

    // Reservations
    resStatusPending: 'قيد الانتظار',
    resStatusConfirmed: 'مؤكد',
    resStatusConfirmedShort: 'OK',
    resStatusArrived: 'وصل',
    resStatusCompleted: 'مكتمل',
    resStatusNoShow: 'لم يحضر',
    totalGuests: 'إجمالي الضيوف',
    editReservation: 'تعديل الحجز',
    newReservation: 'حجز جديد',
    create: 'إنشاء',
    reservationsTitle: 'الحجوزات',
    reservationsSubtitle: 'إدارة حجوزات الطاولات',
    customerName: 'اسم العميل',
    partySize: 'عدد الأشخاص',
    durationMin: 'المدة (د)',
    tableOptional: 'الطاولة (اختياري)',
    noTableSelected: '-- لم يتم اختيار طاولة --',
    capacityPersons: 'أشخاص',
    persons: 'أشخاص',
    minShort: 'د',
    dateLabel: 'التاريخ:',
    statusFilterLabel: 'الحالة:',
    clear: 'مسح',
    reservationStatTotal: 'الإجمالي',
    reservationStatConfirmed: 'مؤكد',
    reservationStatPending: 'قيد الانتظار',
    reservationStatCancelled: 'ملغى',
    reservationNotFound: 'لا توجد حجوزات',
    reservationEmptyHint: 'استخدم زر + لإضافة حجز جديد',
    deleteReservationConfirm: 'هل أنت متأكد من حذف هذا الحجز؟',
    timeLabel: 'الوقت',
    notesPlaceholder: 'طلب خاص، حساسية، عيد ميلاد، إلخ.',
    // Stock
    stockLoadError: 'تعذر تحميل بيانات المخزون.',
    allFieldsRequired: 'جميع الحقول مطلوبة.',
    invalidQuantity: 'يجب أن تكون الكمية رقماً صالحاً غير سالب.',
    invalidCriticalLevel: 'يجب أن يكون الحد الحرج رقماً صالحاً غير سالب.',
    saveFailed: 'تعذر الحفظ.',
    updateStock: 'تحديث المخزون',
    newIngredient: 'مكون جديد',
    supplierName: 'اسم المورد',
    reorderQuantity: 'كمية إعادة الطلب',
    ingredient: 'مكون',
    ingredientName: 'اسم المكون',
    totalIngredients: 'إجمالي المكونات',
    criticalStock: 'المخزون الحرج',
    normalStock: 'المخزون الطبيعي',
    addIngredient: '+ إضافة مكون',
    unit: 'وحدة',
    criticalLevel: 'الحد الحرج',
    supplierOptional: '📦 المورد (اختياري)',
    phoneWhatsapp: 'الهاتف (واتساب)',
    supplierEmailHint: 'عند انخفاض المخزون للحد الحرج، يتم إنشاء روابط طلب واتساب وبريد إلكتروني تلقائياً في رسائل المسؤول.',
    ingredientNotFound: 'لا توجد مكونات',
    statusCritical: '⚠️ حرج',
    statusNormal: '✓ طبيعي',
    deleteIngredientConfirm: 'هل أنت متأكد من حذف هذا المكون؟',
    criticalCount: 'حرج',
    // MenuManagement
    dataLoadError: 'تعذر تحميل البيانات.',
    variantAddError: 'تعذر إضافة المتغير.',
    variantDeleteError: 'تعذر حذف المتغير.',
    enterValidValue: 'الرجاء إدخال قيمة صالحة.',
    bulkPriceUpdateError: 'تعذر تحديث الأسعار جماعياً.',
    categoryNameRequired: 'اسم الفئة مطلوب.',
    categorySaveError: 'تعذر حفظ الفئة.',
    categoryDeleteError: 'تعذر حذف الفئة.',
    nameAndPriceRequired: 'الاسم والسعر مطلوبان.',
    menuItemSaveError: 'تعذر حفظ عنصر القائمة.',
    menuItemDeleteError: 'تعذر حذف عنصر القائمة.',
    aiScanFailed: 'فشل المسح بالذكاء الاصطناعي. جرب صورة أوضح.',
    excelDownloadError: 'تعذر تحميل Excel.',
    importFailed: 'فشل الاستيراد.',
    editCategory: 'تعديل الفئة',
    newCategory: 'فئة جديدة',
    categoryName: 'اسم الفئة',
    optional: 'اختياري',
    editProduct: 'تعديل المنتج',
    newProduct: 'منتج جديد',
    productName: 'اسم المنتج',
    variantsExample: 'صغير / متوسط / كبير',
    bulkPriceUpdate: 'تحديث الأسعار جماعياً',
    updating: 'جارٍ التحديث...',
    apply: 'تطبيق',
    adding: 'جارٍ الإضافة...',
    qrMenuCode: 'رمز QR للقائمة',
    // Kitchen
    justNow: 'الآن',
    actionFailed: 'فشل الإجراء.',

    // صفحة الطاولات
    tablesLoadError: 'تعذر تحميل الطاولات.',
    orderCreateError: 'تعذر إنشاء الطلب.',
    tableNameRequired: 'اسم الطاولة مطلوب.',
    tableAddError: 'تعذر إضافة الطاولة.',
    tablesAddError: 'تعذر إضافة الطاولات.',
    tableDeleteError: 'تعذر حذف الطاولة.',
    tableCloseError: 'تعذر إغلاق الطاولة.',
    paymentFailed: 'فشل الدفع.',
    invalidPromoCode: 'رمز ترويجي غير صالح',
    invalidGiftVoucher: 'قسيمة هدية غير صالحة',
    addOrder: '➕ إضافة طلب',
    closeTable: '✕ إغلاق الطاولة',
    deleteTableAction: '🗑️ حذف الطاولة',
    tableNotSpecified: 'لم يتم تحديد الطاولة',
    searchTableHint: 'ابحث عن طاولة...',
    noTablesYet: 'لا توجد طاولات بعد',
    noTableMatching: 'لم يتم العثور على طاولات',
    statusEmpty: 'فارغة',
    statusOccupied: 'مشغولة',
    statusReserved: 'محجوزة',
    allFloors: 'جميع الطوابق',
    categoriesNav: '⚙️ الفئات',
    addFloorCategory: '+ إضافة فئة طابق / منطقة',
    addTableShort: '+ طاولة',
    seenLabel: '• تم الاطلاع',
    markSeen: 'اطلعت',
    resolvedLabel: 'تم الحل',
    hide: '▲ إخفاء',
    show: '▼ إظهار',
    ordersSheetTitle: 'الطلبات',
    checkoutTitle: 'الحساب',
    noPendingOrders: 'لا توجد طلبات بانتظار الدفع',
    markReadyShort: '✓ جاهز',
    orderSubtotal: 'إجمالي الطلب',
    closeCheck: '💰 إغلاق الحساب',
    addNewOrder: '➕ إضافة طلب جديد',
    createOrderTitle: 'إنشاء طلب',
    orderNotePlaceholder: 'ملاحظة الطلب...',
    addNewTable: 'إضافة طاولة جديدة',
    paymentMixed: 'مختلط',
    categoryNameLabel: 'اسم الفئة',

    // معالج الإعداد
    onbTitle: 'مرحباً! 🎊',
    onbSubtitle: 'لنقم بإعداد مطعمك في بضع خطوات',
    onbStepRestaurant: 'المطعم',
    onbStepTables: 'الطاولات',
    onbStepMenu: 'القائمة',
    onbStepDone: 'تم',
    onbStep1Hint: 'أدخل المعلومات الأساسية عن مطعمك. يمكنك التعديل لاحقاً من الإعدادات.',
    onbRestaurantName: 'اسم المطعم',
    onbOwnerName: 'المالك',
    onbAddress: 'العنوان',
    onbNameRequired: 'اسم المطعم مطلوب',
    onbContinue: 'متابعة ←',
    onbSkip: 'تخطي هذه الخطوة',
    onbDoneTitle: 'اكتمل الإعداد!',
    onbDoneHint: 'يمكنك الآن بدء إدارة مطعمك.',
    onbGoDashboard: 'الذهاب إلى لوحة التحكم',
    onbStep2Hint: 'اختياري: أضف فئة طابق/منطقة، ثم أنشئ الطاولات بالجملة.',
    onbCategoriesLabel: 'الفئات',
    onbCategoryNamePh: 'فئة جديدة (مثل: حديقة، صالة)',
    onbBulkTablesTitle: 'إنشاء طاولات بالجملة',
    onbPrefix: 'البادئة',
    onbCount: 'العدد',
    onbCapacity: 'السعة',
    onbStep3Hint: 'أضف فئات القائمة، ثم عرّف بسرعة بعض المنتجات. تُحرر القائمة التفصيلية من إدارة القائمة.',
    onbMenuCategoriesLabel: 'فئات القائمة',
    onbMenuCategoryPh: 'فئة جديدة (مثل: حساء، مشروبات)',
    onbQuickItemTitle: 'إضافة منتج سريعة',
    onbNeedCategoryFirst: 'أضف فئة واحدة على الأقل أولاً.',
    onbReopenTitle: 'معالج الإعداد',
    onbReopenDesc: 'افتح معالج الإعداد خطوة بخطوة لمعلومات المطعم والطاولات والقائمة من جديد.',
    onbReopenBtn: 'فتح المعالج',

    // Sound preferences
    soundPresetTitle: 'صوت التنبيه',
    soundPresetDesc: 'الصوت الذي يُشغّل على شاشة المطبخ عند وصول طلب جديد.',
    soundPreset_beep: 'صفير',
    soundPreset_chime: 'رنين',
    soundPreset_bell: 'جرس',
    soundVolumeLabel: 'مستوى الصوت',
    soundTestBtn: 'تجربة الصوت',

    // DeliveryOrders i18n tail
    deliveryOrdersTitle: 'طلبات التوصيل',
    deliveryOrdersSubtitle: 'الطلبات من جميع المنصات',
    deliveryEmptyTitle: 'لا توجد طلبات توصيل',
    deliveryEmptyFiltered: 'حاول تغيير الفلاتر وإعادة البحث',
    deliveryEmptyDefault: 'ستظهر الطلبات هنا عند تفعيل تكاملات المنصات',
    activeOrders: 'الطلبات النشطة',
    completedCancelled: 'مكتملة / ملغاة',
    paidOnline: 'مدفوع إلكترونياً',
    payOnDelivery: 'الدفع عند الاستلام',
    cancelledByRestaurant: 'تم الإلغاء من قبل المطعم',
    statusUpdateFailed: 'تعذر تحديث الحالة.',
    loadFailed: 'تعذر تحميل البيانات.',
    filterAll: 'الكل',
    prevPage: 'السابق',
    nextPage: 'التالي',

    // Users i18n tail
    role: 'الدور',
    registrationDate: 'تاريخ التسجيل',
    totalUsers: 'إجمالي المستخدمين',
    addUser: 'إضافة مستخدم',
    editUserTitle: 'تعديل المستخدم',
    newUserTitle: 'مستخدم جديد',
    newPasswordOptional: 'كلمة مرور جديدة (اتركها فارغة للإبقاء على الحالية)',
    userNameEmailRequired: 'الاسم والبريد الإلكتروني مطلوبان.',
    invalidEmailAddress: 'يرجى إدخال عنوان بريد إلكتروني صالح.',
    passwordRequired: 'كلمة المرور مطلوبة.',
    passwordMinChars: 'يجب أن تكون كلمة المرور 6 أحرف على الأقل.',
    deleteUserConfirm: 'هل أنت متأكد من حذف هذا المستخدم؟',

    // Tables.js checkout sheet i18n tail
    discountAndTreat: 'خصم / ضيافة',
    amountMode: 'مبلغ',
    percentMode: 'نسبة',
    treatLabel: 'ضيافة',
    promoCodeAndVoucher: 'رمز ترويجي / قسيمة هدية',
    promoCodeShort: 'ترويج',
    giftVoucher: 'قسيمة هدية',
    removeAction: 'إزالة',
    balanceLabel: 'الرصيد',
    amountToPay: 'المبلغ المستحق',
    amountsMatch: 'المبالغ متطابقة',
    remainingLabel: 'المتبقي',
    processing: 'جارٍ المعالجة...',
    treatCloseBill: 'ضيافة — إغلاق الفاتورة',
    takePayment: 'تحصيل الدفع',

    // Payments + Reports i18n tail
    dailyCashReport: 'تقرير الكاشير اليومي',
    transactionCount: 'عدد المعاملات',
    paymentList: 'قائمة المدفوعات',
    paymentTypeCol: 'نوع الدفع',
    timeCol: 'الوقت',
    noPaymentsForDate: 'لا توجد سجلات دفع لهذا التاريخ',
    dateRangeSalesReport: 'تقرير المبيعات حسب نطاق التاريخ',
    startDate: 'من',
    endDate: 'إلى',
    runReport: 'إنشاء التقرير',
    periodTotalRevenue: 'إجمالي إيرادات الفترة',
    selectDateRange: 'يرجى تحديد تاريخي البداية والنهاية.',
    reportLoadFailed: 'تعذر تحميل بيانات التقرير.',
    salesReportLoadFailed: 'تعذر تحميل تقرير المبيعات.',
    advancedReports: 'التقارير المتقدمة',
    advancedReportsSubtitle: 'تحليلات المبيعات وتقارير الإيرادات التفصيلية',
    reportsTabReports: 'التقارير',
    reportsTabBI: 'لوحة BI',
    reportsTabDetail: 'تقارير تفصيلية',
    periodToday: 'اليوم',
    periodThisWeek: 'هذا الأسبوع',
    periodThisMonth: 'هذا الشهر',
    periodCustomDate: 'تاريخ مخصص',
    reportLoadingMsg: 'جارٍ تحميل التقرير...',
    noDataYet: 'لا توجد بيانات بعد',
    selectDateRangeAndRun: 'اختر نطاق التاريخ ثم انقر إنشاء التقرير',
    noDataForPeriod: 'لا توجد بيانات لهذه الفترة',

    // Tables.js create-order/add-table sheet i18n tail
    noProductInCategory: 'لا توجد منتجات في هذه الفئة',
    noteOptionalLabel: 'ملاحظة (اختياري)',
    itemSuffix: 'منتج',
    creating: 'جارٍ الإنشاء...',
    createOrderBtn: 'إنشاء الطلب',
    singleTableMode: 'طاولة واحدة',
    bulkAddMode: 'إضافة جماعية',
    tableNameLabel: 'اسم الطاولة',
    capacityPeople: 'السعة (أشخاص)',
    categoryFloorZone: 'الفئة (الطابق / المنطقة)',
    uncategorized: 'بدون فئة',
    addTableBtn: 'إضافة طاولة',
    prefixLabel: 'البادئة',
    countLabel: 'العدد',
    maxLabel: 'حد أقصى',
    startNumber: 'رقم البداية',
    tablesToCreate: 'الطاولات المراد إنشاؤها',
    countSuffix: 'قطعة',
    categoryLabel: 'الفئة',
    invalidPrefixCount: 'أدخل بادئة صالحة وعدداً (1-50).',

    // Reports.js BI tab + Reports tab tail
    showBtn: 'عرض',
    biLoadFailed: 'تعذر تحميل بيانات لوحة BI.',
    dashboardLoadingMsg: 'جارٍ تحميل اللوحة...',
    hourlyOrderDensity: 'كثافة الطلبات بالساعة',
    noDataForDate: 'لا توجد بيانات لهذا التاريخ',
    topSellingItems: 'الأكثر مبيعاً',
    waiterPerformance: 'أداء النادل',
    deliveryPlatformSummary: 'ملخص منصات التوصيل',
    platformCol: 'المنصة',
    orderShortCol: 'الطلبات',
    revenueCol: 'الإيرادات',
    cancelledCol: 'ملغاة',
    orderCountSuffix: 'طلب',
    orderCountCol: 'عدد الطلبات',
    cashCollected: 'تحصيل نقدي',
    cardCollected: 'تحصيل بالبطاقة',
    totalCollected: 'إجمالي التحصيل',
    paymentTypeBreakdown: 'توزيع طرق الدفع',
    hourlyBreakdown: 'التوزيع بالساعة',
    unknown: 'غير معروف',

    // Reports.js Detail tab i18n tail
    detailLoadFailed: 'تعذر تحميل بيانات التقرير التفصيلي.',
    categoryBasedSales: 'المبيعات حسب الفئة',
    noDataInRange: 'لا توجد بيانات في هذا النطاق',
    paymentChannelsTrend: 'اتجاه قنوات الدفع',
    vatReportTitle: 'تقرير ضريبة القيمة المضافة',
    vatRate: 'نسبة الضريبة',
    grossAmount: 'المبلغ الإجمالي',
    vatLabel: 'الضريبة',
    netAmount: 'المبلغ الصافي',
    stockStatusTitle: 'حالة المخزون',
    criticalStockShort: 'مخزون حرج',
    noStockRecord: 'لا توجد سجلات مخزون',
    unitCol: 'الوحدة',
    criticalThreshold: 'الحد الحرج',
    criticalBadge: 'حرج',
    normalBadge: 'عادي',

    // Settings.js i18n tail
    tabGeneral: 'عام',
    tabInterface: 'الواجهة',
    tabNotifications: 'الإشعارات',
    tabQRMenu: 'قائمة QR',
    tabCurrency: 'العملة',
    criticalStockAlertLabel: 'تنبيه المخزون الحرج',
    criticalStockAlertDesc: 'إشعار عند انخفاض المخزون إلى المستوى الحرج',
    recipeStockDeduction: 'خصم مخزون الوصفة',
    recipeStockDeductionDesc: 'خصم مكونات الوصفة من المخزون عند تقديم الطلب',
    settingsLoadFailed: 'تعذر تحميل الإعدادات.',
    currencyUpdated: 'تم تحديث العملة.',
    updateFailedShort: 'تعذر التحديث.',
    notifsDisabledMsg: 'تم تعطيل الإشعارات.',
    notifsEnabledMsg: 'تم تفعيل الإشعارات!',
    vapidNotConfigured: 'لم يتم ضبط VAPID.',
    operationFailed: 'فشلت العملية.',
    pushTestBody: 'إشعارات الدفع تعمل!',
    testNotifSent: 'تم إرسال الإشعار التجريبي.',
    testNotifFailed: 'تعذر إرسال الاختبار.',
    saveFailedShort: 'فشل الحفظ.',
    updateCurrencyBtn: 'تحديث العملة',
    saveSettingsBtn: 'حفظ الإعدادات',
    pushNotSupported: 'هذا المتصفح لا يدعم إشعارات الدفع.',
    pushEnabledDevice: 'إشعارات الدفع مفعلة على هذا الجهاز. ستتلقى تنبيهات للطلبات الجديدة.',
    pushEnableHint: 'قم بالتفعيل لتلقي تنبيهات فورية من المتصفح عند ورود طلبات جديدة.',

    // Recipes.js i18n tail
    selectMenuItem: 'اختر عنصر القائمة',
    selectPlaceholder: 'اختر',
    recipeLabel: 'الوصفة',
    addIngredientBtn: 'إضافة مكوّن',
    recipeLoadFailed: 'تعذر تحميل الوصفة.',
    recipeAddFailed: 'تعذر إضافة الوصفة.',
    portionCalculator: 'حاسبة الحصص',
    maxPortions: 'الحد الأقصى للحصص',
    limitingIngredient: 'المكوّن المحدِّد',
    portionAfterRecipe: 'يُحسب بعد تعريف الوصفة',
    addIngredientToRecipe: 'إضافة مكوّن إلى الوصفة',
    quantityPerPortion: 'الكمية (لكل حصة)',

    // GiftVouchers.js i18n tail
    giftVouchersTitle: 'قسائم الهدايا',
    giftVouchersSubtitle: 'أنشئ وأدر قسائم الهدايا',
    newVoucherBtn: 'قسيمة هدية جديدة',
    queryCode: 'استعلام عن الرمز',
    queryBtn: 'استعلام',
    validVoucher: 'قسيمة هدية صالحة',
    remainingBalance: 'الرصيد المتبقي',
    invalidCode: 'رمز غير صالح',
    errorOccurred: 'حدث خطأ',
    deleteVoucherConfirm: 'هل أنت متأكد من حذف قسيمة الهدية هذه؟',
    noVouchersYet: 'لا توجد قسائم هدايا بعد',
    createFirstVoucher: 'أنشئ أول قسيمة هدية',
    printAction: 'طباعة',
    usedLabel: 'مستخدم',
    expiredLabel: 'منتهي الصلاحية',
    endsLabel: 'ينتهي',
    customCodeOptional: 'رمز مخصص (اختياري)',
    autoGeneratedPh: 'يتم توليده تلقائياً',
    endDateLabel: 'تاريخ الانتهاء',
    notesLabel: 'ملاحظات',
    customMessagePh: 'رسالة مخصصة...',
    createBtn: 'إنشاء',
    dearLabel: 'السيد/السيدة',
    expiresLabel: 'ينتهي في',

    // PromoCodes.js i18n tail
    promoCodesTitle: 'أكواد الحملات',
    promoCodesSubtitle: 'إدارة أكواد الخصم والعروض',
    newCodeBtn: 'كود جديد',
    noPromoCodesYet: 'لا توجد أكواد حملات بعد',
    createFirstPromoCode: 'أنشئ أول كود حملة',
    deletePromoConfirm: 'هل أنت متأكد من حذف كود الحملة هذا؟',
    namelessCampaign: 'حملة بلا اسم',
    discountSuffix: 'خصم',
    minShortLabel: 'حد أدنى',
    usageLabel: 'الاستخدام',
    activeStatus: 'فعّال',
    inactiveStatus: 'غير فعّال',
    setActive: 'تفعيل',
    setInactive: 'تعطيل',
    editCodeTitle: 'تعديل الكود',
    newPromoCodeTitle: 'كود حملة جديد',
    codeLabel: 'الكود',
    campaignName: 'اسم الحملة',
    summerSalePh: 'تخفيضات الصيف',
    discountTypeLabel: 'نوع الخصم',
    percentOption: 'نسبة مئوية (%)',
    fixedAmountOption: 'مبلغ ثابت (₺)',
    amountOption: 'المبلغ (₺)',
    minOrderLabel: 'الحد الأدنى للطلب',
    maxUsageLabel: 'الحد الأقصى للاستخدام',
    unlimitedPh: 'غير محدود',
    updateBtn: 'تحديث',

    // WaiterStats.js i18n tail
    waiterStatsSubtitle: 'إحصائيات الطلبات والإيرادات حسب الموظف',
    waiterDataLoadFailed: 'تعذر تحميل بيانات النادل.',
    sortLabel: 'ترتيب',
    averageOrder: 'متوسط الطلب',
    topPerformance: 'الأفضل أداءً',
    staffList: 'قائمة الموظفين',
    staffCountSuffix: 'موظف',
    dataLoadingMsg: 'جارٍ تحميل البيانات...',
    tryDifferentPeriod: 'جرب اختيار فترة مختلفة',
    waiterNameCol: 'اسم النادل',
    avgOrderCol: 'متوسط الطلب',
    lastActivityCol: 'آخر نشاط',

    // Checkout.js i18n tail
    planInfoMissing: 'معلومات الخطة مفقودة.',
    planInfoLoadFailed: 'تعذر تحميل معلومات الخطة.',
    firstNameRequired: 'الاسم مطلوب',
    lastNameRequired: 'الكنية مطلوبة',
    phoneRequired: 'رقم الهاتف مطلوب',
    phoneInvalid: 'أدخل رقم هاتف صالح',
    cityRequired: 'المدينة مطلوبة',
    addressRequired: 'العنوان مطلوب',
    paymentFormLoadFailed: 'تعذر تحميل نموذج الدفع. يرجى المحاولة مرة أخرى.',
    paymentStartFailed: 'تعذر بدء الدفع. يرجى المحاولة مرة أخرى.',
    securePayment: 'دفع آمن',
    iyzicoProtected: 'دفع محمي بواسطة iyzico',
    paymentHeader: 'الدفع',
    enterBillingInfo: 'أدخل معلومات الفوترة',
    billingInfoTitle: 'معلومات الفوترة',
    firstNameLabel: 'الاسم',
    lastNameLabel: 'الكنية',
    cityLabel: 'المدينة',
    addressPh: 'الحي، الشارع، رقم المبنى...',
    paymentFormPreparing: 'جارٍ تحضير نموذج الدفع...',
    proceedToPayment: 'المتابعة للدفع',
    sslEncrypted: 'مشفر SSL',
    iyzicoSecured: 'مؤمّن بـ iyzico',
    orderSummary: 'ملخص الطلب',
    yearlyBilling: 'فوترة سنوية',
    monthlyBilling: 'فوترة شهرية',
    yearShort: 'سنة',
    monthShort: 'شهر',
    yearlyBonusHint: 'مع الدفع السنوي تحصل على شهرين مجاناً!',
    userSuffix: 'مستخدم',
    freeTrialDays: 'تجربة مجانية 14 يوماً',
    cancelAnytime: 'إلغاء في أي وقت',
    planLabel: 'الخطة',

    // الطلبات
    orderPreparing: 'قيد التحضير',
    orderReady: 'جاهز',
    orderCancelled: 'ملغي',
    tableNo: 'طاولة',

    // المدفوعات
    cash: 'نقدي',
    card: 'بطاقة',
    online: 'أونلاين',
    discount: 'خصم',
    tax: 'ضريبة',
    subtotal: 'المجموع الجزئي',
    // التوصيل
    delivery_new: 'جديد',
    delivery_accepted: 'مقبول',
    delivery_preparing: 'قيد التحضير',
    delivery_ready: 'جاهز',
    delivery_delivered: 'تم التوصيل',
    delivery_cancelled: 'ملغي',

    // إعادة تعيين كلمة المرور
    newPassword: 'كلمة المرور الجديدة',
    // الحالات العامة
    // === Batch i18n merge (agent outputs) ===
    posDisplayThanks: 'شكراً لكم!',
    posDisplayPaymentReceived: 'تم استلام دفعتك، نتمنى لك يوماً سعيداً.',
    posDisplayPaymentPending: 'في انتظار الدفع',
    posDisplayWaitForCashier: 'يرجى انتظار أمين الصندوق...',
    posDisplayTellCashier: 'أخبر أمين الصندوق بطلبك',
    posDisplayCustomerScreen: 'شاشة العميل',
    posDisplayAdAlt: 'ترويج',
    posDisplayAdHint: 'يمكن للمدير إضافة صور ترويجية من الإعدادات ← إعدادات الإيصال.',
    posDisplayPerUnit: 'قطعة',
    posDisplayDiscount: 'خصم',
    posDisplayVatIncluded: 'ضريبة القيمة المضافة (شاملة)',
    paymentResultTokenMissing: 'لم يتم العثور على معلومات رمز الدفع.',
    paymentResultFailedGeneric: 'فشلت عملية الدفع.',
    paymentResultFetchError: 'تعذر استرداد نتيجة الدفع. يرجى التواصل مع الدعم.',
    paymentResultChecking: 'جارٍ التحقق من الدفع',
    paymentResultVerifying: 'يرجى الانتظار، جاري التحقق من دفعتك...',
    paymentResultSuccess: 'تم الدفع بنجاح!',
    paymentResultSuccessDesc: 'تم إنشاء اشتراكك بنجاح. لديك الآن حق الوصول إلى جميع الميزات.',
    paymentResultPlan: 'الخطة',
    paymentResultBillingCycle: 'الفترة',
    paymentResultYearly: 'سنوي',
    paymentResultMonthly: 'شهري',
    paymentResultAmountPaid: 'المبلغ المدفوع',
    paymentResultValidUntil: 'صالح حتى',
    paymentResultTransactionId: 'رقم المعاملة',
    paymentResultGoToDashboard: 'الذهاب إلى لوحة التحكم',
    paymentResultViewSubscription: 'عرض اشتراكي',
    paymentResultReceiptSent: 'تم إرسال إيصال الدفع إلى عنوان بريدك الإلكتروني.',
    paymentResultFailed: 'فشل الدفع',
    paymentResultFailedDesc: 'تعذر إتمام عملية الدفع.',
    paymentResultRetry: 'حاول مرة أخرى',
    paymentResultBackToPlans: 'العودة إلى الخطط',
    paymentResultGoHome: 'الذهاب إلى الصفحة الرئيسية',
    paymentResultSupportPrefix: 'إذا استمرت المشكلة، تواصل مع',
    paymentResultSupportSuffix: 'للدعم.',
    securityTitle: 'الأمان',
    securityProtectAccount: 'احمِ حسابك',
    security2FATitle: 'المصادقة الثنائية (TOTP)',
    security2FADescription: 'حماية إضافية باستخدام تطبيق المصادقة (Google/Authy/1Password)',
    securityActive: 'نشط',
    securityInactive: 'غير مفعل',
    securityBackupCodes: 'رموز النسخ الاحتياطي',
    securityShownOnce: 'تُعرض مرة واحدة فقط',
    securityBackupCodesHint: 'استخدم هذه الرموز إذا فقدت الوصول إلى تطبيق المصادقة. احفظها في مكان آمن.',
    securitySavedClose: 'لقد حفظتها، إغلاق',
    securityScanQRStep: '1. امسح رمز QR أدناه باستخدام تطبيق المصادقة.',
    securityManualCode: 'الرمز اليدوي',
    securityEnterCodeStep: '2. أدخل الرمز المكون من 6 أرقام من التطبيق:',
    securityVerifying: 'جاري التحقق...',
    security2FAEnable: 'تفعيل',
    security2FADisable: 'تعطيل المصادقة الثنائية',
    security2FASetup: 'إعداد المصادقة الثنائية',
    securityPreparing: 'جاري التحضير...',
    securityEnterPasswordTOTP: 'أدخل كلمة المرور ورمز TOTP.',
    securityTOTPCode: 'رمز TOTP مكون من 6 أرقام',
    securitySetupFailed: 'تعذر بدء الإعداد.',
    securityCodeInvalid: 'الرمز غير صحيح.',
    securityDisableFailed: 'تعذر التعطيل.',
    gdprTitle: 'اللائحة العامة لحماية البيانات / KVKK',
    gdprSubtitle: 'حقوق البيانات الشخصية وإدارة الخصوصية',
    gdprTabRights: 'حقوقي بموجب اللائحة',
    gdprTabRequest: 'إرسال طلب',
    gdprTabMyRequests: 'طلباتي',
    gdprTabAdmin: 'لوحة المسؤول',
    gdprTypeExport: 'تصدير البيانات',
    gdprTypeDelete: 'حذف البيانات (الحق في النسيان)',
    gdprTypeRectify: 'تصحيح البيانات',
    gdprTypeRestrict: 'تقييد المعالجة',
    gdprTypeObject: 'الاعتراض على المعالجة',
    gdprStatusPending: 'قيد الانتظار',
    gdprStatusProcessing: 'قيد المعالجة',
    gdprStatusCompleted: 'مكتمل',
    gdprStatusRejected: 'مرفوض',
    gdprStatTotal: 'إجمالي الطلبات',
    gdprStatPending: 'قيد الانتظار',
    gdprStatCompleted: 'مكتمل',
    gdprStatRejected: 'مرفوض',
    gdprRightsHeading: 'حقوقك بموجب القانون رقم 6698 / اللائحة العامة لحماية البيانات',
    gdprRightsIntro: 'بموجب قانون حماية البيانات الشخصية (KVKK) واللائحة العامة الأوروبية لحماية البيانات (GDPR)، لديك الحقوق التالية:',
    gdprRightInfoTitle: 'الحق في المعلومات',
    gdprRightInfoDesc: 'لديك الحق في معرفة ما إذا كانت بياناتك الشخصية تتم معالجتها.',
    gdprRightPortabilityTitle: 'قابلية نقل البيانات',
    gdprRightPortabilityDesc: 'يمكنك طلب الحصول على بياناتك الشخصية المعالجة بتنسيق منظم وقابل للقراءة آليًا.',
    gdprRightRectifyTitle: 'الحق في التصحيح',
    gdprRightRectifyDesc: 'يمكنك طلب تصحيح البيانات الشخصية غير الدقيقة أو غير المكتملة.',
    gdprRightDeleteTitle: 'الحق في المحو / النسيان',
    gdprRightDeleteDesc: 'يمكنك طلب حذف بياناتك الشخصية أو إتلافها.',
    gdprRightObjectTitle: 'الاعتراض على المعالجة',
    gdprRightObjectDesc: 'يمكنك الاعتراض على معالجة بياناتك الشخصية.',
    gdprRightRestrictTitle: 'تقييد المعالجة',
    gdprRightRestrictDesc: 'في ظل ظروف معينة، يمكنك طلب تقييد معالجة بياناتك الشخصية.',
    gdprDataController: 'مراقب البيانات',
    gdprControllerInfo: 'RestaFlex — سيتم الرد على طلباتك في غضون 30 يومًا كحد أقصى. للأسئلة:',
    gdprCreateRequest: 'إنشاء طلب',
    gdprNewRequest: 'طلب جديد بموجب اللائحة',
    gdprRequestType: 'نوع الطلب',
    gdprDescriptionOptional: 'الوصف (اختياري)',
    gdprDescriptionPlaceholder: 'معلومات إضافية حول طلبك...',
    gdprSubmitting: 'جارٍ الإرسال...',
    gdprSubmitRequest: 'إرسال الطلب',
    gdprDownloadNow: 'هل ترغب في تنزيل بياناتك الآن؟',
    gdprDownloadPackage: 'تنزيل حزمة بياناتي (JSON)',
    gdprNoRequests: 'لم تقم بإرسال أي طلبات بعد.',
    gdprResponse: 'الرد',
    gdprTotalConsent: 'إجمالي الموافقة',
    gdprAnalyticsAccepted: 'تم قبول التحليلات',
    gdprAnalyticsRejected: 'تم رفض التحليلات',
    gdprMarketingAccepted: 'تم قبول التسويق',
    gdprAllStatuses: 'جميع الحالات',
    gdprAllTypes: 'جميع الأنواع',
    gdprFilter: 'تصفية',
    gdprNoRequestsFound: 'لم يتم العثور على طلبات.',
    gdprProcess: 'معالجة',
    gdprProcessRequest: 'معالجة الطلب',
    gdprStatus: 'الحالة',
    gdprResponseNote: 'ملاحظة الرد',
    gdprResponsePlaceholder: 'الرد الذي سيتم إرساله للمستخدم...',
    gdprExportFailed: 'تعذر تصدير البيانات.',
    pricingTrialBadge: 'تجربة مجانية 14 يوماً — لا حاجة لبطاقة ائتمان',
    pricingTitleLine1: 'اختر الخطة المناسبة',
    pricingTitleHighlight: 'لـ',
    pricingTitleLine2: 'مطعمك',
    pricingSubtitle: 'أدر طاولاتك وطلباتك ومطبخك من منصة واحدة مع RestaFlex.',
    pricingMonthly: 'شهري',
    pricingYearly: 'سنوي',
    pricingTwoMonthsFree: 'شهران مجاناً',
    pricingPlansLoadError: 'فشل تحميل الخطط.',
    pricingNoPlansFound: 'لم يتم العثور على خطط. يرجى المحاولة لاحقاً.',
    pricingMostPopular: 'الأكثر شعبية',
    pricingYearlySavingsPrefix: 'وفر',
    pricingYearlySavingsSuffix: 'سنوياً!',
    pricingTablesSuffix: 'طاولة',
    pricingStartFreeTrial: 'ابدأ التجربة المجانية لـ 14 يوماً',
    pricingComparisonTitle: 'مقارنة الميزات',
    pricingComparisonSubtitle: 'أي خطة تناسبك؟ قارن واتخذ قرارك.',
    pricingFeatureColumn: 'الميزة',
    pricingPriceMonthly: 'السعر (شهري)',
    pricingMaxTables: 'الحد الأقصى للطاولات',
    pricingMaxUsers: 'الحد الأقصى للمستخدمين',
    pricingFeatureQrMenu: 'قائمة QR',
    pricingFeatureTableManagement: 'إدارة الطاولات',
    pricingFeatureOrderManagement: 'إدارة الطلبات',
    pricingFeatureKitchenDisplay: 'شاشة المطبخ',
    pricingFeaturePaymentSystem: 'نظام الدفع',
    pricingFeatureStockManagement: 'إدارة المخزون',
    pricingFeatureRecipeSystem: 'نظام الوصفات',
    pricingFeatureWaiterManagement: 'إدارة النُدُل',
    pricingFeatureAdvancedAnalytics: 'تحليلات متقدمة',
    pricingFeatureApiAccess: 'الوصول إلى API',
    pricingFaqTitle: 'الأسئلة الشائعة',
    pricingFaqSubtitle: 'إجابات على الأسئلة التي تدور في ذهنك.',
    pricingFaq1Q: 'ماذا يحدث عند انتهاء الفترة التجريبية؟',
    pricingFaq1A: 'عند انتهاء تجربتك المجانية لـ 14 يوماً، يتم تعليق حسابك. بياناتك لن تُحذف، ويمكنك اختيار خطة لمتابعة العمل.',
    pricingFaq2Q: 'هل يمكنني الإلغاء في أي وقت؟',
    pricingFaq2A: 'نعم، يمكنك إلغاء اشتراكك في أي وقت. عند الإلغاء، ستستمر في الحصول على الخدمة حتى نهاية الفترة الحالية، ولن يتم تحصيل رسوم للفترة التالية.',
    pricingFaq3Q: 'هل يمكنني تغيير خطتي؟',
    pricingFaq3A: 'نعم، يمكنك ترقية أو تخفيض خطتك في أي وقت. تسري الترقية فوراً، بينما يطبق التخفيض في نهاية الفترة الحالية.',
    pricingFaq4Q: 'هل الدفع آمن؟',
    pricingFaq4A: 'تتم معالجة جميع المدفوعات بأمان عبر بنية iyzico التحتية بتشفير SSL بسعة 256 بت. لا يتم تخزين تفاصيل بطاقتك في نظامنا.',
    pricingCtaTitle: 'ابدأ الآن',
    pricingCtaSubtitle: 'استخدم جميع الميزات مجاناً لمدة 14 يوماً. لا حاجة لبطاقة ائتمان.',
    pricingCtaTryFree: 'جرب مجاناً',
    pricingCtaChoosePlan: 'اختر خطتي',
    webhooksTitle: 'تكاملات Webhook',
    webhooksSubtitle: 'ادمج Zapier أو Make.com أو أنظمتك المخصصة مع الأحداث في الوقت الفعلي.',
    webhookNewButton: '+ Webhook جديد',
    webhookNewTitle: 'إضافة Webhook جديد',
    webhookEditTitle: 'تعديل Webhook',
    webhookHintZapier: 'الصق رابط Trigger هنا',
    webhookHintMake: 'رابط وحدة Webhook المخصصة',
    webhookHintN8n: 'رابط تشغيل عقدة Webhook',
    webhookHintCustomLabel: 'نظام مخصص',
    webhookHintCustomDesc: 'أي نقطة نهاية HTTPS',
    webhookStatTotal: 'إجمالي Webhooks',
    webhookStatFailing: 'فاشل',
    webhookEmptyTitle: 'لا توجد Webhooks بعد',
    webhookEmptyDesc: 'أضف webhook للتكامل مع Zapier أو Make.com.',
    webhookErrorsLabel: 'أخطاء',
    webhookErrorLabel: 'خطأ',
    webhookLastTriggered: 'آخر تشغيل',
    webhookTestSend: 'اختبار',
    webhookTestSent: 'تم إرسال webhook الاختبار.',
    webhookTestFailed: 'فشل إرسال الاختبار.',
    webhookDeliveryHistory: 'سجل التسليم',
    webhookNoDeliveries: 'لا توجد سجلات تسليم بعد.',
    webhookDeleteConfirm: 'هل تريد حذف هذا الـ webhook؟',
    webhookUpdateFailed: 'فشل التحديث.',
    webhookNameRequired: 'الاسم مطلوب.',
    webhookUrlRequired: 'الرابط مطلوب.',
    webhookEventRequired: 'اختر حدثًا واحدًا على الأقل.',
    webhookUrlInvalid: 'أدخل رابطًا صالحًا.',
    webhookNameLabel: 'الاسم',
    webhookNamePlaceholder: 'مثال: إشعار طلب Zapier',
    webhookEndpointLabel: 'رابط Webhook',
    webhookHttpsRecommended: '(يوصى باستخدام HTTPS)',
    webhookEventsLabel: 'الأحداث',
    webhookSecretLabel: 'سر التوقيع',
    webhookSecretHint: '— اختياري، يتم إنشاؤه تلقائيًا إذا تُرك فارغًا',
    webhookSecretPlaceholder: 'سرك الخاص أو اتركه فارغًا',
    webhookSecurityLabel: 'الأمان',
    webhookSecurityPart1: 'يتم توقيع كل طلب وإرساله مع',
    webhookSecurityPart2: 'رأس.',
    webhookSecurityPart3: 'يمكنك التحقق من هذا الرأس في Custom Request الخاص بـ Zapier.',
    webhookSaving: 'جاري الحفظ…',
    webhookEventOrderCreated: 'تم إنشاء الطلب',
    webhookEventOrderStatusChanged: 'تغيرت حالة الطلب',
    webhookEventPaymentCompleted: 'اكتمل الدفع',
    webhookEventReservationCreated: 'تم إنشاء الحجز',
    webhookEventReservationStatusChanged: 'تغيرت حالة الحجز',
    webhookEventCustomerCreated: 'تسجيل عميل جديد',
    webhookEventDeliveryOrderCreated: 'تم استلام طلب التوصيل',
    webhookEventDeliveryOrderStatusChanged: 'تغيرت حالة التوصيل',
    subscriptionStatusTrial: 'تجريبي',
    subscriptionStatusCancelled: 'ملغى',
    subscriptionStatusExpired: 'منتهي الصلاحية',
    subscriptionStatusPastDue: 'متأخر',
    subscriptionLoadError: 'فشل تحميل البيانات.',
    subscriptionCancelSuccess: 'تم إلغاء اشتراكك. ستستمر في تلقي الخدمة حتى نهاية الفترة الحالية.',
    subscriptionCancelError: 'فشلت عملية الإلغاء.',
    subscriptionTitle: 'اشتراكي',
    subscriptionSubtitle: 'أدر حالة اشتراكك وحدّث خطتك.',
    subscriptionWord: 'اشتراك',
    subscriptionTrialPeriod: 'فترة تجريبية',
    subscriptionTrialEnd: 'نهاية التجربة',
    subscriptionNextPayment: 'الدفعة التالية',
    subscriptionDaysRemaining: 'الأيام المتبقية',
    subscriptionDaysUnit: 'أيام',
    subscriptionEnded: 'انتهى',
    subscriptionTimeUsage: 'استخدام الوقت',
    subscriptionDaysLeft: 'يوم متبقي',
    subscriptionNoActive: 'ليس لديك اشتراك نشط',
    subscriptionNeedPlan: 'يجب عليك اختيار خطة لاستخدام النظام.',
    subscriptionChoosePlan: 'اختر خطة',
    subscriptionChangePlan: 'تغيير الخطة',
    subscriptionCurrentPlan: 'الخطة الحالية',
    subscriptionMaxTables: 'الحد الأقصى',
    subscriptionTablesUnit: 'طاولة',
    subscriptionMaxUsers: 'الحد الأقصى',
    subscriptionUsersUnit: 'مستخدم',
    subscriptionUpgradeBtn: 'ترقية',
    subscriptionDowngradeBtn: 'تخفيض',
    subscriptionStartBtn: 'ابدأ',
    subscriptionActivePlan: 'الخطة النشطة',
    subscriptionPaymentHistory: 'سجل المدفوعات',
    subscriptionDateCol: 'التاريخ',
    subscriptionPeriodCol: 'الفترة',
    subscriptionPaymentSuccess: 'ناجح',
    subscriptionPaymentFailed: 'فشل',
    subscriptionCancelTitle: 'إلغاء الاشتراك',
    subscriptionCancelInfo: 'إذا ألغيت اشتراكك، ستستمر في تلقي الخدمة حتى نهاية الفترة الحالية. لا يمكن التراجع عن الإلغاء.',
    subscriptionCancelInfoTrial: 'ستنتهي فترتك التجريبية فوراً وستفقد الوصول إلى جميع الميزات.',
    subscriptionCancelConfirm: 'سيتم إلغاء اشتراكك في نهاية الفترة الحالية.',
    subscriptionCancelConfirmTrial: 'سيتم إلغاء اشتراكك التجريبي فوراً. هل أنت متأكد؟',
    subscriptionCancelAccessUntil: 'سيظل وصولك نشطاً حتى {date}.',
    subscriptionCancelScheduled: 'اشتراكك مجدول للإلغاء',
    subscriptionAccessUntil: 'وصولك نشط حتى:',
    subscriptionCancelling: 'جارٍ الإلغاء...',
    subscriptionCancelYes: 'نعم، إلغاء',
    printersTitle: 'الطابعات',
    printersSubtitle: 'إدارة طابعات الإيصالات والمطبخ والباركود',
    printerAddBtn: 'إضافة طابعة',
    printerAddFirstBtn: 'أضف أول طابعة',
    printerAddTitle: 'إضافة طابعة',
    printerEditTitle: 'تعديل الطابعة',
    printerEmptyTitle: 'لم تتم إضافة طابعات بعد',
    printerEmptySubtitle: 'أضف طابعة لإدارة إيصالاتك',
    printerJobsTab: 'قائمة الطباعة',
    printerJobQueueTitle: 'قائمة مهام الطباعة',
    printerNoJobs: 'لا توجد مهام في القائمة',
    printerDefault: 'افتراضي',
    printerTypeReceipt: 'إيصال',
    printerTypeKitchen: 'المطبخ',
    printerTypeBar: 'البار',
    printerConnectionNetwork: 'شبكة (IP)',
    printerConnectionUsb: 'USB',
    printerConnectionSerial: 'منفذ تسلسلي',
    printerConnectionLabel: 'الاتصال',
    printerAddressLabel: 'العنوان',
    printerPortLabel: 'المنفذ',
    printerComPortLabel: 'منفذ COM',
    printerPaperWidthLabel: 'عرض الورق',
    printerNameLabel: 'اسم الطابعة',
    printerNamePlaceholder: 'مثلاً طابعة الكاشير',
    printerTypeLabel: 'النوع',
    printerIpLabel: 'عنوان IP',
    printerNameRequired: 'اسم الطابعة مطلوب.',
    printerIpRequired: 'عنوان IP مطلوب.',
    printerComPortRequired: 'منفذ COM مطلوب.',
    printerDeleteConfirm: 'هل أنت متأكد من حذف هذه الطابعة؟',
    printerRetryFailed: 'فشلت إعادة المحاولة.',
    printerOnline: 'متصل',
    printerOffline: 'غير متصل',
    printerTestSent: 'تم إرسال صفحة الاختبار',
    printerTestFailed: 'فشل الاختبار',
    printerStatusBtn: 'الحالة',
    printerTestBtn: 'اختبار',
    printerRetryBtn: 'إعادة المحاولة',
    printerLabel: 'طابعة',
    printerAttempt: 'محاولة',
    printerJobStatusPending: 'قيد الانتظار',
    printerJobStatusPrinting: 'جارٍ الطباعة',
    printerJobStatusDone: 'مكتمل',
    printerJobStatusFailed: 'فشل',
    printerStatTotal: 'إجمالي الطابعات',
    printerStatActive: 'نشط',
    printerStatInactive: 'غير نشط',
    printerStatPending: 'مهام معلقة',
    printerIsDefaultTitle: 'الطابعة الافتراضية',
    printerIsDefaultHint: 'يتم اختيارها تلقائيًا لعمليات هذا النوع',
    printerIsActiveHint: 'لا يتم إرسال مهام إلى الطابعات غير النشطة',
    whiteLabelTitle: 'إدارة العلامة البيضاء',
    whiteLabelSubtitle: 'إعدادات العلامات المخصصة للشركاء',
    whiteLabelNewConfig: 'إعداد جديد',
    whiteLabelNewConfigTitle: 'إعداد علامة بيضاء جديد',
    whiteLabelEditConfig: 'تعديل الإعداد',
    whiteLabelStatTotal: 'إجمالي الإعدادات',
    whiteLabelStatActive: 'نشط',
    whiteLabelStatPassive: 'غير نشط',
    whiteLabelStatusActive: 'نشط',
    whiteLabelStatusPassive: 'غير نشط',
    whiteLabelEmptyTitle: 'لا توجد إعدادات علامة بيضاء بعد',
    whiteLabelEmptyDesc: 'أنشئ علامات مخصصة للشركاء',
    whiteLabelRestaurantsSuffix: 'مطاعم',
    whiteLabelDetailTitle: 'التفاصيل',
    whiteLabelSlug: 'المعرّف',
    whiteLabelDomain: 'النطاق',
    whiteLabelSupportEmail: 'البريد الإلكتروني للدعم',
    whiteLabelSupportPhone: 'هاتف الدعم',
    whiteLabelBrandingUrl: 'رابط العلامة',
    whiteLabelLinkedRestaurants: 'المطاعم المرتبطة',
    whiteLabelNoRestaurants: 'لم يتم تعيين أي مطعم بعد.',
    whiteLabelUnassignTitle: 'إلغاء التعيين',
    whiteLabelPartnerName: 'اسم الشريك',
    whiteLabelPartnerNamePlaceholder: 'مثلاً: Acme Restaurant Solutions',
    whiteLabelAppName: 'اسم التطبيق',
    whiteLabelLogoUrl: 'رابط الشعار',
    whiteLabelPrimaryColor: 'اللون الأساسي',
    whiteLabelSecondaryColor: 'اللون الثانوي',
    whiteLabelTextColor: 'لون النص',
    whiteLabelBgColor: 'لون الخلفية',
    whiteLabelCustomDomain: 'نطاق مخصص',
    whiteLabelFooterText: 'نص التذييل',
    whiteLabelFooterPlaceholder: '© 2026 اسم الشريك. جميع الحقوق محفوظة.',
    whiteLabelCustomCss: 'CSS مخصص',
    whiteLabelHidePoweredBy: 'إخفاء "Powered by RestaFlex"',
    whiteLabelPreview: 'معاينة',
    whiteLabelSaving: 'جارٍ الحفظ...',
    whiteLabelNameSlugRequired: 'الاسم والمعرّف مطلوبان.',
    whiteLabelSlugPattern: 'يمكن أن يحتوي المعرّف على أحرف صغيرة وأرقام وشرطات فقط.',
    whiteLabelDeleteConfirm: 'سيتم حذف إعداد العلامة البيضاء هذا. سيتم إلغاء تعيين المطاعم المرتبطة. هل تريد المتابعة؟',
    whiteLabelLoadError: 'تعذر تحميل البيانات.',
    whiteLabelDetailError: 'تعذر تحميل التفاصيل.',
    whiteLabelDeleteError: 'خطأ في الحذف.',
    whiteLabelUpdateError: 'خطأ في التحديث.',
    whiteLabelUnassignError: 'خطأ في إلغاء التعيين.',
    qrmenuWaiterCalled: 'تم استدعاء النادل! سيصل إلى طاولتك قريباً.',
    qrmenuWaiterCallFailed: 'تعذر إرسال الاتصال. يرجى المحاولة مرة أخرى.',
    qrmenuLoadFailed: 'تعذر تحميل القائمة.',
    qrmenuPaymentVerifyFailed: 'تعذر التحقق من الدفع. يرجى الاتصال بالمطعم.',
    qrmenuDefaultTitle: 'قائمة المطعم',
    qrmenuEnterName: 'يرجى إدخال اسمك.',
    qrmenuRestaurantNotFound: 'لم يتم العثور على معلومات المطعم. يرجى مسح رمز QR مرة أخرى.',
    qrmenuOrderFailed: 'تعذر إرسال الطلب. يرجى المحاولة مرة أخرى.',
    // QR Menü tema sistemi (Faz B+E1)
    qrThemeTitle: 'السمة',
    qrThemeDesc: 'اختر من بين 44 سمة جاهزة. تشمل كل سمة الخطوط والألوان والتخطيط.',
    qrThemeAllCats: 'الكل',
    qrThemeSearchPh: 'بحث عن السمات (الاسم، الخط، التخطيط...)',
    qrThemeNoMatch: 'لم يتم العثور على سمة مطابقة.',
    qrThemeDarkOnly: 'الداكنة فقط',
    qrThemeRandom: 'عشوائي',
    qrThemeFav: 'إضافة إلى المفضلة',
    qrThemeUnfav: 'إزالة من المفضلة',
    qrThemeFavoritesOnly: 'المفضلة',
    qrThemeClearFilters: 'مسح المرشحات',
    qrThemeRecent: 'المستخدمة مؤخراً',
    qrThemeCategoryFilter: 'مرشح فئة السمة',
    qrThemeLivePreview: 'معاينة مباشرة',
    qrThemeCatClassic: 'كلاسيكي',
    qrThemeCatCafe: 'مقهى',
    qrThemeCatFastFood: 'وجبات سريعة',
    qrThemeCatModern: 'حديث',
    qrThemeCatTropical: 'استوائي',
    qrThemeCatBakery: 'مخبز',
    qrThemeCatPub: 'حانة/بار',
    qrThemeCatEthnic: 'عرقي / مطبخ',
    qrThemeCatCorporate: 'مؤسسي',
    qrCustomOverrideTitle: 'تجاوز ألوان السمة (اختياري)',
    qrCustomOverrideDesc: 'يتجاوز ألوان السمة المحددة. اتركه فارغًا لاستخدام الافتراضي.',
    qrCustomPrimary: 'اللون الأساسي',
    qrCustomSecondary: 'اللون الثانوي',
    qrCustomFont: 'تجاوز الخط',
    qrCustomFontTheme: 'افتراضي السمة',
    qrThemeSampleItem: 'منتج عينة',
    qrThemePreviewItem: 'لاتيه',
    qrThemeSampleDesc: 'وصف مختصر',
    qrThemeDarkLabel: 'سمة داكنة',
    qrThemeDarkShort: 'داكن',
    qrVariantPreviewLabel: 'معاينة النمط',
    qrLayoutPrefix: 'التخطيط',
    qrPublicUrlTitle: 'رابط القائمة العامة',
    qrPublicUrlDesc: 'رابط القائمة العامة الذي سيمسحه العملاء',
    qrScanForMenu: 'امسح رمز QR لعرض القائمة',
    printQr: 'طباعة رمز QR',
    popupBlocked: 'تم حظر النافذة المنبثقة. الرجاء السماح بالنوافذ المنبثقة.',
    downloadFailed: 'فشل التنزيل.',
    downloadSvg: 'تنزيل SVG',
    linkCopied: 'تم نسخ الرابط',
    copyFailed: 'تعذر النسخ',
    copy: 'نسخ',
    qrLogoTitle: 'شعار المطعم',
    qrLogoDesc: 'الشعار الذي سيظهر أعلى قائمة QR (PNG/JPG/WEBP، 2 ميجا كحد أقصى)',
    qrLogoUploadBtn: 'رفع الشعار',
    qrLogoUpload: 'رفع الشعار',
    qrLogoUploaded: 'تم رفع الشعار.',
    qrLogoRemove: 'إزالة الشعار',
    qrLogoSize: 'حجم الشعار',
    qrLogoMaxSize: 'الحد الأقصى لحجم الملف: 2 ميجابايت',
    qrThemeCategory: 'فئة السمة',
    qrThemeSearch: 'بحث عن سمة',
    qrThemeNotFound: 'السمة غير موجودة',
    qrThemeReset: 'إعادة ضبط السمة',
    qrDisplayTitle: 'العرض والسلوك',
    qrDisplayDesc: 'إدارة ما يراه العميل في قائمة QR',
    qrLayoutLabel: 'التخطيط',
    qrLayoutGrid: 'شبكة',
    qrLayoutList: 'قائمة',
    qrLayoutMagazine: 'مجلة',
    qrShowImages: 'إظهار صور المنتجات',
    qrShowDescriptions: 'إظهار أوصاف المنتجات',
    qrShowPrices: 'إظهار الأسعار',
    qrShowAllergens: 'إظهار معلومات مسببات الحساسية',
    qrShowCalories: 'إظهار معلومات السعرات الحرارية',
    qrActiveTheme: 'المظهر النشط',
    qrCartDisabledHint: 'ميزة سلة QR معطلة — يمكن للعملاء فقط عرض القائمة، لا يمكنهم الطلب.',
    qrCartDisabledInfo: 'هذا المطعم لا يقبل طلبات QR، يرجى استدعاء النادل.',
    qrCartEmpty: 'سلتك فارغة — أضف عناصر من القائمة',
    qrEnableCart: 'ميزة السلة والطلب (QR)',
    qrEnableWaiterCall: 'زر استدعاء النادل',
    qrWelcomeMsg: 'رسالة الترحيب',
    qrWelcomeMsgPh: 'مرحبًا بكم، نتمنى لكم اختيارًا لذيذًا!',
    qrCartSendToWaiter: 'إرسال الطلب عبر QR',
    qrCartTitle: 'طلبك جاهز',
    qrCartSubtitle: 'أظهر هذا الـ QR للنادل',
    qrCartGenerating: 'جارٍ إنشاء رمز QR...',
    qrCartGenFail: 'تعذر إنشاء QR.',
    qrCartTotal: 'الإجمالي',
    qrCartInstruction: 'اتصل بالنادل واطلب منه مسح رمز QR هذا. سيتم تسجيل طلبك تلقائيًا.',
    qrCartRegenerate: 'انتهى الوقت — إنشاء QR جديد',
    qrCartClaimed: 'تم استلام الطلب!',
    qrCartClaimedSub: 'يتم التحضير، سيصلك قريبًا.',
    qrCartOrderNo: 'رقم الطلب',
    qrCartRejectedTitle: 'تم رفض السلة',
    qrCartRejectedSub: 'لم يتمكن النادل من الموافقة على سلتك. يرجى مراجعة سلتك والمحاولة مرة أخرى، أو التحدث إلى النادل.',
    qrCartTryAgain: 'حاول مرة أخرى',
    qrCartZoom: 'تكبير QR',
    zoomImage: 'تكبير الصورة',
    qrCartZoomHint: 'انقر للإغلاق',
    qrCartShare: 'مشاركة QR',
    qrCartShareTitle: 'رمز QR للطلب',
    qrCartShareText: 'رمز الطلب لإظهاره للنادل',
    qrCartAutoClose: 'إغلاق تلقائي…',
    qrCartCloseNow: 'إغلاق الآن',
    qrCartRetrying: 'إعادة المحاولة',
    confirmRemoveImage: 'هل أنت متأكد من حذف صورة هذا المنتج؟',
    qrPending: 'QR في الانتظار',
    qrPendingCartsTitle: 'سلات QR المعلقة',
    qrPendingCartsSub: 'عملاء بانتظار الطلب — انقر للمراجعة',
    qrPendingCartsSub2: 'سلال تنتظر موافقتك',
    qrNoPendingCarts: 'لا توجد سلال معلقة',
    qrCartClaimFail: 'تعذر استلام السلة.',
    qrAcceptToOrder: 'تحويل إلى طلب',
    qrCartPickTable: 'اختر طاولة',
    qrCartPickTableHint: 'لأي طاولة تخص هذه السلة؟',
    qrCartNoTables: 'لم يتم العثور على طاولات.',
    tableOccupied: 'مشغولة',
    qrCartReject: 'رفض',
    qrCartCallCustomer: 'اتصال بالعميل',
    qrCartRejectConfirm: 'هل أنت متأكد من رفض سلة QR هذه؟',
    qrCartRejectReason: 'النادل رفض',
    qrCartRejectFail: 'تعذر رفض السلة.',
    qrCartRejected: 'تم رفض السلة',
    qrCartBulkClaim: 'الموافقة على الكل',
    qrCartBulkClaimConfirm: 'هل تريد تحويل جميع السلال المعلقة إلى طلبات؟',
    qrCartBulkOk: 'سلات تم تحويلها',
    qrCartBulkFail: 'فشل',
    qrCartBulkReject: 'رفض الكل',
    qrCartBulkRejectConfirm: 'هل تريد رفض جميع السلال المعلقة؟ لا يمكن التراجع عن هذا الإجراء.',
    qrCartBulkRejectOk: 'سلات تم رفضها',
    sortBy: 'فرز حسب',
    sortNewestFirst: 'الأحدث أولاً',
    sortOldestFirst: 'الأقدم أولاً',
    sortTotalDesc: 'أعلى مبلغ',
    qrPendingSearchPh: 'بحث عن العميل أو الهاتف أو الطاولة أو الرمز…',
    qrPendingNoMatch: 'لا توجد سلة مطابقة',
    qrPendingEmptyHint: 'ستظهر طلبات QR العملاء هنا',
    orderSourceQrOnline: 'طلب QR',
    orderStatQrToday: 'QR اليوم',
    soundMute: 'كتم الصوت',
    soundUnmute: 'تشغيل الصوت',
    retry: 'إعادة المحاولة',
    qrMinOrder: 'الحد الأدنى لمبلغ الطلب',
    qrMinOrderHint: 'اضبط على 0 لعدم وجود حد أدنى. طلبات سلة QR التي تقل عن هذا المبلغ سيتم رفضها.',
    qrMinOrderWarn: 'الحد الأدنى',
    qrMinOrderMissing: 'المتبقي',
    qrMinOrderMet: 'تم استيفاء الحد الأدنى للطلب',
    clearCartBtn: 'إفراغ السلة',
    clearCartConfirm: 'هل تريد إفراغ السلة؟',
    qrResetSettings: 'إعادة تعيين إعدادات قائمة QR',
    qrResetConfirm: 'هل تريد إعادة تعيين إعدادات قائمة QR إلى الإفتراضي؟ سيتم مسح جميع تغييرات السمة والشعار والتخطيط.',
    qrResetDone: 'تمت إعادة التعيين. انقر "حفظ" لتطبيق.',
    qrExportConfig: 'تصدير تكوين السمة كـ JSON',
    qrExportConfigError: 'فشل التصدير',
    qrImportConfig: 'استيراد تكوين السمة من JSON',
    qrImportConfigOk: 'تم استيراد الإعدادات. انقر "حفظ" للتطبيق.',
    qrImportConfigError: 'JSON غير صالح أو تعذر التحليل.',
    viewDetails: 'عرض التفاصيل',
    hideDetails: 'إخفاء التفاصيل',
    tap: 'انقر',
    torchOn: 'تشغيل الضوء',
    torchOff: 'إيقاف الضوء',
    flipCamera: 'قلب الكاميرا',
    pickImageSourcePrompt: 'من أين تريد اختيار الصورة؟',
    camera: 'الكاميرا',
    gallery: 'المعرض',
    cameraPermDenied: 'تم رفض إذن الكاميرا',
    viewPendingCarts: 'عرض السلال المعلقة',
    scan: 'مسح',
    // Mobile scan ekranı
    scanQrTitle: 'مسح طلب QR',
    scanQrHint: 'قم بتأطير رمز QR على هاتف العميل',
    scanQrFetching: 'جارٍ جلب السلة...',
    scanQrInvalidPayload: 'رمز QR غير صالح.',
    scanQrExpired: 'انتهت صلاحية السلة.',
    scanQrAlreadyClaimed: 'تمت معالجة السلة بالفعل.',
    scanQrNotFound: 'لم يتم العثور على السلة.',
    scanQrFetchFail: 'تعذر جلب السلة.',
    scanQrCartReady: 'السلة جاهزة',
    scanQrCustomer: 'العميل',
    scanQrNote: 'ملاحظة العميل',
    scanQrTotal: 'الإجمالي',
    scanQrReject: 'إلغاء',
    scanQrAccept: 'قبول الطلب',
    scanQrSuccess: 'تم قبول الطلب!',
    scanQrOrderNo: 'رقم الطلب',
    scanQrViewOrder: 'عرض الطلب',
    scanQrScanMore: 'مسح جديد',
    cameraPermNeeded: 'يلزم إذن الكاميرا',
    cameraPermDesc: 'يجب منح حق الوصول إلى الكاميرا لمسح رموز QR.',
    grantPermission: 'منح الإذن',
    // Görsel yükleme
    menuMgmtUploadImage: 'رفع صورة',
    menuMgmtChangeImage: 'تغيير الصورة',
    menuMgmtRemoveImage: 'إزالة الصورة',
    menuSearchPh: 'بحث عن منتج أو وصف…',
    menuNoMatch: 'لا يوجد منتج مطابق',
    menuMgmtImageHint: 'JPEG/PNG/WEBP/GIF، 2 ميجا كحد أقصى',
    menuMgmtDropHere: 'أفلت هنا',
    menuMgmtDragOrClick: 'اسحب أو انقر',
    uploading: 'جارٍ التحميل…',
    invalidFileType: 'يتم قبول ملفات الصور فقط.',
    fileTooLarge: 'يجب أن يكون الملف أقل من 2 ميجا.',
    uploadFailed: 'فشل التحميل.',
    productImage: 'صورة المنتج',
    pickImage: 'اختيار صورة',
    changeImage: 'تغيير الصورة',
    imageUploaded: 'تم رفع الصورة',
    imageRemoved: 'تم إزالة الصورة',
    removeFailed: 'فشل الإزالة',
    cameraRollPermDenied: 'تم رفض إذن المعرض',
    qrmenuOrderReceived: 'تم استلام الطلب!',
    qrmenuOrderSentToKitchen: 'تم إرسال طلبك إلى المطبخ. سيتم تحضيره قريباً.',
    qrmenuApproxReadyIn: 'جاهز خلال حوالي',
    qrmenuMinutes: 'دقيقة',
    qrmenuOrderNo: 'رقم الطلب',
    qrmenuBackToMenu: 'العودة إلى القائمة',
    qrmenuSecurePayment: 'دفع آمن',
    qrmenuPlaceOrder: 'إرسال الطلب',
    qrmenuYourCart: 'سلتك',
    qrmenuYourInfo: 'معلوماتك',
    qrmenuFullNameLabel: 'الاسم الكامل *',
    qrmenuFullNamePlaceholder: 'اسمك الكامل',
    qrmenuPhoneLabel: 'الهاتف (اختياري)',
    qrmenuEmailLabel: 'البريد الإلكتروني (للإيصال)',
    qrmenuNoteLabel: 'ملاحظة (اختياري)',
    qrmenuNotePlaceholder: 'الحساسية، طلبات خاصة...',
    qrmenuPaymentMethod: 'طريقة الدفع',
    qrmenuPayCash: 'نقداً (الدفع على الطاولة)',
    qrmenuPayCardTable: 'بطاقة (الدفع على الطاولة)',
    qrmenuPayOnline: 'الدفع عبر الإنترنت (ادفع الآن)',
    qrmenuSelected: 'محدد',
    qrmenuSending: 'جاري الإرسال...',
    qrmenuGoToPayment: 'متابعة الدفع',
    qrmenuDigitalMenu: 'القائمة الرقمية',
    qrmenuAll: 'الكل',
    qrmenuAllergenFilter: 'تصفية مسببات الحساسية',
    qrmenuAllergenFilterHint: 'حدد مسببات الحساسية التي تريد استبعادها:',
    // ── 14 مسببات الحساسية الإلزامية (label + desc) — AR ──
    allergenGlutenLabel: 'الجلوتين',
    allergenGlutenDesc: 'القمح والشعير والشوفان ومشتقاتها',
    allergenCrustaceansLabel: 'القشريات',
    allergenCrustaceansDesc: 'الجمبري والسلطعون والكركند ومشتقاتها',
    allergenEggsLabel: 'البيض',
    allergenEggsDesc: 'البيض ومنتجات البيض',
    allergenFishLabel: 'الأسماك',
    allergenFishDesc: 'الأسماك ومنتجات الأسماك',
    allergenPeanutsLabel: 'الفول السوداني',
    allergenPeanutsDesc: 'الفول السوداني ومشتقاته',
    allergenSoyLabel: 'الصويا',
    allergenSoyDesc: 'فول الصويا ومشتقاته',
    allergenMilkLabel: 'الحليب / اللاكتوز',
    allergenMilkDesc: 'الحليب ومنتجات الألبان (بما في ذلك اللاكتوز)',
    allergenNutsLabel: 'المكسرات',
    allergenNutsDesc: 'اللوز والبندق والجوز والفستق والكاجو إلخ.',
    allergenCeleryLabel: 'الكرفس',
    allergenCeleryDesc: 'ساق الكرفس وبذوره ومشتقاته',
    allergenMustardLabel: 'الخردل',
    allergenMustardDesc: 'بذور الخردل وأوراقه ومشتقاته',
    allergenSesameLabel: 'السمسم',
    allergenSesameDesc: 'بذور السمسم ومشتقاته',
    allergenSulphitesLabel: 'الكبريتيت',
    allergenSulphitesDesc: 'ثاني أكسيد الكبريت (SO₂) والكبريتيت',
    allergenLupinLabel: 'الترمس',
    allergenLupinDesc: 'دقيق الترمس وبذوره ومشتقاته',
    allergenMolluscsLabel: 'الرخويات',
    allergenMolluscsDesc: 'بلح البحر والمحار والحبار والأخطبوط إلخ.',
    qrmenuClearFilter: 'مسح التصفية',
    qrmenuItemsCount: 'عناصر',
    qrmenuNoItemsInCategory: 'لا توجد عناصر في هذه الفئة',
    qrmenuCheckoutBtn: 'تأكيد السلة',
    qrmenuFooterHint: 'أضف العناصر إلى سلتك لتقديم طلب',
    qrmenuCallingWaiter: 'جاري استدعاء النادل...',
    qrmenuCallWaiter: 'استدعاء النادل',
    qrmenuAllergens: 'مسببات الحساسية',
    qrmenuOption: 'خيار',
    qrmenuSpecialRequestPlaceholder: 'طلب خاص، حساسية...',
    qrmenuClose: 'إغلاق',
    qrmenuAddToCart: 'أضف إلى السلة',
    shiftsTitle: 'المناوبات والحضور',
    shiftAutoGenerate: 'إنشاء تلقائي',
    shiftCopyWeek: 'نسخ الأسبوع',
    shiftPrintBtn: 'طباعة',
    shiftAddAssignment: 'إضافة مناوبة',
    shiftStatTotal: 'إجمالي المناوبات',
    shiftStatActive: 'في العمل',
    shiftStatStaff: 'مجدول',
    shiftStatClosed: 'مكتمل',
    shiftStatusScheduled: 'مجدول',
    shiftStatusCheckedIn: 'في العمل',
    shiftStatusCheckedOut: 'انتهى الدوام',
    shiftStatusAbsent: 'غائب',
    shiftStatusLate: 'متأخر',
    shiftTabWeekly: 'الخطة الأسبوعية',
    shiftTabTemplates: 'قوالب المناوبات',
    shiftTabSummary: 'ملخص الحضور',
    shiftTabBordro: 'كشف الرواتب',
    shiftTodayBtn: 'اليوم',
    shiftPrintTitle: 'خطة المناوبات الأسبوعية',
    shiftCheckInBtn: 'تسجيل دخول',
    shiftCheckOutBtn: 'تسجيل خروج',
    shiftAbsentBtn: 'غائب',
    shiftStaffHeader: 'الموظف',
    shiftNoAssignmentsThisWeek: 'لا توجد مناوبات هذا الأسبوع',
    shiftPrintedAt: 'تاريخ الطباعة',
    shiftNewTemplate: 'قالب جديد',
    shiftNoTemplatesYet: 'لا توجد قوالب مناوبات بعد',
    shiftNoSummaryData: 'لا توجد بيانات حضور لهذا الأسبوع',
    shiftColShift: 'المناوبة',
    shiftColLate: 'التأخير',
    shiftColTotalHours: 'إجمالي الساعات',
    shiftColOvertime: 'العمل الإضافي',
    shiftHourShort: 'س',
    shiftMinShort: 'د',
    shiftEditAssignment: 'تعديل المناوبة',
    shiftNewAssignment: 'مناوبة جديدة',
    shiftSelectPlaceholder: 'اختر...',
    shiftTemplateLabelOptional: 'قالب المناوبة (اختياري)',
    shiftManualEntry: 'إدخال يدوي',
    shiftNoteLabel: 'ملاحظة',
    shiftNotePlaceholder: 'ملاحظة اختيارية...',
    shiftEditTemplate: 'تعديل القالب',
    shiftNameLabel: 'اسم المناوبة',
    shiftNamePlaceholder: 'مثل: مناوبة الصباح',
    shiftColorLabel: 'اللون',
    shiftCopyDescription: 'سيتم نسخ جميع المناوبات من هذا الأسبوع إلى الأسبوع المحدد.',
    shiftTargetWeek: 'الأسبوع المستهدف (الإثنين)',
    shiftWeekLabel: 'الأسبوع',
    shiftCopying: 'جاري النسخ...',
    shiftCopyBtn: 'نسخ',
    shiftAutoModalTitle: 'إنشاء المناوبات تلقائياً',
    shiftAutoDescription: 'يتم إنشاء مناوبات أسبوعية للموظفين المحددين بناءً على ساعات عمل المطعم.',
    shiftWeekMondayLabel: 'الأسبوع (الإثنين)',
    shiftUseRestaurantHours: 'استخدام ساعات المطعم',
    shiftIncludeWeekend: 'تضمين عطلة نهاية الأسبوع (7 أيام)',
    shiftSelectStaff: 'اختر الموظفين',
    shiftSelectAll: 'اختر الكل',
    shiftClearSelection: 'مسح',
    shiftNoStaffFound: 'لم يتم العثور على موظفين',
    shiftStaffSelected: 'موظف محدد',
    shiftAutoGenerating: 'جاري الإنشاء...',
    shiftAutoCreateForStaff: 'موظف - إنشاء',
    shiftSelectStaffError: 'يرجى اختيار موظف',
    shiftSummaryLoadFailed: 'فشل تحميل الملخص',
    shiftMarkAbsentConfirm: 'تحديد كغائب؟',
    shiftDeleteAssignConfirm: 'هل تريد حذف هذه المناوبة؟',
    shiftDeleteTemplateConfirm: 'هل تريد حذف قالب المناوبة؟',
    shiftTemplateNameRequired: 'اسم المناوبة مطلوب',
    shiftCopyInserted: 'مناوبات منسوخة',
    shiftCopySkipped: 'تم تجاوز التعارضات',
    shiftCopyFailed: 'فشل النسخ',
    shiftAutoSelectAtLeastOne: 'يرجى اختيار موظف واحد على الأقل',
    shiftAutoCreated: 'مناوبات تم إنشاؤها',
    shiftAutoFailed: 'فشل الإنشاء التلقائي',
    dayMon: 'إثن',
    dayTue: 'ثلا',
    dayWed: 'أرب',
    dayThu: 'خمي',
    dayFri: 'جمع',
    daySat: 'سبت',
    daySun: 'أحد',
    menuStatTotal: 'إجمالي المنتجات',
    menuStatActive: 'نشط',
    menuStatInactive: 'غير نشط',
    menuStatCategories: 'الفئات',
    menuMgmtTitle: 'إدارة القائمة',
    menuMgmtProductSuffix: 'منتج',
    menuMgmtCategorySuffix: 'فئة',
    menuMgmtAiScan: 'مسح بالذكاء الاصطناعي',
    menuMgmtExcelDownload: 'تنزيل Excel',
    menuMgmtExcelUpload: 'رفع Excel',
    menuMgmtBulkPrice: 'تسعير جماعي',
    menuMgmtQrCode: 'رمز QR',
    menuMgmtProductsTab: 'المنتجات',
    menuMgmtCategoriesTab: 'الفئات',
    menuMgmtAddProduct: 'إضافة منتج',
    menuMgmtAddCategory: 'إضافة فئة',
    menuMgmtNoCategoriesYet: 'لا توجد فئات بعد',
    menuMgmtNoMenuItems: 'لم يتم العثور على عناصر القائمة',
    menuMgmtProduct: 'المنتج',
    menuMgmtCategoryDeleteConfirm: 'هل أنت متأكد أنك تريد حذف هذه الفئة؟',
    menuMgmtItemDeleteConfirm: 'هل أنت متأكد أنك تريد حذف عنصر القائمة هذا؟',
    menuMgmtImageGallery: 'معرض الصور',
    menuMgmtItemsWithoutImage: 'منتجات بدون صورة',
    menuMgmtPrinter: 'الطابعة',
    menuMgmtDefaultKitchenPrinter: 'طابعة المطبخ الافتراضية',
    menuMgmtPrinterRouteHint: 'سيتم توجيه طلبات هذه الفئة إلى الطابعة المحددة.',
    menuMgmtDetailsTab: 'التفاصيل',
    menuMgmtVariantsTab: 'المتغيرات',
    menuMgmtPriceTry: 'السعر (ليرة تركية)',
    menuMgmtSelectCategory: 'اختر الفئة',
    menuMgmtImageUrl: 'صورة المنتج',
    menuMgmtTaxGroup: 'مجموعة ضريبة القيمة المضافة',
    menuMgmtTaxGroupNone: '— لا شيء / ضريبة يدوية —',
    menuMgmtTaxGroupHint: 'إذا تم اختيار مجموعة، يتم أخذ معدل ضريبة القيمة المضافة تلقائيًا من المجموعة.',
    menuMgmtAllergens: 'مسببات الحساسية',
    menuMgmtSelectedSuffix: 'محدد',
    menuMgmtVisibleOnMenu: 'نشط (مرئي في القائمة)',
    menuMgmtVariantsHint: 'مثال: صغير (-5₺)، متوسط (0₺)، كبير (+5₺). السعر الأساسي:',
    menuMgmtNoVariantsYet: 'لا توجد متغيرات بعد',
    menuMgmtAddNewVariant: 'إضافة متغير جديد',
    menuMgmtVariantPriceDiffHint: 'فرق السعر: أدخل قيمة موجبة (+) أو سالبة (-)؛ الصفر مسموح به أيضًا.',
    menuMgmtBulkWarning: '⚠️ تقوم هذه العملية بتحديث جميع أسعار المنتجات في الفئة المحددة بشكل دائم.',
    menuMgmtAllCategories: 'جميع الفئات',
    menuMgmtUpdateType: 'نوع التحديث',
    menuMgmtIncreasePercent: 'زيادة بنسبة مئوية (%)',
    menuMgmtDecreasePercent: 'تخفيض بنسبة مئوية (%)',
    menuMgmtIncreaseFixed: 'زيادة بمبلغ ثابت (₺)',
    menuMgmtDecreaseFixed: 'تخفيض بمبلغ ثابت (₺)',
    menuMgmtSetFixed: 'تعيين سعر ثابت (₺)',
    menuMgmtValueLabel: 'القيمة',
    menuMgmtPreview: 'معاينة:',
    menuMgmtItemsAffected: 'سيتأثر من المنتجات',
    menuMgmtAiScanTitle: 'مسح صورة القائمة بالذكاء الاصطناعي',
    menuMgmtAiScanDesc: 'قم بتحميل صورة للقائمة. يقوم Gemini AI بقراءة أسماء الأطعمة/المشروبات وأسعارها تلقائيًا.',
    menuMgmtClickToChoosePhoto: 'انقر لاختيار صورة',
    menuMgmtPhotoFormats: 'يدعم JPG وPNG وWEBP',
    menuMgmtAiAnalyzing: 'يقوم Gemini AI بالتحليل...',
    menuMgmtItemsFound: 'تم العثور على منتجات',
    menuMgmtSelectAll: 'تحديد الكل',
    menuMgmtImportTitle: 'استيراد القائمة عبر Excel',
    menuMgmtImportFormatLabel: 'تنسيق القالب:',
    menuMgmtImportFormatDesc: 'الأعمدة التالية مطلوبة: الاسم، الفئة، السعر، معدل ضريبة القيمة المضافة، الوصف، نشط. استخدم زر تنزيل Excel للحصول على القالب (يتضمن ورقة قالب الاستيراد).',
    menuMgmtFileProcessing: 'جارٍ معالجة الملف...',
    menuMgmtClickToChooseExcel: 'انقر لاختيار ملف Excel',
    menuMgmtXlsxSupported: 'يدعم تنسيق .xlsx',
    menuMgmtImportComplete: 'اكتمل الاستيراد',
    menuMgmtInserted: 'تمت الإضافة',
    menuMgmtSkipped: 'تم التخطي',
    menuMgmtQrDesc: 'يمكن للعملاء مسح هذا الرمز لعرض القائمة الرقمية',
    menuMgmtPreviewMenu: 'معاينة القائمة',
    menuMgmtQrPastingHint: 'يمكنك لصق رمز QR هذا على الطاولات أو بطاقات القائمة',
    posSessionOpenTitle: 'فتح الصندوق',
    posSessionOpenSub: 'أدخل المبلغ النقدي الافتتاحي',
    posOpeningCashLabel: 'النقد الافتتاحي (₺)',
    posOpening: 'جاري الفتح...',
    posOpenSession: 'فتح الصندوق',
    posPayment: 'الدفع',
    posTotalAmount: 'المبلغ الإجمالي',
    posSplitPayment: 'مختلط',
    posAmountReceived: 'المبلغ المستلم',
    posChange: 'الباقي',
    posCardChargePrefix: 'سيتم خصم',
    posCardChargeSuffix: 'بالبطاقة',
    posAmountsMatch: 'المبالغ متطابقة',
    posRemaining: 'المتبقي',
    posProcessing: 'جاري المعالجة...',
    posCompleteSale: 'إتمام البيع',
    posZReport: 'تقرير Z',
    posNewProductBtn: '+ منتج جديد',
    posNewProductTitle: 'إضافة منتج جديد',
    posImportFromMenuBtn: '📋 استيراد من القائمة',
    posImportFromMenuTitle: 'استيراد إلى نقطة البيع من القائمة',
    posImportSelectAll: 'تحديد الكل',
    posImportAlreadyAdded: 'تمت الإضافة',
    posImportConfirmBtn: 'استيراد',
    posImportNoSelection: 'حدد المنتجات أولاً',
    posImportResult: '{n} منتج مستورد',
    posImportSkipped: '{n} متخطى',
    posPrintBtn: '🖨️ طباعة',
    posPrintingBtn: 'جارٍ الطباعة...',
    posReportPrintQueued: 'تم وضع التقرير في قائمة الطباعة',
    posReportPrintFailed: 'فشل الطباعة',
    posSaleCount: 'عدد المبيعات',
    posGrossTotal: 'الإجمالي الكلي',
    posOpeningCash: 'النقد الافتتاحي',
    posClosingCash: 'النقد الختامي',
    posCashDifference: 'فرق الصندوق',
    posTopSellers: 'الأكثر مبيعًا',
    posUnits: 'وحدة',
    posOk: 'حسناً',
    posXReport: 'تقرير X',
    posStock: 'المخزون',
    posAddedSuffix: 'تمت الإضافة',
    posBarcodeNotFound: 'الرمز الشريطي غير موجود',
    posKeyboardToggle: 'لوحة المفاتيح على الشاشة',
    posKeyboardEnabled: 'لوحة المفاتيح مفعّلة',
    posKeyboardDisabled: 'لوحة المفاتيح متوقفة',
    posKeyboardClose: 'إغلاق لوحة المفاتيح',
    posKeyboardModeNumeric: 'أرقام',
    posKeyboardModeFull: 'حروف',
    posKeyboardEnter: 'تم',
    posKeyboardSpace: 'مسافة',
    posKeyboardBackspace: 'حذف',
    posProductsLoadFailed: 'تعذر تحميل المنتجات',
    posSessionOpened: 'تم فتح الصندوق',
    posSessionOpenFailed: 'تعذر فتح الصندوق',
    posReceiptNotFound: 'الإيصال غير موجود',
    posRefundedSuffix: 'تم الاسترداد',
    posRefundFailed: 'فشل الاسترداد',
    posSaleCompleted: 'تم إتمام البيع',
    posSaleFailed: 'تعذر إتمام البيع',
    posSessionClosed: 'تم إغلاق الصندوق',
    posSessionCloseFailed: 'تعذر إغلاق الصندوق',
    posXReportFailed: 'تعذر الحصول على تقرير X',
    posExcelDownloadFailed: 'تعذر تنزيل Excel',
    posImportedSuffix: 'تمت الإضافة',
    posUpdatedSuffix: 'تم التحديث',
    posImportFailed: 'فشل الاستيراد',
    posRefundProcess: 'عملية الاسترداد',
    posRefundSearchHint: 'ابحث عن البيع برقم الإيصال',
    posReceiptNo: 'رقم الإيصال',
    posCashier: 'أمين الصندوق',
    posStatusCompleted: 'مكتمل',
    posStatusRefunded: 'مسترد',
    posStatusCancelled: 'ملغى',
    posNoteLabel: 'ملاحظة',
    posAlreadyRefunded: 'تم استرداد/إلغاء هذه العملية مسبقًا — لا يمكن استردادها مرة أخرى.',
    posRefunding: 'جاري الاسترداد...',
    posRefundAction: 'استرداد',
    posCustomerSearch: 'ابحث عن عميل... (اختياري)',
    posUseLoyaltyPoints: 'استخدام النقاط',
    posPromoPlaceholder: 'كود الخصم / القسيمة',
    posPromoApply: 'تطبيق',
    posPromoApplied: 'تم التطبيق',
    posPromoInvalid: 'كود غير صالح',
    posPromoDiscount: 'خصم الكود',
    posHoldOrder: 'تعليق الطلب',
    posHeldOrders: 'الطلبات المعلقة',
    posHeldOrdersHint: 'اختر طلباً لاسترجاعه',
    posNoHeldOrders: 'لا توجد طلبات معلقة',
    posRecallOrder: 'استرجاع',
    posOrderHeld: 'تم تعليق الطلب',
    posOrderRecalled: 'تم استرجاع الطلب',
    posTip: 'إكرامية',
    posTipNone: 'بدون',
    posBeforeTip: 'قبل الإكرامية',
    posTitle: 'صندوق البيع',
    posOpen: 'مفتوح',
    posRevenue: 'الإيرادات',
    posSales: 'مبيعات',
    posSalesHistory: 'سجل المبيعات',
    posSalesHistoryEmpty: 'لا توجد مبيعات لهذا التاريخ',
    posReprintReceipt: 'إعادة طباعة',
    posPrintReceiptBtn: 'طباعة الإيصال',
    posHistoryTitle: 'سجل المبيعات',
    posHistoryCashier: 'الكاشير',
    posHistoryPayment: 'الدفع',
    posHistoryRefundBtn: 'استرداد',
    posTerminalSend: 'إرسال إلى الطرفية',
    posTerminalSent: 'تم الإرسال إلى الطرفية',
    posTerminalNoConfig: 'عنوان IP للطرفية غير مكوَّن',
    posEInvoiceBtn: 'فاتورة إلكترونية',
    posEInvoiceTitle: 'فاتورة إلكترونية / أرشيف',
    posEInvoiceVkn: 'رقم ضريبي / هوية وطنية',
    posEInvoiceCreate: 'إنشاء فاتورة',
    posEInvoiceNote: 'تكامل GIB غير نشط. قم بتفعيله من إعدادات تكامل المحاسبة.',
    posHistoryToday: 'اليوم',
    posHistoryYesterday: 'أمس',
    posHistorySaleCount: 'مبيعات',
    posHistoryTip: 'إكرامية',
    posCustomerScreenTitle: 'فتح شاشة العميل',
    posXReportBtn: 'تقرير X',
    posCloseSession: 'إغلاق الصندوق',
    posSearchPlaceholder: 'ابحث عن منتج أو رمز شريطي...',
    posExportTitle: 'تصدير المنتجات إلى Excel',
    posImportTitle: 'استيراد المنتجات من Excel',
    posOpenSessionFirst: 'افتح الصندوق أولاً',
    posProductsLoading: 'جاري تحميل المنتجات...',
    posProductNotFound: 'المنتج غير موجود',
    posCart: 'السلة',
    posRefund: 'استرداد',
    posNoTableTakeaway: 'بدون طاولة / سفري',
    posPricesVatInclusive: 'الأسعار شاملة الضريبة',
    posPricesVatExclusive: 'الأسعار بدون ضريبة',
    posCartEmpty: 'السلة فارغة',
    posDecreaseQty: 'تقليل الكمية',
    posIncreaseQty: 'زيادة الكمية',
    posRemove: 'إزالة',
    posAddNote: 'إضافة ملاحظة...',
    posTakePayment: 'تحصيل الدفع',
    posSessionCloseTitle: 'إغلاق الصندوق',
    posSessionCloseSub: 'أدخل المبلغ النقدي الحالي',
    posClosingCashLabel: 'النقد الختامي (₺)',
    posClosing: 'جاري الإغلاق...',

    // === Tur 39 batch ===
    resetPwdInvalidLinkTitle: 'رابط غير صالح',
    resetPwdInvalidLinkDesc: 'رابط إعادة تعيين كلمة المرور غير صالح أو مفقود.',
    resetPwdRequestNewLink: 'طلب رابط جديد',
    resetPwdMinLength: 'يجب أن تتكون كلمة المرور من 6 أحرف على الأقل.',
    resetPwdMismatch: 'كلمات المرور غير متطابقة.',
    resetPwdGenericError: 'حدث خطأ. قد تكون صلاحية الرابط منتهية.',
    resetPwdTitle: 'تعيين كلمة مرور جديدة',
    resetPwdSubtitle: 'أدخل كلمة مرور جديدة لحسابك.',
    resetPwdSuccess: 'تم تحديث كلمة المرور بنجاح!',
    resetPwdRedirecting: 'سيتم توجيهك إلى صفحة تسجيل الدخول خلال لحظات...',
    resetPwdSignIn: 'تسجيل الدخول',
    resetPwdMinLengthPlaceholder: '6 أحرف على الأقل',
    resetPwdConfirm: 'تأكيد كلمة المرور',
    resetPwdSaving: 'جاري الحفظ...',
    resetPwdUpdateBtn: 'تحديث كلمة المرور',
    resetPwdBackToLogin: 'العودة إلى تسجيل الدخول',
    forgotPwdEmailRequired: 'البريد الإلكتروني مطلوب.',
    forgotPwdGenericError: 'حدث خطأ. يرجى المحاولة مرة أخرى.',
    forgotPwdTitle: 'نسيت كلمة المرور',
    forgotPwdSubtitle: 'أدخل بريدك الإلكتروني وسنرسل لك رابط إعادة تعيين كلمة المرور.',
    forgotPwdSentTitle: 'تم إرسال رابط إعادة تعيين كلمة المرور!',
    forgotPwdSentDesc: 'انقر على الرابط المرسل إلى هذا العنوان لإعادة تعيين كلمة المرور.',
    forgotPwdBackToLogin: 'العودة إلى تسجيل الدخول',
    forgotPwdSending: 'جاري الإرسال...',
    forgotPwdSendLink: 'إرسال رابط إعادة التعيين',
    auditLoadFailed: 'تعذر تحميل سجلات التدقيق.',
    auditStatTotal: 'إجمالي السجلات',
    auditStatToday: 'اليوم',
    auditStatPerUser: 'لكل مستخدم',
    auditStatTopAction: 'أكثر إجراء',
    auditTitle: 'سجلات التدقيق',
    auditSubtitle: 'من فعل ماذا ومتى ولأي سجل؟ يتم تسجيل العمليات الحرجة هنا.',
    auditActionLabel: 'الإجراء',
    auditEntityLabel: 'الكيان',
    auditApply: 'تطبيق',
    auditClear: 'مسح',
    auditNoRecords: 'لم يتم العثور على سجلات.',
    auditDate: 'التاريخ',
    auditUser: 'المستخدم',
    auditIp: 'IP',
    auditBefore: 'قبل',
    auditAfter: 'بعد',
    auditTotal: 'الإجمالي',
    auditRecords: 'سجلات',
    flagKeyFormatError: 'يجب أن يحتوي flag_key على أحرف صغيرة وأرقام وشرطة سفلية فقط (مثل: new_dashboard).',
    flagRolloutRangeError: 'يجب أن يكون الطرح بين 0 و 100.',
    flagDeleteConfirm: 'هل أنت متأكد من حذف هذا العلم؟',
    flagGlobal: 'عام',
    flagTitle: 'أعلام الميزات',
    flagSubtitle: 'تبديل الميزات مع الطرح التدريجي. السجلات الخاصة بالمطعم تتجاوز الإعداد العام. يتم تحديد نسبة الطرح بشكل ثابت بناءً على تجزئة معرف المطعم.',
    flagNewBtn: 'علم جديد',
    flagKey: 'المفتاح',
    flagScope: 'النطاق',
    flagRollout: 'نسبة الطرح %',
    flagThisRestaurant: 'هذا المطعم',
    flagOptional: 'اختياري',
    flagEmpty: 'لا توجد أعلام ميزات حتى الآن.',
    taxGroupNameRequired: 'الاسم مطلوب.',
    taxGroupRateRangeError: 'يجب أن يكون المعدل بين 0 و 100.',
    taxGroupDeleteConfirm: 'هل أنت متأكد من حذف مجموعة الضرائب هذه؟',
    taxGroupTitle: 'مجموعات الضرائب',
    taxGroupSubtitle: 'حدد معدلات ضريبة القيمة المضافة الخاصة بك وقم بتعيينها لعناصر القائمة. تُستخدم المجموعة الافتراضية للمنتجات الجديدة التي لم يتم تحديد معدل لها.',
    taxGroupNewBtn: 'مجموعة جديدة',
    taxGroupName: 'الاسم',
    taxGroupRate: 'المعدل',
    taxGroupDefault: 'افتراضي',
    taxGroupEmpty: 'لا توجد مجموعات ضرائب.',
    taxGroupNamePlaceholder: 'ضريبة القيمة المضافة 10٪',

    // === Tur 40 batch ===
    settingsHeaderDesc: 'إدارة تفضيلات المطعم والتطبيق',
    restaurantInfoTitle: 'معلومات المطعم',
    restaurantNamePh: 'اسم مطعمك',
    restaurantAddressPh: 'عنوان المطعم',
    workingHoursLabel: 'ساعات العمل',
    workingHoursDesc: 'يستخدم الإنشاء التلقائي للورديات والميزات الأخرى هذه الساعات.',
    openingHourLabel: 'ساعة الفتح',
    closingHourLabel: 'ساعة الإغلاق',
    loginAfterPageTitle: 'الصفحة بعد تسجيل الدخول',
    loginAfterPageDesc: 'إلى أي صفحة تريد الانتقال بعد تسجيل الدخول؟',
    adisyonBadge: 'فاتورة',
    coverImageTitle: 'صورة الغلاف',
    coverImageDesc: 'رابط صورة الغلاف التي ستظهر في أعلى القائمة',
    coverImagePreviewAlt: 'معاينة الغلاف',
    restaurantMenuFallback: 'قائمة المطعم',
    imageUrlLabel: 'رابط الصورة',
    menuTitleDesc: 'إذا تُرك فارغاً، يُستخدم اسم المطعم',
    accentColorTitle: 'لون التمييز',
    accentColorDesc: 'يُستخدم للأسعار واختيار الفئة والأزرار',
    customColorLabel: 'لون مخصص:',
    footerTextTitle: 'نص التذييل',
    footerTextDesc: 'النص الذي يظهر في أسفل القائمة',
    footerTextPh: 'يرجى استدعاء النادل لتقديم الطلب',
    previewMenuBtn: 'معاينة القائمة',
    defaultCurrencyTitle: 'العملة الافتراضية',
    defaultCurrencyDesc: 'عملة قائمة مطعمك وفواتيره. يتم دعم العملات المتعددة (EUR/USD وغيرها للمناطق السياحية).',
    currencyChangeWarning: 'لا يحوّل هذا التغيير أسعار القائمة الحالية. يتأثر العرض وتسميات الطلبات الجديدة فقط. من المخطط تخصيص شاشة إدارة منفصلة لأسعار الصرف.',
    currencyTRYName: 'ليرة تركية',
    currencyUSDName: 'دولار أمريكي',
    currencyEURName: 'يورو',
    currencyGBPName: 'جنيه إسترليني',
    currencyCHFName: 'فرنك سويسري',
    currencyJPYName: 'ين ياباني',
    currencyAEDName: 'درهم إماراتي',
    currencySARName: 'ريال سعودي',
    pageOptDashboardLabel: 'لوحة التحكم',
    pageOptDashboardDesc: 'شاشة الإحصائيات الرئيسية',
    pageOptTablesLabel: 'الطاولات',
    pageOptTablesDesc: 'الانتقال مباشرة إلى شاشة الفواتير',
    pageOptOrdersLabel: 'الطلبات',
    pageOptOrdersDesc: 'شاشة قائمة الطلبات',
    pageOptKitchenLabel: 'شاشة المطبخ',
    pageOptKitchenDesc: 'شاشة تتبع المطبخ',
    colorOrange: 'برتقالي',
    colorRed: 'أحمر',
    colorPurple: 'بنفسجي',
    colorBlue: 'أزرق',
    colorGreen: 'أخضر',
    colorYellow: 'أصفر',
    colorPink: 'وردي',
    colorDark: 'داكن',
    platformMgmtTitle: 'إدارة المنصات',
    platformStatTotal: 'إجمالي المنصات',
    platformStatConfigured: 'مُهيأة',
    platformStatActive: 'نشط',
    platformStatTested: 'اجتاز الاختبار',
    platformMgmtSubtitle: 'إدارة تكاملات منصات التوصيل.',
    platformMgmtLoadFailed: 'تعذر تحميل المنصات.',
    platformMgmtToggleFailed: 'فشل التبديل.',
    platformMgmtConnectionOk: 'الاتصال ناجح.',
    platformMgmtConnectionError: 'خطأ في الاتصال.',
    platformMgmtNotConfigured: 'غير مُعد',
    platformMgmtTesting: 'جارٍ الاختبار...',
    platformMgmtTestBtn: '🔌 اختبار',
    platformMgmtConfigure: 'إعداد',
    platformMgmtDeactivate: '⏸ إيقاف',
    platformMgmtActivate: '▶ تفعيل',
    platformMgmtSettingsSuffix: 'الإعدادات',
    platformMgmtChangePlaceholder: '(أدخل للتغيير)',
    platformMgmtSaving: 'جارٍ الحفظ...',
    trashStatTotal: 'إجمالي المحذوف',
    trashStatOrders: 'الطلبات',
    trashStatCustomers: 'العملاء',
    trashStatMenuItems: 'عناصر القائمة',
    trashTitle: 'سلة المهملات',
    trashSubtitle: 'تُؤرشف السجلات المحذوفة هنا. استخدم الزر على اليمين للاستعادة.',
    trashOrdersTab: 'الطلبات',
    trashMenuItemsTab: 'عناصر القائمة',
    trashCustomersTab: 'العملاء',
    trashRestaurantsTab: 'المطاعم',
    trashLoadFailed: 'تعذر التحميل.',
    trashRestoreConfirm: 'هل أنت متأكد من استعادة هذا السجل؟',
    trashRestoreFailed: 'تعذرت الاستعادة.',
    trashEmpty: 'لا توجد سجلات محذوفة في هذه الفئة. 🎉',
    trashActionCol: 'إجراء',
    trashRestoreBtn: '↩️ استعادة',
    tablesDeleteConfirmSuffix: 'هل أنت متأكد من حذف هذه الطاولة؟',
    tablesCloseConfirmSuffix: 'هل أنت متأكد من إغلاق هذه الطاولة؟',
    tablesCategoryDeleteConfirmSuffix: 'هل أنت متأكد من حذف هذه الفئة؟ ستصبح الطاولات بدون فئة.',
    tablesTablePrefix: 'طاولة',
    tablesWaiterCallTitle: 'نداء النادل',
    tablesWaitingSuffix: 'في الانتظار',
    tablesManageAriaSuffix: 'إدارة هذه الطاولة',
    tablesManageCategoriesTitle: 'فئات الطوابق والمناطق',
    tablesTableLower: 'طاولة',
    tablesAddNewCategory: 'إضافة فئة جديدة',
    tablesCategoryPlaceholder: 'مثل: الطابق الأول، الشرفة، الحديقة...',
    tablesChooseColor: 'اختر اللون',
    tablesPreviewLabel: 'معاينة',
    tablesAddCategoryBtn: 'إضافة فئة',
    tablesTableNamePlaceholder: 'الطاولة 11',
    tableSeatingDuration: 'مدة الجلوس',
    kitchenMinShort: 'د',
    kitchenHourShort: 'س',
    kitchenLate: 'متأخر',
    kitchenRemaining: 'متبقٍ',
    kitchenConnectionError: 'خطأ في الاتصال — حاول التحديث.',
    kitchenScreenTitle: 'شاشة المطبخ',
    kitchenWaitingLabel: 'قيد الانتظار',
    kitchenServedLabel: 'تم التقديم',
    kitchenStatServed: 'تم التقديم اليوم',
    kitchenStatPrepTime: 'الوقت التقديري (د)',
    kitchenPanelBtn: 'اللوحة',
    kitchenWaitingOrders: 'الطلبات المعلقة',
    kitchenEmptyQueue: 'لا توجد طلبات معلقة',
    kitchenServeBtn: 'قدّم',
    loginTotpRequired: 'رمز TOTP مطلوب.',
    loginCodeVerifyFailed: 'تعذر التحقق من الرمز.',
    loginTwoFactorTitle: 'المصادقة الثنائية',
    loginTwoFactorHint: 'أدخل الرمز المكوّن من 6 أرقام من تطبيق المصادقة (أو رمز احتياطي من 8 أرقام).',
    loginVerifying: 'جارٍ التحقق...',
    loginVerifyAndEnter: 'تحقق وادخل',
    loginDifferentAccount: 'تسجيل الدخول بحساب آخر',
    loginTestAccounts: 'حسابات اختبارية:',
    loginTestSuperAdmin: 'المشرف العام',
    loginTestAdmin: 'مدير',
    loginTestWaiter: 'نادل',
    loginTestKitchen: 'مطبخ',
    loginTestChainAdmin: 'مدير السلسلة',
    loginTestDemoChain: 'سلسلة تجريبية',
    reportsChartSR: 'رسم بياني',

    // === Tur 44 Quick Start ===
    quickStartTitle: 'البدء السريع',
    quickStartSubtitle: 'بضع خطوات فقط لتشغيل مطعمك.',
    qsRestaurantInfo: 'أدخل تفاصيل المطعم',
    qsAddFirstTable: 'أضف طاولتك الأولى',
    qsAddMenuItem: 'أضف عنصراً إلى القائمة',
    qsAddStaff: 'أضف موظفاً',
    quickStartOrWizard: 'أو اتبع المعالج خطوة بخطوة:',

    // === Tur 50 shortcuts ===
    shortcutsTitle: 'اختصارات لوحة المفاتيح',
    shortcutHelp: 'تبديل المساعدة',
    shortcutHome: 'الصفحة الرئيسية',
    shortcutTables: 'الطاولات',
    shortcutOrders: 'الطلبات',
    shortcutKitchen: 'شاشة المطبخ',
    shortcutReports: 'التقارير',
    shortcutSettings: 'الإعدادات',
    shortcutMenu: 'إدارة القائمة',
    shortcutCustomers: 'العملاء',
    shortcutPOS: 'نقطة البيع',
    shortcutClose: 'إغلاق النافذة',
    shortcutHint: 'نصيحة: اضغط المفاتيح بالتتابع السريع.',

    // === FAZ K3.1 تتبع طلب العميل ===
    orderTrackTitle: 'تتبع الطلب',
    orderTrackStatusTitle: 'حالة الطلب',
    orderTrackAccepted: 'تم استلام طلبك',
    orderTrackPreparing: 'المطعم يحضّر الطلب',
    orderTrackOnTheWay: 'المندوب في الطريق',
    orderTrackDelivered: 'تم التوصيل',
    orderTrackInProgress: 'قيد التنفيذ...',
    orderTrackEta: 'الوصول التقريبي',
    orderTrackEtaPrefix: 'حوالي',
    orderTrackEtaMinutes: 'دقيقة',
    orderTrackCourier: 'المندوب الخاص بك',
    orderTrackRestaurant: 'المطعم',
    orderTrackYou: 'عنوانك',
    orderTrackMap: 'الخريطة',
    orderTrackLocationUpdating: 'تحديث الموقع...',
    orderTrackLocationWaiting: 'في انتظار موقع المندوب...',
    orderTrackInvalidToken: 'رابط التتبع غير صالح',
    orderTrackInvalidTokenDesc: 'رابط تتبع الطلب هذا غير صالح أو منتهي الصلاحية.',
    orderTrackNetworkError: 'خطأ في الاتصال',
    orderTrackAutoRefresh: 'تتحدث الصفحة تلقائيًا كل 30 ثانية',
    orderTrackEtaWaiting: 'جاري حساب الوقت المقدر — يتحدث عند إرسال الساعي موقعه',
    orderTrackCancelled: 'تم إلغاء الطلب',

    // === Tur 51 a11y ===
    skipToMain: 'تخطّ إلى المحتوى الرئيسي',

    // === Tur 55 confirm ===
    confirmBtn: 'تأكيد',
    confirmDefaultTitle: 'تأكيد',

    // === Onboarding Tour ===
    tourSkip: 'تخطّي',
    tourNext: 'التالي',
    tourPrev: 'السابق',
    tourFinish: 'إنهاء',
    tourGetStarted: 'هيا نبدأ',
    tourGoTo: 'الانتقال إلى الصفحة',
    tourStep1Title: 'أهلاً بك في RestaFlex!',
    tourStep1Body: 'جولة قصيرة لمدة دقيقتين لنعرض لك أماكن الميزات الرئيسية. يمكنك التخطّي في أي وقت.',
    tourStep2Title: 'لوحة التحكم والمؤشرات',
    tourStep2Body: 'راقب إيراداتك اليومية وعدد الطلبات والأكثر مبيعًا من نظرة واحدة، وتتبّع الأداء لحظة بلحظة.',
    tourStep3Title: 'إدارة القائمة',
    tourStep3Body: 'أدر الأصناف والمنتجات والأسعار من هنا. التغييرات تنعكس تلقائيًا على قائمة QR.',
    tourStep4Title: 'الطاولات والطلبات',
    tourStep4Body: 'توزيع الطاولات، تدفق الطلبات، المطبخ والدفع — كل ذلك في شاشة واحدة.',
    tourStep5Title: 'الإعدادات',
    tourStep5Body: 'معلومات المطعم والطابعات وخطاطيف الويب والمستخدمون وبقية خيارات الضبط كلها في الإعدادات.',
    // UI-01: قسم "الإدارة والتكاملات" داخل الإعدادات
    settingsIntegrationsTitle: 'الإدارة والتكاملات',
    settingsIntegrationsSub: 'وصول سريع إلى الطابعات وتكاملات الويب هوك وKVKK وإعدادات العلامة البيضاء.',
    tabAdmin: 'الإدارة',
    settingsAdminSub: 'مجموعات الضرائب وسجلات التدقيق والأمان وجميع صفحات إدارة النظام.',
    settingsSectionDataSafety: 'البيانات والأمان',
    settingsSectionIntegrations: 'التكاملات',
    settingsSectionConfig: 'التكوين',
    customerTagFilterLabel: 'تصفية الوسم',
    customerTagToggleHint: 'التصفية بهذا الوسم',
    whatsappBtnTitle: 'واتساب',
    whatsappOrderRef: 'بشأن الطلب',
    payrollDescPrefix: 'دفع الراتب',
    payrollHoursHeader: 'مُنجز',
    payrollRateHeader: 'السعر',
    payrollScheduledHeader: 'مجدول',
    payrollOvertimeHeader: 'إضافي د',
    csvAvgOrder: 'متوسط الطلب',
    csvRevenuePerCustomer: 'لكل عميل',
    recentAuditTitle: 'إجراءات الإدارة الأخيرة',
    statusPreparing: 'قيد التحضير',
    statusReady: 'جاهز',
    kitchenReadyBtn: 'جاهز',
    datePresetLast7: 'آخر 7 أيام',
    datePresetLast30: 'آخر 30 يومًا',
    datePresetLast90: 'آخر 90 يومًا',
    datePresetThisMonth: 'هذا الشهر',
    datePresetLastMonth: 'الشهر الماضي',
    segmentQuickLabel: 'سريع',
    segmentBirthday: 'عيد ميلاد قريب',
    segmentNewCustomer: 'عميل جديد',
    segmentVIP: 'VIP',
    dateChipToday: '📅 اليوم',
    dateChipTomorrow: '➡️ غدًا',
    dateChipAll: '🗓️ الكل',
    dateChipYesterday: '⬅️ أمس',
    promoStatusActive: 'نشط',
    promoStatusExpired: 'منتهي',
    voucherStatusUsed: 'مستهلك',
    printerSearchPlaceholder: 'ابحث عن طابعة / IP...',
    webhookSearchPlaceholder: 'ابحث عن webhook (URL/تسمية)...',
    taxGroupSearchPlaceholder: 'ابحث عن مجموعة ضرائب (اسم/معدل)...',
    flagSearchPlaceholder: 'ابحث عن علامة (مفتاح/وصف)...',
    plnProfitLoss: 'تقرير الربح والخسارة',
    nav_chain: 'إدارة السلسلة',
    stockSearchPlaceholder: 'ابحث عن مكون...',
    promoSearchPlaceholder: 'ابحث عن رمز أو وصف...',
    voucherSearchPlaceholder: 'ابحث عن رمز...',
    refundSearchPlaceholder: 'ابحث عن طاولة أو سبب أو رقم طلب...',
    notifDismissRead: 'مسح المقروءة',
    notifDismissReadHint: 'إخفاء الإشعارات المقروءة',
    notifDismissVisible: 'إخفاء المرئية',
    notifDismissVisibleHint: 'إخفاء الإشعارات المصفاة',
    peakHourTitle: 'ساعة الذروة',
    recipeItemSearchPlaceholder: 'اكتب أو اختر صنف القائمة...',
    recipeItemSearchHint: 'ابحث في {N} عنصرًا',
    items: 'عناصر',
    foodCostPctLabel: 'تكلفة الطعام',
    foodCostPctTooltip: 'تكلفة الوصفة / سعر البيع',
    bulkTagBtn: '🏷️➕ إضافة وسوم جماعية',
    bulkTagModalTitle: 'إضافة الوسوم بالجملة',
    bulkTagModalDesc: 'سيتم إضافة الوسوم التالية إلى {count} عميلاً',
    bulkTagApplyBtn: 'تطبيق',
    bulkTagSuccess: 'تمت إضافة الوسوم',
    bulkTagFailed: 'تعذر تحديث بعض العملاء',
    avgOrderValue: 'متوسط الطلب',
    copyAllBtn: 'نسخ الكل',
    downloadTxtBtn: 'تنزيل TXT',
    customersStatTotal: 'الإجمالي',
    stockTotalValue: 'قيمة المخزون',
    deliveryStatPending: 'قيد الانتظار',
    deliveryStatDelivered: 'تم التسليم',
    deliveryStatCancelled: 'ملغى',
    deliveryStatRevenue: 'إجمالي الإيرادات',
    supplierStatTotal: 'إجمالي الموردين',
    supplierStatActive: 'نشط',
    supplierStatInactive: 'غير نشط',
    supplierStatProducts: 'إجمالي المنتجات',
    cashStatIncome: 'الدخل',
    cashStatExpense: 'المصروف',
    cashStatNet: 'صافي الرصيد',
    cashStatCount: 'عدد المعاملات',
    paymentStatTotal: 'إجمالي الإيرادات',
    paymentStatCompleted: 'مكتمل',
    paymentStatPending: 'معلق',
    paymentStatAvg: 'متوسط الدفع',
    tableStatTotal: 'إجمالي الطاولات',
    tableStatOccupied: 'مشغول',
    tableStatReserved: 'محجوز',
    tableStatFree: 'متاح',
    promoStatActive: 'نشط',
    promoStatExpired: 'منتهي الصلاحية',
    promoStatUsage: 'إجمالي الاستخدام',
    promoStatTotal: 'إجمالي الخصم',
    voucherStatActive: 'نشط',
    voucherStatTotalValue: 'القيمة الإجمالية',
    voucherStatUsed: 'مستخدم',
    voucherStatCount: 'إجمالي القسائم',
    userSearchPlaceholder: 'ابحث بالاسم أو البريد...',
    menuItemSearchPlaceholder: 'ابحث عن منتج...',
    // نصوص الحالة الفارغة (صفحات القوائم)
    emptyUsersTitle: 'لا يوجد مستخدمون بعد',
    emptyUsersHint: 'ابدأ بإضافة أول عضو إلى فريقك.',
    emptyRecipeTitle: 'لا توجد وصفة معرّفة',
    emptyRecipeHint: 'أضف أول مكوّن لبناء وصفة هذا الصنف.',
    // الموردون
    supplierTitle: 'الموردون',
    supplierSubtitle: 'إدارة موردي المخزون والمواد الخام.',
    supplierAdd: 'إضافة مورد',
    supplierEditTitle: 'تعديل المورد',
    supplierNewTitle: 'مورد جديد',
    supplierContactPerson: 'الشخص المسؤول',
    supplierTaxNumber: 'الرقم الضريبي',
    supplierNotes: 'ملاحظات',
    supplierTotal: 'الإجمالي',
    supplierActive: 'نشط',
    supplierInactive: 'غير نشط',
    supplierLedger: 'الحساب',
    supplierLedgerTitle: 'كشف الحساب',
    supplierLedgerDebit: 'مدين',
    supplierLedgerCredit: 'دفعة',
    supplierLedgerBalance: 'الرصيد',
    supplierLedgerEmpty: 'لا توجد حركات',
    supplierLedgerEmptyHint: 'لا توجد أوامر مستلمة أو دفعات لهذا المورد بعد.',
    supplierShowInactive: 'عرض غير النشط',
    supplierEmptyTitle: 'لا يوجد موردون بعد',
    supplierEmptyHint: 'ابدأ بإضافة أول مورد.',
    supplierNameRequired: 'اسم الشركة مطلوب.',
    supplierLoadError: 'تعذر تحميل الموردين.',
    supplierSearchPlaceholder: 'بحث عن مورد...',
    supplierSelect: 'اختر المورد',
    // أوامر الشراء (ERP-02 الجزء 4)
    poTitle: 'أوامر الشراء',
    poSubtitle: 'أوامر شراء المواد من الموردين.',
    poNew: 'طلب جديد',
    poEdit: 'تعديل الطلب',
    poNumber: 'رقم الطلب',
    poSupplier: 'المورد',
    poDate: 'التاريخ',
    poExpectedDate: 'تاريخ التسليم المتوقع',
    poReceivedDate: 'تاريخ الاستلام',
    poStatus_draft: 'مسودة',
    poStatus_sent: 'مُرسل',
    poStatus_received: 'مُستلم',
    poStatus_cancelled: 'ملغى',
    poItems: 'العناصر',
    poAddRow: '+ إضافة سطر',
    poIngredient: 'المادة',
    poQuantity: 'الكمية',
    poUnitPrice: 'سعر الوحدة',
    poLineTotal: 'المبلغ',
    poGrandTotal: 'المجموع الكلي',
    poNotes: 'ملاحظات',
    poMarkReceived: 'تأكيد الاستلام',
    poReceiveConfirm: 'تأكيد استلام هذا الطلب؟ سيتم تحديث المخزون تلقائياً.',
    poStatTotal: 'إجمالي الطلبات',
    poStatPending: 'قيد الانتظار',
    poStatCompleted: 'مكتمل',
    poStatTotalAmount: 'إجمالي المبلغ',
    poStatThisMonth: 'هذا الشهر',
    paymentStatCount: 'عدد المدفوعات',
    paymentStatFailed: 'فشل',
    datePresetGroupLabel: 'الإعدادات المسبقة للتاريخ',
    datePresetLast7Days: 'آخر 7 أيام',
    datePresetLast30Days: 'آخر 30 يومًا',
    tableStatCapacity: 'إجمالي السعة',
    promoStatDiscount: 'إجمالي الخصم',
    voucherStatRedeemed: 'مُستَرد',
    voucherStatRedeemedValue: 'القيمة المستردة',
    notifReadFilterLabel: 'تصفية حالة القراءة',
    loginDemoGroupAria: 'اختصارات الحسابات التجريبية',
    loginDemoTitle: 'حسابات تجريبية',
    loginDemoDevOnly: 'يظهر فقط في بيئة التطوير',
    loginDemoSuperadmin: 'مشرف عام',
    loginDemoAdmin: 'مدير (مطعم تجريبي)',
    loginDemoWaiter: 'نادل',
    loginDemoKitchen: 'مطبخ',
    onbStepperAriaLabel: 'خطوات الإعداد',
    onbProgressBarLabel: 'تقدم الإعداد',
    onbCompletedSuffix: 'مكتمل',
    peakHourChartAria: 'كثافة الطلبات حسب الساعة',
    peakHourSourceLive: 'بيانات مباشرة',
    peakHourSourceOrders: 'من سجل الطلبات',
    peakHourSourceDemo: 'بيانات تجريبية',
    peakHourLegendHigh: 'ذروة (>75%)',
    peakHourLegendMid: 'متوسط (40–75%)',
    peakHourLegendLow: 'منخفض (<40%)',
    reportsDownloadCSV: 'تنزيل CSV',
    a11yDownloadCsvLabel: 'تنزيل CSV',
    metricCol: 'المقياس',
    valueCol: 'القيمة',
    amountCol: 'المبلغ (₺)',
    amountExtraCol: 'إضافي (₺)',
    settingsDirtyBadge: 'تغييرات غير محفوظة',
    hrTotalPayrolls: 'إجمالي كشوف الرواتب',
    hrTotalNetSalary: 'إجمالي الراتب الصافي',
    hrRemainingLeave: 'الإجازة المتبقية',
    hrDocumentCount: 'عدد المستندات',
    hrYears: 'سنة',
    hrWeeks: 'أسبوع',
    hrLast6Payrolls: 'آخر 6 كشوف رواتب',
    hrPeriod: 'الفترة',
    hrNetShort: 'صافي',
    hrSGKShort: 'تأمين',
    hrNoPayrollRecord: 'لا توجد سجلات رواتب.',
    hrLast30DaysShifts: 'مناوبات آخر 30 يومًا',
    hrShowAllShifts: 'عرض جميع المناوبات ←',
    hrNoLinkedAccountShifts: 'لم يُربط حساب تسجيل دخول بهذا الموظف — لا يمكن عرض المناوبات.',
    hrNoShiftsLast30Days: 'لا توجد مناوبات في آخر 30 يومًا.',
    hrMoreShifts: 'مناوبات أخرى…',
    hrSeveranceNoticeTitle: 'مكافأة نهاية الخدمة والإشعار',
    hrSeveranceNoticeDesc: 'حساب تقريبي حسب مدة الخدمة.',
    hrCalculateSeveranceNotice: 'حساب نهاية الخدمة والإشعار',
    hrCSVImportEmployeesTitle: 'إضافة موظفين دفعة واحدة عبر CSV',
    hrImport: 'استيراد',
    hrImporting: 'جاري الاستيراد…',
    hrRowsImport: 'صفًا لاستيراد',
    hrColAccount: 'الحساب',
    hrAccountLinked: 'حساب مربوط',
    hrNoAccount: 'لا يوجد حساب',
    hrDetail: 'تفاصيل',
    hrAnnualPayrollSummary: 'ملخص الرواتب السنوي',
    hrColEmployerCostShort: 'تكلفة صاحب العمل',
    hrPeople: 'شخص',
    hrNoDataFound: 'لم يتم العثور على بيانات.',
    hrPreviousMonth: 'الشهر السابق',
    hrMuhtasarSummaryTitle: 'ملخص ضريبة الاستقطاع',
    hrMuhtasarSummaryAria: 'تنزيل PDF ملخص ضريبة الاستقطاع',
    hrMuhtasarPDFBtn: 'PDF الاستقطاع',
    hrBankTransferCSVTitle: 'تنزيل CSV التحويل البنكي',
    hrBankFileBtn: 'ملف بنكي',
    hrCSVExport: 'تصدير CSV',
    hrCustomDeduction: 'خصم خاص',
    hrDownloadPDF: 'تنزيل PDF',
    hrToday: 'اليوم',
    hrDayMon: 'إثن',
    hrDayTue: 'ثلا',
    hrDayWed: 'أرب',
    hrDayThu: 'خمي',
    hrDayFri: 'جمع',
    hrDaySat: 'سبت',
    hrDaySun: 'أحد',
    hrMore: 'المزيد',
    hrViewList: 'قائمة',
    hrViewCalendar: 'تقويم',
    hrClearDate: 'مسح التاريخ',
    hrLast30Days: 'آخر 30 يومًا',
    hrExpiringDocuments: 'منتهية/سترتفع',
    channel: 'قناة',
    customersMessageBodyPlaceholder: 'مرحبا {name}، يسعدنا رؤيتك مرة أخرى. خصم 20% خاص لهذا الشهر...',
    settingsPushTestBtn: 'اختبار',
    tablesCustomerOptionalLabel: 'العميل (اختياري — للولاء)',
    orderStatTodayRevenue: 'إيرادات اليوم',
    reservationStatWeekTotal: 'إجمالي هذا الأسبوع',
    refundStatCount: 'إجمالي عدد المستردات',
    refundStatAmount: 'إجمالي مبلغ الاسترداد',
    refundStatPending: 'قيد الانتظار',
    refundStatCompleted: 'مكتمل',
    auditStatTotalFiltered: 'إجمالي السجلات',
    auditStatLast24h: 'آخر 24 ساعة',
    auditStatCritical: 'إجراء حرج',
    auditStatUniqueUsers: 'مستخدمون فريدون',
    stockStatTotalItems: 'إجمالي المنتجات',
    stockStatLowStock: 'مخزون منخفض',
    stockStatValue: 'قيمة المخزون',
    stockStatCategoryCount: 'عدد الفئات',
    courierStatActiveCouriers: 'كادر فعّال',
    courierStatAssignedDeliveries: 'توصيلات مسندة',
    courierStatDeliveredToday: 'تم التوصيل اليوم',
    shiftStatTodayActive: 'فعّال اليوم',
    shiftStatOpenShifts: 'مناوبات مفتوحة',
    shiftStatWeekHours: 'إجمالي ساعات الأسبوع',
    shiftStatTotalStaff: 'إجمالي الموظفين',
    wsPodiumLabel: 'أفضل 3 نوادل',
    wsPodiumFirst: 'الأول',
    wsPodiumSecond: 'الثاني',
    wsPodiumThird: 'الثالث',
    kitchenOldestOrder: 'أقدم طلب',
    kitchenAvgWait: 'متوسط الانتظار',
    posDisplayQueueOverview: 'حالة الطلب',
    posDisplayQueuePreparing: 'قيد التحضير',
    posDisplayQueueReady: 'جاهز',
    posDisplayQueueAvgWait: 'متوسط الانتظار',
    posSummaryTodayCount: 'مبيعات اليوم',
    posSummaryUnitsSuffix: 'وحدة',
    posSummaryTodayRevenue: 'إيرادات اليوم',
    posSummaryRevenueSub: 'الإجمالي',
    posSummaryAvgBasket: 'متوسط السلة',
    posSummaryAvgBasketSub: 'لكل مبيعة',
    posSummaryOpenSession: 'جلسة مفتوحة',
    posSummarySessionActive: 'نشط',
    posSummarySessionClosed: 'مغلق',
    posSummarySessionNone: 'لا توجد جلسة',
    trashStatOthers: 'أخرى',
    recipeOverviewRegionAria: 'ملخص الوصفة',
    recipeOverviewTotal: 'إجمالي الوصفات',
    recipeOverviewAvgCost: 'متوسط التكلفة',
    recipeOverviewMargin: 'متوسط الهامش',
    recipeOverviewLinked: 'عناصر القائمة المرتبطة',
    flagStatPartial: 'إطلاق جزئي',
    featureFlagSearchPlaceholder: 'بحث الميزة...',
    webhookOverviewTotal: 'إجمالي الاشتراكات',
    webhookOverviewActive: 'نشط',
    webhookOverviewDeliveries24h: 'تسليمات آخر 24 س',
    webhookOverviewFailed: 'فشل',
    printerStatTodayJobs: 'مهام اليوم',
    printerStatPendingJobs: 'مهام معلقة',
    taxStatTotalGroups: 'إجمالي المجموعات',
    taxStatDefaultCount: 'افتراضي',
    taxStatMaxRate: 'أعلى نسبة',
    taxStatMinRate: 'أدنى نسبة',
    chainStaffSearchPlaceholder: 'بحث بالاسم أو البريد...',
    chainStaffActive: 'نشط',
    chainStaffBranchCount: 'عدد الفروع',
    chainStaffTopRole: 'الأدوار',
    supplierStatOutstanding: 'الرصيد المتبقي',
    supplierStatPoThisMonth: 'طلبات هذا الشهر',
    supplierStatRecent30d: 'المضافة آخر 30 يومًا',
    supplierActiveFilterAria: 'تصفية النشاط',
    clearDates: 'مسح التواريخ',
    role_chain_admin: 'مدير السلسلة',
    poEmptyTitle: 'لا توجد أوامر شراء بعد',
    poEmptyHint: 'أنشئ أول أمر شراء.',
    poNoItemsError: 'أضف عنصراً واحداً على الأقل.',
    poSupplierRequired: 'اختر مورداً.',
    courierTitle: 'مندوبو التوصيل',
    courierSubtitle: 'إدارة مندوبي التوصيل.',
    courierAdd: 'إضافة مندوب',
    courierEditTitle: 'تعديل المندوب',
    courierNewTitle: 'مندوب جديد',
    courierName: 'الاسم الكامل',
    courierVehicle: 'المركبة',
    courierVehicle_motorbike: 'دراجة نارية',
    courierVehicle_bicycle: 'دراجة هوائية',
    courierVehicle_car: 'سيارة',
    courierVehicle_walking: 'مشياً',
    courierLicensePlate: 'رقم اللوحة',
    courierNotes: 'ملاحظات',
    courierActive: 'نشط',
    courierInactive: 'غير نشط',
    courierLocation: 'الموقع',
    courierLocationTitle: 'تحديث الموقع',
    courierLat: 'خط العرض',
    courierLng: 'خط الطول',
    courierStatTotal: 'إجمالي المندوبين',
    courierStatActive: 'نشط',
    courierStatOnDelivery: 'في التوصيل',
    courierStatIdle: 'خامل',
    courierStatus: 'الحالة',
    courierStatusPlaceholder: 'في الطريق / عند العميل / في المطعم',
    courierLastSeen: 'آخر ظهور',
    courierUseMyLocation: 'استخدم موقعي الحالي',
    courierShowInactive: 'عرض غير النشط',
    courierEmptyTitle: 'لا يوجد مندوبون بعد',
    courierEmptyHint: 'أضف أول مندوب لبدء التوصيل.',
    courierNameRequired: 'الاسم مطلوب.',
    courierPhoneRequired: 'الهاتف مطلوب.',
    courierLoadError: 'تعذر تحميل المندوبين.',
    courierSearchPlaceholder: 'بحث عن مندوب...',
    courierAssignNone: 'غير معين',
    courierRating: 'تقييم المندوب',
    courierRatingPrompt: 'كيف تقيم هذا التوصيل؟',
    courierAvgRating: 'متوسط التقييم',
    courierRatingError: 'تعذر حفظ التقييم',
    courierRatingDone: 'تم حفظ تقييمك',
    qrClaimedToday: 'مُستلم',
    qrConversionRate: 'تحويل',
    stockCostPerUnit: 'تكلفة الوحدة (₺)',
    stockCostHint: '— لحساب تكلفة الطعام',
    foodCostTitle: 'تحليل التكلفة',
    foodCostUnitCost: 'تكلفة الوحدة',
    foodCostSellPrice: 'سعر البيع',
    foodCostMargin: 'الهامش',
    foodCostMissing: 'بعض المكونات تفتقر لتكلفة الوحدة — أضفها من صفحة المخزون.',
    foodCostAnalysisTitle: 'تحليل التكلفة والهامش',
    foodCostAvgMargin: 'متوسط الهامش',
    foodCostMissingShort: 'تكلفة مفقودة',
    foodCostNoData: 'لا توجد عناصر بوصفات. أنشئ وصفة من صفحة الوصفات.',
    foodCostTargetMargin: 'الهامش المستهدف',
    foodCostSuggested: 'مُقترح ₺',
    cogsTitle: 'تكلفة البضائع المباعة اليومية',
    cogsTotal: 'COGS',
    cogsTotalRevenue: 'الإيرادات',
    cogsGrossProfit: 'الربح الإجمالي',
    customerTags: 'الوسوم',
    customerTagsHint: 'تقسيم العملاء (vip, vegan, no-spice...)',
    customerTagAddPlaceholder: 'اكتب وسماً، اضغط Enter أو فاصلة للإضافة',
    customerAllTags: 'جميع الوسوم',
    customerClearTag: 'مسح الوسم',
    segmentTitle: 'تقسيم العملاء',
    segmentTagsCount: 'شريحة',
    segmentNoData: 'لا توجد بيانات تقسيم بعد. أضف وسوم للعملاء.',
    // ERP-07 Part 1 — حركات النقد
    cashTxTitle: 'حركات النقد',
    cashTxSubtitle: 'تتبع إيرادات ومصروفات المطعم.',
    cashTxNew: 'حركة جديدة',
    cashTxEdit: 'تعديل الحركة',
    cashTxTypeIn: 'دخل',
    cashTxTypeOut: 'مصروف',
    cashTxAmount: 'المبلغ (₺)',
    cashTxCategory: 'الفئة',
    cashTxDate: 'التاريخ',
    cashTxMethod: 'الطريقة',
    cashTxMethod_cash: 'نقدي',
    cashTxMethod_bank: 'بنك',
    cashTxMethod_card: 'بطاقة',
    cashTxMethod_other: 'أخرى',
    cashTxDescription: 'الوصف',
    cashTxStatTotalIn: 'إجمالي الدخل',
    cashTxStatTotalOut: 'إجمالي المصروف',
    cashTxStatBalance: 'الرصيد',
    cashTxFilterType: 'النوع',
    cashTxFilterAll: 'الكل',
    cashTxClearFilters: 'مسح الفلاتر',
    cashTxEmptyTitle: 'لا توجد حركات',
    cashTxEmptyHint: 'أضف أول دخل/مصروف.',
    cashTxAmountRequired: 'المبلغ مطلوب (>0).',
    cashTxCategory_sale: 'مبيعات',
    cashTxCategory_supplier: 'مورد',
    cashTxCategory_rent: 'إيجار',
    cashTxCategory_salary: 'راتب',
    cashTxCategory_tax: 'ضريبة',
    cashTxCategory_utilities: 'فواتير',
    cashTxCategory_other: 'أخرى',
    cashTxAuto: 'تلقائي',
    cashTxAutoHint: 'تم إنشاء هذه الحركة تلقائيًا من سجل مرتبط (أمر شراء/دفعة).',
    cashTxSyncPayments: 'مزامنة من المدفوعات',
    cashTxSyncConfirm: 'استيراد المدفوعات غير المتزامنة كإيرادات؟',
    cashTxSyncResult: 'تمت إضافة {n} حركة.',
    pnlTabTitle: 'الربح / الخسارة',
    pnlSubtitle: 'صافي الربح/الخسارة للفترة المحددة من الإيرادات وتكلفة البضائع والمصروفات.',
    pnlIncome: 'إجمالي الدخل',
    pnlCogs: 'تكلفة البضائع',
    pnlGrossProfit: 'الربح الإجمالي',
    pnlExpense: 'إجمالي المصروفات',
    pnlNetProfit: 'صافي الربح',
    pnlIncomeBreakdown: 'فئات الدخل',
    pnlExpenseBreakdown: 'فئات المصروفات',
    pnlEmptyTitle: 'لا توجد بيانات',
    pnlEmptyHint: 'لا توجد حركات نقدية لهذه الفترة.',
    customerLedger: 'الحساب',
    customerLedgerTitle: 'كشف الحساب',
    customerLedgerDebit: 'مدين',
    customerLedgerCredit: 'دفعة',
    customerLedgerBalance: 'الرصيد',
    customerLedgerOrder: 'طلب',
    customerLedgerPayment: 'دفعة',
    customerLedgerEmpty: 'لا توجد حركات',
    customerLedgerEmptyHint: 'لا توجد طلبات أو دفعات لهذا العميل بعد.',
    supplierMakePayment: 'تسجيل دفعة',
    supplierPaymentAmount: 'المبلغ (₺)',
    supplierPaymentMethod: 'الطريقة',
    supplierPaymentDate: 'التاريخ',
    supplierPaymentNote: 'ملاحظة',
    supplierPaymentSave: 'حفظ',
    userHourlyRate: 'الأجر بالساعة (₺)',
    userPayroll: 'الراتب',
    payrollTitle: 'حساب الراتب',
    payrollPeriodStart: 'البداية',
    payrollPeriodEnd: 'النهاية',
    payrollCalculate: 'احسب',
    payrollShifts: 'المناوبات',
    payrollHours: 'الساعات',
    payrollOvertimeHours: 'ساعات إضافية',
    payrollRegularPay: 'الأجر العادي',
    payrollOvertimePay: 'أجر العمل الإضافي',
    payrollTotal: 'الإجمالي',
    payrollPay: 'دفع الراتب',
    payrollPaid: 'تم تسجيل دفعة الراتب كمعاملة نقدية.',
    payrollEmpty: 'لا توجد مناوبات',
    payrollEmptyHint: 'لا مناوبات في هذه الفترة.',
    payrollNoRate: 'لم يتم تحديد الأجر بالساعة — يُحسب الأجر بصفر.',
    payrollReportTabTitle: 'تقرير الرواتب',
    payrollReportTitle: 'تقرير رواتب الموظفين',
    payrollReportSubtitle: 'المناوبات × الأجر بالساعة لكل الموظفين في الفترة المحددة.',
    payrollReportStaff: 'موظفون',
    payrollReportEmployee: 'موظف',
    payrollReportEmpty: 'لا توجد سجلات مناوبات لهذه الفترة.',
    exportCsv: 'تصدير CSV',
    msgWhatsApp: 'فتح في واتساب',
    stockOrderWhatsapp: 'اطلب',
    stockAdjustBtn: 'تعديل',
    stockAdjustQuick: 'تعديل المخزون السريع',
    stockAdjustCurrent: 'المخزون الحالي',
    stockAdjustAdd: 'إضافة (وارد)',
    stockAdjustRemove: 'حذف (تالف/استخدام)',
    stockAdjustAmount: 'الكمية',
    stockAdjustNewQty: 'المخزون الجديد',
    stockAdjustNegative: 'لا يمكن أن يكون المخزون الجديد سالبًا',
    stockAdjustReasonOptional: 'السبب (اختياري)',
    stockAdjustReasonPlaceholder: 'مثل: استلام مورد، فاقد، تصحيح',
    stockAdjustHistory: 'السجل',
    stockAdjustNoHistory: 'لا توجد سجلات تعديل بعد.',
    wasteWidgetTitle: 'حركة المخزون',
    wasteWidgetGoStock: 'إلى المخزون',
    wasteTotal: 'فاقد',
    wasteIncoming: 'وارد',
    wasteIncomingDesc: 'من المورد',
    wasteItemsCount: 'مواد',
    wasteTopList: 'الأعلى فاقدًا',
    refundsTitle: 'الاستردادات',
    refundsSubtitle: 'جميع سجلات الاسترداد',
    refundStatTotal: 'إجمالي الاسترداد',
    refundsTotalAmount: 'إجمالي المسترد',
    refundsCount: 'عدد الاستردادات',
    refundsAvg: 'متوسط الاسترداد',
    refundsFilterFrom: 'من',
    refundsFilterTo: 'إلى',
    refundsFilterApply: 'تصفية',
    refundsFilterClear: 'مسح',
    refundsFilterMonth: 'هذا الشهر',
    refundsColPayment: 'دفعة #',
    refundsColOrderTable: 'طلب / طاولة',
    refundsColMethod: 'الطريقة',
    refundsColReason: 'السبب',
    refundsEmptyTitle: 'لا توجد استردادات',
    refundsEmptyHint: 'لم يتم إجراء أي استرداد بعد.',
    stockHistoryTitle: 'سجل المخزون',
    stockHistorySubtitle: 'جميع سجلات الدخول والخروج للمخزون',
    stockHistoryTotal: 'إجمالي السجلات',
    stockHistoryIn: 'وارد',
    stockHistoryOut: 'صادر',
    stockHistoryNetValue: 'صافي القيمة',
    stockHistoryFilterType: 'النوع',
    stockHistoryFilterIngredient: 'المكون',
    stockHistoryFilterAll: 'الكل',
    stockHistoryColMovement: 'الحركة',
    stockHistoryColBefore: 'قبل → بعد',
    stockHistoryColValue: 'القيمة (₺)',
    stockHistoryColUser: 'المستخدم',
    stockHistoryEmpty: 'لا توجد سجلات',
    stockHistoryEmptyHint: 'لا توجد حركات للمخزون لهذا التصفية.',
    msgSms: 'إرسال SMS',
    msgEmail: 'إرسال بريد',

    // Tur 197
    orderStatTotal: 'الإجمالي',
    orderStatPreparing: 'قيد التحضير',
    orderStatReady: 'جاهز',
    orderStatServed: 'تم التسليم',
    datePresetToday: 'اليوم',
    datePreset7Days: 'آخر 7 أيام',
    datePreset30Days: 'آخر 30 يوم',
    datePresetClear: '✕ مسح التاريخ',
    recipeStatSteps: 'خطوات الوصفة',
    recipeStatCost: 'التكلفة الإجمالية',
    recipeStatPrice: 'سعر البيع',
    recipeStatMargin: 'هامش الربح',
    webhookStatSuccess: 'آخر ناجح',
    flagStatTotal: 'الإجمالي',
    flagStatEnabled: 'مفعّل',
    flagStatDisabled: 'معطّل',
    taxStatTotal: 'الإجمالي',
    taxStatDefault: 'الافتراضي',
    taxStatRange: 'النطاق',
    // HR (Tur 210)
    hrPageTitle: 'إدارة الموارد البشرية',
    hrPageSubtitle: 'الرواتب والإجازات وعمليات الموارد البشرية',
    hrTabEmployees: 'الموظفون',
    hrTabPayroll: 'الرواتب',
    hrTabLeaves: 'الإجازات',
    hrTabDocuments: 'المستندات',
    hrNewEmployee: 'موظف جديد',
    hrEditEmployee: 'تعديل الموظف',
    hrFirstName: 'الاسم',
    hrLastName: 'اللقب',
    hrTcKimlik: 'الرقم الوطني',
    hrElevenDigit: '11 رقمًا',
    hrBirthDate: 'تاريخ الميلاد',
    hrHireDate: 'تاريخ التعيين',
    hrDepartment: 'القسم',
    hrPosition: 'المنصب',
    hrEmploymentType: 'نوع التوظيف',
    hrGrossSalaryRequired: 'الراتب الإجمالي (₺) *',
    hrGrossSalaryPlaceholder: 'مثال: 25000',
    hrHourlyRateOptional: 'الأجر بالساعة (₺، اختياري)',
    hrIban: 'IBAN',
    hrPhone: 'الهاتف',
    hrEmail: 'البريد الإلكتروني',
    hrAddress: 'العنوان',
    hrNotes: 'ملاحظات',
    hrActiveEmployee: 'موظف نشط',
    hrCancel: 'إلغاء',
    hrSave: 'حفظ',
    hrSaving: 'جاري الحفظ…',
    hrEmployeesRegistered: 'موظف مسجّل',
    hrTotalEmployees: 'إجمالي الموظفين',
    hrActive: 'نشط',
    hrPassive: 'غير نشط',
    hrMonthlyTotalGross: 'إجمالي الراتب الشهري',
    hrColFullName: 'الاسم الكامل',
    hrColDepartment: 'القسم',
    hrColPosition: 'المنصب',
    hrColHireDate: 'تاريخ التعيين',
    hrColEmploymentType: 'النوع',
    hrColGrossSalary: 'الراتب الإجمالي',
    hrColStatus: 'الحالة',
    hrColActions: 'إجراءات',
    hrNoEmployeesYet: 'لم تتم إضافة أي موظفين بعد.',
    hrDelete: 'حذف',
    hrCalculatePayroll: 'حساب الراتب',
    hrEmployee: 'الموظف',
    hrSelectPlaceholder: '-- اختر --',
    hrYear: 'السنة',
    hrMonth: 'الشهر',
    hrWorkingDaysTotal: 'أيام العمل (الإجمالي)',
    hrWorkedDays: 'أيام العمل الفعلية',
    hrOvertimeHours: 'ساعات إضافية',
    hrBonus: 'علاوة (₺)',
    hrAdvance: 'سلفة (₺)',
    hrCalculate: 'احسب',
    hrCalculating: 'جاري الحساب…',
    hrCalculationSummary: 'ملخص الحساب',
    hrGrossSalary: 'الراتب الإجمالي',
    hrOvertimePay: 'أجر العمل الإضافي',
    hrBonusPremium: 'علاوة / مكافأة',
    hrSgkEmployee: 'SGK الموظف (14٪)',
    hrUnemploymentEmployee: 'تأمين البطالة (1٪)',
    hrIncomeTax: 'ضريبة الدخل',
    hrStampTax: 'رسم الطابع',
    hrAdvanceDeduction: 'خصم السلفة',
    hrNetSalary: 'صافي الراتب',
    hrSgkEmployerShare: 'حصة SGK لصاحب العمل',
    hrTotalCost: 'التكلفة الإجمالية',
    hrThisMonthTotalCost: 'إجمالي تكلفة هذا الشهر',
    hrTotalNetPayment: 'إجمالي صافي المدفوعات',
    hrPendingApproval: 'بانتظار الموافقة',
    hrBulkCalculate: 'حساب جماعي',
    hrColGross: 'إجمالي',
    hrColSgkEmployee: 'SGK',
    hrColUnemployment: 'بطالة',
    hrColIncomeTaxShort: 'ض. الدخل',
    hrColStampTax: 'الطابع',
    hrColDeductions: 'الخصومات',
    hrColNetSalary: 'صافي الراتب',
    hrColSgkEmployer: 'SGK ص.ع.',
    hrColTotalCost: 'إجمالي التكلفة',
    hrNoPayrollForPeriod: 'لا توجد كشوف رواتب لهذه الفترة.',
    hrApprove: 'اعتماد',
    hrPaid: 'مدفوع',
    hrPrint: 'طباعة',
    hrCreateLeaveRequest: 'إنشاء طلب إجازة',
    hrLeaveType: 'نوع الإجازة',
    hrStartDate: 'تاريخ البدء',
    hrEndDate: 'تاريخ الانتهاء',
    hrDescriptionReason: 'الوصف / السبب',
    hrSubmitRequest: 'إرسال الطلب',
    hrAllEmployees: 'جميع الموظفين',
    hrAllStatuses: 'جميع الحالات',
    hrPending: 'قيد الانتظار',
    hrApproved: 'معتمد',
    hrRejected: 'مرفوض',
    hrLeaveRequest: 'طلب إجازة',
    hrTotalLeaves: 'إجمالي الإجازات',
    hrEntitlement: 'الاستحقاق',
    hrUsed: 'المستخدمة',
    hrRemaining: 'المتبقية',
    hrDays: 'يوم',
    hrStart: 'البداية',
    hrEnd: 'النهاية',
    hrDay: 'يوم',
    hrNoLeavesFound: 'لا توجد سجلات إجازة.',
    hrReject: 'رفض',
    hrAddDocument: 'إضافة مستند',
    hrDocumentType: 'نوع المستند',
    hrTitle: 'العنوان',
    hrDocumentTitlePlaceholder: 'عنوان المستند',
    hrFileUrl: 'رابط الملف',
    hrAdd: 'إضافة',
    hrTotalDocuments: 'إجمالي المستندات',
    hrThisMonth: 'هذا الشهر',
    hrEmployeeCount: 'عدد الموظفين',
    hrNoDocumentsFound: 'لا توجد مستندات.',
    hrView: 'عرض',
    hrSearchEmployee: 'بحث عن موظف...',
    hrBulkLeaveTitle: 'إضافة إجازة جماعية',
    hrBulkLeaveBtn: 'إجازة جماعية',
    hrBulkLeaveHint: 'عيّن إجازة لجميع الموظفين دفعة واحدة لرأس السنة أو الأعياد الدينية أو العطلات الرسمية.',
    hrBulkScope: 'النطاق',
    hrBulkAllActive: 'جميع الموظفين النشطين',
    hrBulkSelected: 'الموظفون المحددون',
    hrBulkCreate: 'تعيين جماعي',
    hrStatus: 'الحالة',
    hrSelectDateRange: 'أدخل نطاق التاريخ.',
    hrEndBeforeStart: 'لا يمكن أن يكون تاريخ الانتهاء قبل تاريخ البدء.',
    hrSelectAtLeastOne: 'اختر موظفًا واحدًا على الأقل.',
    hrNoActiveEmployees: 'لا يوجد موظفون نشطون.',
    hrCalcModeGross: '📥 الإجمالي ← الصافي',
    hrCalcModeNet: '📤 الصافي ← الإجمالي',
    hrNetTarget: 'الهدف الصافي (₺)',
    hrEstimatedGross: 'الإجمالي المقدّر',
    hrIterations: 'تكرار',
    // HR mevzuat genişletme (Tur 229)
    hrOptionalAllowancesDeductions: 'البدلات والاستقطاعات الشهرية (اختياري)',
    hrMaritalStatus: 'الحالة الاجتماعية',
    hrMaritalSingle: 'أعزب',
    hrMaritalMarried: 'متزوج',
    hrMaritalWidowed: 'أرمل',
    hrMaritalDivorced: 'مطلق',
    hrChildrenCount: 'عدد الأطفال',
    hrMonthlyAllowancesTaxFree: 'البدلات الشهرية (معفاة، تُضاف للصافي)',
    hrMealAllowance: 'بطاقة طعام',
    hrTransportAllowance: 'بدل مواصلات',
    hrFamilyAllowance: 'بدل عائلة',
    hrChildAllowance: 'بدل أطفال',
    hrMonthlyDeductions: 'الاستقطاعات الشهرية',
    hrUnionDues: 'اشتراك النقابة',
    hrBesPayment: 'BES (تقاعد)',
    hrWeeklyHolidayHours: 'ساعات العطلة الأسبوعية',
    hrWeeklyHolidayHint: 'معامل 1.5x',
    hrPublicHolidayHours: 'ساعات العطلة الرسمية',
    hrPublicHolidayHint: 'معامل 2x',
    hrAllowancesAndSpecialDeductions: 'البدلات والاستقطاعات الخاصة',
    hrSpecialDeductions: 'استقطاعات خاصة',
    hrAlimony: 'النفقة',
    hrGarnishment: 'الحجز',
    hrWeeklyHolidayPay: 'أجر العطلة الأسبوعية',
    hrPublicHolidayPay: 'أجر العطلة الرسمية',
    stockLowAlert: '⚠️ {count} مكوّنات منخفضة بشكل حرج',
    settingsSavedAt: 'تم الحفظ',
    // Tur 248 i18n tail sweep
    custCorporateLabel: 'مؤسسي',
    custTypeLabel: 'نوع العميل',
    custIndividual: 'فردي',
    custCorporateInfo: 'بيانات الشركة',
    custCompanyName: 'اسم الشركة',
    custTaxNumber: 'الرقم الضريبي',
    custTaxOffice: 'دائرة الضرائب',
    custCreditLimit: 'حد الائتمان (₺)',
    custAddressLabel: 'العنوان',
    custLedgerAddDebt: 'إضافة دين',
    custLedgerTakePayment: 'استلام دفعة',
    setTaxSgkSection: 'معلومات الضريبة والـ SGK (لـ e-Bildirge / Muhtasar)',
    setTaxNumberLabel: 'الرقم الضريبي',
    setTaxOfficeLabel: 'دائرة الضرائب',
    setSgkSicilNo: 'رقم منشأة SGK',
    setTaxSgkHint: 'تُستخدم هذه المعلومات تلقائيًا في ملفات SGK Bildirge و Muhtasar PDF.',
    dashDocExpiryTitle: 'انتهاء صلاحية المستندات',
    dashViewAll: 'الكل ←',
    dashDocExpiryEmpty: 'لا توجد مستندات منتهية/قاربت على الانتهاء',
    rptTopSpendersTitle: 'أعلى 10 منفقين',
    rptViewAll: 'الكل ←',
    rptNoDataShort: 'لا توجد بيانات بعد',
    hrSgkSicilNoLabel: 'رقم سجل SGK (اختياري)',
    hrSgkSicilNoPlaceholder: 'لتقرير قسط الخدمة الشهري لـ SGK',
    hrSgkBildirgeBtn: 'SGK Bildirge',
    hrSearchLeave: 'بحث عن إجازة...',
    hrSearchDocument: 'بحث عن مستند...',
    // Couriers (Tur 216)
    crGeoNotSupported: 'المتصفح لا يدعم تحديد الموقع',
    crGeoFailed: 'تعذّر الحصول على الموقع',
    crFillAtLeastOne: 'املأ حقلًا واحدًا على الأقل',
    crAgoNow: 'الآن',
    crAgoMin: 'د مضت',
    crAgoHour: 'س مضت',
    crAgoDay: 'ي مضت',
    crLast7Days: 'آخر 7 أيام',
    crLast30Days: 'آخر 30 يومًا',
    crThisMonth: 'هذا الشهر',
    crLastMonth: 'الشهر الماضي',
    crClearDate: 'مسح التاريخ',
    loginEmailPlaceholder: 'example@restaurant.com',
    // Empty states (Tur 218)
    stockNoItemsTitle: 'لا توجد مكونات بعد',
    stockNoItemsDesc: 'أضف أول مكوّن لبدء تتبع المخزون.',
    stockAddItem: '+ مكوّن جديد',
    stockNoSearchResultsTitle: 'لم يتم العثور على نتائج',
    stockNoSearchResultsDesc: 'حاول تغيير معايير البحث أو الفلتر.',
    rcpNoItemsTitle: 'لا توجد وصفات بعد',
    rcpNoItemsDesc: 'أضف وصفات لأصناف القائمة لتتبع تكاليفها.',
    rcpNoSearchResultsTitle: 'لم يتم العثور على نتائج',
    rcpNoSearchResultsDesc: 'حاول تغيير معايير البحث.',
    whkNoItemsTitle: 'لا توجد اشتراكات webhook بعد',
    whkNoItemsDesc: 'أضف اشتراكًا لإرسال الأحداث إلى Zapier أو Make أو خادمك.',
    whkAddBtn: '+ اشتراك جديد',
    whkNoSearchResultsTitle: 'لم يتم العثور على نتائج',
    whkNoSearchResultsDesc: 'غيّر بحث الرابط أو الحدث.',
    auditNoItemsTitle: 'لا توجد سجلات بعد',
    auditNoItemsDesc: 'سيتم تسجيل إجراءات النظام هنا.',
    auditNoSearchResultsTitle: 'لم يتم العثور على نتائج',
    auditNoSearchResultsDesc: 'غيّر البحث أو فلتر التاريخ.',
    // Empty states 2 (Tur 219)
    taxNoItemsTitle: 'لا توجد مجموعات ضريبية بعد',
    taxNoItemsDesc: 'جمّع نسب ض.ق.م لتعليم أصناف القائمة بسرعة.',
    taxAddBtn: '+ مجموعة ضريبية جديدة',
    taxNoSearchResultsTitle: 'لم يتم العثور على نتائج',
    taxNoSearchResultsDesc: 'غيّر البحث أو فلتر التاريخ.',
    flagNoItemsTitle: 'لا توجد feature flags بعد',
    flagNoItemsDesc: 'استخدم flags للتحكم في طرح الميزات الجديدة.',
    flagAddBtn: '+ flag جديد',
    flagNoSearchResultsTitle: 'لم يتم العثور على نتائج',
    flagNoSearchResultsDesc: 'غيّر البحث أو فلتر التاريخ.',
    promoNoItemsTitle: 'لا توجد أكواد ترويجية بعد',
    promoNoItemsDesc: 'أنشئ أول كود خصم لمكافأة عملائك.',
    promoAddBtn: '+ كود جديد',
    promoNoSearchResultsTitle: 'لم يتم العثور على نتائج',
    promoNoSearchResultsDesc: 'غيّر معايير البحث أو الفلتر.',
    rsvNoItemsTitle: 'لا توجد حجوزات بعد',
    rsvNoItemsDesc: 'حجوزات العملاء ستظهر هنا. يمكنك إضافة حجز يدويًا أيضًا.',
    rsvAddBtn: '+ حجز جديد',
    rsvNoSearchResultsTitle: 'لم يتم العثور على نتائج',
    rsvNoSearchResultsDesc: 'غيّر البحث أو فلتر التاريخ.',
    // Empty states 3 (Tur 221)
    prnNoItemsTitle: 'لا توجد طابعات بعد',
    prnNoItemsDesc: 'أضف طابعة حرارية متوافقة مع ESC/POS لأتمتة طباعة المطبخ/الفواتير.',
    prnAddBtn: '+ طابعة جديدة',
    prnNoSearchResultsTitle: 'لم يتم العثور على نتائج',
    prnNoSearchResultsDesc: 'غيّر معايير البحث أو الفلتر.',
    notifNoItemsTitle: 'لا توجد إشعارات بعد',
    notifNoItemsDesc: 'ستظهر إشعارات الطلبات والمدفوعات وأحداث النظام هنا فور حدوثها.',
    notifNoSearchResultsTitle: 'لم يتم العثور على نتائج',
    notifNoSearchResultsDesc: 'غيّر الفلتر أو البحث أو معيار التاريخ.',
    // Empty states 4 (Tur 222)
    mmNoItemsTitle: 'لا توجد أصناف قائمة بعد',
    mmNoItemsDesc: 'أضف أول فئة ومنتج لبناء قائمتك.',
    mmAddBtn: '+ صنف جديد',
    mmNoSearchResultsTitle: 'لم يتم العثور على نتائج',
    mmNoSearchResultsDesc: 'غيّر البحث أو فلتر الفئة.',
    trashNoItemsTitle: 'سلة المحذوفات فارغة',
    trashNoItemsDesc: 'تظهر السجلات المحذوفة هنا ويمكن استعادتها.',
    trashNoSearchResultsTitle: 'لم يتم العثور على نتائج',
    trashNoSearchResultsDesc: 'غيّر معيار البحث.',
    // Empty states 5 (Tur 223)
    hrPayrollEmptyTitle: 'لا يوجد كشف رواتب لهذه الفترة',
    hrPayrollEmptyDesc: 'استخدم "حساب جماعي" لإنشاء كشوف الرواتب لجميع الموظفين، أو احسبها فرديًا.',
    wsNoItemsTitle: 'لا يوجد نشاط نُدُل بعد',
    wsNoItemsDesc: 'ستظهر بيانات الأداء هنا عندما يأخذ النُدُل طلبات.',
    wsNoSearchResultsTitle: 'لم يتم العثور على نتائج',
    wsNoSearchResultsDesc: 'غيّر البحث أو نطاق التاريخ.',
    shfNoItemsTitle: 'لا توجد ورديات معيّنة لهذا الأسبوع',
    shfNoItemsDesc: 'استخدم قالبًا أو اضغط على خانة لتعيين وردية.',
    shfAddBtn: '+ تعيين وردية',
    shfNoSearchResultsTitle: 'لم يتم العثور على نتائج',
    shfNoSearchResultsDesc: 'غيّر بحث الموظفين.',
    gdprAdminEmptyTitle: 'لا توجد طلبات GDPR بعد',
    gdprAdminEmptyDesc: 'تتم إدارة طلبات حذف/تصدير بيانات KVKK / GDPR من هنا.',
    gdprUserEmptyTitle: 'لم ترسل أي طلبات بعد',
    gdprUserEmptyDesc: 'أنشئ طلبًا جديدًا لتنزيل بياناتك أو حذفها.',
    gdprNewRequestBtn: '+ طلب جديد',
    securityNoTwoFa: 'لم يتم تفعيل المصادقة الثنائية بعد',
    securityNoTwoFaDesc: 'يمكنك تفعيل المصادقة الثنائية لحماية حسابك.',
    securitySetup2fa: 'تفعيل',
    // Empty states 7 (Tur 226)
    tableNoItemsTitle: 'لا توجد طاولات بعد',
    tableNoItemsDesc: 'أضف أول طاولة لبدء إدارة الطلبات.',
    tableAddBtn: '+ طاولة جديدة',
    tableNoCategoryItemsTitle: 'لا توجد طاولات في هذه الفئة',
    tableNoCategoryItemsDesc: 'اختر فئة مختلفة أو أضف طاولات إلى هذه الفئة.',
    ordNoItemsTitle: 'لا توجد طلبات بعد',
    ordNoItemsDesc: 'ستظهر الطلبات الجديدة هنا فور وصولها.',
    ordNoSearchResultsTitle: 'لم يتم العثور على نتائج',
    ordNoSearchResultsDesc: 'غيّر الفلتر أو معيار التاريخ.',
    payNoItemsTitle: 'لا توجد مدفوعات بعد',
    payNoItemsDesc: 'ستظهر مدفوعات الطلبات المكتملة هنا.',
    payNoSearchResultsTitle: 'لم يتم العثور على نتائج',
    payNoSearchResultsDesc: 'غيّر نطاق التاريخ.',
    kitNoItemsTitle: 'لا توجد طلبات قيد التحضير',
    kitNoItemsDesc: 'ستظهر الطلبات الجديدة هنا فور وصولها.',
    // Empty states 8 (Tur 227)
    posCartEmptyTitle: 'السلة فارغة',
    posCartEmptyDesc: 'اختر المنتجات من اللوحة اليسرى لإضافتها إلى السلة.',
    posProductsEmpty: 'لا توجد منتجات في هذه الفئة',
    posProductsEmptyDesc: 'جرب فئة مختلفة أو بحث الباركود.',
    posHistoryEmpty: 'لا يوجد سجل بعد',
    posHistoryEmptyDesc: 'لم يتم العثور على مبيعات لهذا التاريخ.',
    posHoldEmpty: 'لا توجد طلبات معلّقة',
    posHoldEmptyDesc: 'ستظهر الطلبات التي تعلقها هنا.',
    cdNoOrdersTitle: 'لا توجد طلبات بعد',
    cdNoOrdersDesc: 'سيظهر سجل طلبات هذا العميل هنا.',
    cdNoLoyaltyTitle: 'لا يوجد نشاط ولاء بعد',
    cdNoLoyaltyDesc: 'يتم احتساب نقاط الولاء عند إتمام الطلبات.',
    msNoPaymentsTitle: 'لا توجد مدفوعات بعد',
    msNoPaymentsDesc: 'سيظهر سجل مدفوعاتك هنا عند تجديد خطتك.',
    msNoInvoicesTitle: 'لا توجد فواتير بعد',
    msNoInvoicesDesc: 'تُنشأ الفواتير تلقائيًا في نهاية الفترة.',
    msInvoicesTitle: 'الفواتير',
    dashTopItemsEmpty: 'لا مبيعات اليوم',
    dashTopItemsEmptyDesc: 'ستظهر الأكثر مبيعًا هنا مع وصول الطلبات.',
    dashActivityEmpty: 'لا يوجد نشاط بعد',
    dashActivityEmptyDesc: 'ستظهر الإجراءات الأخيرة هنا.',
    // i18n tail (Tur 211)
    rptVatRatePct: 'ض.ق.م %',
    rptVatLabel: 'ض.ق.م',
    rptCriticalLabel: 'حرج',
    rptMarginPct: 'الهامش %',
    rptProfitTooltip: 'الربح',
    notifCsvDate: 'التاريخ',
    notifCsvSeverity: 'الأهمية',
    notifCsvType: 'النوع',
    notifCsvTitle: 'العنوان',
    notifCsvMessage: 'الرسالة',
    notifPresetToday: 'اليوم',
    notifPresetLast7Days: 'آخر 7 أيام',
    notifPresetThisMonth: 'هذا الشهر',
    notifPresetLastMonth: 'الشهر الماضي',
    notifClearDate: 'مسح التاريخ',
    tableBulkPrefixDefault: 'طاولة',
    tablePromoCodePlaceholder: 'WELCOME10',
    tableVoucherCodePlaceholder: 'GV-KARAD100',
    giftCustomerNamePh: 'أحمد محمد',
    giftEmailPh: 'example@mail.com',
    // i18n tail (Tur 213)
    custDateLabel: 'التاريخ',
    custDateLast7Days: 'آخر 7 أيام',
    custDateLast30Days: 'آخر 30 يومًا',
    custDateThisMonth: 'هذا الشهر',
    custDateLastMonth: 'الشهر الماضي',
    custClearDate: 'مسح التاريخ',
    custNewBadge: 'جديد',
    custProfileLinkTitle: 'فتح صفحة الملف الشخصي (سجل الطلبات + الولاء)',
    auditSearchPlaceholder: 'ابحث عن مستخدم/إجراء...',
    supPaymentDescPrefix: 'دفعة للمورّد',
    supTaxNumberShort: 'الرقم الضريبي',
    supActiveLabel: 'نشط',
    supCashRefPrefix: 'كاش',
    stockWhatsappMsgFull: 'المخزون منخفض بشكل حرج',
    stockWhatsappOrderAsk: 'هل يمكننا تقديم طلب؟',
    stockWhatsappMsgShort: 'المخزون حرج',
    stockWhatsappOrderShort: 'طلب؟',
    // i18n tail (Tur 214)
    navManagementPlatform: 'منصة الإدارة',
    navManagementSystem: 'الإدارة والنظام',
    navMore: 'المزيد',
    checkoutIframeTitle: 'دفع Iyzico',
    checkoutFirstNamePh: 'أحمد',
    checkoutLastNamePh: 'يلماز',
    checkoutCityPh: 'إسطنبول',
    customersCampaignSendTitle: 'إرسال حملة',
    customersCorpNamePlaceholder: 'مثل: شركة ACME',
    customersTaxOfficePlaceholder: 'مثل: قاضي كوي',
    customersAddressPlaceholder: 'العنوان التفصيلي (اختياري)',
    customersCampaignNamePlaceholder: 'مثل: خصم رأس السنة',
    customersCampaignSubjectPlaceholder: 'اشتقنا إليك!',
    hrEmployeeDetailTitle: 'تفاصيل الموظف',
    hrLinkedAccountTitle: 'افتح حساب تسجيل الدخول المرتبط في صفحة المستخدمين',
    hrCreateAccountTitle: 'أنشئ حساب تسجيل دخول لهذا الموظف في صفحة المستخدمين',
    hrBulkImportTitle: 'استيراد جماعي للموظفين (CSV)',
    hrNetTargetPlaceholder: 'مثال: 30000',
    hrAnnualSummary: 'الملخص السنوي',
    hrSgkBildirgePDFTitle: 'PDF وثيقة الأقساط والخدمات الشهرية SGK',
    hrAllowancesShort: 'البدلات',
    hrLeaveReasonPlaceholder: 'مثال: عطلة رأس السنة',
    posEditProduct: 'تعديل المنتج',
    posEditQty: 'تعديل الكمية',
    posEditPrice: 'تعديل السعر',
    onboardingStep1Title: 'مطعم',
    onboardingStep2Title: 'طاولات',
    onboardingStep3Title: 'قائمة',
    onboardingStep4Title: 'تم',
    peakHourSticker: 'الذروة بين 0–23',
    peakHourFallbackHint: 'لا يوجد توزيع ساعي — تُعرض ساعة الذروة فقط',
    dashNoOrdersToday: 'لا توجد طلبات اليوم بعد',
    shiftsBordroBannerPart1: 'انتقل حساب الرواتب إلى',
    shiftsBordroBannerHrLink: 'إدارة الموظفين',
    shiftsBordroBannerPart2: 'هذه الصفحة لتخطيط المناوبات الأسبوعية فقط.',
    reservationsCustomerSearch: 'ابحث عن عميل...',
    cashTxSearchPlaceholder: 'ابحث في الوصف/الفئة...',
    custSegmentInactive: '💤 غير نشط',
    reportsPrintAction: '🖨️ طباعة',
    stockApproaching: '⚠️ يقترب',
    stockApproachingHint: 'يقترب من الحد الأدنى للمخزون',
    customersLastOrderCol: 'آخر طلب',
    customersDaysAgo: 'منذ {n} يومًا',
    customersToday: 'اليوم',
    customersYesterday: 'أمس',
    customersNever: '—',
    quickActionsTitle: 'إجراءات سريعة',
    quickActionNewOrder: 'طلب جديد',
    quickActionNewTable: 'طاولة جديدة',
    quickActionNewCustomer: 'عميل جديد',
    quickActionNewStaff: 'موظف جديد',
    notifPushEnable: '🔔 تفعيل الإشعارات',
    notifPushDisable: '🔕 إيقاف الإشعارات',
    notifPushUnsupported: 'غير مدعوم على هذا الجهاز',
    notifPushGranted: 'الإشعارات مفعّلة',
    notifPushDenied: 'تم رفض الإذن — فعّله من إعدادات المتصفح',
    rptColSegment: 'الفئة',
    rptColLastOrder: 'آخر طلب',
    dashOrderChannelsTitle: 'قنوات طلبات اليوم',
    dashChannelPOS: 'نقاط البيع',
    dashChannelTable: 'طاولة',
    dashChannelOnline: 'أونلاين',
    dashChannelDelivery: 'توصيل',
    posItemAddedToast: '✓ تمت إضافة {name}',
    tableDurationHourShort: 'س',
    settingsCustomerSegments: '👥 حدود شرائح العملاء',
    settingsVipThreshold: 'حد VIP (ل.ت، آخر 12 شهرًا)',
    settingsLoyalThreshold: 'حد العميل المخلص (طلبات، آخر 3 أشهر)',
    settingsInactiveDays: 'حد الخمول (أيام)',
    settingsLostDays: 'حد الفقدان (أيام)',
    mobileBottomNav: 'قائمة الوصول السريع',
    stockBulkReceiptBtn: 'استلام بالجملة',
    stockBulkReceiptTitle: 'إدخال استلام بالجملة',
    stockBulkAdd: 'إضافة',
    stockBulkSearch: 'ابحث عن مكون...',
    stockBulkSubmit: 'حفظ الاستلام',
    stockBulkSuccessTpl: 'تم تحديث {n} مكونات',
    a11yCustomerSearch: 'البحث عن عميل',
    a11ySendCampaign: 'إرسال حملة',
    a11yOpenProfile: 'افتح الملف الشخصي',
    hrCloseModal: 'إغلاق',
    hrPrevMonth: 'الشهر السابق',
    hrNextMonth: 'الشهر التالي',
    hrMuhtasarPDFAriaLabel: 'تحميل ملخص ضريبة الاستقطاع',
    hrBankCSVAriaLabel: 'تحميل CSV التحويل البنكي',
    hrPayrollCSVExportAriaLabel: 'تصدير CSV الرواتب',
    hrPrintPayslipAriaLabel: 'طباعة كشف الراتب',
    hrDownloadPDFAriaLabel: 'تحميل PDF',
    hrImportEmployeesAriaLabel: 'استيراد جماعي للموظفين عبر CSV',
    tablesPickColorAria: 'اختر اللون',
    a11yReportsTablistLabel: 'علامات تبويب التقارير',
    a11yDateFiltersLabel: 'مرشحات التاريخ',
    a11yExportCsvLabel: 'تنزيل كـ CSV',
    a11yPrintLabel: 'طباعة التقرير',
    loginSubmitting: 'جارٍ تسجيل الدخول...',
    loginForgotPasswordAria: 'نسيت كلمة المرور، انتقل إلى صفحة إعادة التعيين',
    loginDemoFill: 'ملء حساب تجريبي',
    posCartClear: 'مسح السلة',
    supplierSearchAriaLabel: 'ابحث عن المورد',
    supCallAria: 'اتصل',
    supWhatsappAria: 'راسل عبر واتساب',
    stockStatusFilterAria: 'فلتر حالة المخزون',
    notifClearDateAria: 'مسح فلتر التاريخ',
    notifDismissReadAria: 'إخفاء الإشعارات المقروءة',
    notifDismissVisibleAria: 'إخفاء الإشعارات المرئية',
    notifListAria: 'قائمة الإشعارات',
    notifSearchAria: 'البحث في الإشعارات',
    orderLabel: 'طلب',
    kitchenLateHint: 'متأخر!',
    settingsTabsAriaLabel: 'علامات تبويب الإعدادات',
    settingsSubTabsAriaLabel: 'علامات التبويب الفرعية للإعدادات العامة',
    settingsCustomerSegmentsAria: 'تبديل حدود شرائح العملاء',
    saveSettingsBtnDisabledAria: 'لا توجد تغييرات للحفظ',
    onbReopenBtnAria: 'إعادة فتح معالج الإعداد',
    themeToggleLabel: 'تبديل السمة',
    userProfileLabel: 'الملف الشخصي',
    headerNavLabel: 'تنقل الرأس',
    onbStepCompleted: 'مكتمل',
    onbWizardNav: 'تنقل المعالج',
    onbPrevStep: 'الخطوة السابقة',
    onbNextStep: 'الخطوة التالية',
    a11yStatusFilterGroup: 'عامل تصفية حالة الطلب',
    a11yDateRangeGroup: 'النطاق الزمني',
    a11yDeliveryStatsRegion: 'إحصاءات التوصيل',
    a11yOrderCardPrefix: 'طلب',
    a11yAdvanceStatusTo: 'تحديث الحالة',
    userSearchAriaLabel: 'ابحث بالاسم أو البريد',
    roleFilterAriaLabel: 'تصفية الدور',
    viewModeLabel: 'العرض',
    dateRangePresetsLabel: 'إعدادات نطاق التاريخ المسبقة',
    clearDateRange: 'مسح نطاق التاريخ',
    dateQuickChipsLabel: 'تصفية التاريخ السريعة',
    filterByDateLabel: 'تصفية حسب التاريخ',
    callCustomer: 'اتصل بالعميل',
    whatsappContact: 'التواصل عبر واتساب',
    changeStatusTo: 'تغيير الحالة إلى',
    reservationTime: 'وقت الحجز',
    dismissError: 'إغلاق الخطأ',
    searchRecipesAria: 'ابحث في الوصفات',
    exportCsvAria: 'تصدير كـ CSV',
    addIngredientAria: 'إضافة مكون جديد',
    recipeStatRegionAria: 'ملخص إحصائيات الوصفة',
    shiftPrevWeekAria: 'الأسبوع السابق',
    shiftNextWeekAria: 'الأسبوع التالي',
    shiftsBordroBannerLinkAria: 'الانتقال إلى صفحة الموارد البشرية',
    shiftStatusOnLeaveSr: 'في إجازة',
    shiftSearchStaffAria: 'البحث عن موظف',
    auditDatePresetGroup: 'إعداد التاريخ المسبق',
    a11yCloseError: 'إغلاق الخطأ',
    a11yDatePresetGroup: 'إعدادات التاريخ المسبقة',
    trashTabsLabel: 'علامات تبويب سلة المهملات',
    flagSearchAria: 'البحث في علامات الميزات',
    flagClearDateAria: 'مسح تصفية التاريخ',
    taxGroupClearDates: 'مسح التواريخ',
    taxGroupFormHeading: 'نموذج مجموعة الضرائب',
    gdprDownloadPackageAria: 'تنزيل حزمة بيانات GDPR',
    gdprFiltersAria: 'مرشحات الطلبات',
    webhookDeliverySuccess: 'ناجح',
    webhookDeliveryFailed: 'فشل',
    a11yRefreshJobs: 'تحديث قائمة الطباعة',
    whiteLabelSearchAria: 'البحث عن التكوين',
    whiteLabelPreviewAria: 'معاينة العلامة',
    whiteLabelPrimaryColorPicker: 'منتقي اللون الأساسي',
    whiteLabelSecondaryColorPicker: 'منتقي اللون الثانوي',
    whiteLabelTextColorPicker: 'منتقي لون النص',
    whiteLabelBgColorPicker: 'منتقي لون الخلفية',
    wsPeriodGroupLabel: 'اختيار الفترة',
    wsSortGroupLabel: 'الترتيب',
    wsDatePresetGroupLabel: 'الفترات الزمنية الجاهزة',
    wsClearDateLabel: 'مسح التاريخ',
    wsStatRegionLabel: 'ملخص الأداء',
    deliverySearchPlaceholder: 'ابحث عن طلب/عميل...',
    settingsTaxOfficePlaceholder: 'مثال: بشكتاش',
    userHrLinkTitle: 'الانتقال إلى إدارة الموظفين',
    platformMgmtNoResults: 'لم يتم العثور على نتائج',
    platformMgmtNoResultsDesc: 'جرب كلمة بحث مختلفة.',
    platformMgmtEmpty: 'لم يتم تكوين أي منصة بعد',
    platformMgmtEmptyDesc: 'اربط منصات مثل Yemeksepeti/Trendyol/Getir/Migros لإدارة الطلبات عبر الإنترنت من هنا.',
    whiteLabelSearchPlaceholder: 'بحث الإعدادات...',
    whiteLabelNoResults: 'لا توجد نتائج',
    whiteLabelNoResultsDesc: 'عدّل معايير البحث.',
    pricingBillingCycleLabel: 'دورة الفوترة',
    pricingMostPopularBadgeLabel: 'شارة الخطة الأكثر شيوعاً',
    msCurrentSubscriptionRegion: 'الاشتراك الحالي',
    hrPayslipWorkingDays: 'أيام العمل',
    hrPayslipMonthlyGross: 'الأجر الإجمالي الشهري',
    hrGarnishmentDeduction: 'خصم الحجز',
    hrEmployerCost: 'تكلفة صاحب العمل',
    hrEmployeeSignature: 'توقيع الموظف',
    hrYearsOfService: 'سنوات الخدمة',
    hrSeverancePay: 'مكافأة نهاية الخدمة',
    hrNoticePay: 'بدل الإشعار',
    hrNoticePeriod: 'فترة الإشعار',
    hrDailyGross: 'الإجمالي اليومي',
    hrTotalGross: 'الإجمالي الكلي',
    hrTotalNet: 'الصافي الكلي',
    cdCustomerInfo: 'معلومات العميل',
    cdJoinDate: 'تاريخ الانضمام',
    cdLoyaltyPoints: 'نقاط الولاء',
    cdCurrentAccount: 'الحساب الجاري',
    customersCampaignNameLabel: 'اسم الحملة',
    customersTargetSegment: 'الشريحة المستهدفة',
    customersAllCustomers: 'جميع العملاء',
    customersEmailSubjectLabel: 'موضوع البريد',
    customersMessageBody: 'نص الرسالة',
    posEditProductTitle: 'تعديل المنتج',
    promoQRHint: 'يمكن للعميل المسح بكاميرا الهاتف',
    navMainMenu: 'القائمة الرئيسية',
    reportsRevenueDelta: 'تغيّر الإيرادات',
    usersLoginBannerPart1: '💡 تدير هذه الصفحة ',
    usersLoginBannerStrong: 'حسابات الدخول',
    usersLoginBannerPart2: '. لكشوف الرواتب/الإجازات/المستندات اذهب إلى ',
    usersLoginBannerLink: 'إدارة الموظفين',
    usersLoginBannerPart3: '.',
    poStatsRegion: 'ملخص الطلبات',
    datePresetGroup: 'إعدادات التاريخ',
    cdStatTotalOrders: 'إجمالي الطلبات',
    cdStatTotalSpent: 'إجمالي الإنفاق',
    cdStatAvgOrder: 'متوسط الطلب',
    cdStatLastOrder: 'آخر طلب',
    a11yUnreadNotifications: 'إشعارات غير مقروءة',
    sidebarLockedFeatureTitle: 'هذه الميزة غير مضمنة في خطتك',
    saSidebarToggle: 'فتح قائمة المشرف العام',
    saSidebarNavLabel: 'قائمة المشرف العام',
    saSidebarClose: 'إغلاق القائمة',
    closeMenu: 'أغلق القائمة',
    chainAdminNavLabel: 'قائمة مسؤول السلسلة',
    settingsSegPreviewAria: 'معاينة توزيع الشرائح الحالي',
    settingsSegPreviewPeople: 'شخص',
    segmentLoyal: 'وفي',
    segmentInactive: 'غير نشط',
    segmentLost: 'مفقود',
    lockScreenDigit: 'رقم',
    lockScreenBackspace: 'مسح',
    shortcutDashboard: 'لوحة التحكم',
    deliveryPlatformBreakdown: 'توزيع المنصات',
    deliveryPlatformOther: 'أخرى',
    deliveryPlatformOrdersShort: 'طلب',
    a11yDeliveryPlatformBreakdown: 'توزيع المنصات',
    stockCategoryBreakdown: 'توزيع المخزون حسب الفئة',
    stockCategoryOther: 'أخرى',
    customersExportExcel: '📊 تصدير Excel',
    reportsYearlyMonthlyShow: 'عرض التفاصيل الشهرية (١٢ شهر × سنتان)',
    reportsMonthShortList: 'ينا,فبر,مار,أبر,ماي,يون,يول,أغس,سبت,أكت,نوف,ديس',
    sortByLabel: 'ترتيب:',
    sortByDate: 'التاريخ',
    sortByDiscount: 'الخصم',
    sortByUsage: 'الاستخدام',
    voucherSortDate: 'التاريخ',
    voucherSortAmount: 'المبلغ',
    voucherSortRemaining: 'المتبقي',
    voucherSortExpires: 'تاريخ الانتهاء',
    supSortProductCount: 'المنتجات',
    supSortCreatedAt: 'تاريخ الإضافة',
    supSortAria: 'ترتيب',
    category: 'الفئة',
    stockSortByAria: 'فرز حسب',
    reportsExportAll: 'تنزيل الكل',
    a11yExportAllLabel: 'تنزيل جميع علامات التقارير بصيغة CSV',
    customersBulkSelectedLabel: 'تم اختيار {n} عميل',
    customersBulkDelete: '🗑️ حذف جماعي',
    customersBulkExport: '📊 تنزيل CSV المحدد',
    customersBulkClear: '❌ مسح التحديد',
    customersBulkDeleteConfirm: 'سيتم حذف {n} عميل. هل تريد المتابعة؟',
    customersBulkSelectAll: 'تحديد الكل',
    customersBulkSelectRow: 'تحديد {name}',
    bulkSelectOrder: 'تحديد الطلب',
    bulkSelectAll: 'تحديد الكل',
    bulkActionBar: 'إجراء جماعي',
    bulkSelected: 'تم تحديد {count} طلب',
    bulkAccept: 'قبول',
    bulkPreparing: 'قيد التحضير',
    bulkReady: 'في الطريق',
    bulkDelivered: 'تم التسليم',
    bulkCancel: 'إلغاء',
    bulkClear: 'مسح التحديد',
    bulkConfirm: 'سيتم تحديث {count} طلب. متابعة؟',
    bulkSuccess: 'تم تحديث {count} طلب.',
    bulkSkipped: 'تم تخطيها',
    bulkNoEligible: 'لا توجد طلبات مؤهلة في التحديد.',
    stockBulkSelectedTpl: 'تم تحديد {n} عنصر',
    stockBulkDelete: 'حذف جماعي',
    stockBulkCategory: 'تصنيف جماعي',
    stockBulkDeleteConfirm: 'سيتم حذف {n} عنصر. هل أنت متأكد؟',
    stockBulkDeleteDone: 'تم حذف {n} عنصر',
    stockBulkCategoryDone: 'تم تحديث {n} عنصر',
    stockBulkCategoryLabel: 'تصنيف جديد',
    selectAll: 'تحديد الكل',
    select: 'تحديد',
    bulkSelectedCount: 'تم تحديد {n} عنصر',
    bulkConfirmAll: 'تأكيد الكل',
    bulkCancelAll: 'إلغاء الكل',
    bulkDelete: 'حذف جماعي',
    bulkSelectRow: 'تحديد',
    bulkDeleteConfirm: 'حذف {n} سجل؟',
    sortByName: 'حسب الاسم',
    sortByCapacity: 'السعة',
    sortByStatus: 'الحالة (الفارغة أولاً)',
    sortByDuration: 'المدة (الأطول أولاً)',
    bulkChangeRole: 'تغيير الدور بالجملة',
    bulkClearSelection: 'مسح التحديد',
    bulkRoleConfirm: 'سيتم تغيير الدور لـ {n} مستخدمين محددين. هل تؤكد؟',
    notifBulkSelected: 'إشعار محدد',
    notifBulkMarkRead: 'تحديد الكل كمقروء',
    notifBulkDismiss: 'إخفاء الكل',
    notifBulkClear: 'مسح التحديد',
    notifBulkSelectAll: 'تحديد الكل',
    notifBulkSelectItem: 'تحديد',
    hrLeavesSelected: 'إجازة محددة',
    hrBulkApprove: 'الموافقة على الكل',
    hrBulkReject: 'رفض الكل',
    hrBulkDelete: 'حذف جماعي',
    hrClearSelection: 'مسح',
    hrSelectAll: 'تحديد الكل',
    hrLeavesBulkDeleteConfirm: 'هل أنت متأكد من الحذف؟',
    hrBulkLeaveActionDone: 'اكتملت العملية الجماعية.',
    menuBulkSelected: 'تم تحديد {n} عنصرًا',
    menuBulkActivate: 'تنشيط',
    menuBulkDeactivate: 'إلغاء التنشيط',
    menuBulkChangeCategory: 'تغيير الفئة بالجملة',
    menuBulkDelete: 'حذف',
    menuBulkClear: 'مسح',
    menuBulkDeleteConfirm: 'سيتم حذف {n} عنصرًا. هل أنت متأكد؟',
    poBulkSelected: 'تم تحديد {n} أمر شراء',
    poBulkReceive: 'استلام الكل',
    poBulkCancel: 'إلغاء الكل',
    poBulkDelete: 'حذف جماعي',
    poBulkClear: 'مسح التحديد',
    poBulkReceiveConfirm: 'استلام الأوامر المحددة؟',
    poBulkCancelConfirm: 'إلغاء الأوامر المحددة؟',
    poBulkDeleteConfirm: 'حذف الأوامر المحددة؟',
    poBulkNoneEligible: 'لا توجد أوامر مؤهلة',
    poBulkSkipped: 'تم تخطي {n} أمر (غير مؤهل)',
    poBulkSelectAll: 'تحديد الكل',
    poBulkSelectRow: 'تحديد',
    poBulkBar: 'إجراء جماعي',
    supBulkSelected: 'تم تحديد {n} موردًا',
    supBulkActivate: 'تفعيل',
    supBulkDeactivate: 'تعطيل',
    supBulkDelete: 'حذف جماعي',
    supBulkClear: 'مسح التحديد',
    supBulkSelectAll: 'تحديد الكل',
    supBulkSelectRow: 'تحديد',
    supBulkDeleteConfirm: 'سيتم حذف {n} موردًا. هل أنت متأكد؟',
    voucherSelectAll: 'تحديد الكل',
    voucherSelectOne: 'تحديد القسيمة',
    voucherSelectedCount: 'تم تحديد {n} قسيمة',
    voucherBulkVoid: 'إيقاف جماعي',
    voucherBulkDelete: 'حذف جماعي',
    voucherClearSelection: 'مسح التحديد',
    voucherBulkNoActive: 'لم يتم تحديد قسائم نشطة',
    voucherBulkVoidConfirm: 'سيتم إيقاف X قسيمة. تأكيد؟',
    voucherBulkDeleteConfirm: 'سيتم حذف X قسيمة. تأكيد؟',
    voucherBulkVoidDone: 'تم إيقاف {n} قسيمة',
    voucherBulkDeleteDone: 'تم حذف {n} قسيمة',
    selectItem: 'تحديد',
    bulkActivate: 'تفعيل',
    bulkDeactivate: 'تعطيل',
    clearSelection: 'مسح التحديد',
    recipesSelectedSuffix: 'وصفات محددة',
    confirmBulkDeleteRecipes: 'حذف الوصفات المحددة؟',
    selectAllAria: 'تحديد الكل',
    selectRowAria: 'تحديد',
    bulkActionsAria: 'إجراءات جماعية',
    refundsSelectedCount: 'تم اختيار {n} مبالغ مستردة',
    refundsBulkCsv: 'تصدير CSV المحدد',
    refundsClearSelection: 'مسح التحديد',
    refundsSelectAll: 'تحديد الكل',
    cmdPaletteTitle: 'لوحة الأوامر',
    cmdPalettePlaceholder: 'ابحث عن أمر...',
    cmdPaletteNoResults: 'لا توجد نتائج',
    cmdPaletteHintNav: '↑↓ للتنقل، Enter للاختيار',
    cmdPaletteHintClose: 'Esc للإغلاق',
    cmdPaletteGroupPages: 'الصفحات',
    cmdPaletteGroupActions: 'الإجراءات',
    cmdPaletteGroupTheme: 'السمة',
    cmdPaletteGroupLanguage: 'اللغة',
    cmdPaletteGoDashboard: 'لوحة التحكم',
    cmdPaletteGoTables: 'الطاولات',
    cmdPaletteGoOrders: 'الطلبات',
    cmdPaletteGoKitchen: 'المطبخ',
    cmdPaletteGoPOS: 'نقاط البيع',
    cmdPaletteGoCustomers: 'العملاء',
    cmdPaletteGoMenu: 'القائمة',
    cmdPaletteGoStock: 'المخزون',
    cmdPaletteGoReports: 'التقارير',
    cmdPaletteGoSettings: 'الإعدادات',
    cmdPaletteNewOrder: 'طلب جديد',
    cmdPaletteNewCustomer: 'عميل جديد',
    cmdPaletteNewStaff: 'موظف جديد',
    cmdPaletteLogout: 'تسجيل الخروج',
    cmdPaletteThemeLight: 'سمة فاتحة',
    cmdPaletteThemeDark: 'سمة داكنة',
    cmdPaletteLangTR: 'التركية',
    cmdPaletteLangEN: 'الإنجليزية',
    cmdPaletteLangAR: 'العربية',
    shortcutCommandPalette: 'لوحة الأوامر',
    settingsBackupTitle: '💾 نسخ احتياطي تلقائي',
    settingsBackupDesc: 'جدولة النسخ الاحتياطي لقاعدة البيانات.',
    settingsBackupEnabled: 'النسخ الاحتياطي التلقائي مفعل',
    settingsBackupInterval: 'فاصل النسخ الاحتياطي',
    settingsBackupManual: 'يدوي',
    settingsBackupDaily: 'يومي',
    settingsBackupWeekly: 'أسبوعي',
    settingsBackupMonthly: 'شهري',
    settingsBackupTime: 'الوقت',
    settingsBackupLast: 'آخر نسخة',
    settingsBackupRunNow: '💾 نسخ احتياطي الآن',
    settingsBackupRunning: 'جارٍ النسخ…',
    settingsBackupDone: 'تم النسخ الاحتياطي',
    settingsBackupAria: 'تبديل إعدادات النسخ الاحتياطي',
    refreshLabel: 'تحديث',
    refreshTooltip: 'تحديث تلقائي',
    refreshManual: 'يدوي',
    refresh30s: '30 ثانية',
    refresh1m: 'دقيقة واحدة',
    refresh5m: '5 دقائق',
    hrTotalEntitlement: 'إجمالي الاستحقاق',
    hrTotalUsed: 'المستخدم',
    hrTotalRemaining: 'المتبقي',
    hrPerEmployeeUsage: 'الاستخدام لكل موظف',
    cdActivityTitle: 'نشاط 30 يومًا',
    cdActivitySummary: 'آخر 30 يومًا: {orders} طلب، {spent} إنفاق، متوسط {avg}/يوم',
    cdActivityOrders: 'طلب',
    posFavorites: 'المفضلة',
    posFavoritesEmpty: 'لا توجد مفضلات بعد. انقر ★ على المنتج.',
    posFavoritesShowAll: 'عرض الكل',
    posFavorite: 'أضف إلى المفضلة',
    posUnfavorite: 'إزالة من المفضلة',
    stockScanBarcode: 'مسح الباركود',
    stockBarcode: 'الباركود',
    stockBarcodeInput: 'الباركود (تلقائي أو يدوي)',
    stockBarcodePlaceholder: 'استخدم الماسح أو اكتب + Enter',
    stockBarcodeNotFound: 'لم يتطابق الباركود: {code}',
    stockBarcodeCreateNew: 'إنشاء مكون جديد',
    stockBarcodeQuickAdd: '+ إضافة مخزون',
    stockBarcodeWaiting: 'في انتظار المسح...',
    stockBarcodeScanCount: 'المسح: {n}',
    stockBarcodeAdded: '✓ {name} +{d} {unit}',
    stockBarcodeReason: 'مسح الباركود',
    savedFiltersLabel: '⭐ الفلاتر المحفوظة',
    savedFiltersEmpty: 'لا توجد فلاتر محفوظة',
    savedFiltersSaveBtn: 'حفظ الفلتر',
    savedFiltersPromptName: 'اسم الفلتر:',
    savedFiltersDelete: 'حذف',
    hrPayrollTimeline12m: 'الجدول الزمني للرواتب لـ 12 شهرًا',
    hrPayrollTimeline12mTotal: 'إجمالي 12 شهرًا',
    hrPayrollTimeline12mAvg: 'متوسط',
    hrPayrollTimeline12mPerMonth: 'شهر',
    customersFindDuplicates: '🔍 العثور على التكرارات',
    customersDupTitle: 'العملاء المكررون',
    customersDupSubtitle: 'تم العثور على {n} مجموعة محتملة',
    customersDupEmpty: 'لم يتم العثور على تكرارات.',
    customersDupGroupLabel: 'مجموعة {i} · {n} عميل',
    customersDupMerge: 'دمج',
    customersDupPickFields: 'أي حقل تحتفظ به؟',
    customersDupPrimary: 'السجل الرئيسي:',
    customersDupConfirmMerge: 'تأكيد ودمج',
    customersDupMergeSuccess: 'تم دمج {n} عميل.',
    customersDupMergeFailed: 'فشل الدمج.',
    menuCatReorderHint: 'اسحب لإعادة ترتيب الفئات',
    categoryChipDragHint: '{name} — اسحب لإعادة الترتيب',
    dragToReorder: 'اسحب لإعادة الترتيب',
    dashRecentActivity: 'النشاط الأخير',
    feedSystem: 'النظام',
    feedOrderCreated: 'طلب',
    whiteLabelActiveTheme: 'السمة النشطة',
    whiteLabelLogoStatus: 'حالة الشعار',
    whiteLabelBrandName: 'اسم العلامة',
    whiteLabelThemeDefault: 'افتراضي',
    whiteLabelThemeCustom: 'مخصص',
    whiteLabelThemeNone: 'غير مُعد',
    whiteLabelLogoLoaded: 'تم التحميل',
    whiteLabelLogoMissing: 'مفقود',
    whiteLabelBrandUnnamed: 'بدون اسم',
    whiteLabelPreviewRefreshed: 'تم تحديث المعاينة',
    gdprStatApproved: 'موافق عليه',
    gdprStatExpired: 'منتهي الصلاحية',
    chainReportsStatBranchCount: 'إجمالي الفروع',
    chainReportsStatTotalOrders: 'إجمالي الطلبات',
    chainReportsStatTotalRevenue: 'إجمالي الإيرادات',
    chainReportsStatActiveBranches: 'الفروع النشطة',
    chainReportsDatePresetGroup: 'الإعدادات المسبقة للتاريخ',
    superadminRestaurantsStatTotal: 'إجمالي المطاعم',
    superadminRestaurantsStatActive: 'نشط',
    superadminRestaurantsStatPassive: 'غير نشط',
    superadminRestaurantsStatNewThisMonth: 'الجدد هذا الشهر',
    saasSubStatTotal: 'إجمالي الاشتراكات',
    saasSubStatActive: 'نشط',
    saasSubStatTrial: 'تجريبي',
    saasSubStatTroubled: 'ملغى/معلق',
    navGroupOperations: 'العمليات',
    navGroupCommerce: 'التجارة والمالية',
    navGroupStaff: 'الموظفون',
    navGroupPosAdmin: 'إدارة نقطة البيع',
    nav_posProducts: 'إدارة المنتجات',
    nav_posReports: 'التقارير',
    nav_posReceiptSettings: 'إعدادات الإيصال',
    // ── PosProducts ──
    posProductsLoadError: 'فشل تحميل المنتجات',
    posProductsBulkDeleteConfirm: 'سيتم حذف {n} منتج. هل أنت متأكد؟',
    posProductsBulkDeleteDone: 'تم حذف {n} منتج',
    posProductsNameRequired: 'اسم المنتج مطلوب',
    posProductsPriceInvalid: 'أدخل سعراً صحيحاً',
    posProductsUpdated: 'تم تحديث المنتج',
    posProductsCreated: 'تمت إضافة المنتج',
    posProductsDeleteConfirm: 'سيتم حذف "{name}". هل أنت متأكد؟',
    posProductsDeleted: 'تم حذف المنتج',
    posProductsImportNoSelection: 'اختر منتجاً أولاً',
    posProductsImportResult: 'تم استيراد {n} منتج',
    posProductsImportSkipped: 'تم تخطي {n}',
    posProductsUnlimited: 'غير محدود',
    posProductsLowStockBadge: 'مخزون منخفض',
    posProductsTitle: 'نقطة البيع — إدارة المنتجات',
    posProductsSubtitle: 'إدارة منتجات مبيعات نقطة البيع',
    posProductsAdd: 'منتج جديد',
    posProductsImportFromMenu: 'استيراد من القائمة',
    posProductsExportExcel: 'تنزيل Excel',
    posProductsImportExcel: 'رفع Excel',
    posProductsStatTotal: 'إجمالي المنتجات',
    posProductsStatActive: 'منتجات نشطة',
    posProductsStatInStock: 'متوفر بالمخزون',
    posProductsStatLowStock: 'مخزون منخفض',
    posProductsSearchPlaceholder: 'ابحث بالاسم أو الباركود...',
    posProductsCategoryFilter: 'تصفية الفئة',
    posProductsAllCategories: 'كل الفئات',
    posProductsNoCategory: '— بدون فئة —',
    posProductsActiveFilterAria: 'تصفية نشط/غير نشط',
    posProductsActiveFilterAll: 'الكل',
    posProductsActiveFilterActive: 'ظاهر في نقطة البيع',
    posProductsActiveFilterInactive: 'غير نشط',
    posProductsActiveHint: 'تظهر المنتجات "المرئية في نقطة البيع" فقط على شاشة /pos.',
    posProductsSortAria: 'الترتيب',
    posProductsColName: 'الاسم',
    posProductsColPrice: 'السعر',
    posProductsColStock: 'المخزون',
    posProductsBulkSelected: 'تم تحديد {n} منتج',
    posProductsBulkDelete: 'حذف جماعي',
    posProductsEmptyTitle: 'لا توجد منتجات بعد',
    posProductsColImage: 'الصورة',
    posProductsColBarcode: 'الباركود',
    posProductsColCategory: 'الفئة',
    posProductsColTax: 'الضريبة %',
    posProductsColMenuLink: 'مرتبط بالقائمة',
    posProductsColActive: 'نشط',
    posProductsColActions: 'إجراءات',
    posProductsMenuLinkedBadge: 'مرتبط بالقائمة',
    posProductsToggleDeactivate: 'إلغاء التفعيل',
    posProductsToggleActivate: 'تفعيل',
    posProductsEditAria: 'تعديل المنتج "{name}"',
    posProductsDeleteAria: 'حذف المنتج "{name}"',
    posProductsModalEditTitle: 'تعديل المنتج',
    posProductsModalAddTitle: 'منتج جديد',
    posProductsStockHint: 'فارغ = غير محدود',
    posProductsColImageUrl: 'رابط الصورة',
    posProductsMenuItemId: 'معرّف منتج القائمة',
    posProductsImportFromMenuTitle: 'استيراد من القائمة إلى نقطة البيع',
    posProductsMenuEmptyTitle: 'لا توجد منتجات في القائمة',
    posProductsMenuEmptyDesc: 'أضف منتجات إلى القائمة أولاً.',
    posProductsMenuAllImportedTitle: 'جميع منتجات القائمة موجودة بالفعل في نقطة البيع',
    posProductsMenuAllImportedDesc: 'تم استيراد جميع منتجات القائمة إلى نقطة البيع.',
    posProductsMenuSelectedCount: '{n} / {total} محدد',
    posProductsMenuAlreadyAddedBadge: 'مضاف',
    posProductsImportConfirm: 'استيراد',
    // ── PosReports ──
    posReportsExportExcel: '📊 تنزيل CSV',
    posReportsCloseSession: 'إغلاق الصندوق وتقرير Z',
    posReportsClosingCashConfirm: 'سيتم إنشاء تقرير Z بعد إغلاق الصندوق. هل تريد المتابعة؟',
    posReportsClosingCashLabel: 'النقدية عند الإغلاق (₺)',
    product: 'المنتج',
    qty: 'الكمية',
    posReportsNoItems: 'لا توجد تفاصيل منتجات لهذه المبيعة.',
    paymentMethod: 'طريقة الدفع',
    posReportsPrintReceipt: '🖨️ إعادة طباعة الإيصال',
    posReportsTabInstant: 'تقرير فوري',
    posReportsTabSales: 'سجل المبيعات',
    posReportsTabZ: 'تقارير Z',
    posReportsSessionLoadFailed: 'تعذّر تحميل معلومات الجلسة.',
    posReportsSalesLoadFailed: 'تعذّر تحميل المبيعات.',
    posReportsColMetric: 'المقياس',
    posReportsSaleDetailFailed: 'تعذّر تحميل تفاصيل المبيعة.',
    posReportsColDate: 'التاريخ',
    posReportsColReceipt: 'رقم الإيصال',
    posReportsColCashier: 'الكاشير',
    posReportsColItems: 'المنتجات',
    posReportsColPayment: 'الدفع',
    posReportsColTotal: 'الإجمالي',
    posReportsTitle: 'نقطة البيع — التقارير',
    posReportsSubtitle: 'تقارير المبيعات، تقارير X/Z، تفاصيل يومية.',
    posReportsNoSession: 'لا توجد جلسة نقطة بيع مفتوحة',
    posReportsNoSessionDesc: 'يجب فتح الصندوق أولاً لإنشاء تقارير X/Z.',
    posReportsGoToPos: 'الذهاب إلى نقطة البيع',
    posReportsActiveSession: 'جلسة مفتوحة',
    posReportsXTitle: 'تقرير X (وسط اليوم)',
    posReportsXDesc: 'ملخص مبيعات لحظي للجلسة المفتوحة. لا يتم إغلاق الجلسة.',
    posReportsGenerateX: '⚡ إنشاء الآن',
    posReportsZTitle: 'تقرير Z (نهاية اليوم)',
    posReportsZDesc: 'يتم إغلاق الصندوق وإنشاء تقرير Z. لا يمكن التراجع عن هذه العملية.',
    posReportsStatSales: 'المبيعات',
    posReportsStatRevenue: 'الإيرادات',
    posReportsStatAvg: 'متوسط السلة',
    posReportsStatToday: 'اليوم',
    posReportsDatePresets: 'إعدادات التاريخ المسبقة',
    from: 'من',
    to: 'إلى',
    posPaySplit: 'مختلط',
    posReportsSearchPlaceholder: 'رقم الإيصال أو العميل...',
    posReportsResultCount: 'النتائج',
    posReportsNoSales: 'لم يتم العثور على مبيعات',
    posReportsNoSalesDesc: 'لا توجد مبيعات مسجلة في الفترة المحددة. غيّر النطاق الزمني أو المرشحات.',
    posReportsViewDetail: 'عرض التفاصيل',
    posReportsZComingSoon: 'قائمة تقارير Z — قريباً',
    posReportsZComingSoonDesc: 'يتم إنشاء تقارير Z تلقائياً عند إغلاق كل جلسة. للحصول على قائمة تقارير Z السابقة، تواصل مع المسؤول.',
    posReportsViewSales: 'سجل المبيعات',
    // ── PosReceiptSettings ──
    posReceiptNoPrinterSelected: 'اختر طابعة افتراضية أولاً.',
    posReceiptTestPrintSent: 'تم إرسال إيصال الاختبار إلى الطابعة.',
    posReceiptTestPrintFailed: 'فشل إرسال إيصال الاختبار.',
    posReceiptSettingsTitle: 'نقطة البيع — إعدادات الإيصال',
    posReceiptSettingsSubtitle: 'إدارة المعلومات الظاهرة على الإيصالات وإعدادات الطابعة.',
    posReceiptSectionInfo: 'معلومات المطعم',
    posReceiptInfoHint: 'تظهر هذه المعلومات تلقائياً في رأس الإيصال.',
    posReceiptTaxNumber: 'الرقم الضريبي',
    posReceiptLogoUrl: 'رابط الشعار',
    posReceiptComingSoon: 'قريباً',
    posReceiptLogoHint: 'ستتم إضافة دعم الشعار للطابعات الحرارية عبر ESC/POS bitmap.',
    posReceiptSectionCustomize: 'تخصيص الإيصال',
    posReceiptHeaderText: 'نص رأس الإيصال',
    posReceiptHeaderPh: 'مرحباً بك!',
    posReceiptFooterText: 'نص ذيل الإيصال',
    posReceiptFooterPh: 'نراك مجدداً!',
    posReceiptPaperWidth: 'عرض الورق',
    posReceiptPaperWidthHint: 'للحصول على عرض مخصص لكل طابعة، قم بضبطه من إدارة الطابعات.',
    posReceiptTaxDisplay: 'عرض الضريبة',
    posReceiptAutoPrint: 'الطباعة التلقائية',
    posReceiptAutoPrintHint: 'طباعة الإيصال تلقائياً من الطابعة الافتراضية في كل عملية بيع.',
    posReceiptSectionPrinter: 'إعدادات الطابعة',
    posReceiptDefaultPrinter: 'طابعة الإيصال الافتراضية',
    posReceiptNoPrinter: '— غير محدد —',
    posReceiptNoPrintersConfigured: 'لا توجد طابعات مهيأة بعد.',
    posReceiptManagePrinters: 'إدارة قائمة الطابعات',
    posReceiptTestPrint: 'طباعة إيصال اختبار',
    posReceiptPreview: 'معاينة',
    // ── تنقل إدارة نقطة البيع (Tur 290 polish) ──
    posAdminNavLabel: 'تنقل إدارة نقطة البيع',
    posAdminToolsLabel: 'الإدارة',
    posAdminProducts: 'إدارة المنتجات',
    posAdminReports: 'التقارير',
    posAdminReceipt: 'إعدادات الإيصال',
    posAdminBackToTerminal: '← محطة POS',
    posProductsActiveHintCreate: 'تتم إضافة المنتجات الجديدة كنشطة تلقائياً؛ يمكنك إخفاؤها لاحقاً من شاشة التعديل.',
    posProductsActiveHintEdit: 'عندما يكون نشطاً، يظهر المنتج في محطة /pos ويمكن بيعه.',
    posReportsZListTitle: 'سجل تقارير Z',
    posReportsZListInfo: 'يتم توليد تقرير Z تلقائياً عند إغلاق صندوق النقد في نهاية اليوم. قائمة تقارير Z السابقة قيد التطوير.',
    posReportsZGoInstant: 'الذهاب إلى التقرير الفوري',
    posReportsZGoSales: 'عرض سجل المبيعات',
    pageOptPosLabel: 'محطة POS',
    pageOptPosDesc: 'محطة نقطة البيع',
    settingsBackupComingSoon: 'واجهة النسخ اليدوي قريبًا',
    settingsBackupComingSoonShort: 'قريبًا',
    settingsTaxSgkAria: 'تبديل تفاصيل الضرائب والضمان',
    setTaxSgkSubtitle: 'الحقول المطلوبة للإقرارات الضريبية الرسمية.',
    settingsTaxNumberPlaceholder: 'رقم ضريبي مكون من 10 أو 11 رقمًا',
    settingsSgkPlaceholder: 'رقم تسجيل SGK',

    // ── مفاتيح الجولة 291 (العملاء/الإشعارات/إيصال POS/POS/تفاصيل العميل/الحجوزات) ──
    // عام
    amount: 'المبلغ',
    savedSuccess: 'تم الحفظ',
    table: 'طاولة',
    tags: 'العلامات',
    totalSpent: 'إجمالي الإنفاق',
    visitCount: 'الزيارات',
    guestName: 'ضيف',
    loyaltyPoints: 'نقاط',
    reservationDate: 'التاريخ',
    notifications: 'الإشعارات',
    clearDate: 'مسح التاريخ',
    datePresetThisWeek: 'هذا الأسبوع',
    // طرق الدفع
    paymentCash: 'نقد',
    paymentCard: 'بطاقة',
    paymentBank: 'تحويل بنكي',
    paymentOther: 'أخرى',
    // POS
    posCategoriesLabel: 'الفئات',
    posClearSearch: 'مسح البحث',
    posCustomerRemove: 'إزالة العميل',
    posPromoRemove: 'إزالة كود العرض',
    posDeleteHeldOrder: 'حذف الطلب المعلق',
    posSaleNetworkFail: 'خطأ في الاتصال — تم الاحتفاظ بالسلة، حاول مرة أخرى',
    posSessionLoadFailed: 'تعذر تحميل الجلسة — تحقق من اتصالك',
    // إعدادات إيصال POS
    posReceiptRestaurantName: 'اسم المطعم',
    posReceiptAddress: 'العنوان',
    posReceiptPhone: 'الهاتف',
    posReceiptSaveBtn: 'حفظ',
    posReceiptCancelBtn: 'إلغاء',
    posReceiptSectionUpcoming: 'قريبًا — حقول تجريبية',
    posReceiptPreviewCashier: 'الكاشير: أحمد',
    posReceiptPreviewReceiptNo: 'إيصال #12345',
    posReceiptPreviewItem1: 'كفتة',
    posReceiptPreviewItem2: 'أيران',
    posReceiptPreviewItem3: 'جاجيك',
    posReceiptPreviewPhoneLabel: 'هاتف',
    posReceiptPreviewTaxNumLabel: 'الرقم الضريبي',
    posReceiptPreviewSubtotal: 'المجموع الفرعي:',
    posReceiptPreviewVat: 'ضريبة القيمة المضافة (10٪):',
    posReceiptPreviewTotal: 'الإجمالي:',
    posReceiptPreviewVatIncluded: '(شامل ضريبة القيمة المضافة)',
    posReceiptPreviewNoFooter: '(لا تذييل)',
    // الإشعارات
    notifWeeklySummaryTitle: 'ملخص آخر 7 أيام',
    notifTotalLabel: 'الإجمالي',
    notifPeakLabel: 'الذروة',
    notifBadgeRead: 'مقروء',
    notifToday: 'اليوم',
    notifYesterday: 'أمس',
    notifDayBeforeYesterday: 'أول أمس',
    notifDaysAgoTmpl: 'منذ {n} أيام',
    // العملاء — الديون/الدفع
    customersAddDebtTitle: 'إضافة دين',
    customersAddPaymentTitle: 'استلام دفعة',
    customersAmountRequired: 'المبلغ مطلوب (يجب أن يكون أكبر من 0).',
    customersDebtSaved: 'تم إضافة قيد الدين.',
    customersPaymentSaved: 'تم إضافة قيد الدفع.',
    customersDebtDescLabel: 'دين',
    customersDebtDescPlaceholder: 'مثال: فاتورة مارس',
    customersDebtDescPrefix: 'العميل',
    customersPaymentDescPlaceholder: 'مثال: إغلاق الحساب',
    customersManualDebtNote: 'قيد دين يدوي',
    customersManualPaymentNote: 'دفعة يدوية',
    customersAvatarUrlLabel: 'رابط الصورة الشخصية',
    customersCollectionLabel: 'تحصيل',
    customersSaveFailed: 'تعذر الحفظ.',
    // العملاء — الحملات
    customersCampaignTitle: 'إرسال حملة',
    customersCampaignNameRequired: 'الرجاء إدخال اسم الحملة.',
    customersCampaignBodyRequired: 'الرجاء إدخال نص الرسالة.',
    customersCampaignSubjectRequired: 'الرجاء إدخال عنوان البريد الإلكتروني.',
    customersCampaignConfirm: 'سيتم إرسال {channel} إلى {n} مستلمين. هل تؤكد؟',
    customersCampaignSendBtn: 'إرسال للمستلمين',
    customersCampaignSending: 'جاري الإرسال…',
    customersCampaignSendFailed: 'تعذر الإرسال.',
    customersCampaignEmailSentTmpl: 'تم إرسال {sent}/{total} بريد إلكتروني ({failed} فشل).',
    customersCampaignWaCreatedTmpl: 'تم إنشاء {n} روابط واتساب. اضغط على كل عنصر من القائمة للإرسال.',
    customersCampaignWaOpenAll: 'فتح الكل',
    customersCampaignWaReady: '{n} روابط واتساب جاهزة. افتح كلًا منها في علامة تبويب جديدة (اسمح بالنوافذ المنبثقة):',
    customersCampaignWillSend: 'سيتم الإرسال للمستلم',
    customersCampaignNoRecipient: 'لا يوجد مستلمون.',
    customersCampaignTipPrefix: 'تلميح',
    customersCampaignTipBody: 'يتم استبدالها باسم كل عميل.',
    customersCampaignSamplePrefix: 'مثال',
    customersCampaignMissingPrefix: 'عملاء يفتقدون',
    customersCampaignMissingSuffix: '',
    customersCampaignChannelEmail: 'بريد إلكتروني',
    customersCampaignChannelPhone: 'هاتف',
    customersCampaignChannelWhatsapp: 'رابط واتساب',
    // العملاء — الشرائح
    custSegmentActive: '✅ نشط',
    custSegmentLost: '😴 مفقود',
    custSegmentLostRecovery: '😴 مفقود (استرجاع)',
    custSegmentLoyal: '🏆 وفي',
    custSegmentNew: '🆕 جديد',
    custSegmentVip: '⭐ VIP',
    // تفاصيل العميل
    custDetailCustomerNote: 'ملاحظة العميل',
    custDetailGoToCustomers: 'الذهاب إلى صفحة العملاء',
    custDetailLedgerHint: 'افتح نافذة دفتر الأستاذ من صفحة العملاء للحصول على تفاصيل الديون/المدفوعات.',
    custDetailNoNote: 'لم تُضف ملاحظات لهذا العميل بعد. يمكنك تعديلها من صفحة العملاء.',
    custDetailNoTags: 'لم تتم إضافة علامات.',
    custDetailTagsLabel: 'العلامات',
    // ── Tur 292 polish keyleri ──
    actualEnd: 'الخروج الفعلي',
    actualStart: 'الدخول الفعلي',
    cashTxFilterFrom: 'من',
    cashTxFilterTo: 'إلى',
    cashTxType: 'النوع',
    chainBranchesEmptyAction: '+ فرع جديد',
    chainBranchesEmptyDesc: 'أضف فرعك الأول لبدء إدارة السلسلة.',
    chainBranchesNoResults: 'لم يتم العثور على نتائج',
    chainBranchesNoResultsDesc: 'حاول تغيير معايير البحث.',
    chainBranchesSearchPh: 'بحث عن فرع...',
    chainDashEmptyBranches: 'لا توجد فروع بعد',
    chainDashEmptyBranchesDesc: 'بمجرد إضافة فروع إلى السلسلة، ستظهر بيانات النشاط هنا.',
    chainDashStatActiveOrders: 'الطلبات النشطة',
    chainDashStatTodayRevenue: 'إيرادات اليوم',
    chainDashStatTotalBranches: 'إجمالي الفروع',
    chainDashStatTotalStaff: 'إجمالي الموظفين',
    chainDashStatTotalTables: 'إجمالي الطاولات',
    chainMenuEmpty: 'لا توجد منتجات بعد',
    chainMenuEmptyAction: '+ منتج جديد',
    chainMenuEmptyDesc: 'حدد عناصر القائمة المشتركة عبر السلسلة من هنا.',
    chainMenuNoResults: 'لم يتم العثور على نتائج',
    chainMenuNoResultsDesc: 'حاول تغيير معايير البحث.',
    chainMenuSearchPh: 'بحث عن منتج...',
    costPerUnit: 'تكلفة الوحدة',
    customers: 'العملاء',
    default: 'افتراضي',
    endTime: 'النهاية',
    foodCost: 'التكلفة',
    grossTotal: 'الإجمالي',
    hour: 'الساعة',
    hrIbanPlaceholder: 'TR...',
    hrLast7Days: 'آخر 7 أيام',
    hrLastMonth: 'الشهر الماضي',
    hrPdfA5Title: 'تنزيل PDF (A5 أفقي)',
    hrPdfFailed: 'فشل إنشاء PDF.',
    hrPdfReady: 'تم تنزيل PDF.',
    hrPopupBlocked: 'تم حظر النافذة المنبثقة. يُرجى السماح بها للطباعة.',
    hrPrintTitle: 'طباعة (علامة تبويب جديدة)',
    loginForgotPassword: 'نسيت كلمة المرور',
    loginRememberMe: 'تذكرني',
    margin: 'الهامش',
    menuItemName: 'المنتج',
    minStock: 'الحد الأدنى',
    netTotal: 'الصافي',
    orderDate: 'تاريخ الطلب',
    orders: 'الطلبات',
    overtimeMinutes: 'العمل الإضافي (د)',
    platformSearchPlaceholder: 'بحث عن منصة...',
    poSearchPlaceholder: 'بحث برقم الطلب/المورد...',
    posProductsBulkDeleteFailed: 'تعذر حذف {n}',
    posProductsImportFromMenuShort: 'القائمة',
    posProductsStockInvalid: 'أدخل قيمة مخزون صالحة',
    posProductsTaxInvalid: 'أدخل نسبة ضريبة صالحة',
    posPromoVoucherInputPlaceholder: 'كود الترويج / القسيمة',
    posReportsClosingCashInvalid: 'أدخل مبلغ نقد إغلاق صالح.',
    posReportsDateFromAria: 'تاريخ البداية',
    posReportsDateRangeInvalid: 'لا يمكن أن يكون تاريخ البداية بعد تاريخ النهاية.',
    posReportsDateToAria: 'تاريخ النهاية',
    posVoucherCodePlaceholder: 'R-6-20260414-12',
    printerSerialPathPlaceholder: 'COM3 أو /dev/ttyUSB0',
    promoCodeSamplePlaceholder: 'SUMMER20',
    promoQrAria: 'رمز QR',
    promoQrTitle: 'رمز QR',
    qrmenuAdd: '+',
    qrmenuDecrement: 'تقليل بواحد',
    qrmenuIncrement: 'إضافة واحد',
    receivedDate: 'تاريخ الاستلام',
    restaurantDetailEmptyUsers: 'لا يوجد مستخدمون بعد',
    restaurantDetailEmptyUsersDesc: 'لم تتم إضافة سجلات مستخدمي هذا المطعم بعد.',
    rptSegActive30d: 'نشط (آخر 30 يوماً)',
    rptSegAnon: 'مجهول',
    rptSegAvgPerCustomer: 'المتوسط لكل عميل',
    rptSegCustomerWord: 'عميل',
    rptSegEmpty: 'لا يوجد عملاء',
    rptSegLoadFailed: 'فشل تحميل تقرير التقسيم.',
    rptSegLostDesc: 'آخر طلب قبل 90 يوماً',
    rptSegLostHint: 'لم يتسوق منذ 90 يوماً. لإرسال حملة استرجاع، قم بتصفية شريحة المفقودين في صفحة العملاء.',
    rptSegLostLabel: '😴 مفقود',
    rptSegLoyalDesc: '10 طلبات أو أكثر',
    rptSegLoyalLabel: '🏆 وفي',
    rptSegNewDesc: 'مسجل في آخر 30 يوماً',
    rptSegNewLabel: '🆕 جديد',
    rptSegTotalCustomers: 'إجمالي العملاء',
    rptSegTotalLabel: 'الإجمالي',
    rptSegTotalRevenue: 'إجمالي الإيرادات',
    rptSegVipDesc: 'إجمالي الإنفاق ≥ 5.000 ₺ أو موسوم بـ VIP',
    rptSegVipLabel: '⭐ VIP',
    rptTabSegmentation: '🎯 التقسيم',
    searchPlaceholder: 'بحث عن وصفة',
    settingsBackupAutoDesc: 'يتم نسخ قاعدة البيانات احتياطياً تلقائياً كل ليلة الساعة 03:00. للحصول على نسخ احتياطي يدوي، تواصل مع مسؤول النظام.',
    settingsBackupAutoTitle: 'النسخ الاحتياطي التلقائي مفعّل',
    settingsBackupRequestManual: 'طلب نسخ احتياطي يدوي',
    settingsBackupRequestSent: 'تم استلام طلب النسخ الاحتياطي اليدوي. سيتواصل معك مسؤول النظام في أقرب وقت ممكن.',
    shiftsStaffSearchPlaceholder: 'بحث عن موظف...',
    staff: 'الموظفون',
    startTime: 'البداية',
    stockAdjustmentsSearchPlaceholder: 'بحث عن مكوّن/سبب...',
    subStatActive: 'الاشتراك النشط',
    subStatCancelled: 'ملغى',
    subStatMonthlyRevenue: 'إجمالي الإيرادات الشهرية',
    subStatRenewingSoon: 'تجديد قريب',
    subStatRenewingSoonSub: 'خلال 7 أيام',
    subscriptionMonthlyAmount: 'المبلغ الشهري',
    superDashStatActiveSubs: 'الاشتراكات النشطة',
    superDashStatMonthlyMRR: 'الإيرادات الشهرية المتكررة',
    superDashStatTotalRestaurants: 'إجمالي المطاعم',
    superDashStatTotalUsers: 'إجمالي المستخدمين',
    superadminDashEmptyRestaurants: 'لا توجد مطاعم بعد',
    superadminDashEmptyRestaurantsDesc: 'ستظهر المطاعم هنا بعد التسجيل عبر restaflex.com.',
    superadminPlansDescPh: 'وصف الخطة...',
    superadminPlansEmpty: 'لا توجد خطط بعد',
    superadminPlansEmptyAction: '+ خطة جديدة',
    superadminPlansEmptyDesc: 'أنشئ خطة SaaS الأولى لبدء عروض الاشتراك.',
    superadminPlansNamePh: 'مثل Starter، Pro، Enterprise',
    superadminPlansNoResults: 'لم يتم العثور على نتائج',
    superadminPlansNoResultsDesc: 'حاول تغيير معايير البحث.',
    superadminPlansSearchPh: 'بحث عن خطة...',
    superadminRestaurantsCreatedTitle: 'تم إنشاء المطعم',
    superadminRestaurantsEmpty: 'لا توجد مطاعم بعد',
    superadminRestaurantsEmptyDesc: 'ستظهر المطاعم هنا بعد التسجيل عبر restaflex.com.',
    superadminRestaurantsNoResults: 'لم يتم العثور على نتائج',
    superadminRestaurantsNoResultsDesc: 'حاول تغيير معايير البحث.',
    superadminRestaurantsSearchPh: 'بحث عن مطعم...',
    superadminSubsEmpty: 'لا توجد اشتراكات بعد',
    superadminSubsEmptyDesc: 'ستظهر الاشتراكات هنا عند انتقال المطاعم إلى خطة.',
    superadminSubsNoResults: 'لم يتم العثور على نتائج',
    superadminSubsNoResultsDesc: 'حاول تغيير معايير التصفية أو البحث.',
    superadminSubsSearchPh: 'بحث عن مطعم...',
    supplier: 'المورد',
    supplierAddress: 'العنوان',
    supplierContact: 'الشخص المسؤول',
    tag: 'الوسم',
    userRole: 'الدور',
    vouchersQrAria: 'رمز QR',
    vouchersQrCodePlaceholder: 'GV-XXXXXXXX',
    vouchersTitle: 'رمز QR',
    waiterStatsSearchPlaceholder: 'بحث عن نادل...',

    // ── مفاتيح الجولة 293-294 ──
    // عناصر نائبة للسلسلة والفروع
    chainBranchesAdminEmailPh: 'manager@example.com',
    chainBranchesAdminNamePh: 'الاسم الكامل',
    chainBranchesEmailPh: 'branch@example.com',
    chainBranchesPhonePh: '05xx xxx xx xx',
    // مستندات لوحة التحكم وأفضل النوادل
    dashDocExpired: 'منتهية',
    dashDocMore: 'مستندات أخرى…',
    dashTopWaiterTitle: 'موظف اليوم المتميز',
    // واجهة عامة
    deleting: 'جاري الحذف...',
    ok: 'موافق',
    langSwitchTo: 'التبديل إلى اللغة',
    // حد الخطأ و404
    errorBoundaryDesc: 'واجهت هذه الصفحة خطأ غير متوقع. يمكنك إعادة المحاولة أو العودة إلى الصفحة الرئيسية.',
    errorBoundaryGoHome: 'الرئيسية',
    errorBoundaryRefresh: 'تحديث',
    errorBoundaryTitle: 'حدث خطأ ما',
    notFoundDesc: 'الصفحة التي تبحث عنها قد تكون قد أُزيلت أو نُقلت أو لم تكن موجودة أصلاً.',
    notFoundGoBack: '← رجوع',
    notFoundGoHome: '🏠 الرئيسية',
    notFoundTitle: 'الصفحة غير موجودة',
    // بوابة الميزات
    featureGateChoosePlan: 'اختر خطة',
    featureGateInlineUpgrade: 'ترقية الخطة',
    featureGateNoSubDesc: 'يجب اختيار خطة لاستخدام هذه الميزة.',
    featureGateSeeAllPlans: 'عرض كل الخطط',
    featureGateUpgradeDesc: 'هذه الميزة غير مشمولة في خطتك الحالية. قم بترقية خطتك للحصول على المزيد.',
    featureGateUpgradePlan: 'ترقية الخطة',
    // أسماء الميزات
    featureNameAdvancedAnalytics: 'تحليلات متقدمة',
    featureNameKitchenDisplay: 'شاشة المطبخ',
    featureNameQrMenu: 'قائمة QR',
    featureNameRecipeSystem: 'نظام الوصفات',
    featureNameStockManagement: 'إدارة المخزون',
    featureNameWaiterManagement: 'إدارة النوادل',
    // إشعارات الموارد البشرية والتحقق
    hrBankFileDownloaded: 'تم تنزيل ملف التحويل البنكي.',
    hrCsvDownloaded: 'تم تنزيل ملف CSV.',
    hrDocumentAdded: 'تمت إضافة الوثيقة.',
    hrDocumentDeleteConfirm: 'هل أنت متأكد من حذف هذه الوثيقة؟',
    hrDocumentDeleted: 'تم حذف الوثيقة.',
    hrDocumentEmployeeRequired: 'يرجى اختيار موظف.',
    hrDocumentTitleRequired: 'يرجى إدخال عنوان الوثيقة.',
    hrEmployeeAdded: 'تمت إضافة الموظف.',
    hrEmployeeDeleted: 'تم حذف الموظف.',
    hrEmployeeUpdated: 'تم تحديث الموظف.',
    hrImportFormatHintDate: 'صيغة التاريخ:',
    hrImportFormatHintSeparator: 'الفاصل: فاصلة منقوطة (;) أو فاصلة (,). UTF-8.',
    hrImportFormatHintType: 'نوع العمل:',
    hrLeaveApproved: 'تمت الموافقة على الإجازة.',
    hrLeaveCreated: 'تم إنشاء طلب الإجازة.',
    hrLeaveDateRangeRequired: 'يرجى إدخال نطاق التاريخ.',
    hrLeaveDeleted: 'تم حذف الإجازة.',
    hrLeaveEmployeeRequired: 'يرجى اختيار موظف.',
    hrLeaveEndBeforeStart: 'لا يمكن أن يكون تاريخ الانتهاء قبل تاريخ البدء.',
    hrLeaveRejected: 'تم رفض الإجازة.',
    hrMuhtasarPdfDownloaded: 'تم تنزيل PDF ضريبة الاستقطاع.',
    hrPayrollApproved: 'تمت الموافقة على كشف الرواتب.',
    hrPayrollBulkComputed: 'اكتمل الحساب الجماعي.',
    hrPayrollDeclaration: 'أُقر بأنني تسلمت المبلغ المذكور في كشف الرواتب كاملاً.',
    hrPayrollEmployeeRequired: 'يرجى اختيار موظف.',
    hrPayrollEmpty: 'لا توجد كشوف رواتب.',
    hrPayrollMarkedPaid: 'تم تعليمها كمدفوعة.',
    hrPayrollNetTargetRequired: 'يرجى إدخال الهدف الصافي.',
    hrPayrollSaved: 'تم حفظ كشف الرواتب.',
    hrSalaryRequired: 'يرجى إدخال الراتب الإجمالي.',
    hrSgkPdfDownloaded: 'تم تنزيل PDF إقرار SGK.',
    hrTcInvalid: 'يجب أن يتكون رقم الهوية الوطنية من 11 رقماً.',
    // حالات الطلب
    orderStatusPreparing: 'قيد التحضير',
    orderStatusReady: 'جاهز',
    orderStatusServed: 'تم التقديم',
    // الاتجاه السنوي / صافي الربح
    reportsDeltaDecrease: 'انخفاض',
    reportsDeltaIncrease: 'زيادة',
    reportsNetProfitDelta: 'تغير صافي الربح',
    reportsYearlyEmptyDesc: 'التفصيل الشهري — سيُفعّل تلقائياً عند جاهزية نقطة النهاية الخلفية.',
    reportsYearlyEmptyTitle: 'لا توجد بيانات لرسم الاتجاه السنوي.',
    reportsYearlyPrevYear: 'السنة الماضية',
    reportsYearlyRevenueLabel: 'الإيرادات (إجمالي الدخل)',
    reportsYearlyThisYear: 'هذه السنة',
    // تفاصيل المطعم (المشرف الأعلى)
    restaurantDetailColEmail: 'البريد الإلكتروني',
    restaurantDetailColName: 'الاسم',
    restaurantDetailColRegistered: 'تاريخ التسجيل',
    restaurantDetailColRole: 'الدور',
    restaurantDetailOccupiedTables: 'الطاولات المشغولة',
    restaurantDetailTableCount: 'عدد الطاولات',
    restaurantDetailTodayOrderStatus: 'حالة طلبات اليوم',
    restaurantDetailTotalTables: 'إجمالي الطاولات',
    restaurantDetailUserCount: 'عدد المستخدمين',
    restaurantDetailUsers: 'المستخدمون',
    // الشريط الجانبي والاشتراك
    sidebarChainImpersonationBanner: 'تحت إدارة السلسلة',
    sidebarChainReturnToPanel: 'العودة إلى لوحة السلسلة',
    subStatusTrial: 'تجريبي',
    // لوحة المشرف الأعلى
    superadminDashActiveRest: 'مطعم نشط',
    superadminDashActiveSubLbl: 'اشتراك نشط',
    superadminDashAddRestaurant: 'إضافة مطعم',
    superadminDashColPlan: 'الخطة',
    superadminDashColRestaurant: 'المطعم',
    superadminDashColStatus: 'الحالة',
    superadminDashColTodayOrders: 'طلبات اليوم',
    superadminDashColTodayRevenue: 'إيرادات اليوم',
    superadminDashDetail: 'تفاصيل',
    superadminDashMrr: 'MRR',
    superadminDashMrrSub: 'الإيراد الشهري المتكرر',
    superadminDashPayingRest: 'مطعم مدفوع',
    superadminDashRestaurantStats: 'إحصائيات المطاعم',
    superadminDashRestaurants: 'المطاعم',
    superadminDashSaasMetrics: 'مقاييس SaaS',
    superadminDashThisMonthRev: 'إيرادات هذا الشهر',
    superadminDashThisMonthRevSub: 'إجمالي تحصيلات الشهر',
    superadminDashTodayTotalRev: 'إجمالي إيرادات اليوم',
    superadminDashTotalRest: 'إجمالي المطاعم',
    superadminDashTrialLbl: 'تجريبي',
    superadminDashTrialUserSub: 'مستخدم تجريبي مجاني',
    superadminLoadFailed: 'فشل تحميل البيانات.',
    // خطط المشرف الأعلى
    superadminPlansColActions: 'الإجراءات',
    superadminPlansColMonthly: 'شهري',
    superadminPlansColPlan: 'الخطة',
    superadminPlansColStatus: 'الحالة',
    superadminPlansColSubs: 'الاشتراكات',
    superadminPlansColTables: 'الطاولات',
    superadminPlansColUsers: 'المستخدمون',
    superadminPlansColYearly: 'سنوي',
    superadminPlansCreateTitle: 'إنشاء خطة جديدة',
    superadminPlansEditTitle: 'تعديل الخطة',
    superadminPlansFeatures: 'ميزة',
    superadminPlansFieldActive: 'الخطة نشطة',
    superadminPlansFieldDesc: 'الوصف',
    superadminPlansFieldFeatures: 'الميزات',
    superadminPlansFieldMaxTables: 'أقصى عدد للطاولات',
    superadminPlansFieldMaxUsers: 'أقصى عدد للمستخدمين',
    superadminPlansFieldMonthly: 'السعر الشهري (₺)',
    superadminPlansFieldName: 'اسم الخطة',
    superadminPlansFieldYearly: 'السعر السنوي (₺)',
    superadminPlansLoadFailed: 'فشل تحميل الخطط.',
    superadminPlansNewPlan: 'خطة جديدة',
    superadminPlansStatMonthlyTotal: 'إجمالي السعر الشهري',
    superadminPlansStatTotal: 'إجمالي الخطط',
    superadminPlansSubtitle: 'إدارة خطط الاشتراك',
    superadminPlansTitle: 'خطط SaaS',
    // مطاعم المشرف الأعلى
    superadminRestaurantDeleteConfirm: 'هل أنت متأكد من حذف هذا المطعم وجميع بياناته؟',
    superadminRestaurantNameSlugRequired: 'الاسم والـ slug مطلوبان.',
    superadminRestaurantsActivate: 'تفعيل',
    superadminRestaurantsAdd: 'إضافة مطعم',
    superadminRestaurantsAddTitle: 'إضافة مطعم جديد',
    superadminRestaurantsCredsEmail: 'البريد الإلكتروني:',
    superadminRestaurantsCredsIntro: 'تم إنشاء المطعم بنجاح. بيانات تسجيل دخول المسؤول:',
    superadminRestaurantsCredsPassword: 'كلمة المرور:',
    superadminRestaurantsCredsWarn: 'لا تنسَ تسليم هذه البيانات لمسؤول المطعم.',
    superadminRestaurantsDeactivate: 'تعطيل',
    superadminRestaurantsDetail: 'تفاصيل',
    superadminRestaurantsEditTitle: 'تعديل المطعم',
    superadminRestaurantsFieldAdminPwd: 'كلمة مرور المسؤول (فارغ = admin123)',
    superadminRestaurantsFieldEmail: 'البريد الإلكتروني',
    superadminRestaurantsFieldName: 'اسم المطعم',
    superadminRestaurantsFieldOwner: 'اسم المالك',
    superadminRestaurantsFieldPhone: 'الهاتف',
    superadminRestaurantsFieldPlan: 'الخطة',
    superadminRestaurantsFieldSlug: 'Slug * (معرّف URL)',
    superadminRestaurantsLoadFailed: 'فشل تحميل المطاعم.',
    superadminRestaurantsTablesLbl: 'طاولة',
    superadminRestaurantsTitle: 'المطاعم',
    superadminRestaurantsUsersLbl: 'مستخدم',
    superadminStatusUpdateFailed: 'فشل تحديث الحالة.',
    // اشتراكات المشرف الأعلى
    superadminSubsActivate: 'تفعيل',
    superadminSubsActiveLbl: 'نشط',
    superadminSubsActiveSub: 'اشتراك نشط',
    superadminSubsCancelledLbl: 'ملغى',
    superadminSubsCancelledSub: 'تم الإلغاء',
    superadminSubsColAction: 'الإجراء',
    superadminSubsColAmount: 'المبلغ',
    superadminSubsColEndDate: 'تاريخ الانتهاء',
    superadminSubsColPeriod: 'الفترة',
    superadminSubsColPlan: 'الخطة',
    superadminSubsColRestaurant: 'المطعم',
    superadminSubsColStatus: 'الحالة',
    superadminSubsCycleMonthly: 'شهري',
    superadminSubsCycleYearly: 'سنوي',
    superadminSubsDaysLeft: 'يوم متبقٍ',
    superadminSubsEnded: 'انتهى',
    superadminSubsEndsToday: 'ينتهي اليوم',
    superadminSubsMrr: 'MRR',
    superadminSubsMrrSub: 'الإيراد الشهري المتكرر',
    superadminSubsRecordsShowing: 'سجل معروض',
    superadminSubsSubtitle: 'عرض وإدارة جميع اشتراكات المطاعم',
    superadminSubsTabActive: 'نشط',
    superadminSubsTabAll: 'الكل',
    superadminSubsTabCancelled: 'ملغى',
    superadminSubsTabExpired: 'منتهي',
    superadminSubsTabPastDue: 'متأخر',
    superadminSubsTabTrial: 'تجريبي',
    superadminSubsThisMonthLbl: 'هذا الشهر',
    superadminSubsThisMonthSub: 'تحصيلات هذا الشهر',
    superadminSubsTitle: 'الاشتراكات',
    superadminSubsTrialLbl: 'تجريبي',
    superadminSubsTrialSub: 'تجربة مجانية',

    // ── مفاتيح صقل الجولة 296-297 ──
    addFailed: 'تعذرت الإضافة.',
    approveFailed: 'تعذرت الموافقة.',
    clearDateFilter: 'مسح التاريخ',
    createFailed: 'تعذر الإنشاء.',
    hrAssignFailed: 'تعذر التعيين.',
    hrBulkCalculationFailed: 'خطأ في الحساب المجمّع.',
    hrCalculationFailed: 'خطأ في الحساب.',
    hrDocumentsLoadFailed: 'تعذر تحميل المستندات.',
    hrEmployeesLoadFailed: 'تعذر تحميل الموظفين.',
    hrImportFailed: 'تعذر الاستيراد.',
    hrLeavesLoadFailed: 'تعذر تحميل الإجازات.',
    hrMarkFailed: 'تعذرت العلامة.',
    hrPayrollsLoadFailed: 'تعذر تحميل كشوف الرواتب.',
    hrSeveranceFailed: 'تعذر حساب مكافأة نهاية الخدمة.',
    loginEmailPh: 'مثال@مطعم.com',
    offlineBannerOffline: 'انقطع الاتصال — قد تُفقد التغييرات، يُرجى التحقق من الشبكة.',
    offlineBannerReconnected: 'تمت إعادة الاتصال.',
    onboardingGoToDashboard: 'الذهاب إلى لوحة التحكم',

    // ── Tur 298 sprint keyleri ──
    paginationPrev: '← السابق',
    paginationNext: 'التالي →',
    paginationPageOf: 'صفحة {page} من {total}',
    paginationAria: 'ترقيم الصفحات',
    serverErrorTitle: 'خطأ في الخادم',
    serverErrorDesc: 'حدث خطأ مؤقت. يرجى المحاولة مرة أخرى أو الاتصال بالمسؤول.',
    serverErrorRetry: '🔄 إعادة المحاولة',
    serverErrorDetails: 'تفاصيل الخطأ (المطور)',
    forbiddenTitle: 'تم حظر الوصول',
    forbiddenDesc: 'ليس لديك إذن لعرض هذه الصفحة. يرجى الاتصال بالمسؤول.',
    forbiddenCurrentRole: 'دورك الحالي',
    posCartRestoredBadge: '🔄 تم استرجاع السلة السابقة',
    dashWidgetEditBtn: '⚙️ تخصيص',
    dashWidgetEditTitle: 'تخصيص الودجات',
    dashWidgetEditDesc: 'قم بإخفاء الودجات التي لا تريد رؤيتها',
    dashWidgetSaveBtn: 'حفظ',
    dashWidgetReset: 'إعادة الضبط',
    chainReportsPrintAria: 'طباعة تقرير السلسلة',
    hrPrintAria: 'طباعة كشف الراتب',
    shiftPrintAria: 'طباعة الوردية',
    // ── مفاتيح الجولة 299 ──
    posReceiptSectionDisplay: '📺 شاشة العميل (POS Display)',
    posReceiptDisplayAdUrlsLabel: 'صور العروض الترويجية (قائمة الروابط)',
    posReceiptDisplayAdUrlsPlaceholder: 'https://example.com/promo1.jpg\nhttps://example.com/promo2.jpg',
    posReceiptDisplayAdUrlsHelp: 'صور ترويجية تُعرض على شاشة العميل في POS Display عندما تكون فارغة (السلة فارغة). عند إضافة عدة روابط، تتبدّل تلقائيًا كل 8 ثوانٍ (كاروسيل).',
    posReceiptDisplayAdPreviewTitle: 'معاينة',
    posReceiptDisplayAdRemove: 'إزالة',
    posReceiptDisplayAdInvalidUrl: 'رابط غير صالح',
    posReportsZStatTotal: 'إجمالي تقارير Z',
    posReportsZStatRevenue: 'إجمالي الإيرادات',
    posReportsZStatAvg: 'متوسط Z',
    posReportsZStatThisWeek: 'هذا الأسبوع',
    posReportsZColZNo: 'رقم Z',
    posReportsZColCashier: 'أمين الصندوق',
    posReportsZColSales: 'المبيعات',
    posReportsZEmpty: 'لا توجد تقارير Z بعد',
    posReportsZEmptyDesc: 'يتم إنشاء تقرير Z تلقائيًا عند إغلاق جلسة POS المفتوحة.',
    posReportsZLoadFailed: 'فشل تحميل تقارير Z.',

    // الجولة 301-304 — تلميع + ذيل التدويل
    selectedCount: 'محدد',
    chainStaffBulkPartial: 'فشلت العمليات',
    chainReportsSortGroup: 'الترتيب',
    tablesCustomerRemoveBtn: 'إزالة',
    reportsStaffPerformanceToday: 'أداء الموظفين (اليوم)',
    reportsOrdersShort: 'طلبات',
    deliveryDatePresetLast7Days: 'آخر 7 أيام',
    deliveryDatePresetLast30Days: 'آخر 30 يومًا',
    deliveryDatePresetThisMonth: 'هذا الشهر',
    deliveryDatePresetLastMonth: 'الشهر الماضي',
    usersPinHelpHint: '(4 أرقام — تسجيل دخول سريع لنقاط البيع، اختياري)',

    // الجولة 305 — ذيل التدويل + الحالات الفارغة
    saasPlanNameRequired: 'اسم الخطة مطلوب.',
    saasPlanMonthlyPriceInvalid: 'يجب أن يكون السعر الشهري صالحًا.',
    saasPlanUpdated: 'تم تحديث الخطة.',
    saasPlanCreated: 'تم إنشاء الخطة.',
    saasPlanDeleted: 'تم حذف الخطة.',
    saasPlanDeleteConfirmTmpl: 'هل أنت متأكد أنك تريد حذف الخطة "{name}"؟ لا يمكن التراجع عن هذا الإجراء.',
    saasSubActivateConfirmTmpl: 'هل أنت متأكد أنك تريد تفعيل الاشتراك يدويًا لـ {name}؟',
    saasSubActivated: 'تم تفعيل الاشتراك.',
    saasSubActivateError: 'تعذّر التفعيل.',
    prnNoJobsTitle: 'قائمة انتظار الطباعة فارغة',
    prnNoJobsDesc: 'لم يتم إرسال أي مهام إلى الطابعات بعد.',

    // الجولة 306 — التحقق من النماذج + حالات HR الفارغة
    formNameRequired: 'الاسم مطلوب',
    formEmailInvalid: 'أدخل بريدًا إلكترونيًا صالحًا',
    formPhoneInvalid: 'أدخل رقم هاتف صالحًا (7 أرقام على الأقل)',
    userPinFourDigits: 'يجب أن يتكون رمز PIN من 4 أرقام',
    hrEmptyEmployeesTitle: 'لا يوجد موظفون بعد',
    hrEmptyEmployeesDesc: 'استخدم "موظف جديد" لإضافة أول موظف.',
    hrEmptyLeavesDesc: 'أنشئ طلب إجازة جديد أو امسح عوامل التصفية.',
    hrEmptyDocumentsTitle: 'لم يتم العثور على وثائق',
    hrEmptyDocumentsDesc: 'حمّل وثيقة جديدة أو امسح عوامل التصفية.',

    // الجولة 307 — التحقق من نماذج العروض/القسائم
    promoCodeRequired: 'الرمز مطلوب',
    promoDiscountInvalid: 'أدخل قيمة خصم صالحة',
    voucherAmountInvalid: 'أدخل مبلغًا صالحًا',

    // الجولة 308 — مسح التدويل العميق (HR + POS + المرشحات المحفوظة)
    hrDocTypeKimlik: 'صورة الهوية',
    hrDocTypeIkametgah: 'وثيقة الإقامة',
    hrDocTypeDiploma: 'الشهادة',
    hrDocTypeSaglikRaporu: 'التقرير الطبي',
    hrDocTypeIsSozlesmesi: 'عقد العمل',
    hrDocTypeSgkBildirim: 'إخطار الضمان الاجتماعي',
    hrDocTypeOther: 'أخرى',
    hrDocumentExpiryOptional: 'تاريخ الانتهاء (اختياري)',
    hrLeaveTypeAnnual: 'إجازة سنوية',
    hrLeaveTypeSick: 'مرضية',
    hrLeaveTypeMaternity: 'أمومة',
    hrLeaveTypePaternity: 'أبوة',
    hrLeaveTypeUnpaid: 'بدون أجر',
    hrLeaveTypeOther: 'أخرى',
    hrEmployeeDeleteConfirm: 'هل أنت متأكد أنك تريد حذف الموظف "{name}"؟',
    hrPayrollBulkCalcConfirm: 'حساب الرواتب لجميع الموظفين لفترة {period}؟',
    hrBulkLeaveAssignConfirm: 'سيتم تخصيص {days} أيام إجازة {type} لـ {count} موظف. هل تؤكد؟',
    hrLeaveActionApprove: 'موافقة',
    hrLeaveActionReject: 'رفض',
    hrLeaveActionDelete: 'حذف',
    hrLeaveActionConfirm: 'هل أنت متأكد أنك تريد {action} طلب الإجازة هذا؟',
    hrPayslipDocType: 'كشف الراتب',
    hrPayslipPeriodLabel: 'الفترة',
    hrPayslipDocNoLabel: 'رقم المستند',
    hrPayslipGeneratedLabel: 'تاريخ الإنشاء',
    hrPayslipEarningsHeader: 'الإيرادات',
    hrPayslipOvertimeRow: '(+) العمل الإضافي (1.5x)',
    hrPayslipWeeklyHolidayRow: '(+) عطلة أسبوعية (1.5x)',
    hrPayslipPublicHolidayRow: '(+) عطلة رسمية (2x)',
    hrPayslipBonusRow: '(+) علاوة',
    hrPayslipGrossTotalRow: 'إجمالي الإيرادات الإجمالية',
    hrPayslipAllowancesHeader: 'البدلات (معفاة، تُضاف للصافي)',
    hrPayslipAllowancesTotalRow: 'إجمالي البدلات',
    hrPayslipLegalDeductionsHeader: 'الاستقطاعات القانونية',
    hrPayslipSgkEmployeeRow: 'الضمان الاجتماعي للموظف (14%)',
    hrPayslipUnemploymentEmployeeRow: 'تأمين البطالة للموظف (1%)',
    hrPayslipStampTaxRow: 'ضريبة الطوابع (0.759%)',
    hrPayslipLegalDeductionsTotalRow: 'إجمالي الاستقطاعات القانونية',
    hrPayslipCustomDeductionsHeader: 'الاستقطاعات الخاصة',
    hrPayslipBesPaymentRow: 'مساهمة التقاعد الخاص',
    hrPayslipCustomDeductionsTotalRow: 'إجمالي الاستقطاعات الخاصة',
    hrPayslipNetSalaryLabel: 'صافي الراتب',
    hrPayslipSgkEmployerRow: 'الضمان الاجتماعي لصاحب العمل (20.5%)',
    hrPayslipUnemploymentEmployerRow: 'تأمين البطالة لصاحب العمل (2%)',
    hrPayslipFootnote: 'تم احتساب هذا الكشف وفقًا لقانون العمل ولوائح الضمان الاجتماعي (2024). تم تطبيق إعفاء ضريبة الدخل وضريبة الطوابع للحد الأدنى للأجور (القانون 7349).',
    hrPayslipEmployerSignLabel: 'توقيع وختم صاحب العمل',
    posRefundConfirm: 'استرداد {receipt} — ₺{total}؟',
    savedFiltersNameRequired: 'اسم عامل التصفية مطلوب',
    savedFiltersSaved: 'تم حفظ عامل التصفية',

    // الجولة 311 — موجه تثبيت PWA
    pwaInstallTitle: 'تثبيت التطبيق',
    pwaInstallDesc: 'أضف RestaFlex إلى الشاشة الرئيسية — يعمل دون اتصال، يفتح بسرعة، تجربة ملء الشاشة.',
    pwaInstallBtn: 'تثبيت',
    pwaInstallDismiss: 'لاحقاً',
    pwaInstalled: 'التطبيق مثبت',

    // الجولة 312 — ثغرات تدويل HR modal الجديدة هذا الأسبوع
    hrEmploymentFullTime: 'دوام كامل',
    hrEmploymentPartTime: 'دوام جزئي',
    hrEmploymentSeasonal: 'موسمي',
    hrPayrollStatusDraft: 'مسودة',
    hrPayrollStatusApproved: 'موافق عليه',
    hrPayrollStatusPaid: 'مدفوع',
    hrProfilePhotoUrl: 'رابط صورة الملف الشخصي',
    reportsMonthLongList: 'يناير,فبراير,مارس,أبريل,مايو,يونيو,يوليو,أغسطس,سبتمبر,أكتوبر,نوفمبر,ديسمبر',
    posSalesHistoryLoadFailed: 'تعذّر تحميل السجل',
    posPrinterNotFound: 'الطابعة غير موجودة',

    // الجولة 315 — اختصارات لوحة المفاتيح + تدقيق التلميحات
    shortcutHelpAlt: 'اختصارات لوحة المفاتيح',
    shortcutHr: 'الموارد البشرية',
    shortcutUsers: 'المستخدمون',
    shortcutReservations: 'الحجوزات',
    shortcutTrash: 'المهملات',
    cmdPaletteGoHR: 'انتقل إلى الموارد البشرية',
    cmdPaletteGoUsers: 'انتقل إلى المستخدمين',
    cmdPaletteGoReservations: 'انتقل إلى الحجوزات',
    cmdPaletteGoTrash: 'انتقل إلى المهملات',
    customerTagRemove: 'إزالة العلامة',

    // الجولة 316 — إعداد OKC + الإعدادات + POSTerminal + الأخطاء (65 مفتاحًا)
    // 1. معالج الإعداد (30)
    okcOnboardingTitle: 'معالج إعداد OKC',
    okcOnboardingClose: 'إغلاق',
    okcOnboardingNext: 'التالي',
    okcOnboardingBack: 'رجوع',
    okcOnboardingSkip: 'تخطي المعالج',
    okcOnboardingFinish: 'إنهاء',
    okcOnboardingStep1Title: 'مرحبًا',
    okcOnboardingStep1Desc: 'مرحبًا بك في RestaFlex Desktop. لنقم بإعداد طابعتك المالية معًا.',
    okcOnboardingStep2Title: 'فحص الخدمة المعتمدة',
    okcOnboardingStep2Desc: 'هل تم إقران جهازك بهذا الكمبيوتر من قبل خدمة معتمدة؟',
    okcOnboardingStep2Yes: 'نعم، تم الإقران',
    okcOnboardingStep2No: 'لا، ليس بعد',
    okcOnboardingStep3Title: 'نوع الاتصال',
    okcOnboardingStep3Usb: 'عبر USB',
    okcOnboardingStep3Ethernet: 'عبر Ethernet',
    okcOnboardingStep3WifiWarn: 'الاتصال اللاسلكي غير قانوني (هيئة الضرائب).',
    okcOnboardingStep4Title: 'اكتشاف الأجهزة',
    okcOnboardingStep4Scan: 'فحص الأجهزة',
    okcOnboardingStep4Scanning: 'جاري الفحص...',
    okcOnboardingStep4Empty: 'لم يتم العثور على أجهزة. أضف يدويًا.',
    okcOnboardingStep4Manual: 'إضافة يدوية',
    okcOnboardingStep5Title: 'تفاصيل الجهاز',
    okcOnboardingStep5Vendor: 'الشركة المصنعة',
    okcOnboardingStep5Model: 'الطراز',
    okcOnboardingStep5DeviceName: 'اسم الجهاز',
    okcOnboardingStep6Title: 'الإقران',
    okcOnboardingStep6Pairing: 'جاري الإقران...',
    okcOnboardingStep6Success: 'تم الإقران (AES-256 + HMAC-SHA256)',
    okcOnboardingStep7Title: 'عملية بيع تجريبية',
    okcOnboardingStep8Title: 'أنت جاهز!',
    // 2. الإعدادات → الطابعة المالية (15)
    okcWizardStart: 'بدء المعالج',
    okcWizardStartDesc: 'إعداد خطوة بخطوة باستخدام المعالج.',
    okcDevicesTitle: 'الأجهزة المالية',
    okcDevicesDesc: 'إدارة جميع أجهزة OKC المتصلة.',
    okcAddDevice: '+ إضافة جهاز',
    okcNoDevices: 'لم تتم إضافة أجهزة بعد',
    okcNoDevicesDesc: 'ابدأ المعالج أو أضف يدويًا.',
    okcEditDevice: 'تعديل',
    okcMakeActive: 'تعيين كافتراضي',
    okcTest: 'اختبار الاتصال',
    okcTestingConnection: 'جاري الاختبار...',
    okcTestSuccess: 'الاتصال ناجح',
    okcTestFailed: 'فشل الاتصال',
    okcDesktopOnly: 'لسطح المكتب فقط',
    okcDesktopOnlyDesc: 'تعمل هذه الميزة في تطبيق RestaFlex Desktop.',
    // 3. تكامل POSTerminal (10)
    posOkcEnabled: 'الطابعة المالية تعمل',
    posOkcDisabled: 'الطابعة المالية متوقفة',
    posOkcSaleSuccess: 'اكتمل البيع — إيصال: {receiptNo}',
    posOkcFailed: 'خطأ في الطابعة المالية',
    posOkcFallbackConfirm: 'الطابعة المالية معطلة. هل تريد التسجيل في الواجهة الخلفية فقط؟',
    posSaleComplete: 'اكتمل البيع بنجاح',
    posOkcXReport: 'إنشاء تقرير X',
    posOkcZReport: 'إنشاء تقرير Z (نهاية اليوم)',
    posOkcZReportConfirm: 'هل تريد إغلاق اليوم المالي؟',
    posOkcCustomerDisplayBroadcast: 'تم تحديث شاشة العميل',
    // 4. رسائل الخطأ (10)
    okcErrConnRefused: 'الجهاز رفض الاتصال — تحقق من IP/المنفذ',
    okcErrPairTimeout: 'انتهت مهلة الإقران',
    okcErrFiscalDayClosed: 'اليوم المالي مغلق — تم إصدار تقرير Z',
    okcErrFiscalDayOpen: 'اليوم المالي لا يزال مفتوحًا — لا يمكن إصدار تقرير Z',
    okcErrTsmUnreachable: 'خادم TSM غير قابل للوصول — اتصل بالخدمة',
    okcErrInvalidHmac: 'فشل التحقق من HMAC — أعد الإقران',
    okcErrPaperOut: 'لا يوجد ورق',
    okcErrLicenseExpired: 'انتهت صلاحية رخصة الجهاز — اتصل بالخدمة',
    okcErrUnknownDevice: 'الجهاز غير مسجل',
    okcErrDeviceBusy: 'الجهاز مشغول — حاول مرة أخرى',
    // أكواد أخطاء QR / السلة
    qrErrorItemsEmpty: 'السلة فارغة',
    qrErrorMinOrder: 'الحد الأدنى للطلب {min}₺',
    qrErrorInvalidPhone: 'رقم هاتف غير صالح',
    qrErrorInvalidQuantity: 'كمية غير صالحة',
    qrErrorInvalidToken: 'رابط غير صالح أو منتهي الصلاحية',
    qrErrorRateLimited: 'طلبات كثيرة، يرجى الانتظار',
    qrErrorGeneric: 'حدث خطأ',
    qrErrorTokenInvalid: 'الرمز غير صالح أو منتهي الصلاحية',
    qrErrorNetwork: 'لا يوجد اتصال بالشبكة — تحقق من الإنترنت',
    // أنماط بطاقات قائمة QR
    qrCardVariantNeoBrutalist: 'نيو بروتاليست',
    qrCardVariantGlass: 'زجاج',
    qrCardVariantGradientGlow: 'توهج متدرج',
    qrCardVariantEditorial: 'تحريري',
    qrCardVariantMinimalistMono: 'أحادي بسيط',
    qrCardVariantPaper: 'ورق',
    qrCardVariantRetroPop: 'ريترو بوب',
    qrCardVariantArtDeco: 'آرت ديكو',
  },
};

export default translations;
